"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[356],{

/***/ 51319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants_loyalty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92106);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86879);
/* harmony import */ var _utils_loyalty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53174);



var LoyaltyAccessor = function(param) {
    var checkType = param.checkType, checkName = param.checkName, component = param.component;
    var ref;
    var organization = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.organization;
    });
    var featureBag = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.global.featureBag;
    });
    var loyaltyDriverID = (ref = organization.organization) === null || ref === void 0 ? void 0 : ref.loyalty_driver_id;
    var functionalitySupported = false;
    if (checkType === _constants_loyalty__WEBPACK_IMPORTED_MODULE_0__/* .LOYALTY_ACCESSOR_TYPES.ROUTE */ .Mo.ROUTE) {
        functionalitySupported = (0,_utils_loyalty__WEBPACK_IMPORTED_MODULE_2__/* .allowedLoyaltyRoutes */ .kz)(loyaltyDriverID).includes(checkName) && // @ts-expect-error `checkName` can't index `LOYALTY_ROUTE_FEATURE_MAP`.
        featureBag[_constants_loyalty__WEBPACK_IMPORTED_MODULE_0__/* .LOYALTY_ROUTE_FEATURE_MAP */ .c3[checkName]] !== false;
    } else {
        var ref1, ref2;
        // @ts-expect-error `checkName` can't index `features`.
        functionalitySupported = (ref1 = organization.loyalty) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.features) === null || ref2 === void 0 ? void 0 : ref2[checkName];
    }
    // Only return component if loyalty feature is supported
    return !functionalitySupported ? null : component;
};
/* harmony default export */ __webpack_exports__["Z"] = (LoyaltyAccessor);


/***/ }),

/***/ 9671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ug": function() { return /* binding */ ConnectedCartIcon; },
  "GS": function() { return /* binding */ ConnectedChevronIcon; },
  "WX": function() { return /* binding */ ConnectedPersonIcon; },
  "Cu": function() { return /* binding */ ConnectedRewardsIcon; },
  "ER": function() { return /* binding */ ConnectedSelectedHeartIcon; },
  "D": function() { return /* binding */ ConnectedStarIcon; },
  "VF": function() { return /* binding */ ConnectedStaticHeartIcon; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/constants/styles.ts
var styles = __webpack_require__(30438);
;// CONCATENATED MODULE: ./src/components/account/uielements/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 0px;\n  padding-left: ",
        "px;\n\n  @media (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: contain;\n  max-height: ",
        "px;\n  max-width: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledChevronIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8aaa3934-0"
})(_templateObject(), styles/* LAYOUT.GUTTER */._.GUTTER / 4);
var StyledStarIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8aaa3934-1"
})(_templateObject1(), styles/* LAYOUT.GUTTER */._.GUTTER / 4);
var CustomAccountIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-8aaa3934-2"
})(_templateObject2(), styles/* SPACING_SCALE.LARGE */.jl.LARGE, styles/* SPACING_SCALE.LARGE */.jl.LARGE);

// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/components/account/uielements/index.tsx





// Heart Icon
var _StaticHeartIcon = /*#__PURE__*/ (0,react.memo)(function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: theme.global.primary_active_color,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.995 21c.185 0 .441-.11.636-.221C18.265 17.199 22 13.086 22 8.893 22 5.453 19.578 3 16.346 3c-1.858 0-3.469.935-4.351 2.383C11.123 3.945 9.5 3 7.644 3 4.41 3 2 5.454 2 8.893c0 4.193 3.735 8.306 9.369 11.886.185.11.441.221.626.221zm0-1.297c-.041 0-.092-.04-.175-.09-4.535-2.967-8.558-6.95-8.558-10.72 0-2.766 1.858-4.646 4.372-4.646 1.908 0 3.088 1.156 3.796 2.313.216.332.36.432.565.432.205 0 .339-.11.575-.432.728-1.147 1.888-2.313 3.786-2.313 2.514 0 4.372 1.88 4.372 4.646 0 3.77-4.013 7.753-8.548 10.72-.083.05-.144.09-.185.09z"
                })
            })
        })
    });
});
var ConnectedStaticHeartIcon = (0,styled_components_browser_esm/* withTheme */.Zz)(_StaticHeartIcon);
var _SelectedHeartIcon = /*#__PURE__*/ (0,react.memo)(function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: theme.global.primary_active_color,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.995 21c.185 0 .441-.11.636-.221C18.265 17.199 22 13.086 22 8.893 22 5.453 19.578 3 16.418 3c-1.93 0-3.54 1.066-4.423 2.715C11.123 4.076 9.5 3 7.582 3 4.412 3 2 5.454 2 8.893c0 4.193 3.735 8.306 9.369 11.886.185.11.441.221.626.221z"
                })
            })
        })
    });
});
var ConnectedSelectedHeartIcon = (0,styled_components_browser_esm/* withTheme */.Zz)(_SelectedHeartIcon);
var _active_background_color;
// Person Icon
// eslint-disable-next-line react/display-name
var _PersonIcon = /*#__PURE__*/ (0,react.memo)(function(param) {
    var theme = param.theme;
    return theme.header.account_icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomAccountIcon, {
        src: theme.header.account_icon,
        role: "presentation",
        alt: "Account Icon"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: (_active_background_color = theme.header.active_background_color) !== null && _active_background_color !== void 0 ? _active_background_color : "black",
            fillRule: "evenodd",
            d: "M12.008 12.305c1.687 0 3.094-1.492 3.094-3.43 0-1.875-1.415-3.336-3.094-3.336-1.672 0-3.094 1.477-3.086 3.344 0 1.93 1.398 3.422 3.086 3.422zm5.031 7.156c1.063 0 1.5-.305 1.5-.984 0-2.008-2.508-4.774-6.539-4.774s-6.54 2.766-6.54 4.774c0 .68.438.984 1.5.984h10.08z"
        })
    });
});
var ConnectedPersonIcon = (0,styled_components_browser_esm/* withTheme */.Zz)(_PersonIcon);
var _active_font_color;
// Cart Icon
// eslint-disable-next-line react/display-name
var _CartIcon = /*#__PURE__*/ (0,react.memo)(function(param) {
    var theme = param.theme;
    return theme.header.cart_icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: theme.header.cart_icon,
        alt: "Cart Icon"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        role: "img",
        "aria-label": "Cart",
        width: "14px",
        height: "17px",
        viewBox: "0 0 14 17",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Cart Icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "S02.-Menu",
                stroke: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: (_active_font_color = theme.header.active_font_color) !== null && _active_font_color !== void 0 ? _active_font_color : "black",
                    d: "M3.25,3.75 C3.25,1.67893219 4.92893219,0 7,0 C9.07106781,0 10.75,1.67893219 10.75,3.75 L13,3.75 C13.5522847,3.75 14,4.19771525 14,4.75 L14,15.75 C14,16.3022847 13.5522847,16.75 13,16.75 L1,16.75 C0.44771525,16.75 6.76353751e-17,16.3022847 0,15.75 L0,4.75 C-6.76353751e-17,4.19771525 0.44771525,3.75 1,3.75 L3.25,3.75 Z M4.75,3.75 L9.25,3.75 C9.25,2.50735931 8.24264069,1.5 7,1.5 C5.75735931,1.5 4.75,2.50735931 4.75,3.75 Z"
                })
            })
        ]
    });
});
var ConnectedCartIcon = (0,styled_components_browser_esm/* withTheme */.Zz)(_CartIcon);
// Chevron Icon
var _ChevronIcon = /*#__PURE__*/ (0,react.memo)(function Value(param) {
    var theme = param.theme;
    var color = (0,utils/* getFontStyles */.l)(theme.header.font, [
        "color"
    ]).color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChevronIcon, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 0L12 0 12 12 0 12z",
                        transform: "matrix(0 1 1 0 0 0)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: color,
                        d: "M6.293 8.372l3.6-4.095c.147-.179.142-.458-.01-.632-.153-.173-.399-.178-.557-.01L6.005 7.406 2.683 3.634C2.608 3.548 2.507 3.5 2.4 3.5c-.106 0-.208.048-.283.134-.156.178-.156.466 0 .643l3.62 4.095c.155.17.402.17.556 0z"
                    })
                ]
            })
        })
    });
});
var ConnectedChevronIcon = (0,styled_components_browser_esm/* withTheme */.Zz)(_ChevronIcon);
// Rewards Icon
// eslint-disable-next-line react/display-name
var _RewardsIcon = /*#__PURE__*/ (0,react.memo)(function(param) {
    var theme = param.theme;
    return theme.accounts.rewards_icon ? // eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: theme.accounts.rewards_icon,
        role: "presentation",
        alt: "Rewards Icon"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: theme.global.primary_active_color,
                    d: "M50.36 80c-2.106 0-4.175-.964-6.055-1.84-1.538-.717-3.128-1.458-4.305-1.458-1.177 0-2.767.74-4.305 1.458-2.474 1.152-5.277 2.458-8.058 1.517-2.886-.977-4.442-3.819-5.815-6.325-.806-1.473-1.64-2.995-2.512-3.657-.894-.678-2.558-1.042-4.167-1.393-2.69-.589-5.74-1.255-7.504-3.781-1.747-2.504-1.42-5.718-1.13-8.554.175-1.72.357-3.497.006-4.622-.321-1.031-1.434-2.308-2.51-3.541C2.126 45.654 0 43.216 0 40s2.127-5.653 4.004-7.804c1.077-1.233 2.19-2.509 2.511-3.54.35-1.125.17-2.904-.006-4.623-.289-2.836-.617-6.05 1.13-8.553 1.764-2.526 4.813-3.193 7.504-3.781 1.61-.352 3.274-.716 4.167-1.394.872-.661 1.706-2.184 2.512-3.656 1.373-2.507 2.93-5.349 5.815-6.326 2.781-.942 5.584.364 8.058 1.517 1.538.717 3.128 1.458 4.305 1.458 1.177 0 2.767-.741 4.306-1.457C46.78.688 49.582-.618 52.363.323c2.886.977 4.442 3.819 5.815 6.326.807 1.472 1.64 2.995 2.512 3.656.894.678 2.558 1.042 4.167 1.394 2.691.588 5.741 1.255 7.504 3.782 1.747 2.503 1.42 5.716 1.13 8.552-.175 1.72-.357 3.498-.006 4.622.321 1.033 1.434 2.308 2.511 3.542C77.873 34.347 80 36.785 80 40c0 3.216-2.127 5.654-4.005 7.804-1.076 1.233-2.19 2.51-2.51 3.541-.35 1.124-.17 2.902.006 4.621.289 2.837.617 6.051-1.13 8.555-1.764 2.526-4.814 3.192-7.505 3.78-1.609.352-3.273.716-4.166 1.394-.872.662-1.705 2.184-2.512 3.656-1.373 2.507-2.929 5.349-5.816 6.326-.647.217-1.323.326-2.003.323z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#FFF",
                    d: "M47.98 54.667c2.448 0 3.83-1.336 3.83-3.776v-9.764c1.398-.115 2.19-1.091 2.19-2.556v-3.144c0-1.565-.893-2.57-2.463-2.57h-4.004c1.037-.79 1.656-1.895 1.656-3.13 0-2.585-2.002-4.394-4.638-4.394-2.16 0-3.845 1.235-4.551 3.418-.706-2.183-2.39-3.418-4.551-3.418-2.636 0-4.638 1.81-4.638 4.394 0 1.235.59 2.34 1.627 3.13h-3.975c-1.512 0-2.463 1.005-2.463 2.57v3.144c0 1.465.792 2.441 2.19 2.556v9.764c0 2.44 1.382 3.776 3.83 3.776h15.96zm-9.031-21.81h-2.002c-2.622 0-3.961-1.58-3.961-3.13 0-1.436 1.123-2.34 2.563-2.34 1.974 0 3.4 1.593 3.4 4.235v1.235zm4.104 0h-2.002v-1.235c0-2.642 1.426-4.235 3.4-4.235 1.44 0 2.563.904 2.563 2.34 0 1.55-1.426 3.13-3.96 3.13zm-4.205 6.605h-9.996c-.735 0-1.066-.374-1.066-1.106v-2.728c0-.732.331-1.091 1.066-1.091h9.996v4.925zm12.315 0h-10.01v-4.925h10.01c.734 0 1.051.359 1.051 1.091v2.728c0 .732-.317 1.106-1.051 1.106zM38.848 53.016H32.02c-1.326 0-2.046-.733-2.046-2.054v-9.82h8.873v11.874zm9.131 0h-6.827V41.14h8.873v9.821c0 1.321-.72 2.054-2.046 2.054z"
                })
            ]
        })
    });
});
var ConnectedRewardsIcon = (0,styled_components_browser_esm/* withTheme */.Zz)(_RewardsIcon);
// Star Icon
var _StarIcon = /*#__PURE__*/ (0,react.memo)(function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStarIcon, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "19",
            height: "17",
            viewBox: "0 0 19 17",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Star"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.00439 16.7617C4.32471 17.0117 4.73096 16.9258 5.21533 16.5742L9.34814 13.5352L13.4888 16.5742C13.9731 16.9258 14.3716 17.0117 14.6997 16.7617C15.02 16.5195 15.0903 16.1211 14.895 15.5508L13.2622 10.6914L17.4341 7.69141C17.9185 7.34766 18.1138 6.98828 17.9888 6.59766C17.8638 6.22266 17.4966 6.03516 16.895 6.04297L11.7778 6.07422L10.2231 1.19141C10.0356 0.613281 9.75439 0.324219 9.34814 0.324219C8.94971 0.324219 8.66846 0.613281 8.48096 1.19141L6.92627 6.07422L1.80908 6.04297C1.20752 6.03516 0.840332 6.22266 0.715332 6.59766C0.58252 6.98828 0.785645 7.34766 1.27002 7.69141L5.44189 10.6914L3.80908 15.5508C3.61377 16.1211 3.68408 16.5195 4.00439 16.7617Z",
                    fill: theme.global.primary_active_color
                })
            ]
        })
    });
});
var ConnectedStarIcon = (0,styled_components_browser_esm/* withTheme */.Zz)(_StarIcon);


/***/ }),

/***/ 53247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ menuCard/* Allergens */.L; },
  "C": function() { return /* reexport */ modal; }
});

// EXTERNAL MODULE: ./src/components/allergens/menuCard/index.tsx
var menuCard = __webpack_require__(15185);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/lodash/merge.js
var merge = __webpack_require__(98537);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/utils.ts
var utils = __webpack_require__(30694);
// EXTERNAL MODULE: ./src/constants/styles.ts
var constants_styles = __webpack_require__(30438);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var cmsConfig_utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/components/allergens/modal/styles.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0 0 ",
        "px;\n\n  @media (max-width: 767px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: ",
        "px;\n  margin: 0 auto;\n  padding: ",
        "px 0 ",
        "px;\n  top: 0px;\n  max-width: 770px;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    gap: ",
        "px;\n    padding: ",
        "px;\n    div:first-child {\n      button {\n        border-width: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid\n    ",
        ";\n  border-left: none;\n  border-right: none;\n  display: none;\n  margin: 0;\n  padding: ",
        "px;\n\n  @media (max-width: 767px) {\n    display: block;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: all 0.2s linear;\n\n  ",
        "\n\n  cursor: pointer;\n  min-height: 60px;\n  padding: 0 ",
        "px;\n  position: relative;\n  width: calc(20% - 12px);\n\n  svg {\n    display: none;\n  }\n\n  @media (max-width: 767px) {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n\n    padding: ",
        "px ",
        "px;\n    text-align: left;\n    width: 100%;\n\n    svg {\n      display: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgba(0, 0, 0, 0.4);\n  left: 0;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        "px;\n  margin: 0 auto;\n  max-width: ",
        "px;\n  position: relative;\n  top: 10%;\n  width: 100%;\n  max-height: 90%;\n  padding: 20px 0 0 0;\n  overflow: hidden;\n  overflow-y: auto;\n\n  @media (max-width: 767px) {\n    height: 100vh;\n    top: 0;\n    max-width: none;\n    max-height: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





/**
 * @param   {string|object} arg
 * @param   {object}        [breakpoints]
 * @returns {*}
 */ var dietaryPreferencesButton = function(isActive, theme) {
    var buttons = theme.buttons;
    var fontStyles = (0,cmsConfig_utils/* getFontStyles */.l)(buttons.knockout_font, {
        color: function(value) {
            return isActive ? buttons.knockout_button_text_hover_color : value;
        }
    });
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        backgroundColor: isActive ? buttons.knockout_button_background_hover_color : buttons.knockout_button_background_color,
        borderWidth: "1px",
        borderColor: isActive ? (0,utils/* getSafeHoverColor */.X2)(buttons.knockout_button_border_hover_color, buttons.knockout_button_border_color) : buttons.knockout_button_border_color,
        borderRadius: "".concat(buttons.knockout_button_border_radius, "px")
    }, fontStyles), {
        "@media (min-width: 768px)": {
            "&:hover": !isActive ? {
                background: buttons.knockout_button_background_hover_color,
                borderColor: (0,utils/* getSafeHoverColor */.X2)(buttons.knockout_button_border_hover_color, buttons.knockout_button_border_color),
                color: buttons.knockout_button_text_hover_color
            } : {}
        }
    });
};
var StyledAllergenContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b785e6cf-0"
})(_templateObject(), constants_styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var displayOnMobile = param.displayOnMobile;
    return !displayOnMobile && "\n      display: none;\n    ";
});
var StyledAllergens = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b785e6cf-1"
})(_templateObject1(), constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER, constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledAllergensIntro = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-b785e6cf-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.dietary_preferences_modal.border_color;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledAllergenButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b785e6cf-3"
})(_templateObject3(), function(param) {
    var isActive = param.isActive, theme = param.theme;
    return dietaryPreferencesButton(isActive, theme);
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER, function(props) {
    return props.isActive ? "block" : "none";
});
var StyledGenericModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b785e6cf-4"
})(_templateObject4(), constants_styles/* ORDER.MIGRATE_CART */.kl.MIGRATE_CART);
var StyledGenericModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b785e6cf-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.dietary_preferences_modal.background_color;
}, function(param) {
    var theme = param.theme;
    return theme.dietary_preferences_modal.border_radius;
}, function(props) {
    return props.maxWidth || 500;
});
var StyledCopy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b785e6cf-6"
})(function(param) {
    var theme = param.theme;
    return {
        padding: "20px",
        "h1, h3, p": {
            margin: "0",
            textAlign: "center"
        },
        "h3, p": (0,_object_spread/* default */.Z)({}, (0,cmsConfig_utils/* getFontStyles */.l)(theme.dietary_preferences_modal.font, [
            "color",
            "font_family",
            "font_size", 
        ])),
        h3: {
            paddingBottom: "40px"
        },
        h1: (0,_object_spread/* default */.Z)({}, (0,cmsConfig_utils/* getFontStyles */.l)(theme.dietary_preferences_modal.secondary_font, [
            "color",
            "font_family",
            "font_size", 
        ])),
        "@media (max-width: 767px)": {
            textAlign: "left",
            h1: (0,_object_spread/* default */.Z)({}, (0,cmsConfig_utils/* getFontStyles */.l)(theme.dietary_preferences_modal.secondary_font, [
                "font_size"
            ], {
                font_size: function(val) {
                    return typeof val === "number" ? val / 1.5 : val;
                }
            })),
            h3: {
                padding: "20px 0"
            }
        }
    };
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-b785e6cf-7"
})(_templateObject6());
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-b785e6cf-8"
})(function(param) {
    var theme = param.theme, isActive = param.isActive;
    var color = (0,cmsConfig_utils/* getFontStyles */.l)(theme.buttons.knockout_font).color;
    var _knockout_button_border_hover_color;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dietaryPreferencesButton(isActive, theme)), {
        flex: 1,
        minWidth: "".concat(constants_styles/* SPACING_SCALE.XL */.jl.XL, "px"),
        overflow: "hidden",
        svg: {
            marginRight: "10px"
        },
        "@media (max-width: 767px)": {
            border: "none",
            padding: "0 10px",
            borderRadius: "50%",
            zIndex: 1,
            svg: {
                marginRight: 0
            },
            span: {
                color: "transparent",
                position: "absolute",
                width: "1px"
            },
            "&:hover": {
                boxShadow: "none"
            }
        },
        "@media (min-width: 768px)": {
            "&:hover": {
                background: isActive ? theme.buttons.knockout_button_background_color : theme.buttons.knockout_button_background_hover_color,
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: isActive ? theme.buttons.knockout_button_border_color : (_knockout_button_border_hover_color = theme.buttons.knockout_button_border_hover_color) !== null && _knockout_button_border_hover_color !== void 0 ? _knockout_button_border_hover_color : theme.buttons.knockout_button_border_color,
                color: isActive ? color : theme.buttons.knockout_button_text_hover_color
            }
        }
    });
});
var StyledFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b785e6cf-9"
})(function(param) {
    var theme = param.theme;
    return {
        padding: "20px 60px 20px",
        background: "rgba(#255, 0.3)",
        p: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cmsConfig_utils/* getFontStyles */.l)(theme.dietary_preferences_modal.font, [
            "color",
            "font_family", 
        ])), {
            fontSize: "12px",
            margin: 0,
            paddingBottom: "20px"
        }),
        "@media (max-width: 767px)": {
            padding: "20px 20px 120px"
        }
    };
});

// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/uielements/X/index.tsx
var X = __webpack_require__(66086);
// EXTERNAL MODULE: ./src/components/uielements/genericFocusTrap/index.tsx
var genericFocusTrap = __webpack_require__(38806);
// EXTERNAL MODULE: ./src/constants/events.ts
var constants_events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/redux/allergens/actions.ts
var actions = __webpack_require__(92153);
// EXTERNAL MODULE: ./src/utils/events.ts
var utils_events = __webpack_require__(41762);
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(87809);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
;// CONCATENATED MODULE: ./src/components/allergens/modal/index.tsx

















var AllergensModal = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(AllergensModal, Component);
    var _super = (0,_create_super/* default */.Z)(AllergensModal);
    function AllergensModal() {
        (0,_class_call_check/* default */.Z)(this, AllergensModal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            showModal: false,
            activeAllergens: []
        };
        return _this;
    }
    var _proto = AllergensModal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.allergens.allergens.length === 0) {
            this.props.fetchAllergens();
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (!this.state.showModal && this.state.showModal !== prevState.showModal) {
            this.setState({
                activeAllergens: this.props.allergens.activeAllergens.slice(0)
            });
        }
        if (this.props.allergens.activeAllergens !== prevProps.allergens.activeAllergens) {
            this.setState({
                activeAllergens: this.props.allergens.activeAllergens.slice(0)
            });
        }
    };
    _proto.toggleModal = function toggleModal(showModal) {
        this.setState({
            showModal: showModal
        });
    };
    _proto.toggleAllergen = function toggleAllergen(allergenId) {
        var activeAllergens = merge_default()([], this.state.activeAllergens);
        var index = activeAllergens.indexOf(allergenId);
        if (index > -1) {
            activeAllergens.splice(index, 1);
        } else {
            activeAllergens.push(allergenId);
        }
        this.setState({
            activeAllergens: activeAllergens
        });
    };
    _proto.applyPreferences = function applyPreferences() {
        var _this = this;
        this.props.updateAllergens(this.state.activeAllergens);
        this.toggleModal(false);
        var selectedAllergenNames = [];
        // Map through our active allergen ID array and get the names
        this.state.activeAllergens.map(function(allergenId) {
            var allergenName = (0,utils_events/* safelyGetValueForKA */.mY)(_this.props.allergens.allergens, "id", allergenId, "label");
            selectedAllergenNames.push(allergenName);
        });
        // Join array into a string
        var selectedAllergensString = selectedAllergenNames.join(", ");
        // GA Event
        (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.browse */.m1.browse, googleAnalytics/* gaActions.dietaryPreferencesUpdated */.cE.dietaryPreferencesUpdated, {
            label: selectedAllergensString
        });
        // KA Event
        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.DIETARY_PREFERENCES_UPDATED */.AH.DIETARY_PREFERENCES_UPDATED, {
            name: selectedAllergensString
        });
    };
    _proto.render = function render() {
        var _this = this;
        var _state = this.state, showModal = _state.showModal, activeAllergens = _state.activeAllergens;
        var _props = this.props, allergens = _props.allergens, displayOnMobile = _props.displayOnMobile, maxWidth = _props.maxWidth;
        if (!allergens.allergens.length) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAllergenContainer, {
                    displayOnMobile: displayOnMobile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                        isActive: !!this.props.allergens.activeAllergens.length,
                        onClick: function() {
                            _this.toggleModal(true);
                            // Consolidated pageview events
                            (0,events/* pageViewEventHandler */.f)(constants_events/* MODAL.DIETARY_PREFERENCES_MODAL */.zr.DIETARY_PREFERENCES_MODAL);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "19",
                                height: "16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M5.535 1.574c.578 0 1.074.446 1.074 1.023S6.113 3.62 5.535 3.62c-.578 0-1.074-.446-1.074-1.023s.496-1.023 1.074-1.023ZM5.507.262c-1.101 0-2.037.709-2.34 1.68H.66a.643.643 0 0 0-.66.654c0 .367.303.656.688.656h2.506c.276.97 1.24 1.678 2.34 1.678 1.13 0 2.066-.708 2.369-1.678h10.16c.386 0 .69-.289.69-.656 0-.367-.304-.656-.69-.656H7.904C7.573.971 6.636.262 5.507.262Zm8.316 6.558c.579 0 1.074.446 1.074 1.023s-.495 1.023-1.074 1.023c-.578 0-1.074-.446-1.074-1.023s.468-1.023 1.074-1.023Zm-.028-1.312c-1.101 0-2.037.708-2.34 1.679H.688c-.413 0-.688.288-.688.656 0 .367.303.655.688.655h10.767c.275.97 1.239 1.68 2.34 1.68 1.13 0 2.066-.71 2.369-1.68h1.9c.385 0 .688-.288.688-.655 0-.368-.303-.656-.688-.656h-1.9c-.303-.97-1.24-1.679-2.369-1.679Zm-3.882 8.105c0-.577-.496-1.023-1.073-1.023a1.07 1.07 0 0 0-1.074 1.023c0 .577.496 1.023 1.074 1.023.577 0 1.073-.446 1.073-1.023Zm-3.443-.656c.304-.97 1.24-1.679 2.342-1.679 1.128 0 2.065.709 2.368 1.679h6.884c.385 0 .688.289.688.656 0 .367-.303.656-.688.656h-6.857c-.303.97-1.238 1.678-2.368 1.678-1.101 0-2.065-.708-2.341-1.678H.688c-.385 0-.688-.289-.688-.656 0-.367.275-.656.688-.656H6.47Z",
                                    fill: "currentColor"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: "dietary_preferences.menu_trigger"
                                })
                            })
                        ]
                    })
                }),
                showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(genericFocusTrap/* GenericFocusTrap */.G, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGenericModal, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGenericModalContent, {
                            maxWidth: maxWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(X/* ConnectedXButton */.e9, {
                                    onClick: function() {
                                        return _this.toggleModal(false);
                                    },
                                    name: "Dietary preference modal"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCopy, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "dietary_preferences.modal_eyebrow",
                                            tag: "h3",
                                            html: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "dietary_preferences.modal_headline",
                                            tag: "h1",
                                            html: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "dietary_preferences.modal_subheadline",
                                            tag: "p",
                                            html: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAllergensIntro, {
                                    children: "Select all that apply"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAllergens, {
                                    children: allergens.allergens.map(function(allergen) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAllergenButton, {
                                            onClick: function() {
                                                return _this.toggleAllergen(allergen.id);
                                            },
                                            // @ts-expect-error
                                            isActive: activeAllergens.includes(allergen.id),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: allergen.label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "19",
                                                    height: "14",
                                                    viewBox: "0 0 19 14",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        fill: "currentColor",
                                                        fillRule: "nonzero",
                                                        d: "M.39 7.59C-.792 6.505.98 4.73 2.163 5.913l4.629 4.537L16.837.39c1.182-1.183 2.955.592 1.773 1.775L6.792 14 .39 7.59z"
                                                    })
                                                })
                                            ]
                                        }, allergen.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooter, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "dietary_preferences.modal_disclaimer",
                                            tag: "p",
                                            html: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                            onClick: function() {
                                                return _this.applyPreferences();
                                            },
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                accessor: "dietary_preferences.modal_cta"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        });
    };
    return AllergensModal;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        allergens: state.app.allergens
    };
};
var mapDispatchToProps = {
    fetchAllergens: actions/* default.fetchAllergens */.Z.fetchAllergens,
    updateAllergens: actions/* default.updateAllergens */.Z.updateAllergens
};
var connector = (0,es.connect)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ var modal = (connector(AllergensModal));

;// CONCATENATED MODULE: ./src/components/allergens/index.ts





/***/ }),

/***/ 15185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Allergens; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56580);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49586);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66686);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73393);








function Allergens(props) {
    var compileAllergensMethod = props.compileAllergensMethod, mode = props.mode, productAllergens = props.productAllergens, selectedOptions = props.selectedOptions;
    var activeAllergens = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.useSelector)(function(state) {
        return state.app.allergens;
    }).activeAllergens;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), compiledAllergens = ref[0], setCompiledAllergens = ref[1];
    var displayedTags = [];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (compileAllergensMethod) {
            var compiledAllergens = compileAllergensMethod(productAllergens, selectedOptions || [], mode);
            setCompiledAllergens(compiledAllergens);
        }
    }, [
        activeAllergens
    ]);
    if (!(activeAllergens === null || activeAllergens === void 0 ? void 0 : activeAllergens.length) || !(compiledAllergens === null || compiledAllergens === void 0 ? void 0 : compiledAllergens.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kq, {
        gap: "$1",
        children: compiledAllergens.map(function(allergen) {
            var id = Number(allergen.id);
            if (displayedTags.includes(id) || !activeAllergens.includes(id) || allergen.is_removal && mode === _constants_global__WEBPACK_IMPORTED_MODULE_4__/* .ALLERGEN_CARD_MODE.OPTIONS */ .JT.OPTIONS) {
                return null;
            }
            displayedTags.push(id);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DietaryTag, {
                children: allergen.label
            }, allergen.id);
        })
    });
}
var _background_color, _border_color, _border_radius;
var DietaryTag = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-e9f27488-0"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        backgroundColor: (_background_color = theme.dietary_preferences_tag.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        border: "1px solid",
        borderColor: (_border_color = theme.dietary_preferences_tag.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent",
        borderRadius: (_border_radius = theme.dietary_preferences_tag.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0,
        fontWeight: 500,
        padding: ".25rem"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_7__/* .getFontStyles */ .l)(theme.dietary_preferences_tag.font, {
        line_height: function() {
            return "1";
        }
    }));
});


/***/ }),

/***/ 37356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux-loading-bar/build/index.js
var build = __webpack_require__(10852);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/constants/styles.ts
var styles = __webpack_require__(30438);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/components/app/layout/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a,\n  button {\n    &:focus:not(:focus-visible) {\n      outline: none;\n    }\n  }\n\n  input:focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // Background color/image overrides\n  ",
        "\n\n  > div {\n    height: 100%;\n    margin: 0 auto;\n\n    @media print {\n      padding-top: 20px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  position: fixed;\n  width: 1px;\n  height: 1px;\n  margin: 0;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n  &:focus {\n    top: 0;\n    z-index: ",
        ";\n    height: ",
        "px;\n    padding: 0 10px;\n    clip: auto;\n    font-weight: bold;\n    line-height: ",
        "px;\n    color: ",
        ";\n    text-decoration: none;\n    width: auto;\n\n    @media (min-width: 768px) {\n      height: ",
        "px;\n      line-height: ",
        "px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject(), function(param) {
    var theme = param.theme, hasContextualCart = param.hasContextualCart;
    var primaryFont = (0,utils/* getFontStyles */.l)(theme.text.primary_font);
    var secondaryFont = (0,utils/* getFontStyles */.l)(theme.text.secondary_font);
    var _color, _fontSize, _color1, _color2, _fontSize1;
    return "\n    :root {\n      --layer-0: 0;\n      --layer-1: 1;\n      --layer-2: 2;\n      --layer-3: 3;\n      --layer-4: 4;\n      --layer-5: 5;\n      --layer-10: 10;\n      --layer-20: 20;\n      --layer-50: 50;\n      --layer-100: 100;\n\n      --neg-size-7: -1.75rem;\n      --neg-size-6: -1.5rem;\n      --neg-size-5: -1.25rem;\n      --neg-size-4: -1rem;\n      --neg-size-4: -.75rem;\n      --neg-size-2: -.5rem;\n      --neg-size-1: -.25rem;\n      --size-1: .25rem;\n      --size-2: .5rem;\n      --size-3: .75rem;\n      --size-4: 1rem;\n      --size-5: 1.25rem;\n      --size-6: 1.5rem;\n      --size-7: 1.75rem;\n      --size-8: 2rem;\n      --size-12: 3rem;\n      --size-16: 4rem;\n      --size-18: 4.5rem;\n      --size-20: 5rem;\n      --size-24: 6rem;\n      --size-32: 8rem;\n      --size-48: 12rem;\n      --size-72: 18rem;\n      --size-80: 20rem;\n      --size-96: 24rem;\n      --size-128: 32rem;\n\n      --size-xl: 32rem;\n      --size-2xl: 48rem;\n      --size-3xl: 64rem;\n      --size-4xl: 72rem;\n      --size-5xl: 96rem;\n\n      --safe-offset--ascending: 0;\n      --safe-offset--leading: 0;\n      --safe-offset--trailing: 0;\n      --safe-offset--descending: ".concat(hasContextualCart ? "var(--size-20)" : "0", ";\n\n      @media (min-width: 768px) {\n        --safe-offset--descending: 0;\n      }\n\n      /* Configs */\n      --config-text__primary-text-size: ").concat(primaryFont.fontSize, ";\n      --config-text__primary-text-color: ").concat(primaryFont.color, ";\n      --config-text__secondary-text-size: ").concat(secondaryFont.fontSize, ";\n      --config-text__secondary-text-color: ").concat(secondaryFont.color, ";\n\n      --config-global__body-color: ").concat(theme.global.body_color, ";\n      --config-global__error-color: ").concat(theme.global.error_color, ";\n      --config-global__border-radius: ").concat(theme.global.border_radius, ";\n      --config-global__loading-bar-color: ").concat(theme.global.loading_bar_color, ";\n      --config-global__primary-active-color: ").concat(theme.global.primary_active_color, ";\n      --config-global__primary-border-color: ").concat(theme.global.primary_border_color, ";\n      --config-global__secondary-body-color: ").concat(theme.global.secondary_body_color, ";\n\n      --config-primary-font-family__bold: ").concat(theme.primary_font.bold.font_family, ";\n      --config-primary-font-family__light: ").concat(theme.primary_font.light.font_family, ";\n      --config-primary-font-family__medium: ").concat(theme.primary_font.medium.font_family, ";\n      --config-primary-font-family__regular: ").concat(theme.primary_font.regular.font_family, ";\n\n      --config-secondary-font-family__bold: ").concat(theme.secondary_font.bold.font_family, ";\n      --config-secondary-font-family__light: ").concat(theme.secondary_font.light.font_family, ";\n      --config-secondary-font-family__medium: ").concat(theme.secondary_font.medium.font_family, ";\n      --config-secondary-font-family__regular: ").concat(theme.secondary_font.regular.font_family, ";\n\n      --config-primary-button__background-color: ").concat(theme.buttons.primary_button_background_color, ";\n      --config-primary-button__hover__background-color: ").concat(theme.buttons.primary_button_background_hover_color, ";\n      --config-primary-button__color: ").concat(theme.buttons.primary_font.color, ";\n\n      --badge__background-color: ").concat(theme.buttons.primary_button_background_color, ";\n      --badge__color: ").concat(theme.buttons.primary_font.color, ";\n      --badge__font-family: ").concat(theme.primary_font.regular.font_family, ";\n\n      --navigation-item__border-color: ").concat(theme.global.secondary_body_color, ";\n      --navigation-item__color: ").concat((_color = secondaryFont.color) !== null && _color !== void 0 ? _color : theme.global.primary_active_color, ";\n      --navigation-item__font-family: ").concat(theme.secondary_font.bold.font_family, ";\n      --navigation-item__font-size: ").concat((_fontSize = primaryFont.fontSize) !== null && _fontSize !== void 0 ? _fontSize : "16px", ";\n\n      --config-checkout_font_color: ").concat((_color1 = theme.checkout.font.color) !== null && _color1 !== void 0 ? _color1 : "inherit", ";\n    }\n\n    body {\n      background-color: ").concat(theme.global.body_color || styles/* COLORS.BODY */.DM.BODY, ";\n      color: ").concat((_color2 = primaryFont.color) !== null && _color2 !== void 0 ? _color2 : styles/* COLORS.TEXT */.DM.TEXT, ";\n      font-family: ").concat(theme.primary_font.regular.font_family, ";\n      font-size: ").concat((_fontSize1 = primaryFont.fontSize) !== null && _fontSize1 !== void 0 ? _fontSize1 : "16px", ";\n    }\n\n    h2 {\n      font-size: 16px;\n      font-family: ").concat(theme.primary_font.medium.font_family, ";\n      font-weight: 400;\n\n      @media (min-width: 768px) {\n        font-size: 24px;\n      }\n    }\n\n    textarea, select, input, button {\n      font-family: ").concat(theme.primary_font.regular.font_family, ";\n    }\n\n    a, button {\n      color: ").concat(primaryFont.color || styles/* COLORS.TEXT */.DM.TEXT, ";\n    }\n  ");
});
var StyledLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b552cc68-0"
})(_templateObject1());
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b552cc68-1"
})(_templateObject2(), function(param) {
    var backgroundOverride = param.backgroundOverride, theme = param.theme;
    return backgroundOverride && "\n    background-color: ".concat(theme.global.secondary_body_color, ";\n  ");
});
var AccessibilityAid = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b552cc68-2"
})(_templateObject3(), styles/* ORDER.SKIP_TO_CONTENT */.kl.SKIP_TO_CONTENT, styles/* LAYOUT.MOBILE_HEADERHEIGHT */._.MOBILE_HEADERHEIGHT, styles/* LAYOUT.MOBILE_HEADERHEIGHT */._.MOBILE_HEADERHEIGHT, styles/* COLORS.TEXT */.DM.TEXT, styles/* LAYOUT.HEADERHEIGHT */._.HEADERHEIGHT, styles/* LAYOUT.HEADERHEIGHT */._.HEADERHEIGHT);

// EXTERNAL MODULE: ./src/brand-components/index.ts + 14 modules
var brand_components = __webpack_require__(96588);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./src/utils/safePolished.ts
var safePolished = __webpack_require__(68902);
;// CONCATENATED MODULE: ./src/components/account/loyaltyNav/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-bottom: solid 1px ",
        ";\n  height: 3.75rem;\n\n  position: fixed;\n  top: var(--size-12);\n  width: 100%;\n  z-index: ",
        ";\n\n  @media (min-width: 768px) {\n    height: 5rem;\n    top: var(--size-20);\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100%;\n  justify-content: space-between;\n  margin: 0 auto;\n  max-width: ",
        "px;\n  width: 100%;\n\n  @media (max-width: 767px) {\n    align-items: center;\n    display: flex;\n    max-width: 100%;\n    overflow: scroll;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: none;\n  border: none;\n  border-top: 5px solid transparent;\n  border-bottom: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  flex: 1;\n  font-family: ",
        ";\n  font-size: ",
        "px;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  margin: 0 ",
        "px;\n\n  @media (hover: hover) {\n    &:hover {\n      border-bottom: 5px solid\n        ",
        ";\n    }\n  }\n\n  @media (max-width: 767px) {\n    flex: 0 0 auto;\n    font-size: 14px;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  padding: 3px;\n  background: ",
        ";\n  color: ",
        ";\n  text-align: center;\n  font-size: 12px;\n  margin-left: ",
        "px;\n  object-fit: contain;\n\n  @media (max-width: 767px) {\n    min-width: 24px;\n    min-height: 24px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledLoyaltyNavContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33e2749e-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.menu_categories.category_nav_background_color;
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_border_color;
}, styles/* ORDER.LOYALTY_HEADER */.kl.LOYALTY_HEADER);
var StyledLoyaltyNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33e2749e-1"
})(styles_templateObject1(), styles/* LAYOUT.MAXWIDTH */._.MAXWIDTH);
var StyledLoyaltyButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-33e2749e-2"
})(styles_templateObject2(), function(param) {
    var active = param.active, theme = param.theme;
    return "5px solid ".concat(active ? theme.global.primary_active_color : "transparent");
}, function(param) {
    var theme = param.theme;
    return theme.menu_categories.category_nav_font.color;
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.accounts.nav_font_size;
}, styles/* LAYOUT.GUTTER */._.GUTTER / 2, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
});
var StyledNavItemAndNumberContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-33e2749e-3"
})(styles_templateObject3());
var StyledLoyaltyNavNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-33e2749e-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.primary_font.color;
}, function(param) {
    var theme = param.theme;
    return (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.text.primary_font.color);
}, styles/* LAYOUT.GUTTER */._.GUTTER / 2);

// EXTERNAL MODULE: ./src/components/account/loyaltyAccessor/index.tsx
var loyaltyAccessor = __webpack_require__(51319);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/constants/cssClassNames.ts
var cssClassNames = __webpack_require__(5733);
// EXTERNAL MODULE: ./src/constants/loyalty.ts
var constants_loyalty = __webpack_require__(92106);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
// EXTERNAL MODULE: ./src/utils/loyalty.ts
var loyalty = __webpack_require__(53174);
;// CONCATENATED MODULE: ./src/components/account/loyaltyNav/index.tsx














var LoyaltyNav = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LoyaltyNav, Component);
    var _super = (0,_create_super/* default */.Z)(LoyaltyNav);
    function LoyaltyNav() {
        (0,_class_call_check/* default */.Z)(this, LoyaltyNav);
        return _super.apply(this, arguments);
    }
    var _proto = LoyaltyNav.prototype;
    _proto.render = function render() {
        var _props = this.props, activeLoyaltyTab = _props.activeLoyaltyTab, myMessages = _props.myMessages, myOffers = _props.myOffers, myRedeemables = _props.myRedeemables, loyaltyState = _props.loyaltyState;
        // Count unread personal messages
        var unreadPersonalMessagesLength = (0,loyalty/* getUnreadPersonalMessagesLength */.Xy)(myMessages);
        // Combine available rewards and offers
        var currentPoints = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points;
        var combinedRewardsLength = (0,loyalty/* getActiveRewardsAndOffersLength */.gx)(myRedeemables, myOffers, currentPoints !== null && currentPoints !== void 0 ? currentPoints : 0);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoyaltyNavContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLoyaltyNav, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                        checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                        checkName: routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoyaltyButton, {
                                active: activeLoyaltyTab === routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
                                "aria-label": "Go to Rewards page",
                                className: "".concat(cssClassNames/* CSS_CLASSES.LOYALTY.NAV_BUTTON */.Y.LOYALTY.NAV_BUTTON, " ").concat(activeLoyaltyTab === routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS && "active"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavItemAndNumberContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "rewards.title"
                                        }),
                                        combinedRewardsLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoyaltyNavNumber, {
                                            children: combinedRewardsLength
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                        checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                        checkName: routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX,
                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoyaltyButton, {
                                active: activeLoyaltyTab === routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX,
                                "aria-label": "Go to Inbox page",
                                className: "".concat(cssClassNames/* CSS_CLASSES.LOYALTY.NAV_BUTTON */.Y.LOYALTY.NAV_BUTTON, " ").concat(activeLoyaltyTab === routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX && "active"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavItemAndNumberContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "inbox.title"
                                        }),
                                        unreadPersonalMessagesLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoyaltyNavNumber, {
                                            children: unreadPersonalMessagesLength
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                        checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                        checkName: routes/* LOYALTY_ROUTES.FAVORITES */.xM.FAVORITES,
                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: routes/* LOYALTY_ROUTES.FAVORITES */.xM.FAVORITES,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoyaltyButton, {
                                active: activeLoyaltyTab === routes/* LOYALTY_ROUTES.FAVORITES */.xM.FAVORITES,
                                "aria-label": "Go to Favorites page",
                                className: "".concat(cssClassNames/* CSS_CLASSES.LOYALTY.NAV_BUTTON */.Y.LOYALTY.NAV_BUTTON, " ").concat(activeLoyaltyTab === routes/* LOYALTY_ROUTES.FAVORITES */.xM.FAVORITES && "active"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: "favorites.title"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                        checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                        checkName: routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoyaltyButton, {
                                active: activeLoyaltyTab === routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
                                "aria-label": "Go to Order History page",
                                className: "".concat(cssClassNames/* CSS_CLASSES.LOYALTY.NAV_BUTTON */.Y.LOYALTY.NAV_BUTTON, " ").concat(activeLoyaltyTab === routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY && "active"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: "order_history.title"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                        checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                        checkName: routes/* LOYALTY_ROUTES.ACCOUNT */.xM.ACCOUNT,
                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: routes/* LOYALTY_ROUTES.ACCOUNT */.xM.ACCOUNT,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoyaltyButton, {
                                active: activeLoyaltyTab === routes/* LOYALTY_ROUTES.ACCOUNT */.xM.ACCOUNT,
                                "aria-label": "Go to Account page",
                                className: "".concat(cssClassNames/* CSS_CLASSES.LOYALTY.NAV_BUTTON */.Y.LOYALTY.NAV_BUTTON, " ").concat(activeLoyaltyTab === routes/* LOYALTY_ROUTES.ACCOUNT */.xM.ACCOUNT && "active"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: "account.title"
                                })
                            })
                        })
                    })
                ]
            })
        });
    };
    return LoyaltyNav;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        myMessages: state.app.me.messages,
        myOffers: state.app.me.myOffers,
        myRedeemables: state.app.me.redeemables,
        loyaltyState: state.app.me.loyaltyState
    };
};
var connector = (0,es.connect)(mapStateToProps);
/* harmony default export */ var loyaltyNav = (connector(LoyaltyNav));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-dialog/dist/index.mjs
var dist = __webpack_require__(70241);
// EXTERNAL MODULE: ./src/components/uielements/icon/index.tsx + 20 modules
var icon = __webpack_require__(98414);
;// CONCATENATED MODULE: ./src/utils/useDialogContext.ts

var DialogContext = (0,react.createContext)({
    onCancel: function() {
        return undefined;
    }
});
var useDialogContext = function() {
    return (0,react.useContext)(DialogContext);
};

;// CONCATENATED MODULE: ./src/components/cart/close-cart.tsx



function close_cart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  color: var(--sidecart__foreground-color);\n  display: flex;\n  height: var(--size-12);\n  justify-content: center;\n  flex: none;\n  position: absolute;\n  // Move close button to left top corner if mobile view\n  left: var(--size-1);\n  top: var(--size-1);\n  width: var(--size-12);\n  z-index: var(--layer-1);\n\n  @media (min-width: 768px) {\n    background-color: var(--sidecart__background-color);\n    border-radius: 100%;\n    box-shadow: 0px 0px 8px 0px rgba(15, 15, 15, 0.19);\n    right: var(--size-6);\n    top: var(--size-6);\n    left: auto;\n  }\n"
    ]);
    close_cart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CloseCart = function(props) {
    var onCancel = useDialogContext().onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
        asChild: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onClick: onCancel
        }, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Close */.Z.Close, {
                title: "Close cart"
            })
        }))
    });
};
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-e40a7048-0"
})(close_cart_templateObject());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var sdk_dist = __webpack_require__(80684);
;// CONCATENATED MODULE: ./src/components/cart/cross-sells/cross-sells.helpers.tsx

// Create a conditionally filtered array based on whether food hall is enabled
var getfilteredCrossSells = function(data, foodHallEnabled) {
    return (data === null || data === void 0 ? void 0 : data.upsells) ? data.upsells.filter(function(upsell) {
        var ref, ref1;
        return foodHallEnabled ? (ref = upsell === null || upsell === void 0 ? void 0 : upsell.products[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.filter_tags) === null || ref1 === void 0 ? void 0 : ref1.length : true;
    }) : [];
};
var deriveCrossSellParameters = function(basketContent, quantity) {
    var productIds = basketContent.basket_items.map(function(item) {
        return item.product.id;
    });
    return {
        max_upsells: quantity,
        products: productIds,
        step: sdk_dist/* UpsellsStep.add */.p9.add,
        store_location_id: basketContent.location.id
    };
};

// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(20360);
;// CONCATENATED MODULE: ./src/components/cart/cross-sells/item.styles.ts



function item_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  margin: var(--size-1) 0 var(--size-1) 0;\n"
    ]);
    item_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function item_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: max(0.75rem, 0.75em);\n  margin: 2px 0 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  //truncate by number of lines (2)\n  @supports (display: -webkit-box) {\n    white-space: normal;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n"
    ]);
    item_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function item_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: baseline;\n  display: flex;\n  font-size: 0.75rem;\n\n  span {\n    color: rgba(49, 61, 72, 0.5);\n    line-height: 1.58;\n  }\n\n  h3 {\n    flex: 1;\n    margin: var(--size-1) 0 0;\n    text-align: left;\n    font-weight: normal;\n    font-family: ",
        ";\n  }\n"
    ]);
    item_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function item_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  aspect-ratio: 1;\n  cursor: pointer;\n  object-fit: cover;\n  transition: all 0.2s ease;\n  height: 64px;\n  width: 64px;\n  ",
        "\n\n  &:hover {\n    opacity: 0.8;\n  }\n"
    ]);
    item_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function item_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 64px;\n  width: 64px;\n  align-items: center;\n  appearance: none;\n  background: none;\n  border: none;\n  color: var(--config-primary-button__background-color, black);\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n\n  svg {\n    display: block;\n  }\n"
    ]);
    item_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var _background_color, _border_radius;
var Item = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    "data-css-override": "StyledSidecartUpsellItem"
})(function(param) {
    var theme = param.theme, _hasImage = param.hasImage, hasImage = _hasImage === void 0 ? false : _hasImage;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.sidecart.font)), {
        backgroundColor: (_background_color = theme.sidecart.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        borderRadius: "".concat((_border_radius = theme.sidecart.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        minHeight: "var(--size-20)",
        alignItems: hasImage ? "start" : "center",
        justifyContent: "center",
        border: "1px solid var(--sidecart__divider-color, transparent)",
        display: "grid",
        gridTemplateColumns: hasImage ? "var(--size-16) 1fr var(--size-16)" : "1fr var(--size-16)",
        gap: "var(--size-4)",
        overflow: "hidden",
        padding: "var(--size-2) 0 var(--size-2) var(--size-2)",
        textAlign: "left",
        width: "100%"
    });
});
var Details = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    "data-css-override": "UpsellText"
}).withConfig({
    componentId: "sc-7f809ff2-0"
})(item_styles_templateObject());
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-7f809ff2-1"
})({
    color: "inherit",
    cursor: "pointer",
    font: "inherit",
    lineHeight: "inherit",
    margin: 0
});
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-7f809ff2-2"
})(item_styles_templateObject1());
var Units = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f809ff2-3"
})(item_styles_templateObject2(), function(props) {
    return props.theme.primary_font.bold.font_family;
});
var _border_radius1;
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-7f809ff2-4"
})(item_styles_templateObject3(), function(props) {
    return "\n     border-radius: ".concat(((_border_radius1 = props.theme.sidecart.border_radius) !== null && _border_radius1 !== void 0 ? _border_radius1 : 0) / 2, "px;\n  ");
});
var QuickAddButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7f809ff2-5"
})(item_styles_templateObject4());

// EXTERNAL MODULE: ./src/constants/checkout.ts
var checkout = __webpack_require__(80420);
// EXTERNAL MODULE: ./src/redux/commerce/actions.ts
var actions = __webpack_require__(57588);
// EXTERNAL MODULE: ./src/redux/customize/actions.ts
var customize_actions = __webpack_require__(40646);
// EXTERNAL MODULE: ./src/utils/basket.ts
var basket = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/utils/imageHelper.ts
var imageHelper = __webpack_require__(70595);
;// CONCATENATED MODULE: ./src/components/cart/cross-sells/item.tsx











var Upsell = function(param) {
    var id = param.id, item = param.item, upsellId = param.upsellId, onView = param.onView, menuCategories = param.menuCategories;
    var dispatch = (0,es.useDispatch)();
    var ref = (0,react_intersection_observer/* useInView */.YD)({
        threshold: 0.5
    }), ref1 = ref.ref, inView = ref.inView;
    (0,react.useEffect)(function() {
        if (inView) {
            onView(item);
        }
    }, [
        inView
    ]);
    var isImageShown = (0,imageHelper/* hasProductImage */.dU)(item);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
        ref: ref1,
        hasImage: isImageShown,
        "data-id": item.id,
        id: "Cross-Sell-Item-".concat(id),
        "aria-label": "Click to view ".concat(item.name, " details"),
        children: [
            isImageShown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                onClick: function() {
                    dispatch(actions/* default.commerceItemCrossSellClick */.Z.commerceItemCrossSellClick(item, id));
                    dispatch(customize_actions/* default.setProduct */.Z.setProduct({
                        product: item,
                        label: checkout/* PRODUCT_LOCATION_LABELS.CROSS_SELL */.X.CROSS_SELL,
                        upsellId: upsellId,
                        menuCategories: menuCategories
                    }));
                },
                alt: item.name,
                src: (0,imageHelper/* getProductImageSrc */.Wr)(item, {
                    height: 160,
                    width: 160
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Details, {
                // @ts-expect-error styled components issue
                hasImage: !!isImageShown,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        onClick: function() {
                            dispatch(actions/* default.commerceItemCrossSellClick */.Z.commerceItemCrossSellClick(item, id));
                            dispatch(customize_actions/* default.setProduct */.Z.setProduct({
                                product: item,
                                menuCategories: menuCategories,
                                label: checkout/* PRODUCT_LOCATION_LABELS.CROSS_SELL */.X.CROSS_SELL,
                                upsellId: upsellId
                            }));
                        },
                        children: item.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: item.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Units, {
                        children: [
                            item.cost !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "$".concat((0,basket/* toDollars */.DV)(item.cost))
                            }),
                            item.pretty_calories && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.pretty_calories
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickAddButton, {
                "data-testid": "add-cross-sell-item",
                onClick: function() {
                    dispatch(actions/* default.commerceItemCrossSellClick */.Z.commerceItemCrossSellClick(item, id));
                    dispatch(customize_actions/* default.setCrossSellQuickAdd */.Z.setCrossSellQuickAdd(item, menuCategories, upsellId));
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Plus */.Z.Plus, {
                    title: item.name
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/cart/text.tsx




var Heading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-876f5443-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontFamily: "var(--config-primary-font-family__bold)",
        margin: 0
    }, (0,utils/* getFontStyles */.l)(theme.sidecart.secondary_font, {
        color: function(color) {
            if (color === "revert") {
                return "var(--sidecart__foreground-color)";
            }
            return color;
        },
        font_size: function(size) {
            if (size === "revert") {
                return "1rem";
            }
            return size;
        }
    }));
});
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-876f5443-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.sidecart.font, {
        color: function(color) {
            if (color === "revert") {
                return "var(--sidecart__foreground-color)";
            }
            return color;
        },
        font_size: function(size) {
            if (size === "revert") {
                return ".875rem";
            }
            return size;
        }
    })), {
        margin: 0
    });
});

// EXTERNAL MODULE: ./src/components/uielements/box/box.tsx + 1 modules
var box = __webpack_require__(68801);
// EXTERNAL MODULE: ./src/features/menu/service.ts
var service = __webpack_require__(50019);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/redux/conveyanceMode/reducer.ts
var reducer = __webpack_require__(16440);
// EXTERNAL MODULE: ./src/redux/upsells/actions.ts
var upsells_actions = __webpack_require__(38024);
// EXTERNAL MODULE: ./src/utils/menu.ts
var menu = __webpack_require__(682);
;// CONCATENATED MODULE: ./src/components/cart/cross-sells/cross-sells.tsx



function cross_sells_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-2);\n"
    ]);
    cross_sells_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var CrossSells = function(param) {
    var basketContent = param.basketContent, onProductVisibility = param.onProductVisibility;
    var max_cross_sells = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig.sidecart;
    }).max_cross_sells;
    var data = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.upsells.detail;
    });
    var foodHallEnabled = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig.admin.food_hall;
    });
    var time_wanted = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr).time_wanted;
    var categories = (0,service/* useMenu */.H)({
        id: basketContent.location.id,
        wantedAt: time_wanted
    }).categories;
    var dispatch = (0,redux/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (basketContent === null || basketContent === void 0 ? void 0 : basketContent.basket_items.length) {
            dispatch(// @TODO: migrate this redux slice into a react query hook
            upsells_actions/* upsellsActions.fetchUpsells */.K.fetchUpsells((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, deriveCrossSellParameters(basketContent, max_cross_sells)), {
                wanted_at: time_wanted
            })));
        }
    }, []);
    (0,react.useEffect)(function() {
        // Re-fetch cross-sells if basket items have been updated
        if (basketContent === null || basketContent === void 0 ? void 0 : basketContent.basket_items.length) {
            dispatch(upsells_actions/* upsellsActions.fetchUpsells */.K.fetchUpsells(deriveCrossSellParameters(basketContent, max_cross_sells)));
        }
    }, [
        basketContent === null || basketContent === void 0 ? void 0 : basketContent.basket_items.length
    ]);
    (0,react.useEffect)(function() {
        // The precondition for re-fetching cross-sells is that items exist in the basket
        if (basketContent === null || basketContent === void 0 ? void 0 : basketContent.basket_items.length) {
            dispatch(upsells_actions/* upsellsActions.fetchUpsells */.K.fetchUpsells(deriveCrossSellParameters(basketContent, max_cross_sells)));
        }
    }, [
        basketContent.location.id
    ]);
    var filteredItems = getfilteredCrossSells(data, foodHallEnabled);
    // Canonical upsells array for both the foodHallEnabled / disabled cases
    if (!(filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.x, {
        overrides: {
            backgroundColor: "var(--sidecart__secondary-background-color)",
            borderBlockStart: "1px solid var(--sidecart__divider-color)",
            flex: "1",
            padding: "0 var(--size-5)",
            position: "relative"
        },
        "data-css-override": "StyledCheckoutUpsell",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
                overrides: {
                    padding: "var(--size-4) 0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "cross_sell.header",
                        html: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSellItemsContainer, {
                children: filteredItems.slice(0, max_cross_sells).map(function(upsell, arrayIndex) {
                    // Only support the Add On upsell type for now, others will require special cart actions.
                    if (upsell.type === "addon") {
                        return upsell.products.map(menu/* augmentMenuProduct */.P_).map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Upsell, {
                                item: item,
                                id: arrayIndex + index,
                                upsellId: data === null || data === void 0 ? void 0 : data.id,
                                // menu categories are passed all the way through to the setCrossSellQuickAdd saga in order to add cross sells correctly
                                menuCategories: categories,
                                onView: function(product) {
                                    var ref;
                                    onProductVisibility({
                                        product: product,
                                        id: (ref = data === null || data === void 0 ? void 0 : data.id) !== null && ref !== void 0 ? ref : "0"
                                    });
                                }
                            }, item.id);
                        });
                    }
                })
            })
        ]
    });
};
var CrossSellItemsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cb234ce-0"
})(cross_sells_templateObject());

// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/analytics/events/constants.ts
var constants = __webpack_require__(45048);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
;// CONCATENATED MODULE: ./src/components/uielements/button/button.styles.ts

function button_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  appearance: none;\n  background: none;\n  border: none;\n  color: var(--config-global__primary-active-color);\n  cursor: pointer;\n  font-family: var(--config-primary-font-family__bold);\n  font-size: 14px;\n  padding: 0;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ",
        "\n"
    ]);
    button_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Element = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-eee92fca-0"
})(button_styles_templateObject(), function(param) {
    var styles = param.styles;
    return styles;
});

;// CONCATENATED MODULE: ./src/components/uielements/button/button.tsx





var button_Button = function(_param) {
    var children = _param.children, _overrides = _param.overrides, overrides = _overrides === void 0 ? {} : _overrides, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "overrides"
    ]);
    return(// @ts-ignore
    /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        styles: overrides
    }, otherProps), {
        children: children
    })));
};

// EXTERNAL MODULE: ./src/components/uielements/stack/stack.tsx + 2 modules
var stack = __webpack_require__(45866);
// EXTERNAL MODULE: ./src/constants/events.ts
var constants_events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/redux/global/actions.ts
var global_actions = __webpack_require__(79118);
;// CONCATENATED MODULE: ./src/components/cart/delivery-details.tsx













var DeliveryDetails = function() {
    var ref;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var onCancel = useDialogContext().onCancel;
    var fulfillment = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket.fulfillment;
    });
    var strings = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.strings;
    });
    var location = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket.location;
    });
    if (!(fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.address) || fulfillment.type !== sdk_dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
                direction: "vertical",
                gap: "var(--size-1)",
                align: "leading",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "cart_checkout.delivery_address_header"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stack/* Stack */.K, {
                        align: "leading",
                        direction: "vertical",
                        gap: "0",
                        overrides: {
                            color: "#595959",
                            fontSize: ".875rem"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                children: [
                                    fulfillment.address.street_address,
                                    fulfillment.address.street_address_2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            fulfillment.address.street_address_2
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "".concat(fulfillment.address.city, ", ").concat(fulfillment.address.state || "", " ").concat(fulfillment.address.zip_code)
                                ]
                            })
                        })
                    })
                ]
            }),
            ((ref = strings.cart_checkout) === null || ref === void 0 ? void 0 : ref.change_location_cta) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_Button, {
                onClick: function() {
                    // TODO: Remove that function call when all modal changes go out.
                    // That call is temp fix for focus tab when we have sidecart open and trying to open delivery modal
                    onCancel();
                    dispatch(global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal(true, location, sdk_dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY)), (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                        name: constants/* EventNames.CHANGE_DELIVERY_ADDRESS */.V.CHANGE_DELIVERY_ADDRESS,
                        details: constants_events/* K_ANALYTICS_CTA_LOCATIONS.SIDECART */.tG.SIDECART
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "cart_checkout.change_delivery_address_cta"
                })
            })
        ]
    });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a803b21-0"
})({
    display: "flex",
    flexDirection: "row",
    alignItems: "start",
    gap: "var(--size-1)",
    borderTop: "1px solid var(--sidecart__divider-color)",
    width: "100%",
    padding: "var(--size-6)",
    // Move Change Location CTA to right side to create more space in side cart when mobile view
    "& > :last-child": {
        marginLeft: "auto"
    },
    "@media (min-width: 768px)": {
        flexDirection: "column",
        padding: "var(--size-6) var(--size-24) var(--size-6) var(--size-6)",
        "& > :last-child": {
            marginLeft: 0
        }
    }
});
var Address = styled_components_browser_esm/* default.address.withConfig */.ZP.address.withConfig({
    componentId: "sc-6a803b21-1"
})({
    fontStyle: "normal"
});

// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(87809);
;// CONCATENATED MODULE: ./src/components/cart/footer.tsx



function footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-block-start: 1px solid var(--sidecart__divider-color);\n  display: flex;\n  flex-direction: column;\n  padding: var(--size-3) var(--size-6) var(--size-3);\n  gap: var(--size-3);\n"
    ]);
    footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function footer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var Footer = function(param) {
    var subtotal = param.subtotal, isCheckoutDisabled = param.isCheckoutDisabled;
    var onCancel = useDialogContext().onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Continue, {
                    "data-testid": "go-to-checkout-button",
                    // @ts-expect-error
                    disabled: isCheckoutDisabled,
                    "aria-disabled": isCheckoutDisabled,
                    size: "large",
                    onClick: function() {
                        if (!isCheckoutDisabled) {
                            (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.clickCheckOut */.cE.clickCheckOut);
                            onCancel();
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "cart_checkout.continue_to_checkout_cta",
                        dataObj: {
                            subtotal: "$".concat((0,basket/* toDollars */.DV)(subtotal))
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel, {
                onClick: onCancel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "cart_checkout.back_to_menu_cta"
                })
            })
        ]
    });
};
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3a69de27-0"
})(footer_templateObject());
var Continue = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).attrs({
    "data-css-override": "StyledCheckoutButton StyledPrimaryButton"
}).withConfig({
    componentId: "sc-3a69de27-1"
})(footer_templateObject1(), function(props) {
    return props.disabled && "\n      opacity: 0.8;\n      pointer-events: none;\n    ";
});
var Cancel = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3a69de27-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        appearance: "none",
        background: "none",
        border: "none",
        cursor: "pointer",
        display: "none",
        height: "var(--size-10)",
        transition: "opacity 0.2s ease"
    }, (0,utils/* getFontStyles */.l)(theme.sidecart.font, [
        "color",
        "font_family",
        "font_style",
        "line_height", 
    ])), {
        "&:hover": {
            opacity: 0.7
        },
        "@media (min-width: 768px)": {
            display: "block"
        }
    });
});

// EXTERNAL MODULE: ./src/components/cart/items.tsx + 1 modules
var cart_items = __webpack_require__(47971);
// EXTERNAL MODULE: ./src/components/featureAccessor/index.tsx
var featureAccessor = __webpack_require__(88917);
// EXTERNAL MODULE: ./src/components/uielements/render.tsx
var render = __webpack_require__(45190);
// EXTERNAL MODULE: ./src/constants/features.ts
var features = __webpack_require__(51710);
// EXTERNAL MODULE: ./src/features/configs/organization.ts
var organization = __webpack_require__(5981);
;// CONCATENATED MODULE: ./src/components/cart/location.tsx

function location_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  // if fulfillment type is delivery and mobile view - don't surface order location\n  // and delivery address at the same time to save space in side cart\n  display: var(--location-wrapper__display-value);\n  flex-direction: row;\n  align-items: start;\n  gap: var(--size-1);\n  width: 100%;\n  padding: var(--size-6);\n\n  // change location CTA is moved to right side to create more space in side cart if mobile view\n  & > :last-child {\n    margin-left: auto;\n  }\n\n  @media (min-width: 768px) {\n    --location-wrapper__display-value: flex;\n    flex-direction: column;\n    padding-right: var(--size-24);\n\n    & > :last-child {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    location_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var Location = function() {
    var ref, ref1;
    var ref2 = (0,es.useSelector)(function(state) {
        return state.app.basket;
    }), location = ref2.location, fulfillment = ref2.fulfillment;
    var ref3 = (0,organization/* useOrganization */.o)(), orgData = ref3.data;
    var isSingleLocationEnabled = orgData === null || orgData === void 0 ? void 0 : orgData.locations.features.isSingleLocation.enabled;
    var onCancel = useDialogContext().onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(location_Wrapper, {
        fulfillmentType: fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.type,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
                align: "leading",
                direction: "vertical",
                gap: "var(--size-1)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                        children: "Ordering from:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
                        align: "leading",
                        direction: "vertical",
                        gap: "0",
                        overrides: {
                            color: "#595959",
                            fontSize: ".875rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                children: location === null || location === void 0 ? void 0 : (ref = location.cached_data) === null || ref === void 0 ? void 0 : ref.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                children: location === null || location === void 0 ? void 0 : (ref1 = location.cached_data) === null || ref1 === void 0 ? void 0 : ref1.phone_number
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                featureFlag: [
                    features/* FEATURE_FLAGS.GLOBAL__LOCATIONS_PAGE */.y8.GLOBAL__LOCATIONS_PAGE,
                    features/* FEATURE_FLAGS.CART__CHANGE_LOCATION */.y8.CART__CHANGE_LOCATION, 
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                    condition: !isSingleLocationEnabled,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_Button, {
                            "data-testid": "change-location-button",
                            onClick: function() {
                                onCancel();
                                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                                    name: constants/* EventNames.CHANGE_LOCATION */.V.CHANGE_LOCATION,
                                    details: constants_events/* K_ANALYTICS_CTA_LOCATIONS.SIDECART */.tG.SIDECART
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "cart_checkout.change_location_cta"
                            })
                        })
                    })
                })
            })
        ]
    });
};
var location_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6371b48-0"
})(location_templateObject(), function(param) {
    var fulfillmentType = param.fulfillmentType;
    return "--location-wrapper__display-value: ".concat(fulfillmentType === sdk_dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY ? "none" : "flex");
});

// EXTERNAL MODULE: ./src/redux/basket/index.ts
var redux_basket = __webpack_require__(52912);
// EXTERNAL MODULE: ./src/redux/basket/reducer.ts
var basket_reducer = __webpack_require__(62152);
// EXTERNAL MODULE: ./src/redux/cmsConfig/index.ts
var cmsConfig = __webpack_require__(26738);
// EXTERNAL MODULE: ./src/redux/menu/reducer.ts
var menu_reducer = __webpack_require__(88068);
// EXTERNAL MODULE: ./src/redux/tags/actions.ts
var tags_actions = __webpack_require__(28799);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(54073);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/utils/useMergeDebounceListener.ts


/**
 * Provides an abstraction to debounce & merge (a.k.a buffer) events in a react compatible way.
 *
 * The following will create a buffered listener function that will merge all calls made to that
 * listener function within the duration and report the args back to the callback as an array
 *
 * ```
 * const { listener } = useMergeDebounceListener(
    1000,
    ([item1, item2]) => {
      // do something with all the items
    },
    []
  );

  listener(item1)
  // 200ms pass...
  listener(item2)
 * ```
 */ var useMergeDebounceListener = function(duration, callback, deps) {
    var buffer = [];
    var merge = function(fn) {
        return function(item) {
            buffer.push(item);
            fn(buffer);
        };
    };
    var listener = (0,react.useCallback)(merge(debounce_default()(function(items) {
        callback(items);
        buffer = [];
    }, duration)), deps);
    return {
        listener: listener
    };
};

;// CONCATENATED MODULE: ./src/components/cart/contents.tsx


function contents_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  border-block-start: 1px solid var(--sidecart__divider-color);\n  color: #595959;\n  font-family: ",
        ";\n  font-size: 0.875rem;\n  padding: var(--size-4) var(--size-6);\n  text-align: left;\n  text-decoration: none;\n  width: 100%;\n\n  &:hover {\n    opacity: 0.8;\n    cursor: pointer;\n  }\n"
    ]);
    contents_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function contents_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  height: 100%;\n  overflow-y: scroll;\n"
    ]);
    contents_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function contents_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-block-start: 1px solid var(--sidecart__divider-color);\n  display: flex;\n  flex-direction: column;\n"
    ]);
    contents_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function contents_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--sidecart__background-color);\n  position: sticky;\n  bottom: 0;\n"
    ]);
    contents_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function contents_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  color: white;\n  display: flex;\n  line-height: 1.1;\n  justify-content: center;\n  padding: var(--size-2);\n  position: sticky;\n  bottom: 0;\n  text-align: center;\n  width: 100%;\n"
    ]);
    contents_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




















var Contents = function() {
    var onCancel = useDialogContext().onCancel;
    var ref = (0,es.useSelector)(basket_reducer/* selectCart */.KY), deliveryMinimum = ref.deliveryMinimum, groupedItems = ref.groupedItems, isCheckoutDisabled = ref.isCheckoutDisabled, items = ref.items, requiresDeliveryMinimum = ref.requiresDeliveryMinimum, showFoodHalls = ref.showFoodHalls, showUpsells = ref.showUpsells, subtotal = ref.subtotal;
    var ref1 = (0,es.useSelector)(redux_basket/* selectBasketSlice */.p), basketContent = ref1.content;
    var strings = (0,cmsConfig/* useStrings */.EL)();
    var basketMenu = (0,es.useSelector)(menu_reducer/* selectMenuSlice */.e_).basketMenu;
    var ref2 = (0,react.useState)([]), upsellsSentToAnalytics = ref2[0], setUpsellsSentToAnalytics = ref2[1];
    var dispatch = (0,es.useDispatch)();
    var handleTagNameLink = function(tagName, tag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagName, {
            onClick: function() {
                dispatch(tags_actions/* default.setActiveTag */.Z.setActiveTag(tag));
                onCancel();
            },
            children: tagName
        });
    };
    var ref3 = useMergeDebounceListener(1000, function(items) {
        var visibleUpsells = items.map(function(item) {
            return item.product;
        }).filter(function(product) {
            return !upsellsSentToAnalytics.includes(product.id);
        });
        if (visibleUpsells.length) {
            (0,koalaAnalytics/* fireKAnalyticsUpsellEvent */.xq)(items[0].id, visibleUpsells);
        }
        setUpsellsSentToAnalytics((0,_to_consumable_array/* default */.Z)(upsellsSentToAnalytics).concat((0,_to_consumable_array/* default */.Z)(visibleUpsells.map(function(product) {
            return product.id;
        }))));
    }, [
        upsellsSentToAnalytics
    ]), onProductVisibility = ref3.listener;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Location, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryDetails, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
                        overrides: {
                            padding: "var(--size-4) var(--size-6)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                            className: "koala__ui-side_cart-items-header-h3",
                            "data-css-override": "StyledSubheader",
                            children: strings.cart_checkout.cart_items_header
                        })
                    }),
                    showFoodHalls ? Object.keys(groupedItems).map(function(tagName, index) {
                        var ref, ref1;
                        // @ts-expect-error
                        var group = groupedItems[tagName];
                        var tag = (ref = group[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.menuProduct) === null || ref1 === void 0 ? void 0 : ref1.filter_tags[0];
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                handleTagNameLink(tagName, tag),
                                basketMenu.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_items/* Items */.ob, {
                                    items: group
                                })
                            ]
                        }, "".concat(tag, "-").concat(index));
                    }) : // @ts-expect-error: mismatched types
                    basketMenu.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_items/* Items */.ob, {
                        items: items
                    }),
                    showUpsells && /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSells, {
                        basketContent: basketContent,
                        onProductVisibility: onProductVisibility
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_Footer, {
                children: [
                    requiresDeliveryMinimum && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryMinimumMessage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "cart_checkout.delivery_min_not_met_message",
                            dataObj: {
                                delivery_minimum: deliveryMinimum
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        subtotal: subtotal,
                        isCheckoutDisabled: isCheckoutDisabled
                    })
                ]
            })
        ]
    });
};
var StyledTagName = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    "data-css-override": "StyledTagName"
}).withConfig({
    componentId: "sc-36c6f4ad-0"
})(contents_templateObject(), function(props) {
    return props.theme.primary_font.medium.font_family;
});
var contents_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-36c6f4ad-1"
})(contents_templateObject1());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-36c6f4ad-2"
})(contents_templateObject2());
var contents_Footer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-36c6f4ad-3"
})(contents_templateObject3());
var DeliveryMinimumMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-36c6f4ad-4"
})(contents_templateObject4(), function(props) {
    return props.theme.global.primary_active_color;
});

// EXTERNAL MODULE: ./src/components/content/stitches.ts
var stitches = __webpack_require__(65465);
;// CONCATENATED MODULE: ./src/components/uielements/space/space.tsx

var Space = (0,stitches/* styled */.zo)("div", {
    flex: 1
});

;// CONCATENATED MODULE: ./src/components/cart/empty-cart.tsx

function empty_cart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--sidecart__secondary-foreground-color);\n  font-family: var(--config-secondary-font-family__bold);\n  font-size: 2rem;\n  line-height: 1.1;\n  margin: 0;\n  text-align: center;\n"
    ]);
    empty_cart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function empty_cart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    empty_cart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function empty_cart_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: var(--size-2);\n  width: 100%;\n"
    ]);
    empty_cart_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var EmptyCart = function() {
    var onCancel = useDialogContext().onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Space, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
                align: "center",
                position: "center",
                direction: "vertical",
                overrides: {
                    borderBlockStart: "1px solid var(--sidecart__divider-color)",
                    height: "100%",
                    padding: "var(--size-6)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: empty_cart_Title,
                        accessor: "empty_cart.header",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: empty_cart_Description,
                        accessor: "empty_cart.subheader",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(empty_cart_Button, {
                        onClick: onCancel,
                        "arial-label": "Close Basket",
                        buttonTheme: "secondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "empty_cart.back_cta"
                        })
                    })
                ]
            })
        ]
    });
};
var empty_cart_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-10eb1f52-0"
})(empty_cart_templateObject());
var empty_cart_Description = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-10eb1f52-1"
})(empty_cart_templateObject1());
var empty_cart_Button = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-10eb1f52-2"
})(empty_cart_templateObject2());

// EXTERNAL MODULE: ./src/utils/useAnimatedVisibility.ts
var useAnimatedVisibility = __webpack_require__(80378);
;// CONCATENATED MODULE: ./src/components/cart/cart.tsx



function cart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  background: rgba(26, 26, 26, 0.16);\n  bottom: 0;\n  left: 0;\n  opacity: var(--sidecart-overlay__opacity);\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: all 0.4s ease;\n  z-index: 0;\n"
    ]);
    cart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var CartProvider = function(param) {
    var children = param.children, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContext.Provider, {
        value: {
            onCancel: onCancel
        },
        children: children
    });
};
var Cart = function() {
    var ref = (0,useAnimatedVisibility/* useAnimatedVisibility */.p)(), isMounted = ref.isMounted, shouldDisplay = ref.shouldDisplay, toggle = ref.toggle, ref1 = ref.ref;
    var basketOpen = (0,es.useSelector)(function(state) {
        return state.app.global.basketOpen;
    });
    var ref2 = (0,es.useSelector)(function(state) {
        return state.app.basket;
    }), location = ref2.location, basketContent = ref2.content;
    var dispatch = (0,es.useDispatch)();
    var hasItems = !!(basketContent && basketContent.basket_items.length);
    var isLocationDisabled = (location === null || location === void 0 ? void 0 : location.id) && !location.provider_enabled || false;
    var closeCart = function() {
        toggle();
        dispatch(global_actions/* default.toggleBasket */.Z.toggleBasket(false));
    };
    (0,react.useEffect)(function() {
        if (basketOpen) {
            toggle();
        }
    }, [
        basketOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Root */.fC, {
        open: isMounted,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Portal */.h_, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_Container, {
                // @ts-expect-error: refs are badly typed
                ref: ref1,
                shouldDisplay: shouldDisplay,
                hasItems: hasItems,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                        shouldDisplay: shouldDisplay,
                        "data-testid": "sidecart-overlay"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProvider, {
                        onCancel: function() {
                            closeCart();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel, {
                            className: cssClassNames/* CSS_CLASSES.SIDECART.CONTAINER */.Y.SIDECART.CONTAINER,
                            shouldDisplay: shouldDisplay,
                            onEscapeKeyDown: closeCart,
                            onPointerDownOutside: closeCart,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_Title, {
                                    children: [
                                        "Ordering from ",
                                        location.label
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseCart, {}),
                                !isLocationDisabled && hasItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Contents, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCart, {})
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var cart_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68f19775-0"
})(function(param) {
    var theme = param.theme, shouldDisplay = param.shouldDisplay, hasItems = param.hasItems;
    var primary = (0,utils/* getFontStyles */.l)(theme.sidecart.font);
    var secondary = (0,utils/* getFontStyles */.l)(theme.sidecart.secondary_font);
    var _background_color, _color, _color1, _border_color;
    return {
        "--sidecart__background-color": hasItems ? (_background_color = theme.sidecart.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent" : theme.sidecart.background_color_no_items,
        "--sidecart__secondary-background-color": theme.sidecart.background_color_no_items,
        "--sidecart__foreground-color": (_color = primary.color) !== null && _color !== void 0 ? _color : "black",
        "--sidecart__secondary-foreground-color": (_color1 = secondary.color) !== null && _color1 !== void 0 ? _color1 : "black",
        "--sidecart__divider-color": (_border_color = theme.sidecart.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent",
        "--sidecart-container__opacity": shouldDisplay ? 1 : 0.01,
        alignItems: "stretch",
        bottom: 0,
        display: " flex",
        justifyContent: " flex-end",
        left: 0,
        placeItems: "center",
        position: "fixed",
        right: 0,
        top: 0,
        transition: "all 0.6s linear",
        zIndex: styles/* ORDER.CART */.kl.CART
    };
});
var Overlay = (0,styled_components_browser_esm/* default */.ZP)(dist/* Overlay */.aV).withConfig({
    componentId: "sc-68f19775-1"
})(cart_templateObject(), function(param) {
    var shouldDisplay = param.shouldDisplay;
    return "\n    --sidecart-overlay__opacity: ".concat(shouldDisplay ? 1 : 0.01, ";\n  ");
});
var Panel = (0,styled_components_browser_esm/* default */.ZP)(dist/* Content */.VY).withConfig({
    componentId: "sc-68f19775-2"
})(function(param) {
    var shouldDisplay = param.shouldDisplay, theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        backgroundColor: "var(--sidecart__background-color)",
        color: "var(--sidecart__foreground-color)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        transform: "translateY(".concat(shouldDisplay ? "0%" : "100%", ")"),
        transition: "all 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
        width: "100%",
        zIndex: 1
    }, (0,utils/* getFontStyles */.l)(theme.sidecart.font)), {
        "&:focus": {
            outline: "none"
        },
        "@media (min-width: 768px)": {
            transform: "translateX(".concat(shouldDisplay ? "0" : "100%", ") translateY(0%)"),
            width: "var(--size-96)"
        }
    });
});
var cart_Title = (0,styled_components_browser_esm/* default */.ZP)(dist/* Title */.Dx).withConfig({
    componentId: "sc-68f19775-3"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.sidecart.secondary_font, [
        "color",
        "font_size",
        "font_weight", 
    ])), {
        fontFamily: theme.primary_font.bold.font_family,
        margin: 0,
        overflow: "hidden",
        padding: "var(--size-4) var(--size-12)",
        textAlign: "center",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        "@media (min-width: 768px)": {
            display: "none"
        }
    });
});

;// CONCATENATED MODULE: ./src/components/cart/contextual-cart/contextual-cart.styles.ts


function contextual_cart_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  background-color: var(--contextual-cart-container__background-color);\n  border-top: 1px solid var(--contextual-cart-container__border-color);\n  height: 100%;\n  bottom: 0;\n  height: var(--size-20);\n  overflow: hidden;\n  padding: var(--size-4);\n  position: sticky;\n  transform: translateY(var(--contextual-cart-container__translate-y));\n  transition: all 0.3s cubic-bezier(0.87, 0, 0.13, 1);\n  width: 100%;\n"
    ]);
    contextual_cart_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function contextual_cart_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: grid;\n  grid-template-columns: 1;\n  grid-template-rows: 1;\n  height: var(--size-6);\n\n  svg,\n  img {\n    grid-column: 1 / -1;\n    grid-row: 1 / -1;\n    transition: opacity 0.3s cubic-bezier(0.87, 0, 0.13, 1);\n  }\n\n  svg,\n  img {\n    height: var(--size-6);\n    object-fit: contain;\n    width: var(--size-6);\n  }\n\n  svg:nth-child(1),\n  img:nth-child(1) {\n    opacity: var(--contextual-cart-icon__default__opacity);\n  }\n\n  svg:nth-child(2),\n  img:nth-child(2) {\n    opacity: var(--contextual-cart-icon__adding__opacity);\n  }\n"
    ]);
    contextual_cart_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function contextual_cart_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  overflow: hidden;\n\n  span {\n    display: block;\n    grid-column: 1 / -1;\n    grid-row: 1 / -1;\n    transition: all 0.3s cubic-bezier(0.68, -0.6, 0.32, 1.6);\n  }\n"
    ]);
    contextual_cart_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function contextual_cart_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  transform: translateY(var(--contextual-cart-text-default__translateY));\n"
    ]);
    contextual_cart_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function contextual_cart_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  transform: translateY(var(--contextual-cart-text-adding__translateY));\n"
    ]);
    contextual_cart_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        '\n\n  align-items: center;\n  display: flex;\n  height: var(--size-8);\n  font-weight: 700;\n  justify-content: center;\n  position: relative;\n  width: var(--size-8);\n\n  &:before {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 100%;\n    content: "";\n    height: 100%;\n    position: absolute;\n    transform: scale(var(--contextual-cart-count__scale));\n    transition: transform 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);\n    width: 100%;\n    z-index: 0;\n  }\n\n  & > span {\n    opacity: var(--contextual-cart-count__opacity);\n    position: relative;\n    transition: opacity 0.4s 0.15s cubic-bezier(0.87, 0, 0.13, 1);\n    z-index: 1;\n  }\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var contextual_cart_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89735991-0"
})(contextual_cart_styles_templateObject(), function(param) {
    var isVisible = param.isVisible, theme = param.theme;
    return "\n    --contextual-cart-container__background-color: ".concat(theme.global.body_color || styles/* COLORS.BODY */.DM.BODY, ";\n    --contextual-cart-container__border-color: ").concat(theme.global.primary_border_color || styles/* COLORS.LIGHTGRAY */.DM.LIGHTGRAY, ";\n\n    --contextual-cart-container__translate-y: ").concat(isVisible ? "0%" : "100%", ";\n  ");
});
var CartButton = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs(function() {
    return {
        "aria-label": "View cart"
    };
})(function(param) {
    var theme = param.theme, isAdding = param.isAdding;
    return (0,_object_spread/* default */.Z)({
        alignItems: "center",
        backgroundColor: isAdding ? theme.global.success_color : theme.buttons.primary_button_background_color,
        borderColor: isAdding ? theme.global.success_color : theme.buttons.primary_button_border_color,
        borderRadius: "".concat(theme.buttons.primary_button_border_radius, "px"),
        borderStyle: "solid",
        borderWidth: 1,
        display: "grid",
        gridTemplateColumns: "var(--size-8) 1fr var(--size-8)",
        height: "".concat(theme.forms.field_height, "px"),
        padding: "0 var(--size-3) 0 var(--size-3)",
        transition: "all .3s cubic-bezier(0.87, 0, 0.13, 1)",
        width: "100%"
    }, (0,utils/* getFontStyles */.l)(theme.buttons.primary_font, {
        color: function(value) {
            if (value === "revert" || value === null) {
                return (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.buttons.primary_button_background_color);
            }
            return value;
        },
        font_size: function() {
            return theme.forms.font.font_size;
        }
    }));
});
var CartIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89735991-1"
})(contextual_cart_styles_templateObject1(), function(param) {
    var isAdding = param.isAdding;
    return "\n    --contextual-cart-icon__default__opacity: ".concat(isAdding ? 0 : 1, ";\n    --contextual-cart-icon__adding__opacity: ").concat(isAdding ? 1 : 0, ";\n  ");
});
var CartText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89735991-2"
})(contextual_cart_styles_templateObject2());
var CartTextDefault = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-89735991-3"
})(contextual_cart_styles_templateObject3(), function(param) {
    var isAdding = param.isAdding;
    return "\n    --contextual-cart-text-default__translateY: ".concat(isAdding ? "-100%" : "0%", ";\n  ");
});
var CartTextAdding = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-89735991-4"
})(contextual_cart_styles_templateObject4(), function(param) {
    var isAdding = param.isAdding;
    return "\n    --contextual-cart-text-adding__translateY: ".concat(isAdding ? "0%" : "100%", ";\n  ");
});
var CartCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-89735991-5"
})(_templateObject5(), function(param) {
    var isVisible = param.isVisible;
    return "\n    --contextual-cart-count__scale: ".concat(isVisible ? 1 : 0, ";\n    --contextual-cart-count__opacity: ").concat(isVisible ? 1 : 0, ";\n  ");
});

// EXTERNAL MODULE: ./src/components/account/uielements/index.tsx + 1 modules
var uielements = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/redux/basket/actions.ts
var basket_actions = __webpack_require__(29682);
// EXTERNAL MODULE: ./src/utils/locations.ts + 2 modules
var locations = __webpack_require__(52591);
;// CONCATENATED MODULE: ./src/components/cart/contextual-cart/index.tsx













var Drawer = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var isVisible = param.isVisible, isAdding = param.isAdding, itemCount = param.itemCount, showCart = param.showCart;
    /*
     * Per the useState documentation:
     * The initialState argument is the state used during the initial render. In subsequent renders, it is disregarded.
     * [...] you may provide a function instead, which will be executed only on the initial render
     *
     * https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
     *
     * we also need the process.browser check here so this doesn't run on the server
     */ var _$ref = (0,react.useState)(function() {
        return  true ? document.createElement("div") : 0;
    }), container = _$ref[0];
    (0,react.useEffect)(function() {
        if (container) {
            document.body.appendChild(container);
        }
        return function() {
            container && document.body.removeChild(container);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contextual_cart_styles_Container, {
        // @ts-expect-error ref type mismatch.
        ref: ref,
        isVisible: isVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartButton, {
            isAdding: isAdding,
            onClick: showCart,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartIcon, {
                    isAdding: isAdding,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedCartIcon */.ug, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.CheckMark */.Z.CheckMark, {
                            title: "Checkmark icon"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartText, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartTextDefault, {
                            isAdding: isAdding,
                            children: "View Cart"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartTextAdding, {
                            isAdding: isAdding,
                            children: "Item Added to Cart"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartCount, {
                    isVisible: isVisible,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: itemCount
                    })
                })
            ]
        })
    });
});
Drawer.displayName = "Drawer";
var ContextualCart = function() {
    var ref = (0,useAnimatedVisibility/* useAnimatedVisibility */.p)(), isMounted = ref.isMounted, shouldDisplay = ref.shouldDisplay, ref1 = ref.ref, toggle = ref.toggle;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,redux/* useDispatch */.I0)();
    var basket_items = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket.content;
    }).basket_items;
    var ref2 = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket;
    }), itemAdded = ref2.itemAdded, location = ref2.location;
    var basketOpen = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.global;
    }).basketOpen;
    var webConfig = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }).webConfig;
    (0,react.useEffect)(function() {
        if ((basket_items === null || basket_items === void 0 ? void 0 : basket_items.length) && !isMounted) {
            toggle();
        }
    }, [
        basket_items
    ]);
    (0,react.useEffect)(function() {
        var timeout;
        if (itemAdded) {
            timeout = setTimeout(function() {
                dispatch(basket_actions/* default.basketItemSuccess */.Z.basketItemSuccess(false));
            }, 2500);
        }
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        itemAdded
    ]);
    (0,react.useEffect)(function() {
        var timeout;
        var ref;
        var itemCount = (ref = basket_items === null || basket_items === void 0 ? void 0 : basket_items.length) !== null && ref !== void 0 ? ref : 0;
        if (!basketOpen && !isMounted && itemCount > 0) {
            // the timeout is for the animation transition between the side cart and sticky cta
            timeout = setTimeout(toggle, 150);
        }
        if (!basketOpen && isMounted && itemCount === 0) {
            toggle();
        }
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        basketOpen,
        basket_items
    ]);
    return isMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer, {
        ref: ref1,
        isVisible: shouldDisplay,
        isAdding: itemAdded,
        itemCount: (0,basket/* getBasketItemsCountWithQuantity */.ti)(basket_items),
        showCart: function() {
            toggle();
            if (router.pathname === routes/* ROUTES.STORE */.Z6.STORE) {
                dispatch(global_actions/* default.toggleBasket */.Z.toggleBasket(true));
            } else {
                void router.push("/store/".concat((0,locations/* getLocationId */.By)(location, webConfig), "/").concat(location.label, "?openCart=true"), undefined, {
                    shallow: true
                });
            }
        }
    }) : null;
};

// EXTERNAL MODULE: ./src/components/image/index.tsx
var components_image = __webpack_require__(79743);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 5 modules
var ui = __webpack_require__(49586);
;// CONCATENATED MODULE: ./src/components/uielements/social/facebook.tsx




var Facebook = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9898 13.1716V19.2H10.2206V13.1716H7.91998V10.7273H10.2206V9.83792C10.2206 6.53614 11.5999 4.80005 14.5182 4.80005C15.4129 4.80005 15.6366 4.94384 16.1265 5.061V7.47875C15.578 7.38289 15.4235 7.32963 14.8537 7.32963C14.1774 7.32963 13.8153 7.52135 13.4851 7.89946C13.1549 8.27756 12.9898 8.93259 12.9898 9.86987V10.7326H16.1265L15.2851 13.177H12.9898V13.1716Z",
                fill: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/social/instagram.tsx




var Instagram = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7929 19.2H7.2067C5.88202 19.2 4.7998 18.1178 4.7998 16.7931V7.20695C4.7998 5.88227 5.88202 4.80005 7.2067 4.80005H16.7929C18.1176 4.80005 19.1998 5.88227 19.1998 7.20695V16.7931C19.1998 18.1237 18.1235 19.2 16.7929 19.2ZM12.0027 15.6991C11.0151 15.6991 10.0867 15.3147 9.38886 14.6169C8.69103 13.919 8.30664 12.9906 8.30664 12.003C8.30664 11.0154 8.69103 10.0869 9.38886 9.3891C10.0867 8.69128 11.0151 8.30688 12.0027 8.30688C12.9903 8.30688 13.9188 8.69128 14.6166 9.3891C15.3144 10.0869 15.6988 11.0154 15.6988 12.003C15.6988 12.9906 15.3144 13.919 14.6166 14.6169C13.9129 15.3147 12.9903 15.6991 12.0027 15.6991ZM12.0027 9.09341C10.4001 9.09341 9.09317 10.3944 9.09317 12.003C9.09317 13.6056 10.3942 14.9126 12.0027 14.9126C13.6054 14.9126 14.9123 13.6115 14.9123 12.003C14.9064 10.4004 13.6054 9.09341 12.0027 9.09341ZM17.1288 7.47578C17.1288 7.86772 16.8111 8.18545 16.4191 8.18545C16.0272 8.18545 15.7095 7.86772 15.7095 7.47578C15.7095 7.08384 16.0272 6.76611 16.4191 6.76611C16.8111 6.76611 17.1288 7.08384 17.1288 7.47578Z",
                fill: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/social/tiktok.tsx




var Tiktok = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.9327 5.34784L14.5852 4.80005H12.4828V9.73371L12.4756 14.5528C12.4792 14.5886 12.4828 14.628 12.4828 14.6638C12.4828 15.8704 11.5014 16.8549 10.2908 16.8549C9.08022 16.8549 8.09884 15.8739 8.09884 14.6638C8.09884 13.4572 9.08022 12.4726 10.2908 12.4726C10.5415 12.4726 10.7851 12.5192 11.0107 12.598V10.192C10.7779 10.1526 10.538 10.1311 10.2908 10.1311C7.7944 10.1347 5.76001 12.1683 5.76001 14.6674C5.76001 17.1664 7.7944 19.2 10.2944 19.2C12.7944 19.2 14.8288 17.1664 14.8288 14.6674V8.9353C15.735 9.84112 16.9062 10.7255 18.2027 11.0083V8.54863C16.7951 7.92566 15.3947 6.08538 14.9327 5.34784Z",
                fill: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/social/twitter.tsx




var Twitter = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.79999 16.5252C6.35003 16.6125 7.70549 16.2501 9.02739 15.2906C7.69207 15.0624 6.76607 14.4518 6.26281 13.1903C6.65199 13.1366 6.99421 13.2373 7.39682 13.0762C6.08163 12.4992 5.22944 11.6335 5.19589 10.1372C5.61192 10.1707 5.9273 10.4458 6.42385 10.4056C5.21602 9.22459 4.84696 7.93624 5.60521 6.37278C6.86672 7.82217 8.34296 8.80856 10.148 9.27157C10.2486 9.29841 10.3426 9.32525 10.4432 9.34538C10.9062 9.45274 11.4565 9.68089 11.7383 9.64733C12.2214 9.58694 11.7383 9.03 11.8591 8.3053C12.2416 6.05069 14.7243 5.02403 16.5629 6.34594C17.0997 6.73513 17.5224 6.72842 18.0526 6.49356C18.3277 6.37278 18.6095 6.25199 18.9383 6.11108C18.8645 6.75526 18.3679 7.11089 17.972 7.58732C18.4216 7.68797 18.784 7.56048 19.2 7.42627C19.0591 7.88927 18.7101 8.15097 18.3948 8.40596C18.066 8.66765 17.9385 8.94277 17.9251 9.37222C17.7238 15.8744 10.3359 20.9003 5.28312 16.901C4.79328 16.5118 5.2697 16.901 4.79999 16.5252Z",
                fill: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/social/youtube.tsx




var Youtube = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.14546 16.9078H16.8541C18.1532 16.9078 19.205 15.7647 19.1998 14.3459V9.76191C19.1998 8.34881 18.1532 7.19995 16.8541 7.19995H7.14546C5.85167 7.19995 4.7998 8.34307 4.7998 9.76191V14.3459C4.7998 15.759 5.84641 16.9078 7.14546 16.9078ZM10.4629 9.62695L14.5471 11.9821L10.4629 14.3373V9.62695Z",
                fill: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/social/index.tsx





var Social = {
    Facebook: Facebook,
    Instagram: Instagram,
    Tiktok: Tiktok,
    Twitter: Twitter,
    Youtube: Youtube
};

;// CONCATENATED MODULE: ./src/components/uielements/social/types.ts
var SocialLinks;
(function(SocialLinks) {
    SocialLinks["facebook"] = "facebook";
    SocialLinks["instagram"] = "instagram";
    SocialLinks["tiktok"] = "tiktok";
    SocialLinks["twitter"] = "twitter";
    SocialLinks["youtube"] = "youtube";
})(SocialLinks || (SocialLinks = {}));

// EXTERNAL MODULE: ./src/constants/dates.ts
var dates = __webpack_require__(81584);
// EXTERNAL MODULE: ./src/services/footer.service.ts
var footer_service = __webpack_require__(77203);
// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(32210);
// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var utils_dates = __webpack_require__(63654);
// EXTERNAL MODULE: ./src/utils/stringHelpers.ts
var stringHelpers = __webpack_require__(60738);
;// CONCATENATED MODULE: ./src/components/footer/footer.tsx



















function footer_Content(param) {
    var copyright = param.copyright, background_color = param.background_color, copyright_color = param.copyright_color, link_color = param.link_color, columns = param.columns;
    var getSocialIcon = function getSocialIcon(type) {
        switch(type){
            case SocialLinks.facebook:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Social.Facebook, {
                    title: "Find us on Facebook"
                });
            case SocialLinks.twitter:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Social.Twitter, {
                    title: "Find us on Twitter"
                });
            case SocialLinks.instagram:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Social.Instagram, {
                    title: "Find us on Instagram"
                });
            case SocialLinks.youtube:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Social.Youtube, {
                    title: "Find us on YouTube"
                });
            case SocialLinks.tiktok:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Social.Tiktok, {
                    title: "Find us on TikTok"
                });
            default:
                return null;
        }
    };
    var organization = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization;
    }).organization;
    var logo_cta_url = (0,cmsConfig/* useConfigOverride */.$E)("header").logo_cta_url;
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("footer"), footer_logo = ref.footer_logo, facebook_url = ref.facebook_url, twitter_url = ref.twitter_url, instagram_url = ref.instagram_url, youtube_url = ref.youtube_url, tiktok_url = ref.tiktok_url, apple_store_url = ref.apple_store_url, google_play_store_url = ref.google_play_store_url;
    var socialLinks = [
        {
            id: SocialLinks.facebook,
            value: facebook_url
        },
        {
            id: SocialLinks.twitter,
            value: twitter_url
        },
        {
            id: SocialLinks.instagram,
            value: instagram_url
        },
        {
            id: SocialLinks.youtube,
            value: youtube_url
        },
        {
            id: SocialLinks.tiktok,
            value: tiktok_url
        }, 
    ].filter(function(item) {
        return Boolean(item.value);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_Container, {
        css: {
            backgroundColor: background_color !== null && background_color !== void 0 ? background_color : "transparent",
            "& a": {
                color: link_color !== null && link_color !== void 0 ? link_color : "black"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
            direction: "vertical",
            css: {
                gap: "$6",
                padding: "$12",
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                    condition: Boolean(footer_logo),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: Boolean(logo_cta_url) ? logo_cta_url : routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                src: (0,imageHelper/* resizeImage */.tg)(footer_logo, {
                                    width: 240
                                }),
                                css: {
                                    height: "$12",
                                    width: "$32"
                                },
                                height: 48,
                                width: 128,
                                alt: organization.label
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
                        align: "center",
                        position: "center",
                        css: {
                            gap: "$5",
                            flexWrap: "wrap"
                        },
                        children: Object.keys(columns).map(function(key) {
                            var _key;
                            var links = (_key = columns[key]) !== null && _key !== void 0 ? _key : [];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                condition: links.length > 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
                                    direction: "vertical",
                                    children: links.map(function(link, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: link.url,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                                css: {
                                                    color: link_color !== null && link_color !== void 0 ? link_color : "black"
                                                },
                                                target: link.external ? "_blank" : "_self",
                                                children: link.text
                                            })
                                        }, index);
                                    })
                                })
                            }, key);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                    condition: socialLinks.length > 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
                        css: {
                            gap: "$5"
                        },
                        children: socialLinks.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
                                href: item.value,
                                css: {
                                    color: link_color !== null && link_color !== void 0 ? link_color : "black"
                                },
                                target: "_blank",
                                children: getSocialIcon(item.id)
                            }, item.id);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                    condition: Boolean(apple_store_url || google_play_store_url),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                condition: Boolean(apple_store_url),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
                                    href: apple_store_url,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                        src: "/static/img/app-stores/apple.png",
                                        alt: "Apple App Store",
                                        height: 40,
                                        width: 120
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                condition: Boolean(google_play_store_url),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
                                    href: google_play_store_url,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                        src: "/static/img/app-stores/google.png",
                                        alt: "Google Play Store",
                                        height: 40,
                                        width: 144
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                    condition: Boolean(copyright),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtext, {
                        css: {
                            color: copyright_color !== null && copyright_color !== void 0 ? copyright_color : "black"
                        },
                        dangerouslySetInnerHTML: {
                            __html: (0,stringHelpers/* interpolateIntoString */.vk)(copyright, {
                                year: (0,utils_dates/* formatDate */.p6)(null, dates/* DATE_FORMAT.YEAR */.z.YEAR),
                                brandName: organization.label
                            })
                        }
                    })
                })
            ]
        })
    });
}
function footer_Footer() {
    var router = (0,next_router.useRouter)();
    var footerEnabled = (0,redux/* useSelector */.v9)(function(state) {
        var webConfig = state.app.cmsConfig.webConfig;
        return (0,stringHelpers/* safelyGetConfig */.K6)(webConfig, "global.footer_enabled");
    });
    /**
   * Make sure that `useFooterQuery` is prefetched before
   * this component renders, otherwise it will explode!
   * @see __DANGEROUS_EMPTY_REQUEST_ORIGIN
   */ var origin;
    if (true) {
        origin = (0,src_utils/* getOrigin */.P$)(window.location.host);
    } else {}
    var ref = (0,footer_service/* useFooterQuery */.I)(origin), data = ref.data, status = ref.status;
    /*
   * Display the footer when the following conditions pass:
   * - footer config is enabled
   * - marketing api returns valid footer JSON
   * - we are not on account pages
   */ if (!footerEnabled || status !== "success" || (router === null || router === void 0 ? void 0 : router.pathname) === routes/* ROUTES.ACCOUNT */.Z6.ACCOUNT) {
        return null;
    }
    // @ts-expect-error: api response is unknown
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_Content, (0,_object_spread/* default */.Z)({}, data));
}
var footer_Container = (0,stitches/* styled */.zo)("footer", {});
var Logo = (0,stitches/* styled */.zo)("img", {
    objectFit: "contain"
});
var NavLink = (0,stitches/* styled */.zo)("a", {
    fontSize: "$text200",
    transition: "all .2s ease",
    "&:hover": {
        transform: "translateY(-.25rem)"
    }
});
var SocialLink = (0,stitches/* styled */.zo)("a", {
    transition: "all .2s ease",
    transform: "translate3d(0,0,0)",
    "&:hover": {
        opacity: 0.6
    }
});
var Subtext = (0,stitches/* styled */.zo)("span", {
    fontSize: "$text200"
});

;// CONCATENATED MODULE: ./src/components/fulfillmentManager/styles.ts



function fulfillmentManager_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 900;\n  border-radius: 5px;\n  min-height: 50px;\n  margin: ",
        "px auto;\n  min-width: 300px;\n\n  @media (max-width: 767px) {\n    min-width: 0;\n    width: 100%;\n  }\n"
    ]);
    fulfillmentManager_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledConfirm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7824388c-0"
})(function(param) {
    var theme = param.theme;
    return {
        padding: "40px 60px",
        h2: (0,_object_spread/* default */.Z)({
            margin: "0 0 10px"
        }, (0,utils/* getFontStyles */.l)(theme.modals.secondary_font)),
        p: {
            margin: "0 0 10px"
        },
        "@media (max-width: 767px)": {
            paddingLeft: "20px",
            paddingRight: "20px"
        }
    };
});
var StyledContinueButton = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-7824388c-1"
})(fulfillmentManager_styles_templateObject(), styles/* LAYOUT.GUTTER */._.GUTTER);
var StickWithButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7824388c-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        background: "transparent",
        border: "none",
        cursor: "pointer",
        textDecoration: "underline",
        transition: "opacity 0.2s linear"
    }, (0,utils/* getFontStyles */.l)(theme.modals.font)), {
        "&:hover": {
            opacity: 0.7
        }
    });
});

;// CONCATENATED MODULE: ./src/components/fulfillmentManager/deliveryManager/deliveryConfirm/index.tsx







function SwitchToDeliveryConfirm(param) {
    var fulfillmentModalLocation = param.fulfillmentModalLocation, toggleFulfillmentModal = param.toggleFulfillmentModal;
    var time_wanted = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr).time_wanted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledConfirm, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: "h2",
                accessor: "delivery.switch_to_delivery_header",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: "p",
                accessor: "delivery.switch_to_delivery_subheader",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContinueButton, {
                type: "button",
                onClick: function() {
                    return toggleFulfillmentModal(true, fulfillmentModalLocation, sdk_dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY, false, time_wanted);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "delivery.switch_to_delivery_cta"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickWithButton, {
                    onClick: function() {
                        return toggleFulfillmentModal(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "delivery.stick_with_pickup_cta"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/redux/es/redux.js + 1 modules
var es_redux = __webpack_require__(38726);
// EXTERNAL MODULE: ../../node_modules/redux-form/es/Field.js + 10 modules
var Field = __webpack_require__(82415);
// EXTERNAL MODULE: ../../node_modules/redux-form/es/getFormValues.js + 1 modules
var getFormValues = __webpack_require__(89785);
// EXTERNAL MODULE: ../../node_modules/redux-form/es/reduxForm.js + 15 modules
var reduxForm = __webpack_require__(45900);
// EXTERNAL MODULE: ./src/components/fulfillmentManager/deliveryManager/deliveryForm/validation.ts
var validation = __webpack_require__(192);
// EXTERNAL MODULE: ./src/components/fulfillmentManager/deliveryManager/deliveryForm/styles.ts
var deliveryForm_styles = __webpack_require__(50473);
// EXTERNAL MODULE: ./src/components/checkout/uielements/index.tsx
var checkout_uielements = __webpack_require__(66);
// EXTERNAL MODULE: ./src/components/fulfillmentManager/deliveryManager/deliveryForm/autocomplete.tsx
var autocomplete = __webpack_require__(48350);
// EXTERNAL MODULE: ./src/components/fulfillmentManager/deliveryManager/deliveryForm/googautocomplete.tsx
var googautocomplete = __webpack_require__(66630);
// EXTERNAL MODULE: ./src/components/locations/search/storedAddresses/styles.ts
var storedAddresses_styles = __webpack_require__(87375);
// EXTERNAL MODULE: ./src/components/uielements/form-fields/index.ts + 2 modules
var form_fields = __webpack_require__(92682);
// EXTERNAL MODULE: ./src/components/uielements/selectCheckout/index.tsx
var selectCheckout = __webpack_require__(24274);
// EXTERNAL MODULE: ./src/constants/states.ts
var states = __webpack_require__(49956);
// EXTERNAL MODULE: ./src/features/handoff/time-picker/index.ts + 3 modules
var time_picker = __webpack_require__(5682);
// EXTERNAL MODULE: ./src/redux/conveyanceMode/actions.ts
var conveyanceMode_actions = __webpack_require__(38534);
// EXTERNAL MODULE: ./src/redux/locations/actions.ts
var locations_actions = __webpack_require__(17464);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var me_actions = __webpack_require__(47290);
// EXTERNAL MODULE: ./src/utils/auth.ts + 1 modules
var auth = __webpack_require__(10606);
// EXTERNAL MODULE: ./src/utils/fulfillment.ts
var fulfillment = __webpack_require__(89744);
;// CONCATENATED MODULE: ./src/components/fulfillmentManager/deliveryManager/deliveryForm/index.tsx






























var formName = "delivery-form";
var formSubmitButtonTestId = "delivery_form_submit";
/**
 * This form allows users select their address and desired delivery time window.
 *
 * - If they are logged out, they can enter an address via either a Google
 *   autocomplete or a full delivery form. (address, state, zip, etc.)
 * - If they are logged in, they can select from a list of saved addresses.
 */ var _DeliveryForm = function(param) {
    var myAddresses = param.myAddresses, fetchAddresses = param.fetchAddresses, theme = param.theme, loading = param.loading, fulfillmentModal = param.fulfillmentModal, checkDeliveryAddress = param.checkDeliveryAddress, formValues = param.formValues, handleSubmit = param.handleSubmit, change = param.change, strings = param.strings, reset = param.reset, googleAddressNotSelected = param.googleAddressNotSelected, setDeliveryAddressContinue = param.setDeliveryAddressContinue, clearDeliverySearchErrors = param.clearDeliverySearchErrors, initialValues = param.initialValues;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), isStoredAddressSelected = ref2[0], setIsStoredAddressSelected = ref2[1];
    var timeslotOverride = fulfillmentModal.timeslotOverride, addressValidity = fulfillmentModal.addressValidity, errorMessage = fulfillmentModal.errorMessage, location = fulfillmentModal.location;
    // Web Configs
    var deliverySearchEnabled = (ref = theme.locations) === null || ref === void 0 ? void 0 : ref.delivery_search;
    var displayStoredAddresses = ((ref1 = theme.accounts) === null || ref1 === void 0 ? void 0 : ref1.stored_addresses) && !!(myAddresses === null || myAddresses === void 0 ? void 0 : myAddresses.length);
    var determineFormStatus = (0,fulfillment/* showManualDeliveryFormConditions */.Kk)(displayStoredAddresses, isStoredAddressSelected, formValues);
    var defaultErrorMessage = "Delivery to this address is not currently available. Please try another address.";
    // is the manual delivery form be shown as well as stored addresses?
    var ref3 = (0,react.useState)(determineFormStatus), showDeliveryForm = ref3[0], setShowDeliveryForm = ref3[1];
    /**
   * If a timeslot override exists, manually set the time_wanted
   * value since the day/time toggle won't be shown.
   *
   * @TODO see if this ever changes. If not, we can make it only fire on mount.
   */ (0,react.useEffect)(function() {
        if (timeslotOverride) {
            change("time_wanted", timeslotOverride);
        }
    }, [
        timeslotOverride
    ]);
    // If a user is logged in, fetch their stored addresses on mount.
    (0,react.useEffect)(function() {
        if ((0,auth/* userLoggedIn */.nD)()) {
            fetchAddresses();
        }
        // NOTE: we have to set formValues time_wanted to initial value if it exists when basket is created
        if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.time_wanted) {
            change("time_wanted", initialValues.time_wanted);
        }
    }, []);
    /**
   * The Continue button is disabled under the following conditions:
   * - Delivery search is enabled for the brand, but...
   * - The given address is not valid
   * - Google doesn't recognize the given address
   *
   * @TODO rename `googleAddressNotSelected` in the store since it's ambiguous.
   */ var isContinueButtonDisabled = deliverySearchEnabled && (!addressValidity || googleAddressNotSelected);
    // Check manual form conditions again when displayStoredAddresses changes
    (0,react.useEffect)(function() {
        setShowDeliveryForm(determineFormStatus);
    }, [
        displayStoredAddresses
    ]);
    // Any time the form values change, validate and set the delivery info.
    (0,react.useEffect)(function() {
        // Clear any validation errors before checking the address.
        clearDeliverySearchErrors();
        /**
     * Validate the address if these conditions are met:
     * - The brand has delivery search enabled OR the user has selected a stored
     *   address. If not, their address will be validated when they click Continue.
     * - A street address has been entered.
     */ if ((deliverySearchEnabled || isStoredAddressSelected) && (formValues === null || formValues === void 0 ? void 0 : formValues.street_address)) {
            // @ts-expect-error redux-form values are typed as Record<string, string>
            checkDeliveryAddress(formValues);
        }
    }, [
        formValues
    ]);
    // Show the manual delivery form.
    var showManualDeliveryForm = function() {
        // Reset the form to its empty state.
        reset();
        // The user is no longer using a stored address.
        setIsStoredAddressSelected(false);
        // ...and show the manual delivery form.
        setShowDeliveryForm(true);
    };
    // Submits the delivery form.
    var submit = function() {
        var ref;
        /**
     * If delivery search is enabled, the address has already been validated.
     * Clicking Continue will just close the modal and handle redirect logic.
     */ if (deliverySearchEnabled || isStoredAddressSelected) {
            setDeliveryAddressContinue();
        } else {
            /**
       * If delivery search is *not* enabled, the address must be validated when
       * Continue is clicked. The second argument (`shouldAutoRedirect`) will
       * redirect the user to the correct store page once validation completes.
       */ // @ts-expect-error redux-form values are typed as Record<string, string>
            checkDeliveryAddress(formValues, true);
        }
        if ((formValues === null || formValues === void 0 ? void 0 : (ref = formValues.time_wanted) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== locations/* ORDER_ASAP.toLowerCase */.Tg.toLowerCase()) {
            (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.WANTED_AT_SELECTED */.x.WANTED_AT_SELECTED, {
                name: sdk_dist/* CONVEYANCE_TYPES.DELIVERY.toLowerCase */.P8.DELIVERY.toLowerCase(),
                details: formValues === null || formValues === void 0 ? void 0 : formValues.time_wanted
            });
        }
    };
    // Update the desired delivery date & time.
    var updateDeliveryTime = function(timestamp) {
        change("time_wanted", timestamp);
    };
    // Update the selected address.
    var updateAddress = function(address) {
        change("id", address.id);
        change("street_address", address.street_address);
        change("street_address_2", address.street_address_2);
        change("city", address.city);
        var _state;
        // If stored address, null out the state
        change("state", (_state = address.state) !== null && _state !== void 0 ? _state : null);
        change("zip_code", address.zip_code);
    };
    var AutocompleteComponent = theme.global.radar_maps ? autocomplete/* default */.Z : googautocomplete/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(deliveryForm_styles/* StyledForm */.Gq, {
        onSubmit: handleSubmit(submit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: "h2",
                accessor: "delivery.modal_header",
                html: true
            }),
            addressValidity === false && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    color: "#ff2d44"
                },
                children: "Sorry! ".concat(errorMessage !== null && errorMessage !== void 0 ? errorMessage : defaultErrorMessage)
            }),
            displayStoredAddresses && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: storedAddresses_styles/* StyledDeliveryFormSubheader */.N,
                        accessor: "account.addresses_header",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_uielements/* StyledRadioLegend */.fB, {
                        children: "My Addresses"
                    }),
                    myAddresses.map(function(storedAddress, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_uielements/* StyledRadioRow */.Es, {
                                mobilePadding: 20,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_uielements/* RadioOption */._3, {
                                    id: "address-line-".concat(index),
                                    checked: Boolean((formValues === null || formValues === void 0 ? void 0 : formValues.id) && Number(formValues.id) === storedAddress.id),
                                    name: "stored-address",
                                    onChange: function() {
                                        // The user has clicked a stored address.
                                        setIsStoredAddressSelected(true);
                                        // Hide the manual delivery form.
                                        setShowDeliveryForm(false);
                                        // Update the form with the selected address.
                                        updateAddress(storedAddress);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            storedAddress.street_address,
                                            storedAddress.street_address_2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    ",\xa0",
                                                    storedAddress.street_address_2
                                                ]
                                            }),
                                            ",\xa0",
                                            storedAddress.city,
                                            ", ",
                                            storedAddress === null || storedAddress === void 0 ? void 0 : storedAddress.zip_code
                                        ]
                                    })
                                })
                            })
                        }, storedAddress.id);
                    }),
                    !showDeliveryForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(deliveryForm_styles/* StyledAddAddressButton */.jE, {
                        type: "button",
                        onClick: showManualDeliveryForm,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "delivery.add_new_address_cta",
                            html: true
                        })
                    })
                ]
            }),
            !timeslotOverride && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: storedAddresses_styles/* StyledDeliveryFormSubheader */.N,
                        accessor: "handoff_time.order_info_header",
                        html: true,
                        dataObj: {
                            fulfillmentType: sdk_dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                        condition: Boolean(location === null || location === void 0 ? void 0 : location.id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker/* HandoffTimePicker */.NF, {
                            onChange: updateDeliveryTime,
                            value: formValues === null || formValues === void 0 ? void 0 : formValues.time_wanted,
                            isSubmitting: loading,
                            location: location,
                            handoffType: sdk_dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY,
                            supportsAsap: location.order_asap
                        })
                    })
                ]
            }),
            showDeliveryForm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: storedAddresses_styles/* StyledDeliveryFormSubheader */.N,
                        accessor: "delivery.address_details_subheader",
                        html: true
                    }),
                    deliverySearchEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteComponent, {
                        loading: loading,
                        apiKey: theme.locations.map_key,
                        checkOrSearchDeliveryCoverage: updateAddress,
                        formValues: formValues
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                name: "street_address",
                                type: "text",
                                placeholder: "Address",
                                component: form_fields/* ReduxFormField */.H
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                name: "street_address_2",
                                type: "text",
                                placeholder: (0,stringHelpers/* safelyGetString */.bc)(strings, "checkout_delivery_details.apartment_number_input_placeholder"),
                                component: form_fields/* ReduxFormField */.H
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(deliveryForm_styles/* StyledCityStateZip */.zp, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        name: "city",
                                        type: "text",
                                        placeholder: "City",
                                        component: form_fields/* ReduxFormField */.H
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                            name: "state",
                                            type: "text",
                                            placeholder: "State",
                                            component: selectCheckout/* ReduxFormSelect */.v,
                                            // @ts-expect-error type `e`.
                                            handleChange: function(e) {
                                                return change("state", e.target.value);
                                            },
                                            optionsArray: Object.keys(states/* stateAbbrMappings */.S),
                                            title: "State",
                                            titleEnabled: true,
                                            defaultValue: (formValues === null || formValues === void 0 ? void 0 : formValues.state) || "",
                                            width: "80px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                            name: "zip_code",
                                            type: "text",
                                            maxLength: 6,
                                            inputmode: "numeric",
                                            placeholder: "Zip Code",
                                            component: form_fields/* ReduxFormField */.H
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContinueButton, {
                "data-testid": formSubmitButtonTestId,
                disabled: isContinueButtonDisabled,
                type: "submit",
                submitting: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "delivery.modal_submit_cta"
                })
            })
        ]
    });
};
var deliveryForm_mapStateToProps = function(state) {
    return {
        formValues: (0,getFormValues/* default */.Z)("delivery-form")(state),
        myAddresses: state.app.me.myAddresses,
        strings: state.app.cmsConfig.strings,
        fulfillmentModal: state.app.global.fulfillmentModal,
        googleAddressNotSelected: state.app.locations.googleAddressNotSelected
    };
};
var mapDispatchToProps = {
    clearDeliverySearchErrors: locations_actions/* locationsActions.clearDeliverySearchErrors */.b.clearDeliverySearchErrors,
    fetchAddresses: me_actions/* default.fetchAddresses */.Z.fetchAddresses,
    setDeliveryAddressContinue: conveyanceMode_actions/* default.setDeliveryAddressContinue */.Z.setDeliveryAddressContinue,
    toggleFulfillmentModal: global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal
};
var deliveryForm_connector = (0,es.connect)(deliveryForm_mapStateToProps, mapDispatchToProps);
var DeliveryForm = (0,es_redux/* compose */.qC)(styled_components_browser_esm/* withTheme */.Zz, (0,reduxForm/* default */.Z)({
    form: formName,
    validate: validation/* addressValidation */.U
}), deliveryForm_connector)(_DeliveryForm);

;// CONCATENATED MODULE: ./src/components/fulfillmentManager/deliveryManager/styles.tsx

function deliveryManager_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px;\n\n  @media (max-width: 767px) {\n    padding: 0px;\n  }\n"
    ]);
    deliveryManager_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function deliveryManager_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        "px 0 0;\n\n  a {\n    text-decoration: underline;\n  }\n"
    ]);
    deliveryManager_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledFormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-59ec8843-0"
})(deliveryManager_styles_templateObject(), styles/* LAYOUT.GUTTER */._.GUTTER * 2);
var StyledFormCTA = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-59ec8843-1"
})(deliveryManager_styles_templateObject1(), styles/* LAYOUT.GUTTER */._.GUTTER);

;// CONCATENATED MODULE: ./src/components/fulfillmentManager/deliveryManager/index.tsx










var DeliveryModalStateContainer = function(param) {
    var fulfillmentModal = param.fulfillmentModal, toggleFulfillmentModal = param.toggleFulfillmentModal, checkDeliveryAddress = param.checkDeliveryAddress, basketFulfillment = param.basketFulfillment, deliveryAddressValidating = param.deliveryAddressValidating, revalidate = param.revalidate;
    var address = basketFulfillment === null || basketFulfillment === void 0 ? void 0 : basketFulfillment.address;
    if (fulfillmentModal.confirm) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchToDeliveryConfirm, {
            toggleFulfillmentModal: toggleFulfillmentModal,
            /** @TODO ensure that `location` isn't null. */ // @ts-expect-error
            fulfillmentModalLocation: fulfillmentModal.location
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryForm, {
                checkDeliveryAddress: function(values, shouldAutoRedirect) {
                    return checkDeliveryAddress(values, /** @TODO ensure that `location` isn't null. */ // @ts-expect-error
                    fulfillmentModal.location, revalidate, shouldAutoRedirect);
                },
                initialValues: address,
                loading: deliveryAddressValidating
            }),
            fulfillmentModal.disableModalClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormCTA, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: function() {
                            toggleFulfillmentModal(false);
                            (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                                name: constants/* EventNames.CHANGE_LOCATION */.V.CHANGE_LOCATION,
                                details: constants_events/* MODAL.FULFILLMENT_MANAGER */.zr.FULFILLMENT_MANAGER
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "cart_checkout.change_location_cta"
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/fulfillmentManager/pickupManager/index.tsx









var PickupConfirm = function() {
    var dispatch = (0,es.useDispatch)();
    var locationId = (0,es.useSelector)(// TODO: Why we are not using app.locations?
    function(state) {
        var ref, ref1;
        return (ref = state.app.global.fulfillmentModal) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : ref1.id;
    });
    var time_wanted = (0,es.useSelector)(reducer/* selectConveyance */.Fr).time_wanted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledConfirm, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: "h2",
                accessor: "delivery.switch_to_pickup_header",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "delivery.switch_to_pickup_subheader",
                    html: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContinueButton, {
                type: "button",
                onClick: function() {
                    dispatch(conveyanceMode_actions/* default.clearDeliveryAddress */.Z.clearDeliveryAddress(/** @TODO ensure that `locationId` isn't null. */ // @ts-expect-error
                    locationId));
                    dispatch(conveyanceMode_actions/* default.conveyanceModeSet */.Z.conveyanceModeSet({
                        type: constants_events/* API_CONVEYANCE_TYPES.PICKUP */.tQ.PICKUP,
                        details: []
                    }, time_wanted));
                    dispatch(global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal(false));
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "delivery.switch_to_pickup_cta"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickWithButton, {
                    onClick: function() {
                        return dispatch(global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal(false));
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "delivery.stick_with_delivery_cta"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/uielements/genericModal/index.tsx
var genericModal = __webpack_require__(85526);
;// CONCATENATED MODULE: ./src/components/fulfillmentManager/index.tsx













var FulfillmentManager = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(FulfillmentManager, Component);
    var _super = (0,_create_super/* default */.Z)(FulfillmentManager);
    function FulfillmentManager() {
        (0,_class_call_check/* default */.Z)(this, FulfillmentManager);
        return _super.apply(this, arguments);
    }
    var _proto = FulfillmentManager.prototype;
    _proto.render = function render() {
        var _props = this.props, toggleFulfillmentModal = _props.toggleFulfillmentModal, fulfillmentModal = _props.fulfillmentModal, checkDeliveryAddress = _props.checkDeliveryAddress, basketFulfillment = _props.basketFulfillment, deliveryAddressValidating = _props.deliveryAddressValidating;
        if (!fulfillmentModal.display) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(genericModal/* default */.Z, {
            modalOpen: fulfillmentModal.display,
            toggleModal: toggleFulfillmentModal,
            disableModalClose: fulfillmentModal.disableModalClose,
            name: constants_events/* MODAL.FULFILLMENT_MANAGER */.zr.FULFILLMENT_MANAGER,
            children: [
                fulfillmentModal.type === sdk_dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP && /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupConfirm, {}),
                fulfillmentModal.type === sdk_dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryModalStateContainer, {
                    checkDeliveryAddress: checkDeliveryAddress,
                    toggleFulfillmentModal: toggleFulfillmentModal,
                    fulfillmentModal: fulfillmentModal,
                    basketFulfillment: basketFulfillment,
                    deliveryAddressValidating: deliveryAddressValidating,
                    // @ts-expect-error ensure that `revalidate` isn't null.
                    revalidate: fulfillmentModal.revalidate
                })
            ]
        });
    };
    return FulfillmentManager;
}(react.Component);
var fulfillmentManager_mapStateToProps = function(state) {
    return {
        basketFulfillment: state.app.basket.fulfillment,
        deliveryAddressValidating: state.app.conveyanceMode.loading,
        fulfillmentModal: state.app.global.fulfillmentModal
    };
};
var fulfillmentManager_mapDispatchToProps = {
    toggleFulfillmentModal: global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal,
    checkDeliveryAddress: conveyanceMode_actions/* default.checkDeliveryAddress */.Z.checkDeliveryAddress
};
var fulfillmentManager_connector = (0,es.connect)(fulfillmentManager_mapStateToProps, fulfillmentManager_mapDispatchToProps);
/* harmony default export */ var fulfillmentManager = (fulfillmentManager_connector(FulfillmentManager));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(26806);
// EXTERNAL MODULE: ./src/components/uielements/css.ts
var css = __webpack_require__(64390);
;// CONCATENATED MODULE: ./src/components/account/accountDropdown/styles.ts



function accountDropdown_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  left: 0;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: ",
        ";\n  visibility: ",
        ";\n  opacity: ",
        ";\n  transition: all 0.2s linear;\n"
    ]);
    accountDropdown_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function accountDropdown_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n\n  ul {\n    padding: 0;\n    margin: 0;\n  }\n"
    ]);
    accountDropdown_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function accountDropdown_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px;\n\n  h3 {\n    font-size: 20px;\n    font-family: ",
        ";\n    margin: 0;\n  }\n\n  p {\n    margin: ",
        "px 0 0;\n  }\n"
    ]);
    accountDropdown_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function accountDropdown_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  width: 100%;\n  height: 72px;\n  font-size: 16px;\n  cursor: pointer;\n  background: none;\n  font-family: ",
        ";\n  text-align: left;\n  padding: ",
        "px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ",
        "\n  text-decoration: none;\n"
    ]);
    accountDropdown_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var StyledDropdownOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f20eb928-0"
})(accountDropdown_styles_templateObject(), styles/* COLORS.SEMI_TRANSPARENT */.DM.SEMI_TRANSPARENT, styles/* ORDER.ACCOUNT_DROPDOWN */.kl.ACCOUNT_DROPDOWN, function(props) {
    return props.isVisible ? "visible" : "hidden";
}, function(props) {
    return props.isVisible ? 1 : 0;
});
var styles_background_color;
var StyledDropdownModalContainer = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-f20eb928-1"
})(function(param) {
    var theme = param.theme, isVisible = param.isVisible;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        background: (styles_background_color = theme.modals.background_color) !== null && styles_background_color !== void 0 ? styles_background_color : "white",
        overflowY: "scroll",
        maxHeight: "100%",
        width: "320px",
        position: "fixed",
        top: "0px",
        right: "20px",
        transform: "translateY(".concat(isVisible ? 0 : -150, "px)"),
        transition: "all 0.2s linear"
    }, (0,utils/* getFontStyles */.l)(theme.modals.font)), {
        "@media (max-width: 767px)": {
            right: 0,
            width: "100%"
        }
    });
});
var StyledAccountDropdownContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f20eb928-2"
})(accountDropdown_styles_templateObject1());
var StyledDropdownHeaderContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f20eb928-3"
})(accountDropdown_styles_templateObject2(), styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, styles/* LAYOUT.GUTTER */._.GUTTER / 4);
var StyledDropdownButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-f20eb928-4"
})(accountDropdown_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    border: none;\n    border-top: 1px solid ".concat(theme.modals.border_color, ";\n    color: ").concat(theme.modals.active_font_color, ";\n  ");
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, styles/* LAYOUT.GUTTER */._.GUTTER, css/* LinkHoverCss */.x);
var StyledAccountDropdownNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f20eb928-5"
})(function(param) {
    var theme = param.theme;
    /** @FIXME font refactor (what does readableColor do when the value is "inherit", etc). */ var color = (0,utils/* getFontStyles */.l)(theme.modals.font, [
        "color"
    ]).color;
    return {
        background: color,
        borderRadius: "50%",
        color: (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(color),
        fontSize: "14px",
        height: "32px",
        objectFit: "contain",
        padding: "6px",
        textAlign: "center",
        width: "32px",
        "@media (max-width: 767px)": {
            minWidth: "32px",
            minHeight: "32px"
        }
    };
});

// EXTERNAL MODULE: ./src/components/uielements/X/index.tsx
var X = __webpack_require__(66086);
// EXTERNAL MODULE: ./src/redux/auth/actions.ts
var auth_actions = __webpack_require__(45479);
;// CONCATENATED MODULE: ./src/components/account/accountDropdown/index.tsx

















function AccountDropdown() {
    var dispatch = (0,es.useDispatch)();
    var router = (0,next_router.useRouter)();
    var me = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.data;
    });
    var loyaltyState = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.loyaltyState;
    });
    var myMessages = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.messages;
    });
    var myOffers = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.myOffers;
    });
    var myRedeemables = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.redeemables;
    });
    var accountDropdownOpen = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.accountDropdownOpen;
    });
    var strings = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.strings;
    });
    var navigationRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), activeIndex = ref[0], setActiveIndex = ref[1];
    var ref1 = (0,react.useState)(0), listCount = ref1[0], setListCount = ref1[1];
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", handleKeyboardNavigation);
        document.addEventListener("mousedown", handleClick, false);
        return function() {
            document.removeEventListener("keydown", handleKeyboardNavigation);
            document.removeEventListener("mousedown", handleClick, false);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!me) {
            // If user signs out from dropdown, hide the dropdown
            dispatch(me_actions/* default.toggleAccountDropdown */.Z.toggleAccountDropdown(false));
        }
        if (accountDropdownOpen) {
            setupListNavigation();
        }
        if (navigationRef.current && activeIndex) {
            var linkToFocus = navigationRef.current.querySelector("li:nth-child(".concat(activeIndex, ") a"));
            if (linkToFocus) {
                linkToFocus.focus();
            }
        }
    }, [
        me,
        accountDropdownOpen,
        navigationRef.current,
        activeIndex
    ]);
    // The KeyboardEvent option in Javascript allows us to use an abstracted
    // list of keyboard events that are mapped from various types of keyboards.
    // This list is human readable ("Escape", "ArrowDown", etc)
    var handleKeyboardNavigation = function(evt) {
        // Close modal on 'esc' press
        if (accountDropdownOpen) {
            // space key is mapped as " "
            if (evt.key === "Escape" || evt.key === " ") {
                dispatch(me_actions/* default.toggleAccountDropdown */.Z.toggleAccountDropdown(false));
            }
            if (evt.key === "ArrowDown" || evt.key === "ArrowRight") {
                setActiveIndex(activeIndex < listCount ? activeIndex + 1 : 1);
            }
            if (evt.key === "ArrowUp" || evt.key === "ArrowLeft") {
                setActiveIndex(activeIndex > 1 ? activeIndex - 1 : listCount);
            }
            if (evt.key === "Home") {
                setActiveIndex(1);
            }
            if (evt.key === "End") {
                setActiveIndex(listCount);
            }
        }
    };
    /** @TODO improve event typing. */ // @ts-expect-error
    var handleClick = function(e) {
        if (e.target.id !== "Loyalty-Dropdown-Overlay") {
            return;
        }
        dispatch(me_actions/* default.toggleAccountDropdown */.Z.toggleAccountDropdown(false));
    };
    var setupListNavigation = function() {
        if (navigationRef.current) {
            setActiveIndex(1);
            setListCount(navigationRef.current.querySelectorAll("li").length);
            // we want to try and focus the first element
            setTimeout(function() {
                var ref;
                var linkToFocus = navigationRef === null || navigationRef === void 0 ? void 0 : (ref = navigationRef.current) === null || ref === void 0 ? void 0 : ref.querySelector("li:nth-child(1) a");
                if (linkToFocus) {
                    linkToFocus.focus();
                }
            }, 100);
        }
    };
    // Count unread personal messages
    var unreadPersonalMessagesLength = (0,loyalty/* getUnreadPersonalMessagesLength */.Xy)(myMessages);
    var ref2;
    // Combine available rewards and offers
    var currentPoints = (ref2 = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points) !== null && ref2 !== void 0 ? ref2 : 0;
    var combinedRewardsLength = (0,loyalty/* getActiveRewardsAndOffersLength */.gx)(myRedeemables, myOffers, currentPoints) || 0;
    var pointsCounter = (0,stringHelpers/* pluralizeString */.fB)((0,stringHelpers/* safelyGetString */.bc)(strings, "rewards.rewards_counter"), currentPoints !== 1);
    var cancelRedirect = router === null || router === void 0 ? void 0 : router.pathname.includes(routes/* ROUTES.ACCOUNT */.Z6.ACCOUNT);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownOverlay, {
        isVisible: accountDropdownOpen,
        id: "Loyalty-Dropdown-Overlay",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropdownModalContainer, {
            "aria-label": "Account and Loyalty",
            isVisible: accountDropdownOpen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(X/* ConnectedXButton */.e9, {
                    onClick: function() {
                        return dispatch(me_actions/* default.toggleAccountDropdown */.Z.toggleAccountDropdown(false));
                    },
                    id: "loyalty-dropdown-x-button",
                    name: "Close dropdown"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAccountDropdownContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropdownHeaderContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    id: "account-menu-label",
                                    children: [
                                        "Hi, ",
                                        me === null || me === void 0 ? void 0 : me.first_name,
                                        "!"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                    checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                                    checkName: constants_loyalty/* LOYALTY_FEATURES.SHOW_LOYALTY_STATE */.lw.SHOW_LOYALTY_STATE,
                                    component: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            (loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.membership_level_name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.membership_level_name
                                            }),
                                            currentPoints > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                accessor: "rewards.account_menu_points_subheader",
                                                html: true,
                                                tag: "p",
                                                dataObj: {
                                                    number: currentPoints.toLocaleString(),
                                                    counter: pointsCounter
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            ref: navigationRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                    checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                                    checkName: routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
                                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropdownButton, {
                                                "aria-label": "Go to Rewards page",
                                                className: cssClassNames/* CSS_CLASSES.LOYALTY.DROPDOWN_BUTTON */.Y.LOYALTY.DROPDOWN_BUTTON,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                        accessor: "rewards.title"
                                                    }),
                                                    combinedRewardsLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAccountDropdownNumber, {
                                                        children: combinedRewardsLength
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                    checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                                    checkName: routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX,
                                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropdownButton, {
                                                "aria-label": "Go to Inbox page",
                                                className: cssClassNames/* CSS_CLASSES.LOYALTY.DROPDOWN_BUTTON */.Y.LOYALTY.DROPDOWN_BUTTON,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                        accessor: "inbox.title"
                                                    }),
                                                    unreadPersonalMessagesLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAccountDropdownNumber, {
                                                        children: unreadPersonalMessagesLength
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                    checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                                    checkName: routes/* LOYALTY_ROUTES.FAVORITES */.xM.FAVORITES,
                                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* LOYALTY_ROUTES.FAVORITES */.xM.FAVORITES,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownButton, {
                                                "aria-label": "Go to Favorites page",
                                                className: cssClassNames/* CSS_CLASSES.LOYALTY.DROPDOWN_BUTTON */.Y.LOYALTY.DROPDOWN_BUTTON,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                    accessor: "favorites.title"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                    checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                                    checkName: routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
                                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownButton, {
                                                "aria-label": "Go to Order History page",
                                                className: cssClassNames/* CSS_CLASSES.LOYALTY.DROPDOWN_BUTTON */.Y.LOYALTY.DROPDOWN_BUTTON,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                    accessor: "order_history.title"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                    checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
                                    checkName: routes/* LOYALTY_ROUTES.ACCOUNT */.xM.ACCOUNT,
                                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* LOYALTY_ROUTES.ACCOUNT */.xM.ACCOUNT,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownButton, {
                                                "aria-label": "Go to Account page",
                                                className: cssClassNames/* CSS_CLASSES.LOYALTY.DROPDOWN_BUTTON */.Y.LOYALTY.DROPDOWN_BUTTON,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                    accessor: "account.title"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownButton, {
                                        href: "#",
                                        onClick: function(e) {
                                            e.preventDefault();
                                            dispatch(auth_actions/* default.logout */.Z.logout(cancelRedirect));
                                        },
                                        "aria-label": "Click to Sign Out",
                                        className: cssClassNames/* CSS_CLASSES.LOYALTY.DROPDOWN_BUTTON */.Y.LOYALTY.DROPDOWN_BUTTON,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "account.sign_out_button"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/account/headerLink/styles.ts

function headerLink_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n"
    ]);
    headerLink_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function headerLink_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    headerLink_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function headerLink_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  margin-right: ",
        "px;\n"
    ]);
    headerLink_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var StyledHeaderAccountButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a3cf0f8f-0"
})(headerLink_styles_templateObject());
var StyledFirstName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a3cf0f8f-1"
})(headerLink_styles_templateObject1());
var StyledNotificationsCounter = styled_components_browser_esm/* default.span.attrs */.ZP.span.attrs({
    "data-css-override": "StyledNotificationsCounter"
}).withConfig({
    componentId: "sc-a3cf0f8f-2"
})(headerLink_styles_templateObject2(), styles/* LAYOUT.GUTTER */._.GUTTER / 2);
var StyledNotificationDotMarker = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a3cf0f8f-3"
})(function(param) {
    var theme = param.theme;
    var color = (0,utils/* getFontStyles */.l)(theme.header.font, [
        "color"
    ]).color;
    return {
        background: color,
        borderRadius: "50%",
        color: (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(color),
        fontSize: "9px",
        height: "16px",
        padding: "2px",
        position: "absolute",
        right: "-5px",
        top: "-5px",
        width: "16px"
    };
});

;// CONCATENATED MODULE: ./src/components/account/headerLink/index.tsx







var LoyaltyNavLink = function(param) {
    var toggleAccountDropdown = param.toggleAccountDropdown, myMessages = param.myMessages, myRedeemables = param.myRedeemables, myOffers = param.myOffers, me = param.me, loyaltyState = param.loyaltyState;
    var ref;
    // Count unread personal messages + offers + rewards
    var currentPoints = (ref = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points) !== null && ref !== void 0 ? ref : 0;
    var combinedRewardsLength = (0,loyalty/* getActiveRewardsAndOffersLength */.gx)(myRedeemables, myOffers, currentPoints) || 0;
    var totalNotifications = (0,loyalty/* getUnreadPersonalMessagesLength */.Xy)(myMessages) + combinedRewardsLength;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderAccountButton, {
        "aria-label": "Click to view more Account links",
        onClick: function() {
            return toggleAccountDropdown(true);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNotificationsCounter, {
                className: cssClassNames/* CSS_CLASSES.GLOBAL_HEADER.AUTH_NOTIFICATION_COUNTER */.Y.GLOBAL_HEADER.AUTH_NOTIFICATION_COUNTER,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedPersonIcon */.WX, {}),
                    totalNotifications > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNotificationDotMarker, {
                        children: totalNotifications
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFirstName, {
                className: cssClassNames/* CSS_CLASSES.GLOBAL_HEADER.AUTH_USERNAME */.Y.GLOBAL_HEADER.AUTH_USERNAME,
                children: [
                    "Hi, ",
                    me === null || me === void 0 ? void 0 : me.first_name
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedChevronIcon */.GS, {})
        ]
    });
};
var headerLink_mapStateToProps = function(state) {
    return {
        accountDropdownOpen: state.app.me.accountDropdownOpen,
        myOffers: state.app.me.myOffers,
        myRedeemables: state.app.me.redeemables,
        myMessages: state.app.me.messages,
        loyaltyState: state.app.me.loyaltyState
    };
};
var headerLink_mapDispatchToProps = {
    toggleAccountDropdown: me_actions/* default.toggleAccountDropdown */.Z.toggleAccountDropdown
};
var headerLink_connector = (0,es.connect)(headerLink_mapStateToProps, headerLink_mapDispatchToProps);
/* harmony default export */ var headerLink = (headerLink_connector(LoyaltyNavLink));

;// CONCATENATED MODULE: ./src/components/genericRouteAccessor/index.tsx

/*
This component handles logic for whether to display route-specific components - also accounts for subpages (i.e. `/account/rewards`) and whether component should be displayed on mobile
*/ var GenericRouteAccessor = function(param) {
    var allowedPages = param.allowedPages, component = param.component;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var currentRoute = router === null || router === void 0 ? void 0 : router.route;
    if (!currentRoute) {
        return null;
    }
    // First part of the URL - i.e. `/account`
    var mainRoute = currentRoute && "/".concat(currentRoute.split("/")[1]);
    // Check if current route OR main route is in our allowedPages (if exactMatch is false)
    var allowedOnRoute = containsRoute(allowedPages, currentRoute) || containsRoute(allowedPages, mainRoute) && !((ref = allowedPages[mainRoute]) === null || ref === void 0 ? void 0 : ref.exactMatch);
    // Check screen size according to tabletMax breakpoint
    var mobileSize =  true && window.innerWidth <= 767;
    // If component fails our route check OR the component is supposed to be hidden on mobile, return null
    if (!allowedOnRoute || mobileSize && ((ref1 = allowedPages[currentRoute]) === null || ref1 === void 0 ? void 0 : ref1.hideOnMobile)) {
        return null;
    }
    // Else, return the component
    return component;
};
var containsRoute = function(allowedPages, route) {
    return Object.keys(allowedPages).includes(route);
};
function getAllowedRoutes(route, allowed) {
    return allowed.includes(route);
}

// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
;// CONCATENATED MODULE: ./src/components/header/sign-in.tsx









function Signin(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var loginReferrer = (0,global/* deriveReferrer */.k5)(router);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: "".concat(routes/* ROUTES.LOGIN */.Z6.LOGIN, "?referrer=").concat(loginReferrer),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(sign_in_Container, {
            "data-css-override": "StyledLinkWithIcon",
            onClick: function() {
                return (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.AUTH__CLICK_SIGN_IN */.x.AUTH__CLICK_SIGN_IN);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedPersonIcon */.WX, {}),
                children
            ]
        })
    });
}
var sign_in_Container = (0,stitches/* styled */.zo)("a", {
    alignItems: "center",
    background: "none",
    cursor: "pointer",
    display: "flex",
    gap: "$2-5"
});

;// CONCATENATED MODULE: ./src/components/header/account.tsx











function Account() {
    var strings = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }).strings;
    var config = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig;
    });
    var me = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.data;
    });
    if (config.accounts.disable_accounts) {
        return null;
    }
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericRouteAccessor, {
                allowedPages: (_obj = {}, (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE, {
                    exactMatch: true
                }), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.STORE */.Z6.STORE, null), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.PAGE */.Z6.PAGE, null), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS, null), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT, {
                    exactMatch: true,
                    hideOnMobile: true
                }), _obj),
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountContainer, {
                    css: {
                        "a, button": (0,utils/* getFontStyles */.l)(config.header.font, [
                            "color",
                            "font_family",
                            "font_size", 
                        ])
                    },
                    children: (me === null || me === void 0 ? void 0 : me.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(headerLink, {
                        me: me
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Signin, {
                        children: (0,stringHelpers/* safelyGetString */.bc)(strings, "global_header.sign_in_cta")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountDropdown, {})
        ]
    });
}
var AccountContainer = (0,stitches/* styled */.zo)("div", {
    "a, button": {
        alignItems: "center",
        background: "none",
        border: "none",
        cursor: "pointer",
        display: "flex",
        height: "$12",
        justifyContent: "center",
        "@md": {
            height: "$20",
            marginLeft: 0
        }
    },
    "@print": {
        display: "none"
    }
});

// EXTERNAL MODULE: ./src/constants/global.ts
var constants_global = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/utils/config.ts
var utils_config = __webpack_require__(19257);
;// CONCATENATED MODULE: ./src/components/header/back.tsx












function BackToMenu() {
    var location = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket;
    }).location;
    var webConfig = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }).webConfig;
    var config = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig;
    });
    var ref = (0,react.useState)(), sessionStorageLocation = ref[0], setSessionStorageLocation = ref[1];
    (0,react.useEffect)(function() {
        var meta = sessionStorage.getItem(constants_global/* KOALA_SESSION_STORAGE_KEYS.METADATA */.iy.METADATA);
        if (meta) {
            setSessionStorageLocation(JSON.parse(meta));
        }
    }, []);
    var locationId = undefined;
    if (location) {
        locationId = (0,locations/* getLocationId */.By)(location, webConfig);
    } else if (sessionStorageLocation) {
        locationId = (0,utils_config/* supportsBrandId */.i)(webConfig) ? sessionStorageLocation.location_brand_id : sessionStorageLocation.location_id;
    }
    var locationLabel = location.label || (sessionStorageLocation === null || sessionStorageLocation === void 0 ? void 0 : sessionStorageLocation.location_label);
    // 1) If basket exists, route to basket location
    // 2) If no basket, check session storage
    // 3) If no to both, route to homepage
    var route = locationId ? "/store/".concat(locationId, "/").concat(locationLabel) : routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE;
    var ctaLabel = locationId ? "Menu" : "Back";
    var _active_background_color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: route,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(back_Container, {
            css: {
                color: (_active_background_color = config.header.active_background_color) !== null && _active_background_color !== void 0 ? _active_background_color : "inherit",
                "@md": {
                    borderLeft: "1px solid ".concat(config.header.border_color)
                }
            },
            children: [
                config.header.back_to_menu_icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(back_Image, {
                    src: config.header.back_to_menu_icon,
                    role: "presentation",
                    alt: "Back to Menu Icon"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.BackEnclosed */.Z.BackEnclosed, {
                    title: "go back"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    css: (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(config.header.font, [
                        "color"
                    ])),
                    children: ctaLabel
                })
            ]
        })
    });
}
var back_Container = (0,stitches/* styled */.zo)("a", {
    alignItems: "center",
    display: "flex",
    gap: "$1",
    justifyContent: "center",
    width: "100%",
    "@md": {
        padding: "0 0 0 $5",
        width: "auto"
    }
});
var back_Image = (0,stitches/* styled */.zo)("img", {
    height: "$6",
    objectFit: "contain",
    width: "$6"
});
var Label = (0,stitches/* styled */.zo)("span", {
    display: "none",
    "@md": {
        display: "block"
    }
});

;// CONCATENATED MODULE: ./src/components/header/basket.tsx














var getBasketButtonContents = function(basketItems, css) {
    var count = (0,basket/* getBasketItemsCountWithQuantity */.ti)(basketItems);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedCartIcon */.ug, {}),
            Boolean(count) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity, {
                css: css,
                children: count
            })
        ]
    });
};
function Basket() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,redux/* useDispatch */.I0)();
    var webConfig = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }).webConfig;
    var ref = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket;
    }), content = ref.content, location = ref.location;
    var ref1 = (0,cmsConfig/* useConfigOverride */.$E)("header"), active_background_color = ref1.active_background_color, border_radius = ref1.border_radius, active_font_color = ref1.active_font_color, active_border_color = ref1.active_border_color, font = ref1.font;
    var overrides = (0,_object_spread/* default */.Z)({
        backgroundColor: active_background_color !== null && active_background_color !== void 0 ? active_background_color : "inherit",
        borderRadius: "".concat(border_radius !== null && border_radius !== void 0 ? border_radius : 0, "px"),
        color: active_font_color !== null && active_font_color !== void 0 ? active_font_color : "inherit",
        borderColor: active_border_color !== null && active_border_color !== void 0 ? active_border_color : "inherit"
    }, (0,utils/* getFontStyles */.l)(font, [
        "font_family",
        "font_size",
        "font_weight",
        "line_height", 
    ]));
    var quantityOverrides = {
        backgroundColor: active_font_color !== null && active_font_color !== void 0 ? active_font_color : "inherit",
        color: active_background_color !== null && active_background_color !== void 0 ? active_background_color : "inherit"
    };
    if ((router === null || router === void 0 ? void 0 : router.pathname) === routes/* ROUTES.STORE */.Z6.STORE || Object.keys(location).length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(basket_Element, {
            "data-testid": "basket-button",
            onClick: function() {
                return dispatch(global_actions/* default.toggleBasket */.Z.toggleBasket(true));
            },
            className: cssClassNames/* CSS_CLASSES.GLOBAL_HEADER.ORDER_NOW */.Y.GLOBAL_HEADER.ORDER_NOW,
            // @ts-expect-error: CSSProperties is complaining
            css: overrides,
            children: getBasketButtonContents(content.basket_items, quantityOverrides)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/store/".concat((0,locations/* getLocationId */.By)(location, webConfig), "/").concat(location.label, "?openCart=true"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(basket_Element, {
            "data-testid": "basket-button",
            as: "span",
            className: cssClassNames/* CSS_CLASSES.GLOBAL_HEADER.ORDER_NOW */.Y.GLOBAL_HEADER.ORDER_NOW,
            // @ts-expect-error: CSSProperties is complaining
            css: overrides,
            children: getBasketButtonContents(content.basket_items, quantityOverrides)
        })
    });
}
var basket_Element = (0,stitches/* styled */.zo)("button", {
    alignItems: "center",
    border: "1px solid black",
    cursor: "pointer",
    display: "none",
    height: "$9",
    justifyContent: "center",
    gap: "$1",
    minWidth: "$9",
    padding: "0 $3",
    "@md": {
        display: "flex"
    },
    "img, svg": {
        height: "$4"
    }
});
var Quantity = (0,stitches/* styled */.zo)("span", {
    alignItems: "center",
    borderRadius: "100%",
    display: "flex",
    height: "$3-5",
    fontSize: "8px",
    fontWeight: "bold",
    justifyContent: "center",
    width: "$3-5"
});

// EXTERNAL MODULE: ./src/utils/android.ts
var android = __webpack_require__(90484);
;// CONCATENATED MODULE: ./src/components/android/back-button/index.tsx

function back_button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  appearance: none;\n  background: none;\n  border: none;\n  color: var(--config-global__primary-active-color, black);\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  width: var(--size-12);\n\n  &:active {\n    opacity: 0.5;\n  }\n"
    ]);
    back_button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var AndroidBackButton = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(back_button_Element, {
        onClick: function() {
            return (0,android/* setAndroidCurrentPage */.rT)(router.pathname, router.back, router.push);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Back */.Z.Back, {
            title: "Go back"
        })
    });
};
var back_button_Element = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-786c648b-0"
})(back_button_templateObject());

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ./src/components/android/navigation-drawer/footer/footer.styles.ts



function footer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  opacity: 0.5;\n  padding: var(--size-1) var(--size-4);\n"
    ]);
    footer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var AncillaryNavigation = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-c0110bb-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.android_drawer.bottom_section_font, [
        "color",
        "font_family", 
    ])), {
        display: "flex",
        flexDirection: "column",
        fontSize: "var(--config-text__primary-text-size)",
        fontWeight: 400,
        margin: "auto 0 var(--size-8)"
    });
});
var AncillaryItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c0110bb-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        display: "block",
        padding: "var(--size-1) var(--size-4)"
    }, (0,utils/* getFontStyles */.l)(theme.android_drawer.bottom_section_font, [
        "color"
    ]));
});
var Version = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c0110bb-2"
})(footer_styles_templateObject());
var Logout = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c0110bb-3"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        appearance: "none",
        background: "none",
        border: "none",
        display: "block",
        padding: "var(--size-1) var(--size-4)",
        textAlign: "left"
    }, (0,utils/* getFontStyles */.l)(theme.android_drawer.bottom_section_font, [
        "color"
    ]));
});

// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(44373);
;// CONCATENATED MODULE: ./src/components/android/navigation-drawer/footer/index.tsx








var customRoutes = [
    {
        name: "route_one_name",
        url: "route_one_url"
    },
    {
        name: "route_two_name",
        url: "route_two_url"
    },
    {
        name: "route_three_name",
        url: "route_three_url"
    }, 
];
var navigation_drawer_footer_Footer = function(param) {
    var onDismiss = param.onDismiss;
    var loggedIn = (0,hooks/* useAccount */.mA)().loggedIn;
    var strings = (0,es.useSelector)(function(state) {
        return state.app.cmsConfig;
    }).strings;
    var dispatch = (0,es.useDispatch)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AncillaryNavigation, {
        children: [
            loggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logout, {
                onClick: function() {
                    dispatch(auth_actions/* default.logout */.Z.logout());
                    onDismiss();
                },
                children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.sign_out")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.terms_and_conditions_url"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AncillaryItem, {
                    children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.terms_and_conditions")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.privacy_policy_url"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AncillaryItem, {
                    children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.privacy_policy")
                })
            }),
            customRoutes.filter(function(route) {
                return(// @ts-ignore
                strings.android_drawer[route.name] && // @ts-ignore
                strings.android_drawer[route.url]);
            }).map(function(route) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: strings.android_drawer[route.url],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AncillaryItem, {
                            children: strings.android_drawer[route.name]
                        })
                    })
                });
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Version, {
                children: (0,android/* getAndroidShellVersion */.i)()
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/android/navigation-drawer/header/header.styles.ts


var header_styles_Container = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-3083da71-0"
})(function(param) {
    var theme = param.theme;
    var subtitleProperties = (0,utils/* getFontStyles */.l)(theme.android_drawer.subtitle_font);
    return {
        "--navigation-item__border-color": "transparent",
        "--navigation-item__font-family": subtitleProperties.fontFamily,
        "--navigation-item__font-weight": "normal",
        "--navigation-item__padding-x": 0,
        "--navigation-item__padding-y": "var(--size-2)",
        "--navigation-item__height": "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        height: "var(--size-48)",
        padding: "var(--size-18) var(--size-4) var(--size-4)"
    };
});
var header_styles_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-3083da71-1"
})(function(param) {
    var theme = param.theme;
    var titleProperties = (0,utils/* getFontStyles */.l)(theme.android_drawer.title_font);
    return {
        "--android-navigation-title__color": titleProperties.color,
        "--android-navigation-title__font-family": titleProperties.fontFamily,
        "--android-navigation-title__font-size": titleProperties.fontSize,
        color: "var(--android-navigation-title__color, --config-global__secondary-body-color)",
        fontFamily: "var(--android-navigation-title__font-family, --config-secondary-font-family__bold)",
        fontSize: "var(--android-navigation-title__font-size, --config-text__secondary-text-size)",
        lineHeight: "normal",
        margin: "0"
    };
});

// EXTERNAL MODULE: ./src/components/uielements/navigation/index.tsx + 2 modules
var navigation = __webpack_require__(21516);
;// CONCATENATED MODULE: ./src/components/android/navigation-drawer/header/index.tsx














var Header = function() {
    var router = (0,next_router.useRouter)();
    var referrer = (0,global/* deriveReferrer */.k5)(router);
    var strings = (0,es.useSelector)(function(state) {
        return state.app.cmsConfig;
    }).strings;
    var currentPoints = (0,hooks/* useRewardsState */.rV)().currentPoints;
    var ref = (0,hooks/* useAccount */.mA)(), loggedIn = ref.loggedIn, userDetails = ref.userDetails;
    var loginWithReferrer = "".concat(routes/* ROUTES.LOGIN */.Z6.LOGIN, "?referrer=").concat(referrer);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_styles_Container, {
        children: [
            loggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_styles_Title, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            html: true,
                            accessor: "android_drawer.user_title",
                            dataObj: {
                                user: userDetails === null || userDetails === void 0 ? void 0 : userDetails.name,
                                first: userDetails === null || userDetails === void 0 ? void 0 : userDetails.first_name
                            },
                            tag: "span"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                        featureFlag: features/* FEATURE_FLAGS.ACCOUNT__REWARDS */.y8.ACCOUNT__REWARDS,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation/* Navigation.Item */.W.Item, {
                            href: routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
                            onClick: function() {
                                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.VIEW__REWARDS */.x.VIEW__REWARDS, {
                                    name: constants/* EventNames.ANDROID_NAVIGATION */.V.ANDROID_NAVIGATION,
                                    details: "Reedem points"
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                html: true,
                                accessor: "android_drawer.user_points_total",
                                dataObj: {
                                    points: currentPoints
                                },
                                tag: "span"
                            })
                        })
                    })
                ]
            }),
            !loggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_styles_Title, {
                        children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.guest_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                        featureFlag: features/* FEATURE_FLAGS.ACCOUNT__REWARDS */.y8.ACCOUNT__REWARDS,
                        renderFallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation/* Navigation.Item */.W.Item, {
                            href: loginWithReferrer,
                            children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.guest_subtitle_no_loyalty")
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation/* Navigation.Item */.W.Item, {
                            href: loginWithReferrer,
                            children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.guest_subtitle")
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/android/navigation-drawer/links/links.styles.ts


var NavigationListOverrides = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-51c5a6e4-0"
})(function(param) {
    var theme = param.theme;
    var sectionProperties = (0,utils/* getFontStyles */.l)(theme.android_drawer.section_font);
    return {
        "--navigation-item__border-color": theme.android_drawer.separator,
        "--navigation-item__color": sectionProperties.color,
        "--navigation-item__font-family": sectionProperties.fontFamily
    };
});

;// CONCATENATED MODULE: ./src/components/android/navigation-drawer/links/index.tsx











var Links = function() {
    var strings = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }).strings;
    var loggedIn = (0,hooks/* useAccount */.mA)().loggedIn;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationListOverrides, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(navigation/* Navigation.List */.W.List, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                    featureFlag: features/* FEATURE_FLAGS.ACCOUNT__FAVORITES */.y8.ACCOUNT__FAVORITES,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation/* Navigation.Item */.W.Item, {
                        href: routes/* LOYALTY_ROUTES.FAVORITES */.xM.FAVORITES,
                        onClick: function() {
                            (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.VIEW__FAVORITES */.x.VIEW__FAVORITES, {
                                name: constants/* EventNames.ANDROID_NAVIGATION */.V.ANDROID_NAVIGATION
                            });
                        },
                        children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.favorites")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation/* Navigation.Item */.W.Item, {
                    href: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
                    onClick: function() {
                        (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.VIEW__STORE_LOCATOR */.x.VIEW__STORE_LOCATOR, {
                            name: constants/* EventNames.ANDROID_NAVIGATION */.V.ANDROID_NAVIGATION
                        });
                    },
                    children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.locations")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation/* Navigation.Item */.W.Item, {
                    href: routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
                    onClick: function() {
                        (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.VIEW__ORDER_HISTORY */.x.VIEW__ORDER_HISTORY, {
                            name: constants/* EventNames.ANDROID_NAVIGATION */.V.ANDROID_NAVIGATION
                        });
                    },
                    children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.order_history")
                }),
                loggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation/* Navigation.Item */.W.Item, {
                    href: routes/* LOYALTY_ROUTES.ACCOUNT */.xM.ACCOUNT,
                    children: (0,stringHelpers/* safelyGetString */.bc)(strings, "android_drawer.account")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/android/navigation-drawer/navigation-drawer.styles.ts

function navigation_drawer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  appearance: none;\n  background: white;\n  border: none;\n  border-radius: 100%;\n  box-shadow: 0 0 0.5rem 0 rgba(26, 26, 26, 0.1);\n  color: var(--config-global__primary-active-color);\n  display: flex;\n  height: var(--size-12);\n  justify-content: center;\n  position: fixed;\n  left: var(--size-4);\n  top: var(--size-6);\n  width: var(--size-12);\n  z-index: var(--layer-100);\n\n  svg {\n    flex: 0 0 var(--size-6);\n  }\n"
    ]);
    navigation_drawer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function navigation_drawer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  position: fixed;\n  z-index: var(--layer-50);\n"
    ]);
    navigation_drawer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function navigation_drawer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  background-color: rgba(26, 26, 26, 0.2);\n  backdrop-filter: blur(13.6px);\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  opacity: var(--android-navigation--overlay__opacity);\n  position: absolute;\n  transition: all 0.4s ease;\n"
    ]);
    navigation_drawer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function navigation_drawer_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  background-color: var(--android-navigation--panel__background-color, white);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: absolute;\n  transition: all var(--android-navigation--panel__transition-duration)\n    var(--android-navigation--panel__transition-timing-function);\n  transform: translateX(var(--android-navigation--panel__translateX));\n  max-width: var(--size-80);\n  width: 75%;\n"
    ]);
    navigation_drawer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function navigation_drawer_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  border-top: 1px solid var(--android-navigation-scroll-container__border-color, transparent);\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n"
    ]);
    navigation_drawer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var navigation_drawer_styles_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a6a6a7fc-0"
})(navigation_drawer_styles_templateObject());
var navigation_drawer_styles_Drawer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6a6a7fc-1"
})(navigation_drawer_styles_templateObject1());
var navigation_drawer_styles_Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6a6a7fc-2"
})(navigation_drawer_styles_templateObject2(), function(param) {
    var isVisible = param.isVisible;
    return "\n    --android-navigation--overlay__opacity: ".concat(isVisible ? 1 : 0, ";\n  ");
});
var navigation_drawer_styles_Panel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6a6a7fc-3"
})(navigation_drawer_styles_templateObject3(), function(param) {
    var theme = param.theme, isVisible = param.isVisible;
    return "\n    --android-navigation--panel__background-color: ".concat(theme.android_drawer.background_color, ";\n    --android-navigation--panel__translateX: ").concat(isVisible ? "0" : "-100%", ";\n    --android-navigation--panel__transition-timing-function: ").concat(isVisible ? "ease" : "ease-out", ";\n    --android-navigation--panel__transition-duration: ").concat(isVisible ? ".4s" : ".2s", ";\n  ");
});
var ScrollContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6a6a7fc-4"
})(navigation_drawer_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    --android-navigation-scroll-container__border-color: ".concat(theme.android_drawer.separator, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/android/navigation-drawer/index.tsx









var AndroidNavigationDrawer = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var onDismiss = param.onDismiss, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible;
    /*
     * Per the useState documentation:
     * The initialState argument is the state used during the initial render. In subsequent renders, it is disregarded.
     * [...] you may provide a function instead, which will be executed only on the initial render
     *
     * https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
     *
     * we also need the process.browser check here so this doesn't run on the server
     */ var _$ref = (0,react.useState)(function() {
        return  true ? document.createElement("div") : 0;
    }), container = _$ref[0];
    (0,react.useEffect)(function() {
        if (container) {
            document.body.appendChild(container);
        }
        return function() {
            container && document.body.removeChild(container);
        };
    }, []);
    return container ? /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(navigation_drawer_styles_Drawer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_drawer_styles_Overlay, {
                isVisible: isVisible,
                onClick: function() {
                    return onDismiss();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(navigation_drawer_styles_Panel, {
                ref: ref,
                isVisible: isVisible,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Links, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_drawer_footer_Footer, {
                                onDismiss: onDismiss
                            })
                        ]
                    })
                ]
            })
        ]
    }), container) : null;
});
var AndroidNavigation = function() {
    var ref = (0,useAnimatedVisibility/* useAnimatedVisibility */.p)(), isMounted = ref.isMounted, shouldDisplay = ref.shouldDisplay, toggle = ref.toggle, ref1 = ref.ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_drawer_styles_Button, {
                onClick: function() {
                    return toggle();
                },
                children: shouldDisplay ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Close */.Z.Close, {
                    title: "Close Navigation Drawer"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Menu */.Z.Menu, {
                    title: "Open Navigation Drawer"
                })
            }),
            isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(AndroidNavigationDrawer, {
                ref: ref1,
                isVisible: shouldDisplay,
                onDismiss: function() {
                    return toggle();
                }
            })
        ]
    });
};
/* harmony default export */ var navigation_drawer = (AndroidNavigation);

;// CONCATENATED MODULE: ./src/components/header/navigation-drawer/account-link.tsx








function AccountLink(_param) {
    var children = _param.children, href = _param.href, accessor = _param.accessor, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href",
        "accessor"
    ]);
    var component = /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "a",
        css: {
            height: "$10"
        }
    }, otherProps), {
        children: children
    }));
    if (accessor) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
            checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
            checkName: accessor,
            component: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                passHref: true,
                children: component
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            passHref: true,
            children: component
        });
    }
}

;// CONCATENATED MODULE: ./src/components/header/navigation-drawer/notification.tsx






function Notification(param) {
    var children = param.children;
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("header"), background_color = ref.background_color, font = ref.font;
    var color = (0,utils/* getFontStyles */.l)(font, [
        "color"
    ]).color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
        position: "center",
        css: {
            background: color,
            borderRadius: "100%",
            color: background_color !== null && background_color !== void 0 ? background_color : (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(color),
            display: "flex",
            height: "$5",
            fontSize: ".625em",
            lineHeight: 1,
            textAlign: "center",
            width: "$5"
        },
        children: children
    });
}

;// CONCATENATED MODULE: ./src/components/header/navigation-drawer/account-details.tsx
























function AccountDetails(param) {
    var _showDetailsByDefault = param.showDetailsByDefault, showDetailsByDefault = _showDetailsByDefault === void 0 ? false : _showDetailsByDefault, onSignOut = param.onSignOut;
    // referrer setup
    var router = (0,next_router.useRouter)();
    var referrer = (0,global/* deriveReferrer */.k5)(router);
    var cancelRedirect = router === null || router === void 0 ? void 0 : router.pathname.includes(routes/* ROUTES.ACCOUNT */.Z6.ACCOUNT);
    var ref = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }), strings = ref.strings, webConfig = ref.webConfig;
    var ref1 = (0,utils/* getFontStyles */.l)(webConfig.modals.font, [
        "color"
    ]), fontColor = ref1.color;
    // account details
    var ref2 = (0,hooks/* useAccount */.mA)(), loggedIn = ref2.loggedIn, userDetails = ref2.userDetails, loyalty = ref2.loyalty, points = ref2.points, availableRewards = ref2.availableRewards, unreadMessages = ref2.unreadMessages, logout = ref2.logout;
    var ref3 = (0,react.useState)(showDetailsByDefault), showDetails = ref3[0], toggleDetails = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_details_Container, {
        css: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(webConfig.header.font, [
            "font_size"
        ])), {
            color: fontColor,
            "& button": {
                color: fontColor
            }
        }),
        children: [
            !loggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(routes/* ROUTES.LOGIN */.Z6.LOGIN, "?referrer=").concat(referrer),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: function() {
                        return (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.AUTH__CLICK_SIGN_IN */.x.AUTH__CLICK_SIGN_IN);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Signin, {
                        children: (0,stringHelpers/* safelyGetString */.bc)(strings, "global_header.sign_in_cta")
                    })
                })
            }),
            loggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleLinks, {
                        css: {
                            color: fontColor
                        },
                        onClick: function() {
                            if (!showDetailsByDefault) {
                                toggleDetails(!showDetails);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                                "data-css-override": "StyledLinkWithIcon",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedPersonIcon */.WX, {}),
                                    " Hi, ",
                                    userDetails === null || userDetails === void 0 ? void 0 : userDetails.first_name
                                ]
                            }),
                            !showDetailsByDefault && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                css: {
                                    height: "$6",
                                    transform: showDetails ? "rotate(-90deg)" : "rotate(90deg)",
                                    width: "$6"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Caret */.Z.Caret, {
                                    title: "Down arrow"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Box */.xu, {
                        css: {
                            paddingLeft: "$9"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                                checkName: constants_loyalty/* LOYALTY_FEATURES.SHOW_LOYALTY_STATE */.lw.SHOW_LOYALTY_STATE,
                                component: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                                    align: "leading",
                                    direction: "vertical",
                                    gap: "0",
                                    css: {
                                        fontSize: ".875em"
                                    },
                                    children: [
                                        (loyalty === null || loyalty === void 0 ? void 0 : loyalty.membership_level_name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: loyalty === null || loyalty === void 0 ? void 0 : loyalty.membership_level_name
                                        }),
                                        points.value > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "rewards.account_menu_points_subheader",
                                            html: true,
                                            tag: "span",
                                            dataObj: {
                                                number: points.value.toLocaleString(),
                                                counter: points.message
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                                direction: "vertical",
                                align: "leading",
                                css: {
                                    height: showDetails ? "auto" : 0,
                                    overflow: "hidden",
                                    padding: "$4 0 0"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLink, {
                                        accessor: routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
                                        href: routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
                                        "aria-label": "Go to Rewards page",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                    accessor: "rewards.title"
                                                }),
                                                availableRewards > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification, {
                                                    children: availableRewards
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountLink, {
                                        accessor: routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX,
                                        href: routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX,
                                        "aria-label": "Go to Inbox page",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                accessor: "inbox.title"
                                            }),
                                            unreadMessages > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification, {
                                                children: unreadMessages
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLink, {
                                        accessor: routes/* LOYALTY_ROUTES.FAVORITES */.xM.FAVORITES,
                                        href: routes/* LOYALTY_ROUTES.FAVORITES */.xM.FAVORITES,
                                        "aria-label": "Go to Favorites page",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "favorites.title"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLink, {
                                        accessor: routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
                                        href: routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
                                        "aria-label": "Go to Order History page",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "order_history.title"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLink, {
                                        accessor: routes/* LOYALTY_ROUTES.ACCOUNT */.xM.ACCOUNT,
                                        href: routes/* LOYALTY_ROUTES.ACCOUNT */.xM.ACCOUNT,
                                        "aria-label": "Go to Account page",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "account.title"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLink, {
                                        href: "#",
                                        "aria-label": "Click to Sign Out",
                                        onClick: function(e) {
                                            e.preventDefault();
                                            logout(cancelRedirect);
                                            onSignOut();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "account.sign_out_button"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var account_details_Container = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    fontFamily: "$primaryBold",
    fontSize: "$primary",
    justifyContent: "flex-end",
    margin: "-$12 0 0",
    padding: "$24 $4 $4 $3-5"
});
var ToggleLinks = (0,stitches/* styled */.zo)("button", {
    alignItems: "center",
    background: "none",
    border: "none",
    display: "flex",
    justifyContent: "space-between",
    padding: 0
});

;// CONCATENATED MODULE: ./src/components/header/navigation-drawer/links.tsx





function links_Links(param) {
    var links = param.links, onDismiss = param.onDismiss, _inlineMenu = param.inlineMenu, inlineMenu = _inlineMenu === void 0 ? false : _inlineMenu;
    var font_size = (0,cmsConfig/* useConfigOverride */.$E)("header").font_size;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: links.order.map(function(id) {
            var ref;
            var link = links.links[id];
            var ref1;
            var ref2 = (ref1 = link === null || link === void 0 ? void 0 : link.reference) !== null && ref1 !== void 0 ? ref1 : {}, _type = ref2.type, type = _type === void 0 ? "external" : _type, _label = ref2.label, label = _label === void 0 ? "" : _label, _url = ref2.url, url = _url === void 0 ? "#" : _url, _newWindow = ref2.newWindow, newWindow = _newWindow === void 0 ? false : _newWindow;
            var active = type === "local" && url === ((ref = router.query.id) === null || ref === void 0 ? void 0 : ref[0]);
            var _label1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: type === "local" ? "/".concat(url) : url,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links_Element, {
                    active: active,
                    position: inlineMenu ? "inline" : "drawer",
                    target: newWindow || type !== "local" ? "_blank" : "_self",
                    onClick: function onClick() {
                        onDismiss && onDismiss();
                    },
                    css: {
                        fontSize: "".concat(font_size, "px")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (_label1 = link.label) !== null && _label1 !== void 0 ? _label1 : label
                    })
                })
            });
        })
    });
}
var links_Element = (0,stitches/* styled */.zo)("a", {
    fontFamily: "$primaryBold",
    fontSize: "$primary",
    padding: "$4 0",
    transform: "translateX(0)",
    transition: "all .25s ease-in-out",
    span: {
        borderBottom: "2px solid transparent",
        transition: "all .25s ease-in-out"
    },
    "&:active": {
        opacity: 0.7
    },
    variants: {
        active: {
            true: {
                span: {
                    borderColor: "currentColor"
                }
            }
        },
        position: {
            inline: {
                padding: "0",
                "&:hover": {
                    transform: "translateY(-0.25rem)"
                }
            },
            drawer: {
                "&:hover": {
                    transform: "translateX(0.25rem)"
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/components/header/navigation-drawer/index.tsx
















function navigation_drawer_Drawer(param) {
    var children = param.children, onDismiss = param.onDismiss, _shouldDisplay = param.shouldDisplay, shouldDisplay = _shouldDisplay === void 0 ? false : _shouldDisplay, _hasNavigation = param.hasNavigation, hasNavigation = _hasNavigation === void 0 ? false : _hasNavigation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(navigation_drawer_Panel, {
        shouldDisplay: shouldDisplay,
        onEscapeKeyDown: onDismiss,
        onPointerDownOutside: onDismiss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle, {
                onClick: onDismiss,
                css: {
                    position: "sticky",
                    top: "0",
                    "@md": {
                        position: "relative"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Close */.Z.Close, {
                    title: "Open Navigation Drawer"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                css: {
                    "@md": {
                        display: "none"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountDetails, {
                    showDetailsByDefault: !hasNavigation,
                    onSignOut: onDismiss
                })
            }),
            children
        ]
    });
}
function Navigation(param) {
    var links = param.links, hasNavigation = param.hasNavigation, inlineMenu = param.inlineMenu, signedIn = param.signedIn;
    var ref = (0,useAnimatedVisibility/* useAnimatedVisibility */.p)(), isMounted = ref.isMounted, shouldDisplay = ref.shouldDisplay, toggle = ref.toggle, ref1 = ref.ref;
    var ref2 = (0,cmsConfig/* useConfigOverride */.$E)("modals"), active_font_color = ref2.active_font_color, font = ref2.font;
    var ref3 = (0,utils/* getFontStyles */.l)(font), font_color = ref3.color;
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hasNavigation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                        css: {
                            "@md": {
                                display: inlineMenu ? "none" : "block"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle, {
                            onClick: function() {
                                toggle();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Menu */.Z.Menu, {
                                title: "Open Navigation Drawer"
                            })
                        })
                    }),
                    links && inlineMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
                        as: "nav",
                        css: {
                            display: "none",
                            gap: "$1 $5",
                            order: 2,
                            "@md": {
                                display: "flex",
                                flexWrap: "wrap"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links_Links, {
                            links: links,
                            inlineMenu: inlineMenu
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Box */.xu, {
                css: {
                    "@md": {
                        // non commerce+ customers should never interact with the navigation drawer on desktop
                        display: "none"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericRouteAccessor, {
                        allowedPages: (_obj = {}, (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.ACCOUNT */.Z6.ACCOUNT, null), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT, {
                            exactMatch: true
                        }), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.LOGIN */.Z6.LOGIN, {
                            exactMatch: true
                        }), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.SIGN_UP */.Z6.SIGN_UP, {
                            exactMatch: true
                        }), _obj),
                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToMenu, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericRouteAccessor, {
                        allowedPages: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE, {
                            exactMatch: true
                        }), (0,_define_property/* default */.Z)(_obj1, routes/* ROUTES.STORE */.Z6.STORE, null), (0,_define_property/* default */.Z)(_obj1, routes/* ROUTES.PAGE */.Z6.PAGE, null), _obj1),
                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle, {
                                onClick: function() {
                                    signedIn && toggle();
                                },
                                children: signedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedPersonIcon */.WX, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Signin, {})
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Root */.fC, {
                open: isMounted,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Portal */.h_, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(navigation_drawer_Container, {
                        // @ts-expect-error: ref typing consistenly throws an error
                        ref: ref1,
                        css: {
                            color: font_color,
                            "& a": {
                                color: active_font_color
                            },
                            "& button": {
                                color: font_color
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_drawer_Overlay, {
                                shouldDisplay: shouldDisplay,
                                "data-testid": "sidecart-overlay"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_drawer_Drawer, {
                                hasNavigation: hasNavigation,
                                shouldDisplay: shouldDisplay,
                                onDismiss: function() {
                                    return toggle();
                                },
                                children: links && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinksContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links_Links, {
                                        links: links,
                                        onDismiss: function() {
                                            return toggle();
                                        }
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var Toggle = (0,stitches/* styled */.zo)("button", {
    alignItems: "center",
    appearance: "none",
    background: "none",
    border: "none",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto 0 $4",
    padding: 0,
    "&:focus": {
        outline: "none"
    },
    "&:focus-visible": {
        outline: "inherit"
    },
    "@md": {
        margin: "0 auto 0 0"
    }
});
var navigation_drawer_Container = (0,stitches/* styled */.zo)("div", {
    alignItems: "stretch",
    bottom: 0,
    display: "flex",
    justifyContent: "flex-start",
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
    transition: "all 0.6s linear",
    zIndex: "$50"
});
var navigation_drawer_Overlay = (0,stitches/* styled */.zo)(dist/* Overlay */.aV, {
    background: "rgba(26, 26, 26, 0.16)",
    bottom: 0,
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    transition: "all 0.4s ease",
    zIndex: "$0",
    variants: {
        shouldDisplay: {
            false: {
                opacity: 0.01
            },
            true: {
                opacity: 1
            }
        }
    }
});
var navigation_drawer_Panel = (0,stitches/* styled */.zo)(dist/* Content */.VY, {
    backgroundColor: "$shade200",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "scroll",
    padding: "$6 0 0",
    transition: "all 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
    width: "$72",
    zIndex: "$10",
    variants: {
        shouldDisplay: {
            false: {
                transform: "translateX(-100%)"
            },
            true: {
                transform: "translateX(0%)"
            }
        }
    },
    "@md": {
        backgroundColor: "$shade100",
        padding: "$7 $10 $10",
        width: "$96"
    },
    "&:focus": {
        outline: "none"
    }
});
var LinksContainer = (0,stitches/* styled */.zo)("nav", {
    backgroundColor: "$shade100",
    borderTop: "1px solid $shade300",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: "$3 $4 $4",
    "@md": {
        borderTop: "none",
        padding: "$6 0 0"
    }
});

// EXTERNAL MODULE: ../../packages/sdk/dist/v4/index.mjs + 8 modules
var v4 = __webpack_require__(40024);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-popover/dist/index.mjs
var react_popover_dist = __webpack_require__(13844);
;// CONCATENATED MODULE: ./src/features/menu-availability/button.tsx

var menu_availability_button_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-d97640ae-0"
})(function(param) {
    var theme = param.theme;
    return {
        appearance: "none",
        alignItems: "center",
        backgroundColor: "transparent",
        border: "1px solid",
        borderColor: theme.buttons.primary_button_border_color,
        borderRadius: "0.5rem",
        color: "inherit",
        display: "flex",
        height: "2rem",
        gap: "0.25rem",
        padding: "0 0.5rem",
        whiteSpace: "nowrap"
    };
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
;// CONCATENATED MODULE: ./src/components/ui/form/radio.tsx





var RadioInput = function(_param) /*#__PURE__*/ {
    var children = _param.children, checked = _param.checked, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "checked"
    ]);
    return (0,jsx_runtime.jsxs)(radio_Label, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
                type: "radio",
                checked: checked
            }, otherProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    });
};
var radio_Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-96f5c96a-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        display: "flex",
        gap: ".625rem"
    }, (0,utils/* getFontStyles */.l)(theme.forms.font));
});
var _border_color, _primary_active_color, _primary_active_color1;
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-96f5c96a-1"
})(function(param) {
    var theme = param.theme;
    return {
        all: "unset",
        border: "2px solid",
        borderColor: (_border_color = theme.forms.border_color) !== null && _border_color !== void 0 ? _border_color : "#ddd",
        boxSizing: "border-box",
        borderRadius: "100%",
        height: "1.125rem",
        outline: "revert",
        position: "relative",
        width: "1.125rem",
        "&:checked": {
            borderColor: (_primary_active_color = theme.global.primary_active_color) !== null && _primary_active_color !== void 0 ? _primary_active_color : "black"
        },
        "&:checked:after": {
            backgroundColor: (_primary_active_color1 = theme.global.primary_active_color) !== null && _primary_active_color1 !== void 0 ? _primary_active_color1 : "black",
            borderRadius: "100%",
            content: "''",
            inset: "1px",
            position: "absolute"
        }
    };
});

// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(47661);
// EXTERNAL MODULE: ./src/services/client.ts
var services_client = __webpack_require__(49741);
;// CONCATENATED MODULE: ./src/features/loyalty/addresses.ts




function useSavedAddresses() {
    var client = (0,services_client/* createHttpClient */.d9)({
        origin: (0,src_utils/* getOrigin */.P$)(window.location.host)
    });
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            "loyalty-saved-addresses"
        ],
        queryFn: function() {
            return (0,v4/* getStoredAddresses */.I8)({
                client: client
            });
        },
        refetchOnWindowFocus: false,
        staleTime: 60000
    });
}

;// CONCATENATED MODULE: ./src/features/menu-availability/saved-addresses.tsx




function SavedAddresses(param) {
    var onUpdate = param.onUpdate, value = param.value;
    var ref = useSavedAddresses(), data = ref.data, isSuccess = ref.isSuccess;
    if (!isSuccess) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(saved_addresses_Container, {
            children: data.data.map(function(address, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(saved_addresses_Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioInput, {
                        value: String(address.id),
                        checked: Boolean(value && Number(address.id) === Number(value === null || value === void 0 ? void 0 : value.id)),
                        name: "saved-address",
                        onChange: function() {
                            return onUpdate(address);
                        },
                        children: [
                            address.street_address,
                            address.street_address_2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    ",\xa0",
                                    address.street_address_2
                                ]
                            }),
                            ",\xa0",
                            address.city,
                            ", ",
                            address === null || address === void 0 ? void 0 : address.zip_code
                        ]
                    })
                }, "address-".concat(index));
            })
        })
    });
}
var saved_addresses_Container = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-b8d02f52-0"
})({
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    margin: 0,
    padding: 0
});
var saved_addresses_Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-b8d02f52-1"
})({
    listStyle: "none"
});

// EXTERNAL MODULE: ../../node_modules/radar-sdk-js/dist/radar.js
var radar = __webpack_require__(98735);
// EXTERNAL MODULE: ../../node_modules/use-places-autocomplete/dist/index.esm.js
var index_esm = __webpack_require__(57379);
// EXTERNAL MODULE: ../../node_modules/load-google-maps-api/index.js
var load_google_maps_api = __webpack_require__(42764);
var load_google_maps_api_default = /*#__PURE__*/__webpack_require__.n(load_google_maps_api);
// EXTERNAL MODULE: ./src/constants/locations.ts
var constants_locations = __webpack_require__(56296);
// EXTERNAL MODULE: ./src/utils/errorReporter.ts
var errorReporter = __webpack_require__(19663);
;// CONCATENATED MODULE: ./src/components/autocomplete/helpers.ts









/**
 * takes an array of address components and returns an address object
 */ var mapAutocompleteAddress = function(components) {
    var newFormattedAddress = {};
    components.forEach(function(component) {
        var key = component.types[0];
        // @ts-expect-error: key is cast as as string, but since we're working within a returned object, we can ignore this
        newFormattedAddress[key] = component.short_name;
    });
    return newFormattedAddress;
};
/**
 * A wrapper hook to handle loading google maps and returning autocomplete values
 */ function useAddressAutocomplete() {
    var ref = (0,react.useState)({
        initOnMount: false
    }), options = ref[0], setOptions = ref[1];
    var ref1 = (0,react.useState)(false), ready = ref1[0], setReady = ref1[1];
    var map_key = (0,cmsConfig/* useConfigOverride */.$E)("locations").map_key;
    var ref2 = (0,index_esm/* default */.ZP)(options), init = ref2.init, value = ref2.value, _suggestions = ref2.suggestions, loading = _suggestions.loading, data = _suggestions.data, status = _suggestions.status, updateValue = ref2.setValue, clearSuggestions = ref2.clearSuggestions;
    function tryLoadingGoogleMaps() {
        return _tryLoadingGoogleMaps.apply(this, arguments);
    }
    function _tryLoadingGoogleMaps() {
        _tryLoadingGoogleMaps = (0,_async_to_generator/* default */.Z)(function() {
            var googleMaps, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            load_google_maps_api_default()({
                                key: map_key,
                                libraries: [
                                    constants_global/* GOOGLE_LIBRARIES.PLACES */.Yv.PLACES
                                ]
                            })
                        ];
                    case 1:
                        googleMaps = _state.sent();
                        setOptions({
                            requestOptions: {
                                sessionToken: new googleMaps.places.AutocompleteSessionToken(),
                                types: [
                                    "geocode"
                                ],
                                componentRestrictions: {
                                    country: Object.values(constants_locations/* SUPPORTED_COUNTRIES */.WU)
                                }
                            },
                            googleMaps: googleMaps,
                            debounce: 500
                        });
                        init();
                        setReady(true);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        errorReporter/* captureException */.Tb(e);
                        console.error(e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _tryLoadingGoogleMaps.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        void tryLoadingGoogleMaps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        clearSuggestions: clearSuggestions,
        data: data,
        loading: loading,
        ready: ready,
        status: status,
        updateValue: updateValue,
        value: value
    };
}

// EXTERNAL MODULE: ./src/components/uielements/searchInput/index.tsx
var searchInput = __webpack_require__(66143);
// EXTERNAL MODULE: ./src/utils/radarMaps.ts
var radarMaps = __webpack_require__(84986);
// EXTERNAL MODULE: ../../node_modules/downshift/dist/downshift.esm.js + 1 modules
var downshift_esm = __webpack_require__(11474);
;// CONCATENATED MODULE: ./src/components/ui/form/combobox.tsx







function Combobox(param) {
    var children = param.children, items = param.items, label = param.label, _required = param.required, required = _required === void 0 ? false : _required, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, onChange = param.onChange, onUpdate = param.onUpdate;
    var ref = (0,downshift_esm/* useCombobox */.Kb)({
        items: items,
        onInputValueChange: function(param) {
            var inputValue = param.inputValue;
            return onUpdate(String(inputValue));
        },
        itemToString: function itemToString(item) {
            return item ? item.label : "";
        },
        onSelectedItemChange: function(param) {
            var selectedItem = param.selectedItem;
            if (selectedItem) {
                void onChange(selectedItem.value);
            }
        }
    }), isOpen = ref.isOpen, getLabelProps = ref.getLabelProps, getMenuProps = ref.getMenuProps, getInputProps = ref.getInputProps, highlightedIndex = ref.highlightedIndex, getItemProps = ref.getItemProps;
    var ref1 = (0,cmsConfig/* useConfigOverride */.$E)("forms"), background_color = ref1.background_color, border_color = ref1.border_color, border_radius = ref1.border_radius;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(combobox_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox_Label, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getLabelProps()), {
                children: label
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox_Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getInputProps()), {
                placeholder: placeholder,
                required: required,
                overrides: {
                    backgroundColor: background_color !== null && background_color !== void 0 ? background_color : "transparent",
                    borderColor: border_color !== null && border_color !== void 0 ? border_color : "$shade300",
                    borderRadius: "".concat(Number(border_radius), "px")
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Results, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                hidden: !(isOpen && items.length)
            }, getMenuProps()), {
                children: [
                    isOpen && items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox_Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                            item: item,
                            index: index
                        })), {
                            highlighted: highlightedIndex === index,
                            children: item.label
                        }), "".concat(item.label).concat(index));
                    }),
                    children
                ]
            }))
        ]
    });
}
var combobox_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e4cd2ea-0"
})({
    position: "relative"
});
var combobox_Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-9e4cd2ea-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.forms.font, {
        font_weight: function() {
            return 700;
        }
    }));
});
var combobox_Field = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-9e4cd2ea-2"
})(function(param) {
    var theme = param.theme, overrides = param.overrides;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center",
        appearance: "none",
        backgroundColor: "transparent",
        border: "1px solid #eee",
        borderRadius: "0.5rem",
        boxSizing: "border-box",
        cursor: "text",
        flex: 1,
        height: "3rem",
        lineHeight: 1,
        margin: ".5rem 0 0",
        minWidth: 0,
        padding: ".5rem .75rem",
        position: "relative",
        transition: "all .2s ease",
        width: "100%",
        zIndex: "$10"
    }, overrides, (0,utils/* getFontStyles */.l)(theme.forms.font)), {
        "&:focus": {
            borderColor: theme.global.primary_active_color,
            outline: "none"
        }
    });
});
var Results = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-9e4cd2ea-3"
})(function(param) {
    var hidden = param.hidden;
    return {
        backgroundColor: "white",
        borderRadius: "4px",
        boxShadow: "0 0 4px rgba(0, 0, 0, 0.2)",
        display: hidden ? "none" : "flex",
        flexDirection: "column",
        listStyleType: "none",
        margin: "unset",
        padding: "unset",
        position: "absolute",
        width: "100%",
        zIndex: 100
    };
});
var combobox_Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-9e4cd2ea-4"
})(function(param) {
    var theme = param.theme, _highlighted = param.highlighted, highlighted = _highlighted === void 0 ? false : _highlighted;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        appearance: "none",
        backgroundColor: highlighted ? "#eee" : "transparent",
        border: "none",
        borderRadius: "none",
        borderBottom: "1px solid #ddd",
        cursor: "pointer",
        padding: "0.5rem 1rem",
        textAlign: "left",
        transition: "all 0.2s ease"
    }, (0,utils/* getFontStyles */.l)(theme.primary_font.bold)), {
        "&:last-of-type": {
            borderBottom: 0
        },
        "&:hover": {
            opacity: 0.5
        },
        "&[data-highlighted]": {
            backgroundColor: "rgba(0, 0, 0, 0.05)"
        }
    });
});

;// CONCATENATED MODULE: ./src/components/autocomplete/index.tsx















var RadarAutocomplete = function(param) {
    var onUpdate = param.onUpdate;
    var delivery_search_placeholder = (0,cmsConfig/* useStringsOverride */.Fx)("locations").delivery_search_placeholder;
    var ref = useAddressAutocomplete(), clearSuggestions = ref.clearSuggestions, updateValue = ref.updateValue;
    var autocompleteRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        radar/* default.initialize */.Z.initialize(radarMaps/* RADAR_MAPS_CONFIG.sharableKey */.K.sharableKey);
        autocompleteRef.current = radar/* default.ui.autocomplete */.Z.ui.autocomplete({
            container: "index-delivery-autocomplete",
            width: "100%",
            responsive: false,
            maxHeight: "300px",
            placeholder: "",
            limit: 5,
            minCharacters: 2,
            onSelection: function(address) {
                setSelection(address);
            }
        });
        return function() {
            if (autocompleteRef.current) {
                autocompleteRef.current.remove();
            }
        };
    }, []);
    function setSelection(address) {
        return _setSelection.apply(this, arguments);
    }
    function _setSelection() {
        _setSelection = (0,_async_to_generator/* default */.Z)(function(address) {
            var formattedAddress, _city, ref, ref1, ref2, _postalCode;
            return (0,tslib_es6.__generator)(this, function(_state) {
                formattedAddress = address.formattedAddress;
                // When user selects a place, we can replace the keyword without
                // request data from API by setting the second parameter to `false`
                updateValue(formattedAddress, false);
                clearSuggestions();
                // everything returned can be undefined, so we cast as a string
                // the address object will always be checked by the Ordering API
                // to this should be a safe operation
                void onUpdate({
                    street_address: address.addressLabel,
                    city: (ref2 = (ref1 = (ref = (_city = address.city) !== null && _city !== void 0 ? _city : address.borough) !== null && ref !== void 0 ? ref : address.neighborhood) !== null && ref1 !== void 0 ? ref1 : address.county) !== null && ref2 !== void 0 ? ref2 : "",
                    state: address.state,
                    zip_code: (_postalCode = address.postalCode) !== null && _postalCode !== void 0 ? _postalCode : ""
                });
                return [
                    2
                ];
            });
        });
        return _setSelection.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(autocomplete_Label, {
                children: delivery_search_placeholder
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(searchInput/* StyledRadarAddressSearchInputWrapper */.KK, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "index-delivery-autocomplete"
                })
            })
        ]
    });
};
var autocomplete_Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-146452f3-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.forms.font, {
        font_weight: function() {
            return 700;
        }
    }));
});
// @TODO below is the original GoogleAutocomplete component and is deprecated.
var GoogleAutocomplete = function(param) {
    var onUpdate = param.onUpdate;
    var delivery_search_placeholder = (0,cmsConfig/* useStringsOverride */.Fx)("locations").delivery_search_placeholder;
    var ref = useAddressAutocomplete(), clearSuggestions = ref.clearSuggestions, data = ref.data, ready = ref.ready, updateValue = ref.updateValue;
    function setSelection(suggestion) {
        return _setSelection.apply(this, arguments);
    }
    function _setSelection() {
        _setSelection = (0,_async_to_generator/* default */.Z)(function(suggestion) {
            var description, place_id, details, ref, locality, sublocality, sublocality_level_1, administrative_area_level_1, postal_code, street_number, route, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        description = suggestion.description, place_id = suggestion.place_id;
                        // When user selects a place, we can replace the keyword without
                        // request data from API by setting the second parameter to `false`
                        updateValue(description, false);
                        clearSuggestions();
                        return [
                            4,
                            (0,index_esm/* getDetails */.s_)({
                                placeId: place_id,
                                fields: [
                                    "address_components",
                                    "place_id",
                                    "name",
                                    "types"
                                ]
                            })
                        ];
                    case 1:
                        details = _state.sent();
                        if (typeof details === "string" || !(details === null || details === void 0 ? void 0 : details.address_components)) {
                            return [
                                2
                            ];
                        }
                        ref = mapAutocompleteAddress(details.address_components), locality = ref.locality, sublocality = ref.sublocality, sublocality_level_1 = ref.sublocality_level_1, administrative_area_level_1 = ref.administrative_area_level_1, postal_code = ref.postal_code, street_number = ref.street_number, route = ref.route;
                        // everything returned can be undefined, so we cast as a string
                        // the address object will always be checked by the Ordering API
                        // to this should be a safe operation
                        void onUpdate({
                            street_address: "".concat(String(street_number), " ").concat(String(route)).trim(),
                            city: String((ref1 = locality !== null && locality !== void 0 ? locality : sublocality) !== null && ref1 !== void 0 ? ref1 : sublocality_level_1),
                            state: String(administrative_area_level_1),
                            zip_code: String(postal_code)
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _setSelection.apply(this, arguments);
    }
    if (!ready) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Combobox, {
        label: delivery_search_placeholder,
        items: data.map(function(suggestion) {
            var _structured_formatting = suggestion.structured_formatting, main_text = _structured_formatting.main_text, secondary_text = _structured_formatting.secondary_text;
            return {
                value: suggestion,
                label: "".concat(main_text, ", ").concat(secondary_text)
            };
        }),
        onChange: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // @ts-expect-error: value is unknown but we know it equates to the `value` property in the object returned from `data.map` above
                            return [
                                4,
                                setSelection(value)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }(),
        onUpdate: function(value) {
            updateValue(value);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredByGoogle, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                src: "/static/img/powered_by_google_on_white_hdpi.png",
                alt: "Powered By Google",
                height: 12,
                width: 96
            })
        })
    });
};
var PoweredByGoogle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-146452f3-1"
})({
    marginInlineStart: "auto",
    marginInlineEnd: "1rem",
    marginBlockEnd: ".05rem"
});

;// CONCATENATED MODULE: ./src/features/locations/service.tsx




function useLocation(id) {
    var origin;
    if (true) {
        origin = (0,src_utils/* getOrigin */.P$)(window.location.host);
    } else {}
    var client = (0,services_client/* createHttpClient */.d9)({
        origin: origin
    });
    var locationId = id !== null && id !== void 0 ? id : 0;
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            "location",
            {
                id: locationId
            }
        ],
        queryFn: function() {
            return (0,v4/* getLocation */.k$)({
                id: locationId,
                meta: {
                    include: [
                        "operating_hours",
                        "attributes",
                        "delivery_hours",
                        "business_hours", 
                    ]
                }
            }, {
                client: client
            });
        },
        enabled: id !== undefined,
        refetchOnWindowFocus: false,
        staleTime: 3600000
    });
}

;// CONCATENATED MODULE: ./src/features/menu-availability/address.service.ts






/**
 * Takes the location and a valid address object and checks
 * if the location can delivery to that address. If the response
 * is successful, an object with a key of `can_deliver` is returned as a boolean
 */ function addressCheckDeliveryCoverage(location, address) {
    return _addressCheckDeliveryCoverage.apply(this, arguments);
}
function _addressCheckDeliveryCoverage() {
    _addressCheckDeliveryCoverage = (0,_async_to_generator/* default */.Z)(function(location, address) {
        var client, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = (0,services_client/* createHttpClient */.d9)({
                        origin: (0,src_utils/* getOrigin */.P$)(window.location.host)
                    });
                    return [
                        4,
                        (0,v4/* checkDeliveryCoverage */.ts)(location, address, {
                            client: client
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return _addressCheckDeliveryCoverage.apply(this, arguments);
}
/**
 * Normalizes the required time wanted fields, including a null or ISO timestamp
 * for `time_wanted` (null is used in place of asap), along with the mode.
 */ function addressSetTimeWantedFields(timeWanted) {
    // if `timeWanted` is "asap" or undefined, its considered to be "asap"
    var isASAP = timeWanted === constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP || timeWanted === undefined;
    return {
        time_wanted: isASAP ? null : timeWanted,
        time_wanted_mode: isASAP ? constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP : constants_global/* DELIVERY_TIME_WANTED_MODES.ADVANCE */.hC.ADVANCE
    };
}

;// CONCATENATED MODULE: ./src/features/menu-availability/delivery-details.tsx






















function delivery_details_DeliveryDetails() {
    var ref = (0,react.useState)(false), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(false), editing = ref1[0], setEditing = ref1[1];
    var data = useSavedAddresses().data;
    var ref2 = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr), location = ref2.location, time_wanted = ref2.time_wanted, address = ref2.address;
    var ref3 = useLocation(location), locationDetails = ref3.data, locationSuccess = ref3.isSuccess;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var savedAddress = Boolean(data === null || data === void 0 ? void 0 : data.data.length);
    (0,react.useEffect)(function() {
        if ((address === null || address === void 0 ? void 0 : address.street_address) && (address === null || address === void 0 ? void 0 : address.city) && editing) {
            setEditing(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        address === null || address === void 0 ? void 0 : address.city,
        address === null || address === void 0 ? void 0 : address.street_address
    ]);
    if (!locationSuccess) {
        return null;
    }
    if ((address === null || address === void 0 ? void 0 : address.street_address) && !editing) {
        var streetAddress = address.street_address;
        if (address.street_address_2) {
            streetAddress = "".concat(streetAddress, " ").concat(address.street_address_2);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressDetails, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(delivery_details_Address, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "Delivering to"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                streetAddress,
                                ", ",
                                address.city
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditAddress, {
                    onClick: function() {
                        setEditing(true);
                    },
                    children: "Change delivery address"
                })
            ]
        });
    }
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    // @ts-expect-error
    var AutocompleteComponent = theme.global.radar_maps ? RadarAutocomplete : GoogleAutocomplete;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteComponent, {
                onUpdate: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
                        var fullAddress, response, error, errorResponse;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    fullAddress = (0,_object_spread/* default */.Z)({}, address, addressSetTimeWantedFields(time_wanted));
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        5
                                    ]);
                                    return [
                                        4,
                                        addressCheckDeliveryCoverage(locationDetails.data.id, fullAddress)
                                    ];
                                case 2:
                                    response = _state.sent();
                                    if (response.can_deliver) {
                                        setError(false);
                                        dispatch(conveyanceMode_actions/* default.setDeliveryAddress */.Z.setDeliveryAddress(fullAddress, locationDetails.data));
                                    } else {
                                        setError(true);
                                        // KA event
                                        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
                                            name: constants_events/* ERROR_MESSAGES.CHECK_DELIVERY_COVERAGE_ERROR */.RZ.CHECK_DELIVERY_COVERAGE_ERROR,
                                            details: response.message
                                        });
                                    }
                                    return [
                                        3,
                                        5
                                    ];
                                case 3:
                                    error = _state.sent();
                                    dispatch(global_actions/* default.displayErrorToast */.Z.displayErrorToast("There was an error validating your delivery address. Please try again in a few minutes.", true));
                                    return [
                                        4,
                                        (0,global/* prepareErrorMessage */.Xr)(null, error)
                                    ];
                                case 4:
                                    errorResponse = _state.sent();
                                    (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.VALIDATE_DELIVERY_ADDRESS_ERROR */.RZ.VALIDATE_DELIVERY_ADDRESS_ERROR, error, errorResponse);
                                    return [
                                        3,
                                        5
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(address) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            !error && !savedAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAutocompleteInstructions, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "locations.delivery_search_instructional_text",
                    html: true
                })
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAutocompleteInstructions, {
                error: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "locations.delivery_search_no_results_text"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                css: {
                    marginTop: "1rem"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SavedAddresses, {
                    value: address,
                    onUpdate: function(address) {
                        var fullAddress = (0,_object_spread/* default */.Z)({}, address, addressSetTimeWantedFields(time_wanted));
                        dispatch(conveyanceMode_actions/* default.setDeliveryAddress */.Z.setDeliveryAddress(fullAddress, locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.data));
                    }
                })
            })
        ]
    });
}
var AddressDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bdd20a03-0"
})({});
var delivery_details_Address = styled_components_browser_esm/* default.address.withConfig */.ZP.address.withConfig({
    componentId: "sc-bdd20a03-1"
})(function(param) {
    var theme = param.theme;
    return {
        fontStyle: "normal",
        "h2, p": {
            font: "inherit",
            margin: 0,
            padding: 0
        },
        h2: (0,_object_spread/* default */.Z)({
            opacity: 0.6
        }, (0,utils/* getFontStyles */.l)(theme.header.font, [
            "font_size",
            "font_style",
            "font_family",
            "font_weight",
            "line_height"
        ], {
            font_size: function(value) {
                if (typeof value === "number") {
                    // shrink the size to 87.5% of the primary font size
                    // but ensure a minimum of .875rem (14pt)
                    return "max(0.875rem, ".concat(value * 0.875, "px)");
                }
                return value;
            }
        }), (0,utils/* getFontStyles */.l)(theme.modals.font, [
            "color"
        ])),
        p: (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.header.font, [
            "font_size",
            "font_style",
            "font_family",
            "font_weight",
            "line_height", 
        ]), (0,utils/* getFontStyles */.l)(theme.modals.font, [
            "color"
        ]))
    };
});
var EditAddress = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-bdd20a03-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        all: "unset",
        outline: "revert",
        display: "block",
        color: theme.global.primary_active_color,
        fontWeight: 700,
        margin: "1rem 0 0"
    }, (0,utils/* getFontStyles */.l)(theme.header.font, [
        "font_family",
        "font_size",
        "font_style"
    ], {
        font_size: function(value) {
            if (typeof value === "number") {
                // shrink the size to 87.5% of the primary font size
                // but ensure a minimum of .875rem (14pt)
                return "max(0.875rem, ".concat(value * 0.875, "px)");
            }
            return value;
        }
    })), {
        "&:hover": {
            textDecoration: "underline"
        }
    });
});
var StyledAutocompleteInstructions = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-bdd20a03-3"
})(function(param) {
    var theme = param.theme, _error = param.error, error = _error === void 0 ? false : _error;
    return (0,_object_spread/* default */.Z)({
        fontSize: ".75rem",
        margin: ".75rem 0 0",
        textAlign: "left"
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "font_size",
        "font_style",
        "font_family",
        "font_weight",
        "line_height"
    ], {
        font_size: function(value) {
            if (typeof value === "number") {
                // shrink the size to 75% of the primary font size
                // but ensure a minimum of .75rem (12pt)
                return "max(0.75rem, ".concat(value * 0.75, "px)");
            }
            return value;
        }
    }), (0,utils/* getFontStyles */.l)(theme.modals.font, [
        "color"
    ], {
        color: function(value) {
            return error ? theme.global.error_color : value;
        }
    }));
});

;// CONCATENATED MODULE: ./src/features/menu-availability/icons/delivery.tsx

function DeliveryIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Delivery Icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 11.5V13C14.5 13.1326 14.4473 13.2598 14.3536 13.3536C14.2598 13.4473 14.1326 13.5 14 13.5H12.5C12.3674 13.5 12.2402 13.4473 12.1464 13.3536C12.0527 13.2598 12 13.1326 12 13V11.5",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 11.5V13C5 13.1326 4.94732 13.2598 4.85355 13.3536C4.75979 13.4473 4.63261 13.5 4.5 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V11.5",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 9.5H12.5",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 9.5H5.5",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.5 7.5H15.5",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 7.5L12.632 3.29693C12.5927 3.20855 12.5286 3.13346 12.4475 3.08075C12.3664 3.02805 12.2718 3 12.1751 3H4.82494C4.72822 3 4.63358 3.02805 4.55248 3.08075C4.47138 3.13346 4.40731 3.20855 4.36803 3.29693L2.5 7.5V11.5H14.5V7.5Z",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/menu-availability/icons/pickup.tsx

function PickupIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Pickup Icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 4H3C2.72386 4 2.5 4.22386 2.5 4.5V12.5C2.5 12.7761 2.72386 13 3 13H13C13.2761 13 13.5 12.7761 13.5 12.5V4.5C13.5 4.22386 13.2761 4 13 4Z",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.5 4C5.5 3.33696 5.76339 2.70107 6.23223 2.23223C6.70107 1.76339 7.33696 1.5 8 1.5C8.66304 1.5 9.29893 1.76339 9.76777 2.23223C10.2366 2.70107 10.5 3.33696 10.5 4",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/menu-availability/icons/caret.tsx



function CaretIcon(param) {
    var _css = param.css, css = _css === void 0 ? {} : _css, _direction = param.direction, direction = _direction === void 0 ? "right" : _direction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Icon, {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        direction: direction,
        css: css,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Caret Icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.25 2.625L9.625 7L5.25 11.375",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
function getRotation(direction) {
    switch(direction){
        case "up":
            return "-90deg";
        case "down":
            return "90deg";
        case "left":
            return "180deg";
        default:
            return "0deg";
    }
}
var Icon = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-34674e2e-0"
})(function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? "right" : _direction, _css = param.css, css = _css === void 0 ? {} : _css;
    return (0,_object_spread/* default */.Z)({
        flex: "1 0 .875rem",
        transform: "rotate(".concat(getRotation(direction), ")"),
        width: ".875rem"
    }, css);
});

;// CONCATENATED MODULE: ./src/features/menu-availability/icons/phone.tsx

function PhoneIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Phone Icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.22471 9.75133C7.87302 11.0767 8.94739 12.1462 10.2758 12.7885C10.3729 12.8346 10.4804 12.8545 10.5877 12.8464C10.6949 12.8383 10.7982 12.8024 10.8874 12.7422L12.8433 11.438C12.9298 11.3803 13.0293 11.3451 13.1328 11.3356C13.2364 11.3261 13.3407 11.3426 13.4362 11.3835L17.0954 12.9517C17.2197 13.0045 17.3234 13.0963 17.3911 13.2132C17.4587 13.3301 17.4865 13.4658 17.4702 13.5999C17.3546 14.5049 16.913 15.3367 16.2282 15.9396C15.5434 16.5425 14.6624 16.8751 13.75 16.8751C10.9321 16.8751 8.22956 15.7557 6.23699 13.7631C4.24442 11.7706 3.125 9.06806 3.125 6.25014C3.12505 5.33777 3.45765 4.45671 4.06053 3.77192C4.66341 3.08712 5.49523 2.64556 6.40023 2.5299C6.53431 2.51368 6.67002 2.54146 6.78693 2.60908C6.90384 2.67669 6.99561 2.78046 7.04841 2.90476L8.61798 6.5671C8.65858 6.66183 8.67512 6.76513 8.66614 6.8678C8.65715 6.97047 8.62291 7.06932 8.56647 7.15556L7.26676 9.14147C7.2076 9.23081 7.17263 9.33396 7.16526 9.44085C7.15789 9.54775 7.17837 9.65472 7.22471 9.75133V9.75133Z",
                stroke: "#111213",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/menu-availability/location-details.tsx


















function LocationDetails() {
    var ref, ref1;
    var ref2 = (0,react.useState)(false), showDetails = ref2[0], setShowDetails = ref2[1];
    var location = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr).location;
    var ref3 = useLocation(location), data = ref3.data, isSuccess = ref3.isSuccess;
    var ref4 = (0,organization/* useOrganization */.o)(), orgData = ref4.data;
    var isSingleLocationEnabled = Boolean(orgData === null || orgData === void 0 ? void 0 : orgData.locations.features.isSingleLocation.enabled);
    if (!isSuccess) {
        return null;
    }
    var _data = data.data, street_address = _data.street_address, city = _data.city, zip_code = _data.zip_code;
    var ref5;
    var hours = (0,locations/* deriveWeeklyHours */.gS)((0,locations/* getOperatingHoursForLocation */.kL)(data.data), (ref5 = (ref = data.data.cached_data) === null || ref === void 0 ? void 0 : ref.utc_offset) !== null && ref5 !== void 0 ? ref5 : 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleLocationDetails, {
                onClick: function() {
                    setShowDetails(!showDetails);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(location_details_Address, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                            position: "between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(location_details_Location, {
                                    children: data.data.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                    css: {
                                        flex: "0 0 .875rem",
                                        transform: "rotate(".concat(showDetails ? "180deg" : "0deg", ")")
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretIcon, {
                                        direction: "down"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewAddress, {
                            target: "_blank",
                            href: (0,locations/* googleMapsUrl */.Y_)(data.data.cached_data),
                            children: [
                                street_address,
                                ", ",
                                city,
                                ", ",
                                (ref1 = data.data.cached_data) === null || ref1 === void 0 ? void 0 : ref1.state,
                                ", ",
                                zip_code
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Box */.xu, {
                css: {
                    display: showDetails ? "block" : "none",
                    margin: "1rem 0 0"
                },
                children: [
                    data.data.phone_number && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Phone, {
                        href: "tel:".concat(data.data.phone_number),
                        children: [
                            data.data.phone_number,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hours, {
                        children: hours === null || hours === void 0 ? void 0 : hours.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Weekday, {
                                        isSelected: item.isSelected,
                                        children: item.weekday
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Time, {
                                        isSelected: item.isSelected,
                                        children: [
                                            !Boolean(item.slots.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Closed"
                                            }),
                                            item.slots.map(function(slot, index) {
                                                if (!slot.end) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Closed"
                                                    }, index);
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                                dateTime: slot.start,
                                                                children: slot.start
                                                            }),
                                                            " – ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                                dateTime: slot.end,
                                                                children: slot.end
                                                            })
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                ]
                            }, item.weekday);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: !isSingleLocationEnabled && data.data.supports_pick_up,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    passHref: true,
                    href: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeLocation, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "cart_checkout.change_location_cta"
                        })
                    })
                })
            })
        ]
    });
}
var ToggleLocationDetails = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b6bca99b-0"
})({
    all: "unset",
    outline: "revert",
    width: "100%"
});
var location_details_Location = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b6bca99b-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontWeight: 700,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
    }, (0,utils/* getFontStyles */.l)(theme.header.font, [
        "font_family",
        "font_size",
        "line_height", 
    ]), (0,utils/* getFontStyles */.l)(theme.modals.font, [
        "color"
    ]));
});
var location_details_Address = styled_components_browser_esm/* default.address.withConfig */.ZP.address.withConfig({
    componentId: "sc-b6bca99b-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        all: "unset",
        fontSize: ".875rem"
    }, (0,utils/* getFontStyles */.l)(theme.header.font, [
        "font_family",
        "line_height"
    ]), (0,utils/* getFontStyles */.l)(theme.modals.font, [
        "color"
    ]));
});
var ViewAddress = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b6bca99b-3"
})({
    color: "inherit",
    textDecoration: "underline",
    transition: "all .2s ease",
    "&:hover": {
        opacity: 0.6
    }
});
var ChangeLocation = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b6bca99b-4"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        display: "block",
        color: theme.global.primary_active_color,
        margin: "1rem 0 0",
        fontWeight: 700
    }, (0,utils/* getFontStyles */.l)(theme.header.font, [
        "font_family",
        "font_size",
        "font_style"
    ], {
        font_size: function(value) {
            if (typeof value === "number") {
                // shrink the size to 87.5% of the primary font size
                // but ensure a minimum of .875rem (14pt)
                return "max(0.875rem, ".concat(value * 0.875, "px)");
            }
            return value;
        }
    })), {
        "&:hover": {
            textDecoration: "underline"
        }
    });
});
var Phone = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b6bca99b-5"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.header.font, [
        "font_size",
        "font_style",
        "font_family",
        "font_weight",
        "line_height", 
    ]), (0,utils/* getFontStyles */.l)(theme.modals.font, [
        "color"
    ])), {
        display: "flex",
        justifyContent: "space-between",
        "&:hover": {
            textDecoration: "underline"
        }
    });
});
var Hours = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6bca99b-6"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.header.font, [
        "font_size",
        "font_style",
        "font_family",
        "font_weight",
        "line_height", 
    ]), (0,utils/* getFontStyles */.l)(theme.modals.font, [
        "color"
    ])), {
        display: "grid",
        gridTemplateColumns: "minmax(min-content, auto) max-content",
        gap: ".5rem",
        margin: "1.5rem 0 0"
    });
});
var Weekday = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b6bca99b-7"
})(function(param) {
    var _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected;
    return {
        fontWeight: isSelected ? 700 : 400
    };
});
var Time = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-b6bca99b-8"
})(function(param) {
    var _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected;
    return {
        fontWeight: isSelected ? 700 : 400,
        listStyleType: "none",
        margin: 0,
        padding: 0
    };
});

;// CONCATENATED MODULE: ./src/features/menu-availability/conveyance-details.tsx



















function ConveyanceDetails() {
    var ref = (0,react.useState)(v4/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP), activeConveyance = ref[0], setActiveConveyance = ref[1];
    var ref1 = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr), type = ref1.type, time_wanted = ref1.time_wanted, location = ref1.location;
    var ref2 = useLocation(location), data = ref2.data, isSuccess = ref2.isSuccess;
    var dispatch = (0,redux/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        setActiveConveyance(type);
    }, [
        type
    ]);
    if (!isSuccess) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
        gap: "$6",
        direction: "vertical",
        align: "leading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: data.data.supports_delivery && data.data.supports_pick_up,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(conveyance_details_Button, {
                            onClick: function() {
                                setActiveConveyance(v4/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP);
                                dispatch(conveyanceMode_actions/* default.clearDeliveryAddress */.Z.clearDeliveryAddress(data.data.id));
                                dispatch(conveyanceMode_actions/* default.conveyanceModeSet */.Z.conveyanceModeSet({
                                    type: constants_events/* API_CONVEYANCE_TYPES.PICKUP */.tQ.PICKUP,
                                    details: []
                                }, time_wanted));
                            },
                            active: activeConveyance !== v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupIcon, {}),
                                "Pickup"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(conveyance_details_Button, {
                            onClick: function() {
                                setActiveConveyance(v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY);
                            },
                            active: activeConveyance === v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryIcon, {}),
                                "Delivery"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                css: {
                    width: "100%"
                },
                children: activeConveyance === v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY ? /*#__PURE__*/ (0,jsx_runtime.jsx)(delivery_details_DeliveryDetails, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationDetails, {})
            })
        ]
    });
}
var conveyance_details_border_color, _primary_button_border_radius;
var conveyance_details_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-88f8f27a-0"
})(function(param) {
    var theme = param.theme, active = param.active;
    return (0,_object_spread/* default */.Z)({
        all: "unset",
        boxSizing: "border-box",
        alignItems: "center",
        backgroundColor: active ? theme.buttons.primary_button_background_color : "transparent",
        border: "1px solid",
        borderColor: active ? theme.buttons.primary_button_border_color : (conveyance_details_border_color = theme.header.border_color) !== null && conveyance_details_border_color !== void 0 ? conveyance_details_border_color : "#ddd",
        borderRadius: "".concat((_primary_button_border_radius = theme.buttons.primary_button_border_radius) !== null && _primary_button_border_radius !== void 0 ? _primary_button_border_radius : 0, "px"),
        cursor: "pointer",
        display: "flex",
        gap: ".625rem",
        height: "2.5rem",
        padding: "0.5rem 0.75rem"
    }, (0,utils/* getFontStyles */.l)(theme.buttons.primary_font, [
        "color",
        "font_family",
        "font_weight",
        "line_height"
    ], {
        color: function(value) {
            if (active) {
                // if the value isn't set, use black or white depending on the background color
                if (value === "revert" || value === null) {
                    return (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.buttons.primary_button_background_color);
                }
                return value;
            }
            return theme.modals.font.color;
        }
    }));
});

// EXTERNAL MODULE: ./src/components/uielements/modal/index.tsx + 9 modules
var modal = __webpack_require__(84247);
// EXTERNAL MODULE: ./src/services/locations.service.ts
var locations_service = __webpack_require__(19658);
;// CONCATENATED MODULE: ./src/features/menu-availability/time-picker.tsx


















function TimePicker() {
    var ref;
    var ref1 = (0,react.useState)(), confirmChange = ref1[0], setConfirmChange = ref1[1];
    var dispatch = (0,redux/* useDispatch */.I0)();
    var ref2 = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr), type = ref2.type, time_wanted = ref2.time_wanted, location = ref2.location;
    var ref3 = useLocation(location), data = ref3.data, isSuccess = ref3.isSuccess;
    // this reset is necessary to ensure any updates
    // to the time picker show the confirm modal if necessary
    (0,react.useEffect)(function() {
        setConfirmChange(undefined);
    }, [
        time_wanted
    ]);
    if (!isSuccess) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker/* HandoffTimePicker */.NF, {
                stack: false,
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                        var localBasket, ref, response, invalidItems;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    localBasket = sdk_dist/* sdkStorage.basket.get */.fn.basket.get();
                                    if (!localBasket) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        (0,locations_service/* fetchMenu */.Zy)({
                                            id: data.data.id,
                                            wantedAt: value !== constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP ? value : undefined
                                        })
                                    ];
                                case 1:
                                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                        _state.sent(),
                                        1
                                    ]), response = ref[0];
                                    invalidItems = (0,basket/* basketCheckInvalidItems */.ji)(localBasket.content.basket_items, response);
                                    // confirm restarting if there is a discrepancy
                                    if (invalidItems.length > 0) {
                                        setConfirmChange(value);
                                        return [
                                            2
                                        ];
                                    }
                                    _state.label = 2;
                                case 2:
                                    dispatch(conveyanceMode_actions/* default.setWantedTime */.Z.setWantedTime(value, data.data.id, type));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(value) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                isSubmitting: false,
                location: data.data,
                handoffType: v4/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP,
                supportsAsap: Boolean((ref = data.data) === null || ref === void 0 ? void 0 : ref.order_asap),
                value: confirmChange !== null && confirmChange !== void 0 ? confirmChange : time_wanted
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                requestVisibility: Boolean(confirmChange),
                onCancel: function() {
                    setConfirmChange(undefined);
                },
                children: function(toggle) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                                children: "Restart order"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Content */.u.Content, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Some items in your basket are unavailable for your new order time. Would you like to proceed with changing your order time?"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Footer */.u.Footer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Cancel */.u.Cancel, {
                                        children: "Keep existing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton_styles/* StyledPrimaryButton */.D, {
                                        type: "submit",
                                        onClick: function() {
                                            toggle();
                                            dispatch(basket_actions/* default.destroyBasket */.Z.destroyBasket());
                                            dispatch(conveyanceMode_actions/* default.setWantedTime */.Z.setWantedTime(confirmChange, data.data.id, type));
                                        },
                                        children: "Change Time"
                                    })
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/menu-availability/conveyance.tsx



















function getFulfillmentTime(time) {
    if (!time || time === "asap") {
        return "Today, ASAP";
    }
    if ((0,utils_dates/* isDaySame */.jP)(new Date(), time)) {
        return "Today, ".concat((0,utils_dates/* formatDate */.p6)(time, dates/* DATE_FORMAT.HOURS_WITH_MINUTES */.z.HOURS_WITH_MINUTES));
    }
    return (0,utils_dates/* formatDate */.p6)(time, dates/* DATE_FORMAT.DAY_MONTH_TIME */.z.DAY_MONTH_TIME);
}
function Conveyance() {
    var ref;
    var ref1 = (0,react.useState)(false), popoverVisible = ref1[0], setPopoverVisibility = ref1[1];
    var ref2 = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr), type = ref2.type, address = ref2.address, time_wanted = ref2.time_wanted, location = ref2.location;
    var ref3 = useLocation(location), data = ref3.data, isSuccess = ref3.isSuccess;
    var dispatch = (0,redux/* useDispatch */.I0)();
    /*
   * Setting delivery conveyance without adding an address can cause
   * a visual bug where the handoff UI shows a loading state
   *
   * This happens both when closing the popover and refreshing (both without
   * setting an address). We check for this unique pattern with a `useEffect`
   * that resets the conveyance mode if we find ourselves in this state.
   */ (0,react.useEffect)(function() {
        if (!popoverVisible && type === v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY && !(address === null || address === void 0 ? void 0 : address.street_address) && isSuccess) {
            dispatch(conveyanceMode_actions/* default.clearDeliveryAddress */.Z.clearDeliveryAddress(data.data.id));
            dispatch(conveyanceMode_actions/* default.conveyanceModeSet */.Z.conveyanceModeSet({
                type: constants_events/* API_CONVEYANCE_TYPES.PICKUP */.tQ.PICKUP,
                details: []
            }, time_wanted));
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_popover_dist/* Root */.fC, {
        modal: true,
        onOpenChange: function(open) {
            setPopoverVisibility(open);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trigger, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                    gap: "0",
                    css: {
                        cursor: "pointer"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_availability_button_Button, {
                            as: "div",
                            children: type === v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryIcon, {}),
                                    "Delivery"
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupIcon, {}),
                                    "Pickup"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FulfillmentTime, {
                            children: [
                                "\xa0—\xa0",
                                getFulfillmentTime(time_wanted)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_popover_dist/* Portal */.h_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(conveyance_Content, {
                    sideOffset: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConveyanceDetails, {})
                        }),
                        !Boolean(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.supports_pick_up) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationDetails, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimePicker, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {})
                    ]
                })
            })
        ]
    });
}
var FulfillmentTime = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7a366c65-0"
})({
    whiteSpace: "nowrap"
});
var Trigger = (0,styled_components_browser_esm/* default */.ZP)(react_popover_dist/* Trigger */.xz).withConfig({
    componentId: "sc-7a366c65-1"
})({
    all: "unset",
    ":focus-visible": {
        outline: "revert"
    }
});
var conveyance_background_color;
var conveyance_Content = (0,styled_components_browser_esm/* default */.ZP)(react_popover_dist/* Content */.VY).withConfig({
    componentId: "sc-7a366c65-2"
})(function(param) {
    var theme = param.theme;
    return {
        animationName: "slideUpAndFade",
        animationDuration: "400ms",
        animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
        background: (conveyance_background_color = theme.modals.background_color) !== null && conveyance_background_color !== void 0 ? conveyance_background_color : "white",
        borderRadius: ".5rem",
        filter: "drop-shadow(0px -1px 9px rgba(0,0,0,0.05))",
        transformOrigin: "var(--radix-popover-content-transform-origin)",
        willChange: "transform, opacity",
        width: "100vw",
        zIndex: 100,
        "@media (min-width: 640px)": {
            width: "24rem"
        },
        "@keyframes slideUpAndFade": {
            "0%": {
                opacity: 0,
                transform: "translateY(0.25rem)"
            },
            "100%": {
                opacity: 1,
                transform: "translateY(0)"
            }
        },
        ":focus": {
            outline: "none"
        }
    };
});
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a366c65-3"
})({
    padding: "1.5rem"
});
var _primary_border_color;
var Divider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-7a366c65-4"
})(function(param) {
    var theme = param.theme;
    return {
        background: (_primary_border_color = theme.global.primary_border_color) !== null && _primary_border_color !== void 0 ? _primary_border_color : "#e5e5e5",
        border: "none",
        height: "1px",
        margin: 0
    };
});
var Arrow = (0,styled_components_browser_esm/* default */.ZP)(react_popover_dist/* Arrow */.Eh).withConfig({
    componentId: "sc-7a366c65-5"
})({
    visibility: "hidden",
    fill: "white",
    height: "9px",
    width: "18px",
    "@media (min-width: 640px)": {
        visibility: "visible"
    }
});

;// CONCATENATED MODULE: ./src/components/ui/loading/placeholder.tsx

function placeholder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @keyframes moveLoadingIndicator {\n    from {\n      transform: translateX(-100%);\n    }\n\n    to {\n      transform: translateX(100%);\n    }\n  }\n"
    ]);
    placeholder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var placeholder_background_color;
var Loading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b532bf-0"
})(function(param) {
    var theme = param.theme;
    return {
        "--background": (placeholder_background_color = theme.header.background_color) !== null && placeholder_background_color !== void 0 ? placeholder_background_color : "white",
        "--container-color": "color-mix(\n    in srgb,\n    var(--background),\n    rgb(160 160 160) 40%\n  )",
        backgroundColor: "var(--container-color)",
        inset: 0,
        position: "absolute",
        zIndex: 10,
        "&:before": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            content: "''",
            display: "block",
            height: "100%",
            position: "relative",
            width: "7.5rem",
            zIndex: 2
        },
        "&:after": {
            animation: "moveLoadingIndicator 0.8s ease infinite",
            background: "linear-gradient(\n      to right,\n      var(--container-color) 0%,\n      color-mix(in srgb, var(--background), rgb(255 255 255) 40%) 47.4%,\n      \n      var(--container-color) 100%\n    )",
            content: "''",
            height: "100%",
            left: 0,
            position: "absolute",
            top: 0,
            transform: "translateX(-100%)",
            width: "100%",
            zIndex: 1
        }
    };
});
var LoadingPlaceholder = (0,styled_components_browser_esm/* default */.ZP)(Loading).withConfig({
    componentId: "sc-b532bf-1"
})(placeholder_templateObject());

;// CONCATENATED MODULE: ./src/features/menu-availability/destination.tsx













function Destination() {
    var ref;
    var detail = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.locations;
    }).detail;
    var ref1 = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr), location = ref1.location, type = ref1.type, address = ref1.address;
    var ref2 = useLocation(location), data = ref2.data, isSuccess = ref2.isSuccess;
    var webConfig = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }).webConfig;
    var router = (0,next_router.useRouter)();
    if (!isSuccess) {
        return null;
    }
    var origin = "from";
    var label = location !== (detail === null || detail === void 0 ? void 0 : detail.id) || !router.pathname.includes(routes/* ROUTES.STORE */.Z6.STORE) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/store/".concat((0,locations/* getLocationId */.By)(data.data, webConfig), "/").concat(data.data.label),
        children: data.data.label
    }) : data.data.label;
    var loading = false;
    if (type === v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY) {
        origin = "to";
        if (address === null || address === void 0 ? void 0 : address.street_address) {
            var streetAddress = address.street_address;
            if (address.street_address_2) {
                streetAddress = "".concat(streetAddress, " ").concat(address.street_address_2);
            }
            label = "".concat(streetAddress, ", ").concat(address.city);
        } else {
            loading = true;
            label = "";
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
        gap: "$1-5",
        css: {
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                css: {
                    flex: "0 1 auto",
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Origin, {
                        children: origin
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                        css: {
                            borderRadius: "$md",
                            height: "$8",
                            overflow: "hidden",
                            position: "relative",
                            width: "$24"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPlaceholder, {})
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(destination_Label, {
                        children: label
                    })
                ]
            }),
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretIcon, {}),
            type === v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY && (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.label) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InlineContext, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConveyanceSymbol, {
                        children: "@"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(destination_Label, {
                        children: data.data.label
                    })
                ]
            })
        ]
    });
}
var ConveyanceSymbol = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1b321d17-0"
})({
    marginRight: "4px"
});
var InlineContext = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b321d17-1"
})({
    display: "flex",
    alignItems: "center"
});
var Origin = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1b321d17-2"
})({
    opacity: 0.5
});
var destination_Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1b321d17-3"
})({
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
    whiteSpace: "nowrap"
});

;// CONCATENATED MODULE: ./src/features/menu-availability/icons/pin.tsx

function PinIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Pin Icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8.5C9.10457 8.5 10 7.60457 10 6.5C10 5.39543 9.10457 4.5 8 4.5C6.89543 4.5 6 5.39543 6 6.5C6 7.60457 6.89543 8.5 8 8.5Z",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 6.5C13 11 8 14.5 8 14.5C8 14.5 3 11 3 6.5C3 5.17392 3.52678 3.90215 4.46447 2.96447C5.40215 2.02678 6.67392 1.5 8 1.5C9.32608 1.5 10.5979 2.02678 11.5355 2.96447C12.4732 3.90215 13 5.17392 13 6.5V6.5Z",
                stroke: "currentColor",
                strokeWidth: "0.96875",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/menu-availability/find-a-location.tsx





function FindAlocation() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_availability_button_Button, {
            as: "a",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PinIcon, {}),
                "Find a location"
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/features/menu-availability/menu-availability.tsx











function MenuAvailability() {
    var location = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr).location;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_availability_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
            align: "center",
            position: "center",
            children: [
                !location ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAlocation, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Conveyance, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Destination, {})
            ]
        })
    });
}
var menu_availability_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60dca9e2-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.header.font, {
        font_size: function(value) {
            if (typeof value !== "number") {
                return value;
            }
            if (value * 0.75 < 14) {
                return 14;
            }
            return value * 0.75;
        }
    })), {
        maxWidth: "100%",
        "@media (min-width: 768px)": (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.header.font, [
            "font_size"
        ]))
    });
});

// EXTERNAL MODULE: ./src/types/graphql-schema.ts
var graphql_schema = __webpack_require__(91021);
;// CONCATENATED MODULE: ./src/components/header/header.tsx





























function header_Header() {
    var ref, ref1;
    var ref2 = (0,cmsConfig/* useConfigOverride */.$E)("header"), background_color = ref2.background_color, background_image = ref2.background_image, border_color = ref2.border_color, font = ref2.font, logo = ref2.logo, navigation_display = ref2.navigation_display, logo_cta_url = ref2.logo_cta_url, mobile_logo_width = ref2.mobile_logo_width, desktop_logo_width = ref2.desktop_logo_width;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: graphql_schema/* LinkListQueryDocument */.d8
    }), 1), data = ref3[0].data;
    var me = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.data;
    });
    var organization = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization;
    }).organization;
    var logoImg = logo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Logo, {
        css: {
            maxWidth: mobile_logo_width ? "".concat(mobile_logo_width, "px") : "$40",
            "@md": {
                maxWidth: desktop_logo_width ? "".concat(desktop_logo_width, "px") : "$48"
            }
        },
        src: (0,imageHelper/* resizeImage */.tg)(logo, {
            width: 300
        }),
        alt: organization.label
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: organization.label
    });
    var onAndroidSplashScreen = router.pathname.includes(routes/* ROUTES.ANDROID */.Z6.ANDROID);
    var hasNavigation = Boolean(navigation_display !== "hidden");
    var inlineMenu = Boolean(navigation_display === "link list");
    var showMenuFiltering = getAllowedRoutes(router.pathname, [
        routes/* ROUTES.STORE */.Z6.STORE,
        routes/* ROUTES.LOGIN */.Z6.LOGIN,
        routes/* ROUTES.SIGN_UP */.Z6.SIGN_UP, 
    ]);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,android/* isAndroidShell */.Y2)() && onAndroidSplashScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_drawer, {}),
            !onAndroidSplashScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Container, {
                "data-css-override": "StyledHeader",
                className: cssClassNames/* CSS_CLASSES.GLOBAL_HEADER.CONTAINER */.Y.GLOBAL_HEADER.CONTAINER,
                css: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    backgroundColor: background_color !== null && background_color !== void 0 ? background_color : "white",
                    backgroundImage: background_image ? "url(".concat(background_image, ")") : "none",
                    borderBottom: "1px solid ".concat(border_color !== null && border_color !== void 0 ? border_color : "transparent")
                }, (0,utils/* getFontStyles */.l)(font)), {
                    "@xl": {
                        marginBottom: 0
                    }
                }),
                showMenuFiltering: showMenuFiltering,
                children: (0,android/* isAndroidShell */.Y2)() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AndroidBackButton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                            condition: showMenuFiltering,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
                                css: {
                                    backgroundColor: background_color !== null && background_color !== void 0 ? background_color : "white",
                                    borderBottom: "1px solid ".concat(border_color !== null && border_color !== void 0 ? border_color : "transparent"),
                                    height: "$14",
                                    left: 0,
                                    padding: "0 $4",
                                    position: "absolute",
                                    top: "calc(100% + 1px)",
                                    width: "100%",
                                    "@md": {
                                        padding: "0 $10"
                                    },
                                    "@xl": {
                                        backgroundColor: "revert",
                                        border: "revert",
                                        padding: "0 $2",
                                        position: "static",
                                        width: "revert"
                                    }
                                },
                                position: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuAvailability, {})
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Box */.xu, {
                            css: {
                                alignItems: "center",
                                display: "grid",
                                gridTemplateColumns: "$16 1fr $16",
                                gridTemplateRows: "1fr",
                                "@md": {
                                    display: "flex",
                                    overflow: "hidden",
                                    gap: "$10"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                                    links: data === null || data === void 0 ? void 0 : (ref = data.linkLists) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.links,
                                    hasNavigation: hasNavigation,
                                    inlineMenu: inlineMenu,
                                    signedIn: Boolean(me === null || me === void 0 ? void 0 : me.id)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                                    featureFlag: features/* FEATURE_FLAGS.GLOBAL__LOCATIONS_PAGE */.y8.GLOBAL__LOCATIONS_PAGE,
                                    renderFallback: logoImg,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: Boolean(logo_cta_url) ? logo_cta_url : routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLink, {
                                            "data-testid": "nav-logo-link",
                                            id: "nav-logo",
                                            target: Boolean(logo_cta_url) ? "_blank" : "_self",
                                            css: {
                                                order: inlineMenu ? 1 : 2
                                            },
                                            children: logoImg
                                        })
                                    })
                                }),
                                !hasNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericRouteAccessor, {
                                    allowedPages: (_obj = {}, (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.ACCOUNT */.Z6.ACCOUNT, null), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT, {
                                        exactMatch: true
                                    }), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.LOGIN */.Z6.LOGIN, {
                                        exactMatch: true
                                    }), (0,_define_property/* default */.Z)(_obj, routes/* ROUTES.SIGN_UP */.Z6.SIGN_UP, {
                                        exactMatch: true
                                    }), _obj),
                                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                        css: {
                                            display: "none",
                                            order: 3,
                                            "@md": {
                                                display: "block"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToMenu, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                            condition: showMenuFiltering,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
                                css: {
                                    backgroundColor: background_color !== null && background_color !== void 0 ? background_color : "white",
                                    borderBottom: "1px solid ".concat(border_color !== null && border_color !== void 0 ? border_color : "transparent"),
                                    height: "$14",
                                    left: 0,
                                    padding: "0 $4",
                                    position: "absolute",
                                    top: "calc(100% + 1px)",
                                    width: "100%",
                                    "@md": {
                                        padding: "0 $10"
                                    },
                                    "@xl": {
                                        backgroundColor: "revert",
                                        border: "revert",
                                        padding: "0 $2",
                                        position: "static",
                                        width: "revert"
                                    }
                                },
                                position: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuAvailability, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                            css: {
                                display: "none",
                                gap: "$10",
                                "@md": {
                                    display: "flex"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                    css: {
                                        "@md": {
                                            marginLeft: "auto"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Account, {})
                                }),
                                router.pathname !== routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT && router.pathname !== routes/* ROUTES.ORDER_CONFIRMATION */.Z6.ORDER_CONFIRMATION && router.pathname !== routes/* ROUTES.ARRIVAL_CONFIRMATION */.Z6.ARRIVAL_CONFIRMATION && /*#__PURE__*/ (0,jsx_runtime.jsx)(Basket, {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var header_Container = (0,stitches/* styled */.zo)("header", {
    alignItems: "center",
    display: "grid",
    gridTemplateColumns: "1fr",
    height: "$12",
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 11,
    "@md": {
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(min-content, 1fr))",
        height: "$20",
        padding: "0 $10"
    },
    variants: {
        showMenuFiltering: {
            false: {
                "@xl": {
                    gridTemplateColumns: "1fr 1fr"
                }
            },
            true: {
                marginBottom: "$14",
                "@xl": {
                    gridTemplateColumns: "18rem 1fr 18rem",
                    marginBottom: 0
                }
            }
        }
    },
    defaultVariants: {
        showMenuFiltering: false
    }
});
var LogoLink = (0,stitches/* styled */.zo)("a", {
    display: "flex",
    cursor: "pointer",
    justifyContent: "center",
    "@md": {
        justifyContent: "flex-start"
    }
});
var header_Logo = (0,stitches/* styled */.zo)("img", {
    display: "block",
    height: "$10",
    objectFit: "contain",
    objectPosition: "center",
    "@md": {
        height: "$14",
        objectPosition: "left"
    }
});

;// CONCATENATED MODULE: ./src/components/reorders/modal/styles.ts



function modal_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: var(--size-8) 0 0;\n\n  @media (min-width: 768px) {\n    padding-bottom: var(--size-5);\n  }\n"
    ]);
    modal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function modal_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 var(--size-5);\n  margin: 0 0 var(--size-8);\n"
    ]);
    modal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function modal_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  text-align: left;\n"
    ]);
    modal_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function modal_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  background: var(--reorder-modal-button-wrapper__background-color);\n  border-top: 1px solid var(--reorder-modal-button-wrapper__border-color);\n  bottom: var(--neg-size-5);\n  padding: var(--size-5) var(--size-5) var(--size-8);\n  position: sticky;\n\n  @media (min-width: 768px) {\n    bottom: 0;\n    padding: var(--size-5);\n  }\n"
    ]);
    modal_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  appearance: none;\n  background: none;\n  border: none;\n  color: var(--config-text__primary-text-color);\n  margin: var(--size-3) 0 0;\n  width: 100%;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 var(--size-4);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 var(--size-5);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var StyledReorderForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-ead7e775-0"
})(modal_styles_templateObject());
var StyledReorderFormHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ead7e775-1"
})(modal_styles_templateObject1());
var StyledReorderFormTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-ead7e775-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        marginBottom: "var(--size-1)"
    }, (0,utils/* getFontStyles */.l)(theme.modals.secondary_font, [
        "font_size"
    ]));
});
var StyledReorderFormSubtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ead7e775-3"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontSize: "14px",
        margin: 0
    }, (0,utils/* getFontStyles */.l)(theme.modals.tertiary_font, [
        "color"
    ]));
});
var StyledReorderFormItemList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-ead7e775-4"
})(modal_styles_templateObject2());
var modal_styles_background_color, styles_border_color;
var StyledReorderModalButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ead7e775-5"
})(modal_styles_templateObject3(), function(props) {
    return "\n    --reorder-modal-button-wrapper__background-color: ".concat((modal_styles_background_color = props.theme.modals.background_color) !== null && modal_styles_background_color !== void 0 ? modal_styles_background_color : "transparent", ";\n    --reorder-modal-button-wrapper__border-color: ").concat((styles_border_color = props.theme.modals.border_color) !== null && styles_border_color !== void 0 ? styles_border_color : "transparent", ";\n  ");
});
var StyledReorderModalButton = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-ead7e775-6"
})(styles_templateObject4());
var ReorderModalCancelButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ead7e775-7"
})(styles_templateObject5());
var StyledReorderModalListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-ead7e775-8"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        borderBottom: "1px solid ".concat(theme.global.primary_border_color),
        display: "flex",
        listStyleType: "none",
        padding: "var(--size-5)"
    }, (0,utils/* getFontStyles */.l)(theme.modals.font, [
        "font_size"
    ])), {
        p: {
            fontSize: "14px",
            margin: "var(--size-1) 0 0"
        }
    });
});
var StyledReorderModalQuantity = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ead7e775-9"
})(_templateObject6());
var StyledReorderModalModifiers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ead7e775-10"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontSize: "14px",
        margin: "var(--size-1) 0 0"
    }, (0,utils/* getFontStyles */.l)(theme.modals.tertiary_font, [
        "color"
    ]));
});
var ReorderModalConfirmDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ead7e775-11"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/components/reorders/modal/confirm-missing-items.tsx



var ReorderConfirmMissingItems = function(param) {
    var basketLoading = param.basketLoading, onCancel = param.onCancel, onConfirm = param.onConfirm;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReorderForm, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderFormHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderFormTitle, {
                    children: "Some items are unavailable"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReorderModalConfirmDescription, {
                children: "Heads up! One or more items in this order are not available. Unavailable items will not be included if you proceed with re-order."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReorderModalButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderModalButton, {
                        buttonTheme: "primary",
                        submitting: basketLoading,
                        type: "button",
                        onClick: onConfirm,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "reorders.add_to_cart_cta"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReorderModalCancelButton, {
                        onClick: onCancel,
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/uielements/itemRecipient/index.tsx + 1 modules
var itemRecipient = __webpack_require__(74730);
;// CONCATENATED MODULE: ./src/components/reorders/modal/form.tsx










var ReorderForm = function(param) {
    var meOrderDetails = param.meOrderDetails, basketLoading = param.basketLoading, reorderBasket = param.reorderBasket, route = param.route;
    var ref;
    var orderConveyance = constants_global/* API_FOR_CONVEYANCE_TYPES_SWAP */.NX[meOrderDetails.order_data.basket.conveyance_type.type] || sdk_dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP;
    var reorderAnalyticsLabel = route === routes/* ROUTES.STORE */.Z6.STORE ? "Store Menu" : "Store Locator";
    /**
   * Render the basket item content HTML structure for the reorder form
   *
   * @param basketItem BasketItem
   * @param id number
   * @returns JSX.Element
   */ var renderBasketItemContent = function(basketItem, id) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReorderModalListItem, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderModalQuantity, {
                    children: basketItem.quantity
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        basketItem.product.name,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderModalModifiers, {
                            children: (0,basket/* deriveBasketModifiersList */.IJ)(basketItem)
                        }),
                        basketItem.recipient && /*#__PURE__*/ (0,jsx_runtime.jsx)(itemRecipient/* ItemRecipient */.R, {
                            recipient: basketItem.recipient,
                            themeContext: "checkout"
                        })
                    ]
                })
            ]
        }, "".concat(basketItem.id, "-").concat(id));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReorderForm, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReorderFormHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReorderFormTitle, {
                        children: [
                            orderConveyance,
                            " from ",
                            (ref = meOrderDetails.store_location) === null || ref === void 0 ? void 0 : ref.label
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReorderFormSubtitle, {
                        children: [
                            "Order #",
                            meOrderDetails.order_data.order.order_number,
                            " -",
                            " ",
                            (0,utils_dates/* formatDate */.p6)(meOrderDetails.ready_at, dates/* DATE_FORMAT.MONTH_DAY_YEAR */.z.MONTH_DAY_YEAR)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderFormItemList, {
                children: meOrderDetails.order_data.basket.basket_items.map(function(basketItem, id) {
                    return(// @ts-expect-error TODO: update type of function
                    renderBasketItemContent(basketItem, id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderModalButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderModalButton, {
                    buttonTheme: "primary",
                    submitting: basketLoading,
                    type: "submit",
                    onClick: function(e) {
                        e.preventDefault();
                        reorderBasket(meOrderDetails, reorderAnalyticsLabel);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "reorders.add_to_cart_cta"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/redux/me/index.ts
var selectAccountSlice = function(state) {
    return state.app.me;
};

;// CONCATENATED MODULE: ./src/components/reorders/modal/index.tsx












var ReorderModal = function() {
    var pathname = (0,next_router.useRouter)().pathname;
    var dispatch = (0,es.useDispatch)();
    var ref = (0,es.useSelector)(redux_basket/* selectBasketSlice */.p), orderConfirmMissingItems = ref.orderConfirmMissingItems, basketLoading = ref.loading;
    var ref1 = (0,es.useSelector)(selectAccountSlice), reorderModalOpen = ref1.reorderModalOpen, orderDetails = ref1.orderDetails;
    var reorderBasket = basket_actions/* default.reorderBasket */.Z.reorderBasket;
    var toggleReorderReceipt = me_actions/* default.toggleReorderReceipt */.Z.toggleReorderReceipt, clearMeOrderDetails = me_actions/* default.clearMeOrderDetails */.Z.clearMeOrderDetails;
    var reorderAnalyticsLabel = pathname === routes/* ROUTES.STORE */.Z6.STORE ? "Store Menu" : "Store Locator";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(genericModal/* default */.Z, {
        modalOpen: reorderModalOpen,
        name: constants_events/* MODAL.REORDER_PAST_ORDER */.zr.REORDER_PAST_ORDER,
        toggleModal: function(show) {
            return void dispatch(toggleReorderReceipt(show));
        },
        onClose: function() {
            return void dispatch(clearMeOrderDetails());
        },
        children: [
            !orderConfirmMissingItems && orderDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReorderForm, {
                meOrderDetails: orderDetails,
                reorderBasket: function(order, label) {
                    dispatch(reorderBasket(order, label));
                },
                basketLoading: basketLoading,
                route: pathname
            }),
            orderConfirmMissingItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReorderConfirmMissingItems, {
                onConfirm: function() {
                    dispatch(/** @TODO ensure that `orderDetails` is defined. */ // @ts-expect-error
                    reorderBasket(orderDetails, reorderAnalyticsLabel, false, true));
                },
                onCancel: function() {
                    dispatch(toggleReorderReceipt(false));
                },
                basketLoading: basketLoading
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/toast/styles.tsx

function toast_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: block;\n  padding: ",
        "px ",
        "px;\n  position: fixed;\n  bottom: 0px;\n  width: 100%;\n  z-index: ",
        ";\n\n  @media (max-width: 767px) {\n    padding: ",
        "px ",
        "px;\n  }\n"
    ]);
    toast_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function toast_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n  font-family: ",
        ";\n  font-size: 16px;\n  position: relative;\n  text-align: center;\n\n  p {\n    margin: 0;\n    width: calc(100% - ",
        "px);\n  }\n\n  @media (max-width: 767px) {\n    font-size: 14px;\n  }\n"
    ]);
    toast_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function toast_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background: rgba(255, 255, 255, 0.15);\n  color: ",
        ";\n  cursor: pointer;\n  display: block;\n  font-size: 24px;\n  height: 100%;\n  padding: 0 ",
        "px;\n  position: absolute;\n  right: 0;\n  top: 0px;\n  transition: all 0.2s linear;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.25);\n  }\n"
    ]);
    toast_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledToastLayout = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    "data-css-override": "StyledToastLayout"
}).withConfig({
    componentId: "sc-929a8c50-0"
})(toast_styles_templateObject(), function(param) {
    var status = param.status, theme = param.theme;
    return status !== "error" ? theme.global.primary_active_color : "red";
}, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER * 2, styles/* ORDER.TOAST */.kl.TOAST, styles/* LAYOUT.GUTTER */._.GUTTER / 2, styles/* LAYOUT.GUTTER */._.GUTTER * 2);
var ToastContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-929a8c50-1"
})(toast_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
}, styles/* LAYOUT.GUTTER */._.GUTTER * 2);
var StyledForceDismissButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-929a8c50-2"
})(toast_styles_templateObject2(), styles/* COLORS.WHITE */.DM.WHITE, styles/* LAYOUT.GUTTER */._.GUTTER);

// EXTERNAL MODULE: ./src/components/uielements/genericFocusTrap/index.tsx
var genericFocusTrap = __webpack_require__(38806);
;// CONCATENATED MODULE: ./src/components/toast/index.tsx





var timeout;
var timedDismiss = function(display, dismissToast, forceDismiss) {
    if (forceDismiss) {
        return;
    }
    if (display) {
        timeout = setTimeout(dismissToast, 4000);
    }
};
var Toast = function(param) {
    var toast = param.toast, dismissToast = param.dismissToast;
    if (!toast.display) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericFocusTrap/* GenericFocusTrap */.G, {
        focusTrapOptions: {
            clickOutsideDeactivates: true,
            initialFocus: "#Global-Toast"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledToastLayout, {
            status: toast.status,
            id: "Global-Toast",
            children: [
                timedDismiss(toast.display, dismissToast, toast.forceDismiss),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        "aria-live": "polite",
                        onFocus: function() {
                            return clearTimeout(timeout);
                        },
                        dangerouslySetInnerHTML: {
                            __html: toast.message
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledForceDismissButton, {
                    onClick: dismissToast,
                    "aria-label": "Click to close alert",
                    children: "\xd7"
                })
            ]
        })
    });
};
var toast_mapStateToProps = function(state) {
    return {
        toast: state.app.global.toast
    };
};
var toast_mapDispatchToProps = {
    dismissToast: global_actions/* default.dismissToast */.Z.dismissToast
};
var toast_connector = (0,es.connect)(toast_mapStateToProps, toast_mapDispatchToProps);
/* harmony default export */ var toast = (toast_connector(Toast));

;// CONCATENATED MODULE: ./src/constants/productOptions.ts
var MODIFIER_IMAGE_DISPLAY_TYPES = {
    INLINE: "inline",
    BLEED: "bleed"
};

;// CONCATENATED MODULE: ./src/features/product-customizer/styles.ts



function product_customizer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 0;\n  display: block;\n  height: 100%;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  transform-style: preserve-3d;\n  z-index: ",
        ";\n"
    ]);
    product_customizer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_customizer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgba(26, 26, 26, 0.16);\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: all 0.4s ease;\n  z-index: 0;\n"
    ]);
    product_customizer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_customizer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  padding: 0 0 env(safe-area-inset-bottom);\n  width: 100%;\n"
    ]);
    product_customizer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_customizer_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  flex-direction: row-reverse;\n  display: flex;\n  justify-content: right;\n  margin: 0 0 ",
        "px;\n\n  > p {\n    flex: 1;\n    font-family: ",
        ";\n    font-size: 16px;\n    font-weight: normal;\n    margin: 0;\n    text-align: right;\n  }\n\n  > span {\n    font-size: 16px;\n    margin: 0 ",
        "px;\n  }\n\n  @media (max-width: 767px) {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    product_customizer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_customizer_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        "\n\n  @media (min-width: 768px) {\n    height: 60px;\n    line-height: 60px;\n  }\n"
    ]);
    product_customizer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function product_customizer_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  max-height: calc(100vh - ",
        "px);\n  margin-bottom: ",
        "px;\n  min-height: 400px;\n  overflow-y: scroll;\n  padding-bottom: 40px; // This accounts for mobile browser footers that sometimes appear\n\n  // https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-overflow-scrolling\n  -webkit-overflow-scrolling: touch;\n\n  @media (max-width: 767px) {\n    height: 100vh;\n    max-height: calc(100vh - ",
        "px);\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    product_customizer_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  bottom: 0px;\n  // Ensure box shadow only applies to the top of the footer\n  clip-path: inset(-20px 0px 0px 0px);\n  padding: ",
        "px;\n  position: absolute;\n  width: 100%;\n\n  // Remove top padding if toast error is visible\n  ",
        "\n\n  @media (max-width: 767px) {\n    padding: ",
        "px;\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  height: 50px;\n  text-align: center;\n  font-size: 14px;\n  font-family: ",
        ";\n  display: ",
        ";\n  justify-content: center;\n  align-items: center;\n  margin: ",
        ";\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 20px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  padding: 0;\n  position: absolute;\n  right: ",
        "px;\n  top: ",
        "px;\n  vertical-align: middle;\n  width: 40px;\n  z-index: 1;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 ",
        "px 0;\n  position: relative;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  &:first-child {\n    > div {\n      border: none;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  position: absolute;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: ",
        "px;\n  align-self: flex-start;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  box-shadow: 0 2px 0 0 rgba(237, 237, 237, 0.6);\n  margin: 0 ",
        "px ",
        "px;\n  position: relative;\n  text-align: left;\n  width: calc(33.33% - ",
        "px);\n  display: flex;\n  flex-direction: column;\n\n  &:first-child {\n    margin-left: 0;\n  }\n\n  @media (min-width: 768px) {\n    ",
        "\n\n    ",
        "\n  }\n\n  // Bleed w/ images\n  ",
        "\n\n  // Bleed & Inline\n  @media (max-width: 767px) {\n    width: calc(50% - ",
        "px);\n    margin: 0 ",
        "px ",
        "px;\n\n    &:last-child,\n    &:nth-last-child(2) {\n      margin-bottom: ",
        "px;\n    }\n\n    &:nth-of-type(even) {\n      margin-right: 0;\n    }\n    &:nth-of-type(odd) {\n      margin-left: 0;\n    }\n  }\n\n  @media (max-width: 577px) {\n    &:nth-last-child(2) {\n      margin-bottom: ",
        "px;\n    }\n\n    // Inline || Bleed w/ images\n    ",
        "\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  display: flex;\n  min-height: ",
        "px;\n  max-width: 100%;\n  justify-content: center;\n  border-top: 1px solid\n    ",
        ";\n  align-items: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background: none;\n  color: ",
        ";\n  cursor: pointer;\n  margin: 0 ",
        "px;\n  font-family: ",
        ";\n  font-size: 24px;\n  flex: 1;\n  text-align: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  flex: auto;\n  text-align: left;\n  width: 100%;\n\n  ",
        "\n\n  // Bleed w/ images\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // Conditionally render background image\n  ",
        ";\n  background-repeat: no-repeat;\n  ",
        ";\n  background-size: cover;\n  background-position: center center;\n\n  // Default Bleed\n  ",
        "\n\n  // Default Inline\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n\n  // Bleed w/ images\n  ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px ",
        "px ",
        "px\n    ",
        "px;\n  position: relative;\n  width: 100%;\n\n  // Bleed\n  ",
        "\n\n  // Inline\n  ",
        "\n\n  h4 {\n    color: ",
        ";\n    font-family: ",
        ";\n    margin: 0;\n  }\n\n  p {\n    color: ",
        ";\n    margin: 5px 0 0;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  p {\n    font-family: ",
        ";\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  margin: auto ",
        "px ",
        "px ",
        "px;\n\n  ",
        " {\n    flex: 1 1 0px;\n    margin: 0;\n    border-radius: 0 0 0 0;\n\n    &:first-child {\n      border-radius: ",
        ";\n    }\n\n    &:last-child {\n      border-radius: ",
        ";\n    }\n  }\n\n  ",
        " {\n    padding: 2px;\n    text-align: center;\n  }\n\n  ",
        " {\n    padding: 0;\n    text-align: center;\n\n    ",
        " {\n      text-align: center;\n      display: inline;\n\n      p {\n        margin: 10px 0;\n        -webkit-line-clamp: 3;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        line-clamp: 3;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        box-orient: vertical;\n      }\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    height: 15px;\n    margin: 2px 0 0;\n    padding-left: 6px;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  padding: ",
        "px;\n  @media (max-width: 767px) {\n    padding: 0;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: ",
        "px;\n\n  div {\n    display: flex;\n    margin: 0 0 ",
        "px;\n\n    &:last-of-type {\n      margin: 0;\n    }\n  }\n\n  p {\n    color: ",
        ";\n    margin: 0;\n  }\n\n  img {\n    margin: 3px ",
        "px 0 0;\n    max-height: 15px;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: solid 1px\n    ",
        ";\n\n  // Full-bleed image layout\n  ",
        "\n\n  // Inline image layout - only applies to desktop/tablet\n  ",
        "\n\n  @media (max-width: 577px) {\n    display: block;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 320px;\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n\n  // Full-bleed image layout\n  ",
        "\n\n  @media (min-width: 576px) {\n    // Inline image layout - only applies to desktop/tablet\n    ",
        "\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    height: 20px;\n    padding-left: 5px;\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}








var StyledCustomizeModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-0"
})(product_customizer_styles_templateObject(), styles/* ORDER.CUSTOMIZE */.kl.CUSTOMIZE);
var styles_Overlay = (0,styled_components_browser_esm/* default */.ZP)(dist/* Overlay */.aV).withConfig({
    componentId: "sc-fe03688d-1"
})(product_customizer_styles_templateObject1());
var CustomizeModalContent = (0,styled_components_browser_esm/* default */.ZP)(dist/* Content */.VY).withConfig({
    componentId: "sc-fe03688d-2"
})(product_customizer_styles_templateObject2());
var StyledAddDetails = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    "data-css-override": "StyledAddDetails"
}).withConfig({
    componentId: "sc-fe03688d-3"
})(product_customizer_styles_templateObject3(), styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
}, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER / 2);
var StyledAddToBag = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-fe03688d-4"
})(product_customizer_styles_templateObject4(), function(props) {
    return props.disabled && "\n    cursor: not-allowed;\n    font-style: italic;\n  ";
});
var StyledCustomizeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-5"
})(function(param) {
    var theme = param.theme;
    var _background_color, _border_radius;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        background: (_background_color = theme.modals.background_color) !== null && _background_color !== void 0 ? _background_color : "white",
        borderRadius: "".concat((_border_radius = theme.modals.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        height: "100%",
        maxHeight: "calc(100vh - ".concat(styles/* LAYOUT.GUTTER */._.GUTTER * 4, "px)"),
        margin: "40px auto",
        maxWidth: "".concat(styles/* LAYOUT.CUSTOMIZE_MODAL_MAX_WIDTH */._.CUSTOMIZE_MODAL_MAX_WIDTH, "px"),
        overflow: "hidden",
        position: "relative",
        width: "100%"
    }, (0,utils/* getFontStyles */.l)(theme.modals.font, [
        "color"
    ])), {
        "@media (max-width: 767px)": {
            borderRadius: 0,
            margin: 0,
            maxHeight: "100vh"
        }
    });
});
var FIXED_MOBILE_FOOTER_HEIGHT = 110;
var StyledCustomizeScrollContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-6"
})(product_customizer_styles_templateObject5(), styles/* LAYOUT.GUTTER */._.GUTTER * 4 + 150, styles/* LAYOUT.CUSTOMIZE_FOOTER_MAX_HEIGHT */._.CUSTOMIZE_FOOTER_MAX_HEIGHT, FIXED_MOBILE_FOOTER_HEIGHT, FIXED_MOBILE_FOOTER_HEIGHT);
var StyledCustomizeFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-7"
})(styles_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.modals.footer_color || theme.modals.background_color, ";\n    border-top: 1px solid ").concat(theme.modals.border_color, ";\n    box-shadow: 0 0 20px 0 ").concat(theme.modals.border_color, ";\n  ");
}, styles/* LAYOUT.GUTTER */._.GUTTER, function(props) {
    return props.validationErrorIsVisible && "\n    padding-top: 0px;\n  ";
}, styles/* LAYOUT.GUTTER */._.GUTTER / 2);
var StyledToastError = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-8"
})(styles_templateObject7(), styles/* COLORS.ERROR_RED */.DM.ERROR_RED, styles/* COLORS.ERROR_RED_BACKGROUND */.DM.ERROR_RED_BACKGROUND, function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
}, function(props) {
    return props.isVisible ? "flex" : "none";
}, "0 -".concat(styles/* LAYOUT.GUTTER */._.GUTTER, "px ").concat(styles/* LAYOUT.GUTTER */._.GUTTER, "px -").concat(styles/* LAYOUT.GUTTER */._.GUTTER, "px"));
var StyledPdpCloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fe03688d-9"
})(_templateObject8(), styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER / 2);
var StyledTopOptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-10"
})(_templateObject9(), styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledNestedOptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-11"
})(_templateObject10());
var StyledOptionGroupHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-12"
})(function(param) {
    var theme = param.theme;
    return {
        borderTop: "1px solid ".concat(theme.global.primary_border_color),
        padding: "20px 0",
        marginBottom: "5px",
        "h3,p": (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.modals.font, [
            "color",
            "font_family",
            "font_weight",
            "line_height", 
        ])),
        h3: {
            fontSize: "18px",
            margin: 0,
            textAlign: "left",
            // 'Required' text
            span: {
                color: theme.global.primary_active_color,
                fontSize: "12px",
                paddingLeft: "10px"
            }
        },
        p: {
            fontSize: "14px",
            margin: "5px 0 0"
        }
    };
});
var StyledOptionGroupHelperText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-13"
})(_templateObject11(), styles/* COLORS.ERROR_RED */.DM.ERROR_RED, styles/* LAYOUT.GUTTER */._.GUTTER / 4);
var StyledAdvNestedModOptionGroupHelperText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-14"
})(_templateObject12(), styles/* COLORS.ERROR_RED */.DM.ERROR_RED, styles/* LAYOUT.GUTTER */._.GUTTER / 4);
var StyledOptionQuantityHelperText = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    "data-css-override": "StyledOptionQuantityHelperText"
}).withConfig({
    componentId: "sc-fe03688d-15"
})(_templateObject13());
var StyledOptionContainer = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(param) {
    var groupHasImages = param.groupHasImages, theme = param.theme;
    // Modifier image is in 'bleed' configuration, and images exist for that group
    var bleedConfigWithImagesInGroup = theme.product_detail.modifier_image_layout === MODIFIER_IMAGE_DISPLAY_TYPES.BLEED && groupHasImages;
    return {
        bleedConfigWithImagesInGroup: bleedConfigWithImagesInGroup
    };
}).withConfig({
    componentId: "sc-fe03688d-16"
})(_templateObject14(), function(param) {
    var is_inverted = param.is_inverted, selected = param.selected, theme = param.theme, is_adv_nested_modifier_group = param.is_adv_nested_modifier_group;
    return is_adv_nested_modifier_group ? "\n    background: ".concat(selected ? theme.buttons.primary_button_background_color : theme.buttons.knockout_button_background_color, ";\n    button p {\n      color: ").concat(selected ? (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.buttons.knockout_button_text_color) : (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.buttons.primary_button_text_color), ";\n    }\n\n    border: ").concat(selected ? "2px" : "1px", " solid ").concat((is_inverted ? !selected : selected) ? theme.modals.active_border_color : theme.modals.border_color, ";\n    border-radius: ").concat(theme.modals.border_radius, "px;\n    padding: ").concat(selected ? "0px" : "1px", ";\n  ") : "\n    background: ".concat(theme.modals.background_color, ";\n    border: ").concat(selected ? "2px" : "1px", " solid ").concat((is_inverted ? !selected : selected) ? theme.modals.active_border_color : theme.modals.border_color, ";\n    border-radius: ").concat(theme.modals.border_radius, "px;\n    padding: ").concat(selected ? "0px" : "1px", ";\n  ");
}, styles/* LAYOUT.GUTTER */._.GUTTER / 2, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER * 2 / 3, function(param) {
    var bleedConfigWithImagesInGroup = param.bleedConfigWithImagesInGroup;
    return !bleedConfigWithImagesInGroup && "\n      &:nth-of-type(3n + 4) {\n        margin-left: 0;\n      }\n      &:nth-of-type(3n) {\n        margin-right: 0;\n      }\n    ";
}, function(param) {
    var bleedConfigWithImagesInGroup = param.bleedConfigWithImagesInGroup;
    return bleedConfigWithImagesInGroup && "\n      &:nth-of-type(4n + 5) {\n        margin-left: 0;\n      }\n      &:nth-of-type(4n) {\n        margin-right: 0;\n      }\n    ";
}, function(param) {
    var bleedConfigWithImagesInGroup = param.bleedConfigWithImagesInGroup;
    return bleedConfigWithImagesInGroup && "\n    width: calc(25% - ".concat(styles/* LAYOUT.GUTTER */._.GUTTER * 3 / 4, "px);\n  ");
}, styles/* LAYOUT.GUTTER */._.GUTTER / 4, styles/* LAYOUT.GUTTER */._.GUTTER / 4, styles/* LAYOUT.GUTTER */._.GUTTER / 2, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER / 2, function(param) {
    var groupHasImages = param.groupHasImages, theme = param.theme;
    return (theme.product_detail.modifier_image_layout === MODIFIER_IMAGE_DISPLAY_TYPES.INLINE || theme.product_detail.modifier_image_layout === MODIFIER_IMAGE_DISPLAY_TYPES.BLEED && !groupHasImages) && "\n      margin-left: 0px;\n      margin-right: 0px;\n      width: 100%;\n    ";
});
var StyledQuantitySelector = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-17"
})(_templateObject15(), styles/* LAYOUT.QUANTITY_SELECTOR_HEIGHT */._.QUANTITY_SELECTOR_HEIGHT, function(param) {
    var selected = param.selected, theme = param.theme;
    return selected ? theme.modals.active_border_color : styles/* COLORS.LIGHTGRAY */.DM.LIGHTGRAY;
});
var StyledChangeQuantityButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fe03688d-18"
})(_templateObject16(), function(param) {
    var disabled = param.disabled, theme = param.theme;
    return disabled ? styles/* COLORS.LIGHTGRAY */.DM.LIGHTGRAY : theme.modals.active_border_color;
}, styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, function(param) {
    var increment = param.increment;
    return increment ? "left" : "right";
});
var StyledOptionCard = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs(function(param) {
    var groupHasImages = param.groupHasImages, theme = param.theme;
    // Modifier image is in 'bleed' configuration, and images exist for that group
    var bleedConfigWithImagesInGroup = theme.product_detail.modifier_image_layout === MODIFIER_IMAGE_DISPLAY_TYPES.BLEED && groupHasImages;
    return {
        bleedConfigWithImagesInGroup: bleedConfigWithImagesInGroup
    };
}).withConfig({
    componentId: "sc-fe03688d-19"
})(_templateObject17(), function(param) {
    var hasAdvancedModOptions = param.hasAdvancedModOptions;
    return hasAdvancedModOptions && "\n    flex-direction: column;\n  ";
}, function(param) {
    var bleedConfigWithImagesInGroup = param.bleedConfigWithImagesInGroup;
    return bleedConfigWithImagesInGroup && "\n    align-items: stretch;\n    flex-direction: column;\n    padding: 0;\n  ";
});
var StyledModifierImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-20"
})(_templateObject18(), function(param) {
    var url = param.url;
    return url && "background-image: url(".concat(url, ")");
}, function(param) {
    var url = param.url;
    return !url && "background-color: ".concat(styles/* COLORS.BACKGROUNDGRAY */.DM.BACKGROUNDGRAY);
}, function(param) {
    var theme = param.theme;
    return theme.product_detail.modifier_image_layout === MODIFIER_IMAGE_DISPLAY_TYPES.BLEED && "\n    border-radius: ".concat(theme.global.border_radius, "px ").concat(theme.global.border_radius, "px 0 0;\n    width: 100%;\n    height: 150px;\n  ");
}, function(param) {
    var theme = param.theme;
    return theme.product_detail.modifier_image_layout === MODIFIER_IMAGE_DISPLAY_TYPES.INLINE && "\n    border-radius: ".concat(theme.global.border_radius, "px 0 0 ").concat(theme.global.border_radius, "px;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 80px;\n  ");
});
var StyledOptionWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(param) {
    var groupHasImages = param.groupHasImages, theme = param.theme;
    // Modifier image is in 'bleed' configuration, and images exist for that group
    var bleedConfigWithImagesInGroup = theme.product_detail.modifier_image_layout === MODIFIER_IMAGE_DISPLAY_TYPES.BLEED && groupHasImages;
    return {
        bleedConfigWithImagesInGroup: bleedConfigWithImagesInGroup
    };
}).withConfig({
    componentId: "sc-fe03688d-21"
})(_templateObject19(), function(param) {
    var bleedConfigWithImagesInGroup = param.bleedConfigWithImagesInGroup;
    return bleedConfigWithImagesInGroup ? "display: block" : "display: flex";
});
var StyledOptionContent = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    "data-css-override": "StyledOptionContent"
}).withConfig({
    componentId: "sc-fe03688d-22"
})(_templateObject20(), styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER / 1.25, function(param) {
    var theme = param.theme;
    return theme.product_detail.modifier_image_layout === MODIFIER_IMAGE_DISPLAY_TYPES.BLEED && "\n    // Nothing fancy occurs here\n  ";
}, function(param) {
    var groupHasImages = param.groupHasImages, theme = param.theme;
    return theme.product_detail.modifier_image_layout === MODIFIER_IMAGE_DISPLAY_TYPES.INLINE && groupHasImages && "\n    margin-left: 80px;\n  ";
}, function(param) {
    var selected = param.selected, is_inverted = param.is_inverted, theme = param.theme;
    return (is_inverted ? !selected : selected) ? theme.modals.active_font_color : theme.modals.font.color;
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.modals.font.color;
});
var StyledOptionName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-23"
})(_templateObject21(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
});
var StyledAdvancedOptionGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-24"
})(_templateObject22(), styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER, StyledOptionContainer, function(param) {
    var theme = param.theme;
    return "".concat(theme.buttons.primary_button_border_radius, "px 0 0 ").concat(theme.buttons.primary_button_border_radius, "px ");
}, function(param) {
    var theme = param.theme;
    return "0 ".concat(theme.buttons.primary_button_border_radius, "px ").concat(theme.buttons.primary_button_border_radius, "px 0");
}, StyledOptionCard, StyledOptionContent, StyledOptionName);
var StyledOptionLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-25"
})(_templateObject23());
var StyledOptionGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-26"
})(_templateObject24(), styles/* LAYOUT.GUTTER */._.GUTTER / 4);
var StyledWarningLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-27"
})(_templateObject25(), function(param) {
    var theme = param.theme;
    return (0,safePolished/* safePolished */.F)(polished_esm/* transparentize */.DZ)(".8", theme.modals.font.color);
}, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER / 2, function(param) {
    var theme = param.theme;
    return theme.modals.font.color;
}, styles/* LAYOUT.GUTTER */._.GUTTER / 4);
var StyledCustomizeProductDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-28"
})(_templateObject26(), function(param) {
    var customizable = param.customizable, theme = param.theme;
    return customizable ? theme.modals.border_color : "transparent";
}, function(param) {
    var theme = param.theme;
    return theme.product_detail.image_layout === "bleed" && "\n    display: block;\n  ";
}, function(param) {
    var theme = param.theme;
    return theme.product_detail.image_layout === "inline" && "\n    display: flex;\n  ";
});
var StyledCustomizeProductInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe03688d-29"
})(function(param) {
    var theme = param.theme;
    return {
        padding: "20px",
        width: "100%",
        "& > div": {
            marginBottom: "10px"
        },
        "& div": {
            alignItems: "baseline",
            display: "flex",
            "& > h2": {
                flex: 1
            }
        },
        h2: (0,_object_spread/* default */.Z)({
            fontSize: "".concat(theme.product_detail.image_layout === "bleed" ? "32px" : "24px"),
            margin: "0 40px 0 0",
            textAlign: "left"
        }, (0,utils/* getFontStyles */.l)(theme.modals.secondary_font, [
            "color",
            "font_family",
            "font_weight",
            "font_style",
            "line_height", 
        ])),
        p: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            margin: "10px 0 0"
        }, (0,utils/* getFontStyles */.l)(theme.modals.font)), {
            a: {
                textDecoration: "underline",
                transition: "opacity 0.2s linear",
                "&:hover": {
                    opacity: 0.7
                }
            }
        })
    };
});
var StyledProductImage = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    "data-css-override": "StyledProductImage"
}).withConfig({
    componentId: "sc-fe03688d-30"
})(_templateObject27(), function(param) {
    var src = param.src;
    return src && "url(".concat(src, ")");
}, function(param) {
    var theme = param.theme;
    return theme.product_detail.image_layout === "bleed" && "\n    background-color: #d8d8d8;\n  ";
}, function(param) {
    var theme = param.theme;
    return theme.product_detail.image_layout === "inline" && "\n      background-position: top center;\n      background-size: contain;\n      border: ".concat(styles/* LAYOUT.GUTTER */._.GUTTER, "px solid white;\n      border-right: none;\n      max-width: 300px;\n  ");
});
var StyledWarningLabels = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-fe03688d-31"
})(_templateObject28());

;// CONCATENATED MODULE: ./src/components/uielements/quantityToggle/styles.tsx

function quantityToggle_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  span {\n    font-family: ",
        ";\n    font-size: 16px;\n    padding-left: 12px;\n  }\n"
    ]);
    quantityToggle_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function quantityToggle_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 12px;\n  color: ",
        ";\n  opacity: 0.7;\n  cursor: help;\n\n  &:hover {\n    opacity: 1;\n  }\n"
    ]);
    quantityToggle_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledQuantityToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3a56d74-0"
})(quantityToggle_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
});
var _color;
var StyledMinQuantityInfo = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c3a56d74-1"
})(quantityToggle_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.primary_font.regular.font_family;
}, function(param) {
    var theme = param.theme;
    return (_color = theme.modals.font.color) !== null && _color !== void 0 ? _color : styles/* COLORS.DARKERGRAY */.DM.DARKERGRAY;
});
var StyledQuantityToggleButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c3a56d74-2"
})(function(param) {
    var theme = param.theme, inactive = param.inactive;
    var color = (0,utils/* getFontStyles */.l)(theme.modals.font).color;
    var _color, /** @FIXME font refactor (what happens when color isn't a hex value). */ _background_color;
    return {
        transition: "all 150ms linear",
        border: "none",
        borderRadius: "50%",
        cursor: "pointer",
        fontSize: "18px",
        fontWeight: "bold",
        height: "30px",
        lineHeight: "30px",
        margin: "0 0 0 12px",
        padding: "0",
        pointerEvents: inactive ? "none" : "auto",
        width: "30px",
        background: inactive ? (0,polished_esm/* lighten */.$n)(0.2, (_color = theme.modals.font.color) !== null && _color !== void 0 ? _color : styles/* COLORS.DARKERGRAY */.DM.DARKERGRAY) : color,
        color: (_background_color = theme.modals.background_color) !== null && _background_color !== void 0 ? _background_color : (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(color),
        "&:hover": {
            background: inactive ? "".concat((0,polished_esm/* lighten */.$n)(0.2, color !== null && color !== void 0 ? color : styles/* COLORS.DARKERGRAY */.DM.DARKERGRAY)) : "".concat((0,safePolished/* safePolished */.F)(polished_esm/* darken */._j)(0.2, color !== null && color !== void 0 ? color : styles/* COLORS.PRIMARY_NAVY */.DM.PRIMARY_NAVY))
        }
    };
});

;// CONCATENATED MODULE: ./src/components/uielements/quantityToggle/index.tsx




var QuantityToggle = function(param) {
    var onToggle = param.onToggle, quantity = param.quantity, maxQuantity = param.maxQuantity, _minQuantity = param.minQuantity, minQuantity = _minQuantity === void 0 ? 1 : _minQuantity, _quantityIncrement = param.quantityIncrement, quantityIncrement = _quantityIncrement === void 0 ? 1 : _quantityIncrement;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledQuantityToggle, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Qty."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantityToggleButton, {
                inactive: quantity <= minQuantity,
                "aria-label": "Decrease the quantity by ".concat(quantityIncrement),
                onClick: function() {
                    // Ensure keyboard manipulation can't exceed min
                    var newQuantity = quantity - quantityIncrement;
                    if (newQuantity < minQuantity) {
                        return;
                    }
                    onToggle(newQuantity);
                },
                children: "–"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: quantity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantityToggleButton, {
                inactive: quantity >= maxQuantity,
                "aria-label": "Increase the quantity by ".concat(quantityIncrement),
                onClick: function() {
                    // Ensure keyboard manipulation can't exceed max
                    var newQuantity = quantity + quantityIncrement;
                    if (newQuantity > maxQuantity) {
                        return;
                    }
                    onToggle(newQuantity);
                },
                children: "+"
            }),
            minQuantity > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMinQuantityInfo, {
                title: "Minimum quantity: ".concat(minQuantity),
                "aria-label": "Minimum quantity required: ".concat(minQuantity),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,stringHelpers/* safelyGetString */.bc)((0,es.useSelector)(function(state) {
                        return state.app.cmsConfig.strings;
                    }), "product_details.min_quantity_info", {
                        minQuantity: minQuantity
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var quantityToggle = (QuantityToggle);

;// CONCATENATED MODULE: ./src/features/product-customizer/footer.tsx






function product_customizer_footer_Footer(param) {
    var disabled = param.disabled, product = param.product, addToOrder = param.addToOrder, quantity = param.quantity, toggleQuantity = param.toggleQuantity, editing = param.editing;
    var calorieDisplay = product.calorie_range || (product.final_calories ? "".concat(product.final_calories, " ").concat(sdk_dist/* CALS_IDENTIFIER */.DF) : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAddDetails, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(quantityToggle, {
                        quantity: quantity,
                        onToggle: toggleQuantity,
                        maxQuantity: product.max_quantity || 999,
                        minQuantity: product.min_quantity || 1,
                        quantityIncrement: product.quantity_increment || 1
                    }),
                    calorieDisplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                "aria-live": "polite",
                                children: calorieDisplay
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAddToBag, {
                size: "medium",
                onClick: function() {
                    return addToOrder(product);
                },
                className: "koala__item-detail-add-button",
                disabled: disabled,
                "aria-live": "polite",
                "data-testid": "add-product-to-basket-button",
                children: [
                    disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "locations.location_inactive",
                        html: true
                    }),
                    !disabled && (editing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: "Update Item"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "cart_checkout.add_text"
                            }),
                            " - $",
                            (0,basket/* toDollars */.DV)(product.final_cost, quantity)
                        ]
                    }))
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/allergens/index.ts + 2 modules
var allergens = __webpack_require__(53247);
// EXTERNAL MODULE: ./src/constants/tags.ts
var tags = __webpack_require__(40634);
;// CONCATENATED MODULE: ./src/components/store/marketingTag/styles.tsx

function marketingTag_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --marketing-tag_font-size: 11px;\n\n  ",
        "\n\n  display: flex;\n  background: var(--marketing-tag_background);\n  color: var(--marketing-tag_color);\n  padding: var(--size-1) var(--size-2);\n  font-size: var(--marketing-tag_font-size);\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--size-1);\n\n  ",
        "\n"
    ]);
    marketingTag_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function marketingTag_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        ";\n  margin-right: var(--size-1);\n"
    ]);
    marketingTag_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledMarketingTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f105d7ba-0"
})(marketingTag_styles_templateObject(), function(param) {
    var backgroundColor = param.backgroundColor, textColor = param.textColor;
    return "\n    --marketing-tag_background: ".concat(backgroundColor, ";\n    --marketing-tag_color: ").concat(textColor, ";\n  ");
}, function(param) {
    var position = param.position;
    return position === tags/* MARKETING_TAG_POSITION.MENU_CARD */.W.MENU_CARD ? "\n    position: absolute;\n    top: var(--size-2);\n    left: 0;\n    border-radius: 0px var(--size-1) var(--size-1) 0px;\n  " : "";
});
var StyledTagIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-f105d7ba-1"
})(marketingTag_styles_templateObject1(), function(param) {
    var position = param.position;
    return position === tags/* MARKETING_TAG_POSITION.MENU_CARD */.W.MENU_CARD ? "20px" : "18px";
});

;// CONCATENATED MODULE: ./src/components/store/marketingTag/index.tsx


var MarketingTag = function(param) {
    var tag = param.tag, position = param.position;
    /** @TODO ensure that tag style attributes are defined. */ return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMarketingTag, {
            backgroundColor: tag.background_color,
            textColor: tag.text_color,
            position: position,
            children: [
                tag.icon_image_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagIcon, {
                    src: tag.icon_image_url,
                    alt: "".concat(tag.label, " Tag Icon"),
                    position: position
                }),
                !tag.hide_label ? tag.label : ""
            ]
        })
    });
};
/* harmony default export */ var marketingTag = (MarketingTag);

;// CONCATENATED MODULE: ./src/features/product-customizer/product-detail/index.tsx












function ProductDetail(param) {
    var product = param.product, locationDetail = param.locationDetail;
    var ref;
    var ref1 = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.cmsConfig;
    }), strings = ref1.strings, webConfig = ref1.webConfig;
    var nutrition_url = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.organization.organization;
    }).nutrition_url;
    var isImageShown = (0,imageHelper/* hasProductImage */.dU)(product);
    var dietaryPreferencesEnabled = (0,stringHelpers/* safelyGetConfig */.K6)(webConfig, "menu.dietary_preferences_enabled");
    var productMarketingTag = product.marketing_tags && product.marketing_tags[0];
    // Split product description into lines
    var parsedProductDescription = (ref = product.description) === null || ref === void 0 ? void 0 : ref.split("\n");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCustomizeProductDetail, {
        customizable: product.customizable,
        id: "Item-Detail",
        children: [
            isImageShown && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductImage, {
                src: (0,imageHelper/* getProductImageSrc */.Wr)(product, {
                    width: 900
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCustomizeProductInfo, {
                id: "Item-Detail-Header",
                className: cssClassNames/* CSS_CLASSES.PRODUCT_DETAIL.PRODUCT_INFO */.Y.PRODUCT_DETAIL.PRODUCT_INFO,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: productMarketingTag && /*#__PURE__*/ (0,jsx_runtime.jsx)(marketingTag, {
                            tag: productMarketingTag,
                            position: tags/* MARKETING_TAG_POSITION.PDP */.W.PDP
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                id: "product-name",
                                children: [
                                    product.name,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWarningLabels, {
                                        children: product.labels && product.labels.map(function(label, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: label.image_url,
                                                alt: label.image_description
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    parsedProductDescription && parsedProductDescription.map(function(line, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: line.trim()
                        }, "line-".concat(index));
                    }),
                    nutrition_url && (0,stringHelpers/* safelyGetString */.bc)(strings, "store.nutrition_url_cta") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: nutrition_url,
                            onClick: function() {
                                return (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.nutrition */.m1.nutrition, googleAnalytics/* gaActions.nutritionInfo */.cE.nutritionInfo, {
                                    label: product.name
                                });
                            },
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "store.nutrition_url_cta",
                                html: true,
                                dataObj: locationDetail
                            })
                        })
                    }),
                    dietaryPreferencesEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(allergens/* AllergensMenuCard */.N, {
                        productAllergens: product,
                        mode: constants_global/* ALLERGEN_CARD_MODE.DETAIL */.JT.DETAIL
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/product-customizer/product-options/option.tsx








function Option(param) {
    var option = param.option, supportsQuantitySelection = param.supportsQuantitySelection, isAdvancedModOption = param.isAdvancedModOption;
    var ref, ref1;
    var webConfig = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.cmsConfig;
    }).webConfig;
    var dietaryPreferencesEnabled = webConfig.menu.dietary_preferences_enabled;
    var validOptionCost = option.cost > 0 || option.cost < 0;
    var cost = option.cost, calories = option.calories;
    // Prep calorie parsing logic
    var calorieDisplayOverride = option.calorieDisplayOverride, calories_separator = option.calories_separator, is_inverted = option.is_inverted, max_calories = option.max_calories, selected = option.selected;
    var calorieString = (0,menu/* deriveCalorieDisplay */.Zq)(calories, max_calories, /** @TODO ensure that `calories_separator` is defined. */ // @ts-expect-error
    calories_separator, is_inverted, calorieDisplayOverride, option);
    var containsAdvNestedMods = option.contains_adv_nested_modifiers;
    // Does this option have an image associated with it?
    var hasImage = Boolean(option === null || option === void 0 ? void 0 : (ref = option.images) === null || ref === void 0 ? void 0 : ref.image_url_1_by_1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModifierImage, {
                className: "modifier-image",
                /** @TODO differentiate between `null`  and `undefined`. */ // @ts-expect-error
                url: (option === null || option === void 0 ? void 0 : option.images) && (0,imageHelper/* resizeImage */.tg)(option === null || option === void 0 ? void 0 : (ref1 = option.images) === null || ref1 === void 0 ? void 0 : ref1.image_url_1_by_1, {
                    height: 200
                }),
                supportsQuantitySelection: supportsQuantitySelection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOptionContent, {
                selected: !!option.selected,
                is_inverted: !!option.is_inverted,
                groupHasImages: hasImage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOptionName, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: option.is_inverted ? option.name_inverted : option.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionLabel, {
                                children: option.labels.map(function(label) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: label.image_url,
                                        alt: label.image_description
                                    }, label.name);
                                })
                            })
                        ]
                    }),
                    option.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            marginBottom: 10
                        },
                        children: option.description
                    }),
                    dietaryPreferencesEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(allergens/* AllergensMenuCard */.N, {
                        productAllergens: option,
                        mode: constants_global/* ALLERGEN_CARD_MODE.OPTIONS */.JT.OPTIONS
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CaloriesAndCostText, {
                        calorieString: calorieString,
                        validOptionCost: validOptionCost,
                        cost: cost,
                        is_inverted: is_inverted,
                        isAdvancedModOption: isAdvancedModOption,
                        containsAdvNestedMods: containsAdvNestedMods,
                        selected: selected
                    })
                ]
            })
        ]
    });
}
function CaloriesAndCostText(param) {
    var calorieString = param.calorieString, validOptionCost = param.validOptionCost, cost = param.cost, is_inverted = param.is_inverted, isAdvancedModOption = param.isAdvancedModOption, containsAdvNestedMods = param.containsAdvNestedMods, selected = param.selected;
    if (isAdvancedModOption) return null; // We don't show calories for nested mod options.
    if (calorieString || validOptionCost) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                calorieString,
                calorieString && validOptionCost ? " | " : "",
                validOptionCost ? "$".concat((0,basket/* toDollars */.DV)((0,basket/* invertNumberIfOptionInverted */.a4)(cost, is_inverted))) : ""
            ]
        });
    }
    // This is a fix for the space jumping issue on advanced nested mod options.
    // Without this the buttons will jump when no calories exist and calories are
    // added because of an adv nested modifier.
    if (containsAdvNestedMods && selected) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "\xa0"
        });
    }
    return null;
}

;// CONCATENATED MODULE: ./src/features/product-customizer/product-options/option-card.tsx







function OptionCard(param) {
    var group = param.group, option = param.option, displayOptionsErrors = param.displayOptionsErrors;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var isOptionDisabled = group.is_max_aggregate_quantity_reached || option.is_max_selections_reached;
    var isOptionIncrementDisabled = /** @TODO ensure that `total_aggregate_quantity` and `max_aggregate_quantity` are defined. */ isOptionDisabled || // @ts-expect-error
    group.total_aggregate_quantity + group.choice_quantity_increment > // @ts-expect-error
    group.max_aggregate_quantity;
    var groupHasImages = (0,menu/* doesGroupHaveImages */.MM)(group);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionContainer, {
        option: option,
        group: group,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionCardContainer, {
                option: option,
                group: group,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionWrapper, {
                        groupHasImages: groupHasImages,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                            option: option,
                            supportsQuantitySelection: group.supports_quantity_selection,
                            isAdvancedModOption: false
                        })
                    }),
                    option.contains_adv_nested_modifiers && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedOptionGroup, {
                        displayOptionsErrors: displayOptionsErrors,
                        option: option
                    })
                ]
            }),
            group.supports_quantity_selection && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledQuantitySelector, {
                selected: !!option.selected,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChangeQuantityButton, {
                        onClick: function() {
                            return dispatch(customize_actions/* default.decrementOption */.Z.decrementOption(option.id));
                        },
                        disabled: option.quantity === 0,
                        increment: false,
                        "aria-label": "Decrement ".concat(option.name, " quantity by ").concat(group.choice_quantity_increment || 1),
                        children: "-"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: option.quantity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChangeQuantityButton, {
                        onClick: function() {
                            return dispatch(customize_actions/* default.incrementOption */.Z.incrementOption(option.id));
                        },
                        // Disable if we're already at maxAgg, or if option quantity is max_choice_quantity or 99
                        disabled: isOptionIncrementDisabled,
                        increment: true,
                        "aria-label": "Increment ".concat(option.name, " quantity by ").concat(sdk_dist/* sdkUtils.calculateIncrementor */.fH.calculateIncrementor(option, group)),
                        children: "+"
                    })
                ]
            })
        ]
    });
}
function AdvancedOptionGroup(param) {
    var option = param.option, displayOptionsErrors = param.displayOptionsErrors;
    var advancedOptionGroup = option.option_groups.find(function(group) {
        return group.is_adv_nested_modifier && !group.is_hidden;
    });
    // We only show the group if the option is selected, and it has an advanced option group.
    var showAdvancedOptionGroup = option.selected && advancedOptionGroup;
    if (!showAdvancedOptionGroup) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            displayOptionsErrors && !advancedOptionGroup.valid && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAdvNestedModOptionGroupHelperText, {
                children: "Selection required"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAdvancedOptionGroup, {
                children: advancedOptionGroup.options.map(function(opt) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionContainer, {
                        option: opt,
                        group: advancedOptionGroup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionCardContainer, {
                            option: opt,
                            group: advancedOptionGroup,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                option: opt,
                                supportsQuantitySelection: advancedOptionGroup.supports_quantity_selection,
                                isAdvancedModOption: true
                            })
                        })
                    });
                })
            })
        ]
    });
}
/**
 * A container for the option that handles the styling of the option card.
 */ function OptionContainer(param) {
    var children = param.children, option = param.option, group = param.group;
    var groupHasImages = (0,menu/* doesGroupHaveImages */.MM)(group);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionContainer, {
        "data-testid": "option-container",
        selected: !!option.selected,
        is_adv_nested_modifier_group: Boolean(group.is_adv_nested_modifier),
        is_inverted: !!option.is_inverted,
        className: "koala__ui-item-option".concat(groupHasImages ? "-image" : ""),
        "data-global-id": option.global_option_id,
        groupHasImages: groupHasImages,
        children: children
    });
}
/**
 * A wrapper around the option card that handles the click event for selecting/deselecting an option.
 */ function OptionCardContainer(param) {
    var children = param.children, option = param.option, group = param.group;
    var toggleSelectedOption = // An option is selected or completely deselected by clicking on it.
    function toggleSelectedOption() {
        option.selected ? dispatch(customize_actions/* default.decrementOption */.Z.decrementOption(option.id, true)) : dispatch(customize_actions/* default.incrementOption */.Z.incrementOption(option.id));
    };
    var dispatch = (0,redux/* useDispatch */.I0)();
    var isOptionDisabled = group.is_max_aggregate_quantity_reached || option.is_max_selections_reached;
    var groupHasImages = (0,menu/* doesGroupHaveImages */.MM)(group);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionCard, {
        onClick: function(event) {
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
            toggleSelectedOption();
        },
        // If we're at our max and option is not currently selected, disable selection
        // Do not disable if maxAgg is 0 - this is Olo's single product mode
        disabled: isOptionDisabled,
        groupHasImages: groupHasImages,
        hasAdvancedModOptions: option.contains_adv_nested_modifiers,
        "aria-label": "".concat(option.selected ? "Deselect" : "Select", " ").concat(option.name),
        "aria-pressed": option.selected,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/features/product-customizer/product-options/helper-message.tsx



function HelperMessage(param) {
    var group = param.group;
    var minSelection = group.min_selections;
    var maxSelection = group.max_selections;
    var minAggregate = group.min_aggregate_quantity;
    var maxAggregate = group.max_aggregate_quantity;
    var optionQuantHelperText = (0,menu/* setOptionQuantityRequirementsText */.HH)(minSelection, maxSelection, minAggregate, maxAggregate);
    var showAggregateQuantityCounter = /** @TODO ensure that `minAggregate` and `maxAggregate` are defined. */ /** @ts-ignore */ minAggregate > 0 && maxAggregate > 0 && minAggregate === maxAggregate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOptionQuantityHelperText, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    group.explanation_text && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: group.explanation_text
                    }),
                    optionQuantHelperText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: optionQuantHelperText
                    })
                ]
            }),
            showAggregateQuantityCounter && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "(",
                    group.total_aggregate_quantity,
                    "/",
                    maxAggregate,
                    " selected)"
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/product-customizer/product-options/option-group-header.tsx




function getOptionsStillNeeded(requiredGroup, final) {
    var _surfaceable_option_groups;
    // Array of option groups that contain our selected options
    var selectedOptionGroups = (_surfaceable_option_groups = final.surfaceable_option_groups) !== null && _surfaceable_option_groups !== void 0 ? _surfaceable_option_groups : [];
    // Find the group that has required minimums
    var selectedRequiredGroup = selectedOptionGroups.find(function(group) {
        return group.id === requiredGroup.id;
    });
    /*
   * Required group's min_aggregate_quantity minus how many options user has selected
   * 'Single selection' items in Olo may have max_aggregate_quantity of 0, which is not intuitive.
   * In this case, we need to take into account min_selections instead
   */ var minimumRequirements = requiredGroup.max_aggregate_quantity === 0 ? requiredGroup.min_selections : requiredGroup.min_aggregate_quantity;
    var optionsStillNeeded = /** @TODO ensure that `minimumRequirements` and `total_aggregate_quantity` are defined. */ // @ts-ignore
    minimumRequirements - selectedRequiredGroup.total_aggregate_quantity;
    return optionsStillNeeded;
}
function OptionGroupHeader(param) {
    var group = param.group, final = param.final, displayOptionsErrors = param.displayOptionsErrors;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOptionGroupHeader, {
        id: "option-group-".concat(group.id),
        className: cssClassNames/* CSS_CLASSES.STORE_MENU.PRODUCT_OPTION_GROUP_HEADER */.Y.STORE_MENU.PRODUCT_OPTION_GROUP_HEADER,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                children: [
                    group.description.trim(),
                    group.min_selections && group.min_selections > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Required"
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelperMessage, {
                group: group
            }),
            ((ref = final.surfaceable_option_groups) === null || ref === void 0 ? void 0 : ref.find(function(optionGroup) {
                return optionGroup.id === group.id && !optionGroup.valid;
            })) && // If there's at least 1 option still needed
            getOptionsStillNeeded(group, final) > 0 && // and user has clicked Add to Bag
            displayOptionsErrors && // Display helper text
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOptionGroupHelperText, {
                children: [
                    "Please make the required selection: Choose",
                    " ",
                    getOptionsStillNeeded(group, final)
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/product-customizer/product-options/index.tsx





function ProductOptions(param) {
    var product = param.product;
    var ref = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.customize;
    }), final = ref.final, displayOptionsErrors = ref.displayOptionsErrors;
    // If the product has no option groups, don't show anything.
    if (!product.surfaceable_option_groups || !final) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopOptionContainer, {
        children: product.surfaceable_option_groups.map(function(group) {
            // Don't display hidden option groups or advanced nested modifier groups.
            if (group.is_hidden || group.is_adv_nested_modifier) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNestedOptionContainer, {
                "data-global-id": group.global_id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionGroupHeader, {
                        displayOptionsErrors: displayOptionsErrors,
                        final: final,
                        group: group
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionGroup, {
                        "data-testid": "option-group",
                        children: group.options.map(function(opt) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionCard, {
                                option: opt,
                                group: group,
                                displayOptionsErrors: displayOptionsErrors
                            }, opt.id);
                        })
                    })
                ]
            }, group.id);
        })
    });
}

// EXTERNAL MODULE: ./src/components/uielements/form-fields/styles.ts
var form_fields_styles = __webpack_require__(73081);
;// CONCATENATED MODULE: ./src/features/product-customizer/recipient/index.tsx




var Recipient = function(param) {
    var maxLength = param.maxLength, onChange = param.onChange, title = param.title, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopOptionContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNestedOptionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionGroupHeader, {
                    className: cssClassNames/* CSS_CLASSES.PRODUCT_DETAIL.RECIPIENT_INSTRUCTIONS_HEADER */.Y.PRODUCT_DETAIL.RECIPIENT_INSTRUCTIONS_HEADER,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledInput */.Fy, {
                    placeholder: "Enter recipient (".concat(maxLength, " character limit)"),
                    maxLength: maxLength,
                    onChange: function(e) {
                        if (maxLength && e.target.value.length > maxLength) {
                            return;
                        }
                        onChange(e.target.value);
                    },
                    value: value
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/product-customizer/special-instructions/index.tsx







function SpecialInstructions(param) {
    var value = param.value, onChange = param.onChange, maxLength = param.maxLength;
    var strings = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.cmsConfig;
    }).strings;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopOptionContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNestedOptionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOptionGroupHeader, {
                    className: cssClassNames/* CSS_CLASSES.PRODUCT_DETAIL.SPECIAL_INSTRUCTION_HEADER */.Y.PRODUCT_DETAIL.SPECIAL_INSTRUCTION_HEADER,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            tag: "h3",
                            accessor: "product_details.special_instructions_header",
                            html: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            tag: "p",
                            accessor: "product_details.special_instructions_subheader",
                            html: false
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledInput */.Fy, {
                    placeholder: (0,stringHelpers/* safelyGetString */.bc)(strings, "product_details.special_instructions_placeholder"),
                    maxLength: maxLength,
                    onChange: function(e) {
                        // Ensure we do not exceed the max byte length
                        if (maxLength && e.target.value.length > maxLength) {
                            return;
                        }
                        onChange(e.target.value);
                    },
                    value: value
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/features/product-customizer/warning-labels/index.tsx


function WarningLabels(param) {
    var labels = param.labels;
    if (labels.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWarningLabel, {
        children: labels.map(function(label) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: label.image_url,
                        alt: label.image_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: label.description
                        }
                    })
                ]
            }, label.name);
        })
    });
}

;// CONCATENATED MODULE: ./src/features/product-customizer/editor.tsx





















function ProductEditor() {
    var showValidationErrors = /**
   * Show validation errors for basket items with required options.
   * @TODO change to scrolling via an element ref instead of `getElementById`.
   */ function showValidationErrors() {
        var ref;
        dispatch(customize_actions/* default.displayOptionsErrors */.Z.displayOptionsErrors(true));
        dispatch(customize_actions/* default.triggerToastOptionsError */.Z.triggerToastOptionsError());
        // Find first invalid option group.
        var firstInvalidGroup = final === null || final === void 0 ? void 0 : (ref = final.surfaceable_option_groups) === null || ref === void 0 ? void 0 : ref.find(function(group) {
            return !group.valid;
        });
        // ...and scroll to its corresponding DOM element.
        var el = document.getElementById("option-group-".concat(firstInvalidGroup === null || firstInvalidGroup === void 0 ? void 0 : firstInvalidGroup.id));
        if (el) {
            el.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    var addToCart = /**
   * Validates the selected item options and adds it to cart.
   */ function addToCart() {
        var ref;
        if (!product || !canonicalProduct) {
            return;
        }
        var basketItemId = undefined;
        var location = locationDetail;
        // Edited items should retain the original location, items added from a new location will still reinit the cart.
        if (typeof index === "number") {
            /** @TODO ensure that the basket includes the entire location record. */ // @ts-expect-error
            location = basket.location;
            basketItemId = sdk_dist/* sdkStorage.basket.get */.fn.basket.get().content.basket_items[index].id;
        }
        // If there is no location object passed (we are likely off the menu page on e.g. upsell in sidecart and there is nothing in redux)
        // grab the location id from the current basket. TODO - maybe it's better to explicitly check to see if it's an upsell item before
        // reassigning the location. Are there cases where we'd be adding an item without a location detail object and intentionally want
        // to trigger a re-init of the basket?
        if (location && !location.id) {
            /** @TODO ensure that the basket includes the entire location record. */ // @ts-expect-error
            location = basket.location;
        }
        // Grab category ID and label for Koala Analytics
        var productCategory = sdk_dist/* sdkUtils.findProductCategory */.fH.findProductCategory(product.id, categories);
        var productCategoryLabel = productCategory === null || productCategory === void 0 ? void 0 : productCategory.name;
        var productCategoryId = productCategory === null || productCategory === void 0 ? void 0 : productCategory.global_id;
        var basketProduct = {
            id: basketItemId,
            product: {
                id: product.id,
                global_id: product.global_id,
                name: product.name,
                cross_sell_id: upsellId || null,
                cost: canonicalProduct.cost * quantity,
                category_id: productCategoryId || null,
                category_label: productCategoryLabel || null,
                filter_tags: product === null || product === void 0 ? void 0 : product.filter_tags
            },
            options: options,
            quantity: quantity,
            special_instructions: specialInstructions,
            recipient: recipient
        };
        // If some option groups are invalid, show an error.
        if (final === null || final === void 0 ? void 0 : (ref = final.surfaceable_option_groups) === null || ref === void 0 ? void 0 : ref.some(function(g) {
            return !g.valid;
        })) {
            showValidationErrors();
            return;
        }
        // Null or mismatched location ids require an init/reinit of the basket
        // Unless the mismatch is because we are adding a cross-sell item from a basket
        // associated with a different location than the current menu we've landed on.
        // In that case we should be able to proceed adding the item to the basket normally
        if (!basket.location.id || basket.location.id !== (location === null || location === void 0 ? void 0 : location.id)) {
            if (label !== checkout/* PRODUCT_LOCATION_LABELS.CROSS_SELL */.X.CROSS_SELL) {
                var referralTrackingCode = new sdk_dist/* ConversionTrackingHelper */.jJ().getTrackingKey();
                /**
         * If a delivery address exists, add it to localStorage when creating a basket
         *
         * @FIXME there are some issues with this action type:
         * 1. The location is nullable, which is an issue with the Location slice's empty state.
         * 2. The categories are nullable, again an issue with the Menu slice's empty state.
         * 3. The address null|undefined inconsistencies.
         */ dispatch(basket_actions/* default.initBasket */.Z.initBasket(// @ts-expect-error TODO: make sure location is defined
                location, categories, undefined, address !== null && address !== void 0 ? address : undefined, time_wanted, referralTrackingCode !== null && referralTrackingCode !== void 0 ? referralTrackingCode : undefined));
            }
        }
        /**
     * Add the item to the user's basket and close the modal.
     *
     * @FIXME there is an issue with this action type:
     * 1. The label is nullable, which is an issue with the Customize slice's empty state.
     */ dispatch(basket_actions/* default.addItem */.Z.addItem(basketProduct, label, index));
        dispatch(customize_actions/* default.clearProduct */.Z.clearProduct());
    };
    var dispatch = (0,redux/* useDispatch */.I0)();
    var basket = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.basket.content;
    });
    var locationDetail = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.locations.detail;
    });
    var webConfig = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.cmsConfig;
    }).webConfig;
    var ref = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.conveyanceMode;
    }), address = ref.address, time_wanted = ref.time_wanted;
    var ref1;
    var categories = (0,service/* useMenu */.H)({
        id: (ref1 = locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.id) !== null && ref1 !== void 0 ? ref1 : 0,
        wantedAt: time_wanted
    }).categories;
    var ref2 = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.customize;
    }), canonicalProduct = ref2.canonicalProduct, final = ref2.final, index = ref2.index, label = ref2.label, options = ref2.options, product = ref2.product, quantity = ref2.quantity, toggleToastOptionsError = ref2.toggleToastOptionsError, upsellId = ref2.upsellId;
    /**
   * @REFACTOR
   * The basket item should be selected by ID instead of array index,
   */ // @ts-expect-error
    var basketItem = basket.basket_items[index];
    var editing = typeof index === "number";
    var ref3;
    // Store item recipient and special instructions.
    var ref4 = (0,react.useState)((ref3 = basketItem === null || basketItem === void 0 ? void 0 : basketItem.recipient) !== null && ref3 !== void 0 ? ref3 : ""), recipient = ref4[0], setRecipient = ref4[1];
    var ref5;
    var ref6 = (0,react.useState)((ref5 = basketItem === null || basketItem === void 0 ? void 0 : basketItem.special_instructions) !== null && ref5 !== void 0 ? ref5 : ""), specialInstructions = ref6[0], setSpecialInstructions = ref6[1];
    if (!locationDetail || !final || !product) {
        return null;
    }
    var dietaryPreferencesEnabled = webConfig.menu.dietary_preferences_enabled;
    var specialInstructionsEnabled = webConfig.product_detail.special_instructions_enabled;
    var itemRecipientEnabled = locationDetail.supports_item_recipients;
    var specialInstructionsMaxLength = locationDetail.special_instructions_max_length;
    // Merge allergies into the final customized product.
    var finalWithAllergies = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, final), {
        allergens: dietaryPreferencesEnabled ? (0,menu/* getAllProductOptionAllergens */.XH)(product, options) : final.allergens
    });
    var _item_recipient_label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCustomizeContainer, {
        "data-testid": "product-details-modal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPdpCloseButton, {
                    onClick: function() {
                        return dispatch(customize_actions/* default.clearProduct */.Z.clearProduct());
                    },
                    "aria-label": "Click to close ".concat(product === null || product === void 0 ? void 0 : product.name, " detail modal"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(X/* XSvg */.Ji, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCustomizeScrollContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetail, {
                        product: finalWithAllergies,
                        locationDetail: locationDetail
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptions, {
                        product: product
                    }),
                    specialInstructionsEnabled && specialInstructionsMaxLength && /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialInstructions, {
                        maxLength: specialInstructionsMaxLength,
                        onChange: function(value) {
                            return setSpecialInstructions(value);
                        },
                        value: specialInstructions
                    }),
                    itemRecipientEnabled && constants_global/* MAX_LENGTH.ITEM_RECIPIENT */.uh.ITEM_RECIPIENT && /*#__PURE__*/ (0,jsx_runtime.jsx)(Recipient, {
                        maxLength: constants_global/* MAX_LENGTH.ITEM_RECIPIENT */.uh.ITEM_RECIPIENT,
                        onChange: function(value) {
                            return setRecipient(value);
                        },
                        title: (_item_recipient_label = locationDetail.item_recipient_label) !== null && _item_recipient_label !== void 0 ? _item_recipient_label : "Item Recipient",
                        value: recipient
                    }),
                    product.warningLabels && /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningLabels, {
                        labels: product.warningLabels
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCustomizeFooter, {
                validationErrorIsVisible: toggleToastOptionsError,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledToastError, {
                        role: "alert",
                        isVisible: toggleToastOptionsError,
                        children: "Please make all required selections to add order to your basket"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(product_customizer_footer_Footer, {
                        product: final,
                        addToOrder: addToCart,
                        quantity: quantity,
                        toggleQuantity: function(quantity) {
                            return dispatch(customize_actions/* default.toggleQuantity */.Z.toggleQuantity(quantity));
                        },
                        editing: editing,
                        disabled: !locationDetail.provider_enabled
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/product-customizer/index.tsx










var Customizer = function() {
    var ref = (0,redux/* useSelector */.v9)(function(param) {
        var app = param.app;
        return app.customize;
    }), open = ref.open, product = ref.product;
    var dispatch = (0,redux/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (open) {
            (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.STORE__PRODUCT_VIEW */.x.STORE__PRODUCT_VIEW, {
                name: product === null || product === void 0 ? void 0 : product.name,
                details: product === null || product === void 0 ? void 0 : product.global_id
            });
        }
    }, [
        open,
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Root */.fC, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Portal */.h_, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCustomizeModal, {
                id: "customize",
                className: cssClassNames/* CSS_CLASSES.PRODUCT_DETAIL.CONTAINER */.Y.PRODUCT_DETAIL.CONTAINER,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Overlay, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizeModalContent, {
                        "aria-labelledby": "product-name",
                        onEscapeKeyDown: function() {
                            return dispatch(customize_actions/* default.clearProduct */.Z.clearProduct());
                        },
                        onPointerDownOutside: function() {
                            return dispatch(customize_actions/* default.clearProduct */.Z.clearProduct());
                        },
                        children: open && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductEditor, {})
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/utils/breakpoints.ts
var breakpoints = __webpack_require__(32197);
;// CONCATENATED MODULE: ./src/components/accessibility/index.tsx

function accessibility_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n"
    ]);
    accessibility_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var VisuallyHiddenH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-410f68f9-0"
})(accessibility_templateObject());
var ScreenReaderOnlyHeading = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHiddenH1, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/app/layout/index.tsx






















function Layout(param) {
    var children = param.children, backgroundOverride = param.backgroundOverride, disabled = param.disabled, pageName = param.pageName;
    var navigateBackOnAndroid = function navigateBackOnAndroid() {
        (0,android/* setAndroidCurrentPage */.rT)(router.pathname, router.back, router.push);
    };
    var ref;
    var router = (0,next_router.useRouter)();
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    var webConfig = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }).webConfig;
    var content = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket;
    }).content;
    (0,react.useEffect)(function() {
        if ((0,android/* isAndroidShell */.Y2)()) {
            window.KoalaAndroidShell.canGoBack(router.pathname === routes/* ROUTES.ANDROID */.Z6.ANDROID ? false : true);
            window.addEventListener("android/navigateBack", navigateBackOnAndroid);
        }
        return function() {
            // we don't need to know about the android shell to remove an event tied to it
            window.removeEventListener("android/navigateBack", navigateBackOnAndroid);
        };
    }, []);
    var GlobalFloaterComponent = brand_components/* COMPONENT_CONFIG.GLOBAL_FLOATING */.P.GLOBAL_FLOATING[slug];
    var onLoyaltyPage = router.pathname.includes(routes/* ROUTES.ACCOUNT */.Z6.ACCOUNT);
    var inCheckoutFlow = [
        routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT,
        routes/* ROUTES.ORDER_CONFIRMATION */.Z6.ORDER_CONFIRMATION,
        routes/* ROUTES.ORDER_DETAIL */.Z6.ORDER_DETAIL, 
    ].includes(router.pathname);
    var onAndroidSplashScreen = router.pathname.includes(routes/* ROUTES.ANDROID */.Z6.ANDROID);
    var activeLoyaltyTab = router.pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLayout, {
        role: "document",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                scope: "page-transition",
                style: {
                    backgroundColor: webConfig.global.loading_bar_color,
                    left: 0,
                    position: "fixed",
                    top: 0,
                    zIndex: styles/* ORDER.LOADING */.kl.LOADING
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccessibilityAid, {
                href: "#start-of-content",
                children: "Skip to content"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Header, {}),
            onLoyaltyPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyNav, {
                activeLoyaltyTab: activeLoyaltyTab
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {
                hasContextualCart: (content === null || content === void 0 ? void 0 : (ref = content.basket_items) === null || ref === void 0 ? void 0 : ref.length) > 0 ? true : false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                backgroundOverride: backgroundOverride,
                id: "start-of-content",
                role: "main",
                className: pageName && "".concat(cssClassNames/* CSS_CLASSES.GLOBAL.STYLED_CONTENT_CONTAINER */.Y.GLOBAL.STYLED_CONTENT_CONTAINER, "-").concat(pageName),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenReaderOnlyHeading, {
                        children: "Content Start"
                    }),
                    !disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: children
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(toast, {}),
             true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizer, {}),
            GlobalFloaterComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalFloaterComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReorderModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fulfillmentManager, {}),
            !(0,android/* isAndroidShell */.Y2)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_Footer, {}),
            !(0,breakpoints/* isBreakpointSizeMin */.H)("medium") && !inCheckoutFlow && !onAndroidSplashScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextualCart, {})
        ]
    });
}


/***/ }),

/***/ 47971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ck": function() { return /* binding */ Item; },
  "ob": function() { return /* binding */ Items; },
  "UA": function() { return /* binding */ UnavailableItem; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/cart/items.styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  display: flex;\n  gap: var(--size-4);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ItemContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8af10e65-0"
})(_templateObject());
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-8af10e65-1"
})(function(param) {
    var canEdit = param.canEdit;
    return {
        aspectRatio: "1 / 1",
        cursor: canEdit ? "pointer" : "inherit",
        flex: "0 0 var(--size-20)",
        objectFit: "cover"
    };
});
var Summary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8af10e65-2"
})({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto"
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8af10e65-3"
})(function(param) {
    var canEdit = param.canEdit;
    return {
        appearance: "none",
        background: "none",
        border: "none",
        color: "var(--config-global__primary-active-color)",
        cursor: canEdit ? "pointer" : "default",
        padding: 0,
        textAlign: "left",
        "&:hover": {
            textDecoration: canEdit ? "underline" : "inherit"
        }
    };
});
var Price = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8af10e65-4"
})({
    marginLeft: "auto"
});
var Details = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8af10e65-5"
})({
    display: "flex",
    flexDirection: "column"
});
var Modifier = styled_components_browser_esm/* default.span.attrs */.ZP.span.attrs({
    "data-css-override": "StyledProductModifiers"
})({
    color: "var(--sidecart__foreground-color)",
    fontSize: "max(0.75rem, 0.75em)",
    maxWidth: "100%"
});
var RemoveItemButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-8af10e65-6"
})({
    unset: "all",
    outline: "revert",
    appearance: "none",
    background: "none",
    border: "none",
    cursor: "pointer",
    lineHeight: 1.3
});
var CartModalDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-8af10e65-7"
})({
    fontSize: "var(--config-text__primary-text-size)",
    margin: 0
});

// EXTERNAL MODULE: ./src/components/allergens/index.ts + 2 modules
var allergens = __webpack_require__(53247);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/uielements/X/index.tsx
var X = __webpack_require__(66086);
// EXTERNAL MODULE: ./src/components/uielements/box/box.tsx + 1 modules
var box = __webpack_require__(68801);
// EXTERNAL MODULE: ./src/components/uielements/itemRecipient/index.tsx + 1 modules
var itemRecipient = __webpack_require__(74730);
// EXTERNAL MODULE: ./src/components/uielements/modal/index.tsx + 9 modules
var modal = __webpack_require__(84247);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/components/uielements/stack/stack.tsx + 2 modules
var stack = __webpack_require__(45866);
// EXTERNAL MODULE: ./src/constants/checkout.ts
var checkout = __webpack_require__(80420);
// EXTERNAL MODULE: ./src/constants/global.ts
var global = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/features/menu/service.ts
var service = __webpack_require__(50019);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/redux/basket/index.ts
var basket = __webpack_require__(52912);
// EXTERNAL MODULE: ./src/redux/basket/actions.ts
var actions = __webpack_require__(29682);
// EXTERNAL MODULE: ./src/redux/basket/reducer.ts
var reducer = __webpack_require__(62152);
// EXTERNAL MODULE: ./src/redux/conveyanceMode/reducer.ts
var conveyanceMode_reducer = __webpack_require__(16440);
// EXTERNAL MODULE: ./src/redux/customize/actions.ts
var customize_actions = __webpack_require__(40646);
// EXTERNAL MODULE: ./src/utils/basket.ts
var utils_basket = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/utils/imageHelper.ts
var imageHelper = __webpack_require__(70595);
// EXTERNAL MODULE: ./src/utils/menu.ts
var menu = __webpack_require__(682);
;// CONCATENATED MODULE: ./src/components/cart/items.tsx























var Item = function(param) {
    var basketItem = param.basketItem, basketProduct = param.basketProduct, index = param.index, editProduct = param.editProduct, removeItem = param.removeItem, showImage = param.showImage, showDietaryPreferences = param.showDietaryPreferences, showSpecialInstructions = param.showSpecialInstructions;
    var isImageShown = showImage && (0,imageHelper/* hasProductImage */.dU)(basketProduct);
    var formatSelectedOption = function(optionGroup, option) {
        // If the option contains advanced nested modifiers we change the format of how its displayed.
        if (option.contains_adv_nested_modifiers) {
            // Get the option group which is the advanced nested modifier group.
            var advancedModOptionGroup = option.option_groups.find(function(og) {
                return og.is_adv_nested_modifier;
            });
            var ref;
            // Get the selected advanced nested modifier options from the option group.
            var advOptionNames = advancedModOptionGroup === null || advancedModOptionGroup === void 0 ? void 0 : advancedModOptionGroup.options.filter(function(advOpt) {
                return Boolean((ref = advOpt === null || advOpt === void 0 ? void 0 : advOpt.quantity) !== null && ref !== void 0 ? ref : 0 > 0);
            }).map(function(advOpt) {
                return advOpt.name;
            }).join(" ");
            return optionGroup.supports_quantity_selection ? "".concat(option.quantity, " x ").concat(advOptionNames, " ").concat(option.name) : "".concat(advOptionNames, " ").concat(option.name);
        }
        // If its not an advanced nested modifier we display it as normal.
        return optionGroup.supports_quantity_selection ? "".concat(option.quantity, " x ").concat(option.name) : option.name;
    };
    if (!basketProduct || !basketItem) {
        return null;
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContainer, {
        "data-testid": "basket-item",
        children: [
            isImageShown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                canEdit: Boolean(editProduct),
                onClick: function() {
                    if (editProduct) {
                        editProduct(basketItem, index);
                    }
                },
                src: (0,imageHelper/* getProductImageSrc */.Wr)(basketProduct, {
                    width: 80
                }),
                alt: basketProduct.name,
                width: 80
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Summary, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                "data-testid": "basket-item-label",
                                tabIndex: 0,
                                as: editProduct ? "button" : "span",
                                "aria-label": "Click to edit ".concat(basketProduct.name),
                                onClick: function() {
                                    if (editProduct) {
                                        editProduct(basketItem, index);
                                    }
                                },
                                canEdit: Boolean(editProduct),
                                children: basketProduct.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                children: [
                                    "$",
                                    (0,utils_basket/* toDollars */.DV)(((ref = basketProduct === null || basketProduct === void 0 ? void 0 : basketProduct.final_cost) !== null && ref !== void 0 ? ref : 0) * basketItem.quantity)
                                ]
                            }),
                            removeItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                                trigger: function(open) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveItemButton, {
                                        "data-testid": "remove-item-button",
                                        "aria-label": "Click to delete ".concat(basketProduct.name),
                                        onClick: open,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(X/* XSvg */.Ji, {
                                            size: 10
                                        })
                                    });
                                },
                                children: function(toggle) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                                                children: "Remove item"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Content */.u.Content, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartModalDescription, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                        accessor: "remove_item.confirm_prompt",
                                                        html: true,
                                                        dataObj: {
                                                            productToRemove: basketProduct.name
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Footer */.u.Footer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Cancel */.u.Cancel, {
                                                        children: "Cancel"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                                                        onClick: function() {
                                                            toggle();
                                                            removeItem(basketItem, index);
                                                        },
                                                        children: "Remove"
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Details, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modifier, {
                                children: // @ts-expect-error
                                basketProduct.surfaceable_option_groups.map(function(og) {
                                    // Ignore displaying advanced nested modifiers.
                                    // These are ignored because we manually show them
                                    // for options that contain advanced nested modifiers.
                                    // IE: Extra Mozzarella (Extra) is the advanced nested modifier,
                                    // and Mozzarella is the option containing that advanced nested modifier.
                                    if (og.is_adv_nested_modifier) {
                                        return "";
                                    }
                                    var ref;
                                    return og.options.filter(function(option) {
                                        return Boolean((ref = option === null || option === void 0 ? void 0 : option.quantity) !== null && ref !== void 0 ? ref : 0 > 0);
                                    }).map(function(option) {
                                        return formatSelectedOption(og, option);
                                    }).join(", ");
                                }).filter(function(value) {
                                    return value !== "";
                                }).join(", ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modifier, {
                                children: [
                                    "Quantity: ",
                                    basketItem.quantity
                                ]
                            }),
                            basketItem.special_instructions && showSpecialInstructions && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modifier, {
                                children: [
                                    '"',
                                    basketItem.special_instructions,
                                    '"'
                                ]
                            }),
                            basketItem.recipient && /*#__PURE__*/ (0,jsx_runtime.jsx)(itemRecipient/* ItemRecipient */.R, {
                                recipient: basketItem.recipient,
                                themeContext: "sidecart"
                            }),
                            showDietaryPreferences && basketItem.options.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(allergens/* AllergensMenuCard */.N, {
                                productAllergens: basketProduct,
                                selectedOptions: basketItem.options,
                                compileAllergensMethod: menu/* getAllProductOptionAllergens */.XH,
                                mode: global/* ALLERGEN_CARD_MODE.DETAIL */.JT.DETAIL
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var UnavailableItem = function(param) {
    var name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Summary, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stack/* Stack */.K, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        canEdit: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: name
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modifier, {
                        children: "* Item not currently available at this location"
                    })
                })
            ]
        })
    });
};
function Items(param) {
    var items = param.items;
    var ref = (0,redux/* useSelector */.v9)(basket/* selectBasketSlice */.p), basketContent = ref.content;
    var time_wanted = (0,redux/* useSelector */.v9)(conveyanceMode_reducer/* selectConveyance */.Fr).time_wanted;
    var basketMenu = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.menu;
    }).basketMenu;
    var ref1 = (0,redux/* useSelector */.v9)(reducer/* selectCart */.KY), showProductImages = ref1.showProductImages, showDietaryPreferences = ref1.showDietaryPreferences, showSpecialInstructions = ref1.showSpecialInstructions;
    var categories = (0,service/* useMenu */.H)({
        id: basketContent.location.id,
        wantedAt: time_wanted
    }).categories;
    var dispatch = (0,redux/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: items.map(function(value, index) {
            return value.item && value.final ? /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
                overrides: {
                    borderBlockStart: "1px solid var(--sidecart__divider-color)",
                    padding: "var(--size-6)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    index: value.index ? value.index : index,
                    basketItem: value.item,
                    basketProduct: value.final,
                    removeItem: function(basketItem, index) {
                        dispatch(actions/* default.removeItem */.Z.removeItem(index, basketItem));
                    },
                    editProduct: function(item, index) {
                        var product = dist/* sdkUtils.findMenuItemById */.fH.findMenuItemById(item.product.id, basketMenu);
                        // Failsafe for previous `options` format from existing carts
                        var existingOptions = (0,utils_basket/* prepareExistingOptionsObject */.EI)(item.options);
                        dispatch(customize_actions/* default.setProduct */.Z.setProduct({
                            label: checkout/* PRODUCT_LOCATION_LABELS.BASKET */.X.BASKET,
                            // @ts-expect-error: mismatched types
                            product: product,
                            categories: categories,
                            item: item,
                            index: index,
                            existingOptions: existingOptions
                        }));
                    },
                    showImage: showProductImages,
                    showDietaryPreferences: showDietaryPreferences,
                    showSpecialInstructions: showSpecialInstructions
                })
            }, "".concat(value.item.product.id, "-").concat(index)) : null;
        })
    });
}


/***/ }),

/***/ 66:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Es": function() { return /* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.Es; },
/* harmony export */   "Gi": function() { return /* binding */ ConnectedApplyButton; },
/* harmony export */   "Pj": function() { return /* binding */ StepContent; },
/* harmony export */   "Qj": function() { return /* binding */ LinkButton; },
/* harmony export */   "Sn": function() { return /* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.Sn; },
/* harmony export */   "UN": function() { return /* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.UN; },
/* harmony export */   "_3": function() { return /* binding */ RadioOption; },
/* harmony export */   "_K": function() { return /* binding */ CardIcon; },
/* harmony export */   "fB": function() { return /* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.fB; },
/* harmony export */   "jc": function() { return /* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.jc; },
/* harmony export */   "k$": function() { return /* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.k$; },
/* harmony export */   "lC": function() { return /* binding */ StepHeader; },
/* harmony export */   "le": function() { return /* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.le; },
/* harmony export */   "o3": function() { return /* binding */ StepContainer; },
/* harmony export */   "rY": function() { return /* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.rY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56580);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41631);
/* harmony import */ var _components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25167);
/* harmony import */ var _constants_cssClassNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5733);
/* harmony import */ var _types_orderStatus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74337);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10606);












var StepContainer = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var children = param.children, className = param.className, id = param.id;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledCheckoutComponent */ .Sn, {
        className: className,
        id: id,
        children: children
    });
});
// Wrap in forwardRef per
// https://nextjs.org/docs/api-reference/next/link#if-the-child-is-a-function-component
var LinkButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledLinkButton */ .UN, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        ref: ref,
        children: props.children
    }));
}));
/**
 * Card Icon
 *
 */ var CardIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledCardIcon */ .Gl, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        src: "/static/img/card-icons/".concat(props.type, "/").concat(props.icon, ".svg"),
        alt: "".concat(props.icon, " logo"),
        role: "presentation"
    }));
});
var RadioOption = function(param) {
    var children = param.children, id = param.id, onChange = param.onChange, checked = param.checked, name = param.name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                id: id,
                type: "radio",
                name: name,
                checked: checked,
                onChange: onChange
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: id,
                children: children
            })
        ]
    });
};
var _StepHeader = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var alwaysEnabled = param.alwaysEnabled, children = param.children, orderStatus = param.orderStatus, isUserLoggedIn = param.isUserLoggedIn;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledStepHeader */ .k$, {
        className: _constants_cssClassNames__WEBPACK_IMPORTED_MODULE_5__/* .CSS_CLASSES.CHECKOUT.STEP_HEADER_CONTAINER */ .Y.CHECKOUT.STEP_HEADER_CONTAINER,
        enabled: orderStatus.status !== _types_orderStatus__WEBPACK_IMPORTED_MODULE_6__/* .OrderStatuses.ORDER_NOT_INITIALIZED */ .pf.ORDER_NOT_INITIALIZED && isUserLoggedIn || alwaysEnabled,
        children: children
    });
});
var StepHeader = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.connect)(function(state) {
    return {
        orderStatus: state.app.orderStatus,
        isUserLoggedIn: (0,_utils_auth__WEBPACK_IMPORTED_MODULE_7__/* .isUserLoggedInForCheckout */ .mt)(state.app.me.data, state.app.auth.guestUser)
    };
})(_StepHeader);
var _StepContent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var alwaysEnabled = param.alwaysEnabled, children = param.children, orderStatus = param.orderStatus, isUserLoggedIn = param.isUserLoggedIn;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledStepContent */ .rY, {
        enabled: orderStatus.status !== _types_orderStatus__WEBPACK_IMPORTED_MODULE_6__/* .OrderStatuses.ORDER_NOT_INITIALIZED */ .pf.ORDER_NOT_INITIALIZED && isUserLoggedIn || alwaysEnabled,
        children: children
    });
});
var StepContent = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.connect)(function(state) {
    return {
        orderStatus: state.app.orderStatus,
        isUserLoggedIn: (0,_utils_auth__WEBPACK_IMPORTED_MODULE_7__/* .isUserLoggedInForCheckout */ .mt)(state.app.me.data, state.app.auth.guestUser)
    };
})(_StepContent);
var _ConnectedApplyButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) /*#__PURE__*/ {
    var children = _param.children, orderStatus = _param.orderStatus, loadingStatus = _param.loadingStatus, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "children",
        "orderStatus",
        "loadingStatus"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledPrimaryButton */ .D, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        submitting: orderStatus.status === loadingStatus
    }, otherProps), {
        children: children
    }));
});
var ConnectedApplyButton = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.connect)(function(state) {
    return {
        orderStatus: state.app.orderStatus,
        isUserLoggedIn: (0,_utils_auth__WEBPACK_IMPORTED_MODULE_7__/* .isUserLoggedInForCheckout */ .mt)(state.app.me.data, state.app.auth.guestUser)
    };
})(_ConnectedApplyButton);


/***/ }),

/***/ 41631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Es": function() { return /* binding */ StyledRadioRow; },
/* harmony export */   "Gl": function() { return /* binding */ StyledCardIcon; },
/* harmony export */   "SJ": function() { return /* binding */ StyledRemoveButton; },
/* harmony export */   "Sn": function() { return /* binding */ StyledCheckoutComponent; },
/* harmony export */   "UN": function() { return /* binding */ StyledLinkButton; },
/* harmony export */   "fB": function() { return /* binding */ StyledRadioLegend; },
/* harmony export */   "jc": function() { return /* binding */ StyledHeaderText; },
/* harmony export */   "k$": function() { return /* binding */ StyledStepHeader; },
/* harmony export */   "le": function() { return /* binding */ StyledSubheaderText; },
/* harmony export */   "rY": function() { return /* binding */ StyledStepContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8782);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73393);
/* harmony import */ var _utils_safePolished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68902);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  border-bottom: 1px solid var(--checkout--step-header__border-color);\n  display: flex;\n  justify-content: space-between;\n  opacity: var(--checkout--step-header__opacity);\n  padding: var(--size-4);\n\n  @media (min-width: 768px) {\n    padding: var(--size-6);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  display: var(--checkout--step-content__display);\n  padding: var(--size-4);\n\n  @media (min-width: 768px) {\n    padding: var(--size-6);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 26px;\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  font-family: ",
        ";\n  line-height: normal;\n  margin: 0;\n  text-align: ",
        ";\n  text-decoration: underline;\n  padding: 0;\n\n  // Ensure minimum ADA contrast on text links\n  // @TODO - theme.checkout\n  ",
        "\n\n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  // Visually hidden considerations\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  padding-bottom: ",
        "px;\n  width: 100%;\n  text-align: left;\n\n  @media (max-width: 767px) {\n    padding-bottom: ",
        "px;\n  }\n\n  input,\n  label {\n    cursor: pointer;\n    height: ",
        "px;\n  }\n\n  input {\n    appearance: revert;\n    height: 24px;\n    width: 24px;\n  }\n\n  label {\n    align-items: center;\n    display: flex;\n    flex: 1;\n    margin-left: ",
        "px;\n  }\n\n  img {\n    height: 26px;\n    margin-right: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 0 ",
        "px 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var _background_color, _border_color, _border_radius;
var StyledCheckoutComponent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8323a0a3-0"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        background: (_background_color = theme.checkout.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        border: "1px solid ".concat((_border_color = theme.checkout.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        borderRadius: "".concat((_border_radius = theme.checkout.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        width: "100%"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.checkout.font));
});
var StyledStepHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8323a0a3-1"
})(_templateObject(), function(param) {
    var enabled = param.enabled, theme = param.theme;
    return "\n    --checkout--step-header__border-color: ".concat(enabled ? theme.checkout.border_color : "transparent", ";\n    --checkout--step-header__opacity: ").concat(enabled ? 1 : 0.75, ";\n  ");
});
var StyledStepContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8323a0a3-2"
})(_templateObject1(), function(param) {
    var enabled = param.enabled;
    return "\n    --checkout--step-content__display: ".concat(enabled ? "block" : "none", ";\n  ");
});
var StyledCardIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-8323a0a3-3"
})(_templateObject2(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 4);
var _background_color1, _active_font_color, _active_font_color1, _color;
var StyledLinkButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-8323a0a3-4"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, function(param) {
    var textAlign = param.textAlign;
    return textAlign || "center";
}, function(param) {
    var theme = param.theme;
    return (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .getContrast */ .mj)((_background_color1 = theme.location_card.background_color) !== null && _background_color1 !== void 0 ? _background_color1 : "#ffffff", (_active_font_color = theme.dietary_preferences_tag.active_font_color) !== null && _active_font_color !== void 0 ? _active_font_color : "#000000") > 4.5 ? "\n    color: ".concat((_active_font_color1 = theme.dietary_preferences_tag.active_font_color) !== null && _active_font_color1 !== void 0 ? _active_font_color1 : "#000000", ";\n  ") : "\n    color: ".concat((_color = theme.location_card.font.color) !== null && _color !== void 0 ? _color : "#000000", ";\n    text-decoration: underline;\n  ");
});
var StyledRadioLegend = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].legend.withConfig */ .ZP.legend.withConfig({
    componentId: "sc-8323a0a3-5"
})(_templateObject4());
var StyledRadioRow = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8323a0a3-6"
})(_templateObject5(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 2, function(param) {
    var mobilePadding = param.mobilePadding;
    return mobilePadding || _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 2;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER * 2, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 2, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 2);
var StyledHeaderText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-8323a0a3-7"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        margin: 0
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.checkout.secondary_font));
});
var StyledSubheaderText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledHeaderText).withConfig({
    componentId: "sc-8323a0a3-8"
})(_templateObject6(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 2);
var StyledRemoveButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-8323a0a3-9"
})(function(param) {
    var theme = param.theme;
    var ref = (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.checkout.font), backgroundColor = ref.color;
    var _background_color;
    return {
        background: "none",
        border: "none",
        cursor: "pointer",
        height: "".concat(theme.forms.field_height, "px"),
        padding: "8px",
        width: "40px",
        span: {
            background: backgroundColor ? (0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_6__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(0.25, backgroundColor) : "inherit",
            color: (_background_color = theme.checkout.background_color) !== null && _background_color !== void 0 ? _background_color : "inherit",
            borderRadius: "50%",
            display: "block",
            fontSize: "16px",
            height: "24px",
            lineHeight: "24px",
            transition: "all 150ms linear",
            width: "24px",
            "&:hover": {
                background: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "inherit"
            }
        }
    };
});


/***/ }),

/***/ 90836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56580);
/* harmony import */ var _utils_stringHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60738);




var StringAccessor = function(param) {
    var accessor = param.accessor, html = param.html, tag = param.tag, dataObj = param.dataObj, disableDataObjEncode = param.disableDataObjEncode;
    var Element = tag;
    var strings = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.useSelector)(function(state) {
        return state.app.cmsConfig.strings;
    });
    var str = (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_3__/* .safelyGetString */ .bc)(strings, accessor, dataObj, disableDataObjEncode); // At worst, this will be an empty string.
    // Ensure we have what we need before returning any JSX
    if (!accessor || !str) {
        return null;
    }
    // See if we need to return HTML
    if (html) {
        return Element ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
            dangerouslySetInnerHTML: {
                __html: str
            }
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: str
            }
        });
    }
    // Otherwise, let's try and return a fragment
    return Element ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
        children: str
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: str
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StringAccessor);


/***/ }),

/***/ 65465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zo": function() { return /* binding */ styled; }
/* harmony export */ });
/* unused harmony exports css, globalCss, keyframes, getCssText, theme, createTheme, config, reset, createStitchedTheme, createKoalaTheme */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);
/* harmony import */ var _stitches_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43866);




var colors = {
    accentPrimary: "#0D6CF2",
    accentSecondary: "#5D6E86",
    accentSuccess: "#008060",
    accentHighlight: "##5BCDDA",
    accentError: "#D82C0D",
    accentWarning: "#FFC453",
    shade900: "#000000",
    shade800: "#1A1A1A",
    shade600: "#595959",
    shade400: "#C1C1C1",
    shade300: "#E5E5E5",
    shade200: "#F3F3F3",
    shade100: "#FFFFFF"
};
var typography = {
    fonts: {
        primary: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif",
        secondary: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif"
    },
    fontSizes: {
        primary: "1.25rem",
        secondary: "2rem",
        text800: "3rem",
        text700: "2.5rem",
        text600: "1.75rem",
        text500: "1.5rem",
        text400: "1.25rem",
        text300: "1.125rem",
        text200: ".875rem",
        text100: ".75rem"
    },
    lineHeights: {
        none: 1,
        tighter: 1.1,
        tight: 1.25,
        snug: 1.35,
        normal: 1.5,
        loose: 1.65,
        looser: 2
    },
    letterSpacings: {
        none: 0,
        tight: "-0.025em",
        snug: "-0.0125em",
        loose: "0.025em",
        wide: "0.05em",
        wider: "0.075em"
    }
};
var space = {
    0: "0",
    "0-5": ".125rem",
    1: ".25rem",
    "1-5": ".375rem",
    2: ".5rem",
    "2-5": ".675rem",
    3: ".75rem",
    "3-5": ".875rem",
    4: "1rem",
    "4-5": "1.125rem",
    5: "1.25rem",
    "5-5": "1.375rem",
    6: "1.5rem",
    "6-5": "1.625rem",
    7: "1.75rem",
    "7-5": "1.875rem",
    8: "2rem",
    "8-5": "2.125rem",
    9: "2.25rem",
    10: "2.5rem",
    11: "2.75rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    56: "14rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem",
    128: "32rem"
};
var sizes = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, space), {
    sm: "20rem",
    md: "28rem",
    lg: "36rem",
    xl: "40rem",
    "2xl": "48rem",
    "3xl": "56rem",
    "4xl": "64rem",
    "5xl": "72rem",
    "6xl": "80rem",
    "7xl": "92rem",
    full: "100%"
});
var radii = {
    sm: "0.25rem",
    md: "0.5rem",
    lg: "0.75rem",
    xl: "1rem",
    "2xl": "1.25rem",
    "3xl": "1.5rem",
    "4xl": "1.75rem",
    "5xl": "2rem",
    full: "100%"
};
var zIndices = {
    "-1": -1,
    "0": 0,
    "10": 10,
    "20": 20,
    "30": 30,
    "40": 40,
    "50": 50,
    "100": 100
};
var media = {
    maxsm: "(max-width: 640px)",
    sm: "(min-width: 640px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 1024px)",
    xl: "(min-width: 1280px)",
    "2xl": "(min-width: 1536px)",
    print: "print"
};
var ref = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .createStitches */ .Th)({
    theme: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, typography), {
        colors: colors,
        space: space,
        sizes: sizes,
        radii: radii,
        zIndices: zIndices
    }),
    media: media
}), styled = ref.styled, css = ref.css, globalCss = ref.globalCss, keyframes = ref.keyframes, getCssText = ref.getCssText, theme = ref.theme, createTheme = ref.createTheme, config = ref.config, reset = ref.reset;

function createStitchedTheme(configs) {
    if (!configs) {
        return {};
    }
    var primaryFont = getFontStyles(configs.text.primary_font);
    var secondaryFont = getFontStyles(configs.text.secondary_font);
    var _fontSize, _fontSize1;
    return {
        colors: {
            accentError: configs.global.error_color,
            accentPrimary: configs.global.primary_active_color,
            accentSuccess: configs.global.success_color
        },
        fonts: {
            primaryBold: configs.primary_font.bold.font_family,
            secondaryBold: configs.secondary_font.bold.font_family,
            primary: configs.primary_font.regular.font_family,
            secondary: configs.secondary_font.regular.font_family
        },
        fontSizes: {
            // @ts-expect-error return type for `snakeToPascal` is wrong
            primary: (_fontSize = primaryFont.fontSize) !== null && _fontSize !== void 0 ? _fontSize : "16px",
            // @ts-expect-error return type for `snakeToPascal` is wrong
            secondary: (_fontSize1 = secondaryFont.fontSize) !== null && _fontSize1 !== void 0 ? _fontSize1 : "24px"
        }
    };
}
function createKoalaTheme(config) {
    var cssConfig = createStitchedTheme(config);
    var namespaces = Object.keys(cssConfig);
    var stringValue = namespaces.map(function(namespace) {
        var properties = Object.keys(cssConfig[namespace]);
        return properties.map(function(property) {
            var value = cssConfig[namespace][property];
            return "--".concat(namespace, "-").concat(property, ":").concat(value);
        }).join(";");
    }).join(";");
    return "@media{:root{".concat(stringValue, "}}");
}


/***/ }),

/***/ 88917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FeatureAccessor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42838);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56580);
/* harmony import */ var _constants_features__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51710);




var _FeatureAccessor = function(param) {
    var children = param.children, featureFlag = param.featureFlag, featureBag = param.featureBag, renderFallback = param.renderFallback, _flagRelationship = param.flagRelationship, flagRelationship = _flagRelationship === void 0 ? _constants_features__WEBPACK_IMPORTED_MODULE_2__/* .FLAG_RELATIONSHIP.AND */ .Az.AND : _flagRelationship;
    var renderChildren = false;
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(featureFlag, Array)) {
        renderChildren = flagRelationship === _constants_features__WEBPACK_IMPORTED_MODULE_2__/* .FLAG_RELATIONSHIP.OR */ .Az.OR ? featureFlag.some(function(flag) {
            return featureBag[flag];
        }) : featureFlag.every(function(flag) {
            return featureBag[flag];
        });
    } else {
        renderChildren = featureBag[featureFlag];
    }
    if (renderChildren) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    if (renderFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: renderFallback
        });
    }
    return null;
};
var mapStateToProps = function(state) {
    return {
        featureBag: state.app.global.featureBag
    };
};
var connector = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.connect)(mapStateToProps);
var FeatureAccessor = connector(_FeatureAccessor);


/***/ }),

/***/ 27249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ autocompleteInputId; }
/* harmony export */ });
var autocompleteInputId = "autocomplete-delivery-address";


/***/ }),

/***/ 48350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(58408);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(37164);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56580);
/* harmony import */ var radar_sdk_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98735);
/* harmony import */ var _autocomplete_input_id__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(27249);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50473);
/* harmony import */ var _validation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(192);
/* harmony import */ var _components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90836);
/* harmony import */ var _components_uielements_form_fields__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92682);
/* harmony import */ var _components_uielements_label__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34404);
/* harmony import */ var _components_uielements_searchInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66143);
/* harmony import */ var _constants_events__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26654);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66686);
/* harmony import */ var _features_handoff_time_picker_styles__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56613);
/* harmony import */ var _redux_locations_actions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17464);
/* harmony import */ var _utils_errorReporter__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(19663);
/* harmony import */ var _utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61216);
/* harmony import */ var _utils_stringHelpers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(60738);
/* harmony import */ var radar_sdk_js_dist_radar_css__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29374);
/* harmony import */ var radar_sdk_js_dist_radar_css__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(radar_sdk_js_dist_radar_css__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _utils_radarMaps__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84986);
























// Radar


var RadarAutocomplete = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(RadarAutocomplete, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(RadarAutocomplete);
    function RadarAutocomplete() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(this, RadarAutocomplete);
        var _this;
        _this = _super.apply(this, arguments);
        // We need to generate unique input id for each Radar component
        // as there are cases where we could have more than one instance of GoogleAutocomplete component:
        // Delivery Search on Locators page and Opened Delivery Form Modal
        _this.generatedInputId = "".concat(_autocomplete_input_id__WEBPACK_IMPORTED_MODULE_21__/* .autocompleteInputId */ .h, "-").concat((0,nanoid__WEBPACK_IMPORTED_MODULE_22__/* .nanoid */ .x0)());
        _this.state = {
            address: null,
            searchValue: "",
            missingAddressFields: []
        };
        _this.autocomplete = null;
        _this.initAutocomplete = function() {
            var strings = _this.props.strings;
            if (_this.autocomplete) {
                // Session already started
                return;
            }
            var countryCodeUsOnly = typeof _this.props.webConfig.global.us_only === "undefined" ? true : _this.props.webConfig.global.us_only;
            radar_sdk_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].initialize */ .Z.initialize(_utils_radarMaps__WEBPACK_IMPORTED_MODULE_17__/* .RADAR_MAPS_CONFIG.sharableKey */ .K.sharableKey);
            _this.autocomplete = radar_sdk_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ui.autocomplete */ .Z.ui.autocomplete({
                container: _this.generatedInputId,
                width: "100%",
                maxHeight: "300px",
                placeholder: (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_15__/* .safelyGetString */ .bc)(strings, "locations.delivery_search_placeholder"),
                limit: 5,
                minCharacters: 2,
                onSelection: function(address) {
                    var formValues = _this.props.formValues;
                    var ref, _city, ref1, ref2, ref3, _postalCode;
                    // Set address in the format we want on state
                    _this.setState({
                        // @ts-expect-error `address` is mistyped.
                        address: {
                            time_wanted: (ref = formValues === null || formValues === void 0 ? void 0 : formValues.time_wanted) !== null && ref !== void 0 ? ref : _constants_global__WEBPACK_IMPORTED_MODULE_11__/* .DELIVERY_TIME_WANTED_MODES.ASAP */ .hC.ASAP,
                            street_address: address.addressLabel,
                            city: (ref3 = (ref2 = (ref1 = (_city = address.city) !== null && _city !== void 0 ? _city : address.borough) !== null && ref1 !== void 0 ? ref1 : address.neighborhood) !== null && ref2 !== void 0 ? ref2 : address.county) !== null && ref3 !== void 0 ? ref3 : "",
                            state: address.state,
                            zip_code: (_postalCode = address.postalCode) !== null && _postalCode !== void 0 ? _postalCode : ""
                        }
                    }, function() {
                        /** @TODO ensure that `address` isn't null. */ // @ts-expect-error
                        _this.handleSubmitAddress(_this.state.address);
                    });
                },
                countryCode: countryCodeUsOnly ? "US" : undefined
            });
        };
        _this.handleSubmitAddress = function(address) {
            var _props = _this.props, showDeliveryAddressInvalidError = _props.showDeliveryAddressInvalidError, checkOrSearchDeliveryCoverage = _props.checkOrSearchDeliveryCoverage;
            var validation = address && (0,_validation__WEBPACK_IMPORTED_MODULE_5__/* .addressValidation */ .U)(address);
            // Throw error if missing required address fields
            if (Object.keys(validation).length > 0) {
                _this.setState({
                    missingAddressFields: Object.keys(validation)
                });
                showDeliveryAddressInvalidError();
                return;
            }
            // This has been extended to accept both API calls, depending on where it's used
            checkOrSearchDeliveryCoverage(address, true);
        };
        _this.clearInputField = function() {
            var divWrapper = document.getElementById(_this.generatedInputId);
            var element = divWrapper && divWrapper.getElementsByTagName("input")[0];
            element.value = "";
            _this.props.clearDeliverySearchErrors();
            _this.setState({
                searchValue: ""
            });
        };
        _this.renderInputError = function() {
            var _props = _this.props, invalidDeliverySearchAddress = _props.invalidDeliverySearchAddress, googleAddressNotSelected = _props.googleAddressNotSelected;
            var missingAddressFields = _this.state.missingAddressFields;
            var formattedMissingAddressFields = missingAddressFields.join(", ").replace(/_/g, " ");
            // User enters incomplete address, e.g. Brooklyn, NY
            if (invalidDeliverySearchAddress) {
                return missingAddressFields.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    accessor: "locations.incomplete_address_text",
                    html: true,
                    dataObj: {
                        missingAddressFields: formattedMissingAddressFields
                    }
                });
            }
            if (googleAddressNotSelected) {
                // KA event
                (0,_utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_14__/* .fireKAnalyticsEvent */ .G)(_constants_events__WEBPACK_IMPORTED_MODULE_10__/* .K_ANALYTICS_EVENTS.LOG */ .AH.LOG, {
                    name: _constants_events__WEBPACK_IMPORTED_MODULE_10__/* .LOG_EVENTS.GOOGLE_ADDRESS_NOT_SELECTED */ .yX.GOOGLE_ADDRESS_NOT_SELECTED,
                    details: "Delivery Search"
                });
                return(// User presses enter without selecting an address from the dropdown
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    accessor: "locations.google_address_not_selected_text",
                    html: true
                }));
            }
        };
        return _this;
    }
    var _proto = RadarAutocomplete.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                // Clear any previous errors
                _this.props.clearDeliverySearchErrors();
                try {
                    _this.initAutocomplete();
                } catch (error) {
                    _utils_errorReporter__WEBPACK_IMPORTED_MODULE_25__/* .captureException */ .Tb(error);
                    console.error(error);
                }
                return [
                    2
                ];
            });
        })();
    };
    _proto.render = function render() {
        var _props = this.props, loading = _props.loading, invalidDeliverySearchAddress = _props.invalidDeliverySearchAddress, noDeliveryLocationsFound = _props.noDeliveryLocationsFound, googleAddressNotSelected = _props.googleAddressNotSelected;
        var inputId = "delivery-address-autocomplete-instructions";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_label__WEBPACK_IMPORTED_MODULE_8__/* .StyledLabel */ .a, {
                            as: "span",
                            id: "autocomplete-instructions",
                            visuallyHidden: true,
                            children: "Start typing your address, key down when you find your address, and then press enter"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_uielements_form_fields__WEBPACK_IMPORTED_MODULE_7__/* .SecureField */ .A, {
                            fieldType: inputId,
                            label: "Delivery Address",
                            // @ts-expect-error
                            error: this.renderInputError(),
                            "aria-describedby": inputId,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_searchInput__WEBPACK_IMPORTED_MODULE_9__/* .StyledRadarAddressSearchInputWrapper */ .KK, {
                                    id: this.generatedInputId,
                                    padding: "0 25px 0 35px"
                                }),
                                loading && !noDeliveryLocationsFound && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_handoff_time_picker_styles__WEBPACK_IMPORTED_MODULE_12__/* .StyledLoader */ .Hl, {
                                    right: 20,
                                    top: 10
                                }),
                                (noDeliveryLocationsFound || invalidDeliverySearchAddress || googleAddressNotSelected) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledInputResetButton */ .QW, {
                                    "aria-label": "Clear address",
                                    onClick: this.clearInputField,
                                    children: "\xd7"
                                })
                            ]
                        })
                    ]
                }),
                noDeliveryLocationsFound && !invalidDeliverySearchAddress && !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    tag: _styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledAutocompleteInstructions */ .eD,
                    accessor: "locations.delivery_search_no_results_text",
                    html: true
                }),
                !noDeliveryLocationsFound && !invalidDeliverySearchAddress && !googleAddressNotSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    tag: _styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledAutocompleteInstructions */ .eD,
                    accessor: "locations.delivery_search_instructional_text",
                    html: true
                })
            ]
        });
    };
    return RadarAutocomplete;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var mapStateToProps = function(state) {
    return {
        strings: state.app.cmsConfig.strings,
        invalidDeliverySearchAddress: state.app.locations.invalidDeliverySearchAddress,
        noDeliveryLocationsFound: state.app.locations.noDeliveryLocationsFound,
        googleAddressNotSelected: state.app.locations.googleAddressNotSelected,
        webConfig: state.app.cmsConfig.webConfig
    };
};
var mapDispatchToProps = {
    showDeliveryAddressInvalidError: _redux_locations_actions__WEBPACK_IMPORTED_MODULE_13__/* .locationsActions.showDeliveryAddressInvalidError */ .b.showDeliveryAddressInvalidError,
    clearDeliverySearchErrors: _redux_locations_actions__WEBPACK_IMPORTED_MODULE_13__/* .locationsActions.clearDeliverySearchErrors */ .b.clearDeliverySearchErrors
};
var connector = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.connect)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ __webpack_exports__["Z"] = (connector(RadarAutocomplete));


/***/ }),

/***/ 66630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(58408);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var load_google_maps_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42764);
/* harmony import */ var load_google_maps_api__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(load_google_maps_api__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(37164);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56580);
/* harmony import */ var _autocomplete_input_id__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(27249);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50473);
/* harmony import */ var _validation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(192);
/* harmony import */ var _components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90836);
/* harmony import */ var _components_uielements_form_fields__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92682);
/* harmony import */ var _components_uielements_label__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34404);
/* harmony import */ var _components_uielements_searchInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66143);
/* harmony import */ var _constants_events__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26654);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66686);
/* harmony import */ var _constants_locations__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56296);
/* harmony import */ var _features_handoff_time_picker_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56613);
/* harmony import */ var _redux_locations_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(17464);
/* harmony import */ var _utils_errorReporter__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(19663);
/* harmony import */ var _utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61216);
/* harmony import */ var _utils_stringHelpers__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(60738);

























var GoogleAutocomplete = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(GoogleAutocomplete, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(GoogleAutocomplete);
    function GoogleAutocomplete() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(this, GoogleAutocomplete);
        var _this;
        _this = _super.apply(this, arguments);
        // We need to generate unique input id for each GoogleAutocomplete component
        // as there are cases where we could have more than one instance of GoogleAutocomplete component:
        // Delivery Search on Locators page and Opened Delivery Form Modal
        _this.generatedInputId = "".concat(_autocomplete_input_id__WEBPACK_IMPORTED_MODULE_20__/* .autocompleteInputId */ .h, "-").concat((0,nanoid__WEBPACK_IMPORTED_MODULE_21__/* .nanoid */ .x0)());
        _this.state = {
            address: null,
            searchValue: "",
            missingAddressFields: []
        };
        _this.autocomplete = null;
        _this.initAutocomplete = function() {
            if (_this.autocomplete) {
                // Session already started
                return;
            }
            var input = document.getElementById(_this.generatedInputId);
            _this.autocomplete = new window.google.maps.places.Autocomplete(input, {
                types: [
                    "geocode"
                ],
                fields: [
                    "address_components",
                    "place_id",
                    "name",
                    "types"
                ],
                componentRestrictions: {
                    country: Object.values(_constants_locations__WEBPACK_IMPORTED_MODULE_12__/* .SUPPORTED_COUNTRIES */ .WU)
                }
            });
            _this.autocomplete.addListener("place_changed", _this.storeSelectedAddress);
            // This disables 'enter' form submissions when the autocomplete input is in focus
            input.addEventListener("keydown", function(event) {
                if (event.key === "Enter") {
                    event.preventDefault();
                }
            });
        };
        _this.mapAutocompleteAddress = function(selectedLocation) {
            var addressComponents = selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.address_components;
            if (!addressComponents) {
                // Throw error if address is not recognized by Google
                _this.props.showGoogleAddressNotSelectedError();
                return;
            }
            // Mapping of GeocoderAddressComponent.types[] to GoogleAddressComponentFields
            // All types represented as string and can be found
            // https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
            var newFormattedAddress = {};
            addressComponents.map(function(component) {
                return(// @ts-expect-error
                newFormattedAddress[component.types[0]] = component.short_name);
            });
            return newFormattedAddress;
        };
        // Set the selection to the Google autocomplete provided address
        _this.storeSelectedAddress = function() {
            var ref;
            var _props = _this.props, clearDeliverySearchErrors = _props.clearDeliverySearchErrors, showGoogleAddressNotSelectedError = _props.showGoogleAddressNotSelectedError, formValues = _props.formValues;
            // Clear any previous errors
            clearDeliverySearchErrors();
            var selectedLocation = (ref = _this.autocomplete) === null || ref === void 0 ? void 0 : ref.getPlace();
            // Parse the address object we get from Google
            // @ts-expect-error ensure that selectedLocation is defined.
            var addressComponents = _this.mapAutocompleteAddress(selectedLocation);
            if (!addressComponents) {
                // Throw error if address is not recognized by Google
                showGoogleAddressNotSelectedError();
                return;
            }
            // Parse street address
            var street_number = addressComponents.street_number, route = addressComponents.route;
            var streetAddress = "".concat(street_number !== null && street_number !== void 0 ? street_number : "", " ").concat(route !== null && route !== void 0 ? route : "").trim();
            var ref1, _locality, ref2, ref3, ref4, _postal_code;
            // Set address in the format we want on state
            _this.setState({
                // @ts-expect-error `address` is mistyped.
                address: {
                    time_wanted: (ref1 = formValues === null || formValues === void 0 ? void 0 : formValues.time_wanted) !== null && ref1 !== void 0 ? ref1 : _constants_global__WEBPACK_IMPORTED_MODULE_11__/* .DELIVERY_TIME_WANTED_MODES.ASAP */ .hC.ASAP,
                    street_address: streetAddress,
                    city: (ref4 = (ref3 = (ref2 = (_locality = addressComponents.locality) !== null && _locality !== void 0 ? _locality : addressComponents.sublocality) !== null && ref2 !== void 0 ? ref2 : addressComponents.sublocality_level_1) !== null && ref3 !== void 0 ? ref3 : addressComponents.administrative_area_level_3) !== null && ref4 !== void 0 ? ref4 : "",
                    state: addressComponents.administrative_area_level_1,
                    zip_code: (_postal_code = addressComponents.postal_code) !== null && _postal_code !== void 0 ? _postal_code : ""
                }
            }, function() {
                /** @TODO ensure that `address` isn't null. */ // @ts-expect-error
                _this.handleSubmitAddress(_this.state.address);
            });
        };
        _this.handleSubmitAddress = function(address) {
            var _props = _this.props, showDeliveryAddressInvalidError = _props.showDeliveryAddressInvalidError, checkOrSearchDeliveryCoverage = _props.checkOrSearchDeliveryCoverage;
            var validation = address && (0,_validation__WEBPACK_IMPORTED_MODULE_5__/* .addressValidation */ .U)(address);
            // Throw error if missing required address fields
            if (Object.keys(validation).length > 0) {
                _this.setState({
                    missingAddressFields: Object.keys(validation)
                });
                showDeliveryAddressInvalidError();
                return;
            }
            // This has been extended to accept both API calls, depending on where it's used
            checkOrSearchDeliveryCoverage(address, false);
        };
        _this.clearInputField = function() {
            var element = document.getElementById(_this.generatedInputId);
            element.value = "";
            _this.props.clearDeliverySearchErrors();
            _this.setState({
                searchValue: ""
            });
        };
        _this.renderInputError = function() {
            var _props = _this.props, invalidDeliverySearchAddress = _props.invalidDeliverySearchAddress, googleAddressNotSelected = _props.googleAddressNotSelected;
            var missingAddressFields = _this.state.missingAddressFields;
            var formattedMissingAddressFields = missingAddressFields.join(", ").replace(/_/g, " ");
            // User enters incomplete address, e.g. Brooklyn, NY
            if (invalidDeliverySearchAddress) {
                return missingAddressFields.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    accessor: "locations.incomplete_address_text",
                    html: true,
                    dataObj: {
                        missingAddressFields: formattedMissingAddressFields
                    }
                });
            }
            if (googleAddressNotSelected) {
                // KA event
                (0,_utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_15__/* .fireKAnalyticsEvent */ .G)(_constants_events__WEBPACK_IMPORTED_MODULE_10__/* .K_ANALYTICS_EVENTS.LOG */ .AH.LOG, {
                    name: _constants_events__WEBPACK_IMPORTED_MODULE_10__/* .LOG_EVENTS.GOOGLE_ADDRESS_NOT_SELECTED */ .yX.GOOGLE_ADDRESS_NOT_SELECTED,
                    details: "Delivery Search"
                });
                return(// User presses enter without selecting an address from the dropdown
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    accessor: "locations.google_address_not_selected_text",
                    html: true
                }));
            }
        };
        return _this;
    }
    var _proto = GoogleAutocomplete.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function() {
            var ref, ref1, ref2, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Clear any previous errors
                        _this.props.clearDeliverySearchErrors();
                        // If Google Maps has been loaded with Autocomplete, initialize Autocomplete
                        if ((window === null || window === void 0 ? void 0 : (ref = window.google) === null || ref === void 0 ? void 0 : (ref1 = ref.maps) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.places) === null || ref2 === void 0 ? void 0 : ref2.Autocomplete) !== undefined) {
                            _this.initAutocomplete();
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            load_google_maps_api__WEBPACK_IMPORTED_MODULE_1___default()({
                                key: _this.props.apiKey,
                                libraries: [
                                    _constants_global__WEBPACK_IMPORTED_MODULE_11__/* .GOOGLE_LIBRARIES.PLACES */ .Yv.PLACES
                                ]
                            })
                        ];
                    case 2:
                        _state.sent();
                        _this.initAutocomplete();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        _utils_errorReporter__WEBPACK_IMPORTED_MODULE_24__/* .captureException */ .Tb(error);
                        console.error(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, strings = _props.strings, loading = _props.loading, invalidDeliverySearchAddress = _props.invalidDeliverySearchAddress, noDeliveryLocationsFound = _props.noDeliveryLocationsFound, googleAddressNotSelected = _props.googleAddressNotSelected;
        var inputId = "delivery-address-autocomplete-instructions";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_label__WEBPACK_IMPORTED_MODULE_8__/* .StyledLabel */ .a, {
                            as: "span",
                            id: "autocomplete-instructions",
                            visuallyHidden: true,
                            children: "Start typing your address, key down when you find your address, and then press enter"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_uielements_form_fields__WEBPACK_IMPORTED_MODULE_7__/* .SecureField */ .A, {
                            fieldType: inputId,
                            label: "Delivery Address",
                            // @ts-expect-error
                            error: this.renderInputError(),
                            "aria-describedby": inputId,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_searchInput__WEBPACK_IMPORTED_MODULE_9__/* .StyledSearchInput */ .GB, {
                                    id: this.generatedInputId,
                                    placeholder: (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_16__/* .safelyGetString */ .bc)(strings, "locations.delivery_search_placeholder"),
                                    padding: "0 25px 0 10px",
                                    onChange: function(e) {
                                        return _this.setState({
                                            searchValue: e.target.value
                                        });
                                    }
                                }),
                                loading && !noDeliveryLocationsFound && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_handoff_time_picker_styles__WEBPACK_IMPORTED_MODULE_13__/* .StyledLoader */ .Hl, {
                                    right: 20,
                                    top: 10
                                }),
                                (noDeliveryLocationsFound || invalidDeliverySearchAddress || googleAddressNotSelected) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledInputResetButton */ .QW, {
                                    "aria-label": "Clear address",
                                    onClick: this.clearInputField,
                                    children: "\xd7"
                                })
                            ]
                        })
                    ]
                }),
                noDeliveryLocationsFound && !invalidDeliverySearchAddress && !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    tag: _styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledAutocompleteInstructions */ .eD,
                    accessor: "locations.delivery_search_no_results_text",
                    html: true
                }),
                !noDeliveryLocationsFound && !invalidDeliverySearchAddress && !googleAddressNotSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    tag: _styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledAutocompleteInstructions */ .eD,
                    accessor: "locations.delivery_search_instructional_text",
                    html: true
                })
            ]
        });
    };
    return GoogleAutocomplete;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
var mapStateToProps = function(state) {
    return {
        strings: state.app.cmsConfig.strings,
        invalidDeliverySearchAddress: state.app.locations.invalidDeliverySearchAddress,
        noDeliveryLocationsFound: state.app.locations.noDeliveryLocationsFound,
        googleAddressNotSelected: state.app.locations.googleAddressNotSelected
    };
};
var mapDispatchToProps = {
    showDeliveryAddressInvalidError: _redux_locations_actions__WEBPACK_IMPORTED_MODULE_14__/* .locationsActions.showDeliveryAddressInvalidError */ .b.showDeliveryAddressInvalidError,
    showGoogleAddressNotSelectedError: function() {
        return _redux_locations_actions__WEBPACK_IMPORTED_MODULE_14__/* .locationsActions.showGoogleAddressNotSelectedError */ .b.showGoogleAddressNotSelectedError;
    },
    clearDeliverySearchErrors: _redux_locations_actions__WEBPACK_IMPORTED_MODULE_14__/* .locationsActions.clearDeliverySearchErrors */ .b.clearDeliverySearchErrors
};
var connector = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__.connect)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ __webpack_exports__["Z"] = (connector(GoogleAutocomplete));


/***/ }),

/***/ 50473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gq": function() { return /* binding */ StyledForm; },
/* harmony export */   "QW": function() { return /* binding */ StyledInputResetButton; },
/* harmony export */   "eD": function() { return /* binding */ StyledAutocompleteInstructions; },
/* harmony export */   "jE": function() { return /* binding */ StyledAddAddressButton; },
/* harmony export */   "zp": function() { return /* binding */ StyledCityStateZip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _components_uielements_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64390);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  h2 {\n    font-family: ",
        ";\n    font-size: 24px;\n    margin: 0;\n    padding: 0 ",
        "px ",
        "px;\n\n    @media (max-width: 767px) {\n      font-size: 20px;\n      font-weight: 900;\n      padding: ",
        "px;\n    }\n  }\n\n  > p {\n    font-size: 15px;\n    margin-top: 0;\n  }\n\n  @media (max-width: 767px) {\n    margin: ",
        "px;\n    padding: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n\n  > div {\n    flex: 1;\n    margin-left: ",
        "px;\n\n    &:first-child {\n      flex: 2;\n      margin-left: 0;\n    }\n  }\n\n  @media (max-width: 767px) {\n    display: block;\n    > div {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  position: absolute;\n  right: ",
        "px;\n  top: 0px;\n  width: 22px;\n  color: ",
        ";\n  cursor: pointer;\n  font-size: 20px;\n  height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  background: none;\n  border: none;\n  font-size: 16px;\n  font-family: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  text-align: left;\n  padding: 0;\n  margin: ",
        "px 0 ",
        "px 0;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 0;\n  text-align: left;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledForm = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-72f00f6c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER / 2, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER / 2, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledCityStateZip = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72f00f6c-1"
})(_templateObject1(), _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledInputResetButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-72f00f6c-2"
})(_templateObject2(), _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER / 4, function(param) {
    var theme = param.theme;
    return theme.forms.placeholder_color;
});
var StyledAddAddressButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-72f00f6c-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.store_detail.active_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER / 1.5, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER, _components_uielements_css__WEBPACK_IMPORTED_MODULE_1__/* .LinkHoverCss */ .x);
var StyledAutocompleteInstructions = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-72f00f6c-4"
})(_templateObject4());


/***/ }),

/***/ 192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ addressValidation; }
/* harmony export */ });
/* harmony import */ var _constants_validation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38885);

var addressValidation = function(values) {
    var errors = {};
    // Street
    if (!values.street_address) {
        errors.street_address = "Required";
    }
    // City
    if (!values.city) {
        errors.city = "Required";
    }
    // State
    if (!values.state) {
        errors.state = "Required";
    }
    // Zip Code
    if (!values.zip_code) {
        errors.zip_code = "Required";
    }
    if (values.zip_code && !_constants_validation__WEBPACK_IMPORTED_MODULE_0__/* .REGEX.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA.test */ .mL.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA.test(values.zip_code)) {
        errors.zip_code = "Invalid";
    }
    // Time wanted mode
    if (!values.time_wanted) {
        errors.time_wanted = "Required";
    }
    return errors;
};


/***/ }),

/***/ 87375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ StyledAddressContainer; },
/* harmony export */   "N": function() { return /* binding */ StyledDeliveryFormSubheader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73393);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  border-bottom: solid 1px ",
        ";\n  padding: ",
        "px 0;\n  text-align: left;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledAddressContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-15576213-0"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        alignItems: "center",
        border: "1px solid ".concat(theme.location_search.border_color),
        borderRadius: "".concat(theme.location_search.border_radius, "px"),
        display: "flex",
        justifyContent: "space-between",
        margin: "10px 0",
        p: {
            margin: "0 20px 0 0"
        },
        padding: "20px"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.location_search.font, [
        "font_size"
    ])), {
        /** @FIXME font refactor. */ fontFamily: theme.primary_font.bold.font_family
    });
});
var StyledDeliveryFormSubheader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-15576213-1"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.global.primary_border_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 2);


/***/ }),

/***/ 42538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_content_stitches__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65465);


function Box(param) {
    var children = param.children, _css = param.css, css = _css === void 0 ? {} : _css;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
        css: css,
        children: children
    });
}
var Container = (0,_components_content_stitches__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {});


/***/ }),

/***/ 49586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xu": function() { return /* reexport */ box/* Box */.x; },
  "l0": function() { return /* reexport */ Form; },
  "Kq": function() { return /* reexport */ stack/* Stack */.K; }
});

// EXTERNAL MODULE: ./src/components/ui/box/index.tsx
var box = __webpack_require__(42538);
// EXTERNAL MODULE: ./src/components/ui/stack/index.tsx
var stack = __webpack_require__(96301);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/components/content/stitches.ts
var stitches = __webpack_require__(65465);
// EXTERNAL MODULE: ./src/features/configs/configs.ts
var configs = __webpack_require__(74380);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/components/ui/form/base.tsx






function Base(props) {
    var font = (0,configs/* useConfigOverride */.$E)("forms").font;
    var children = props.children, label = props.label, name = props.name, _required = props.required, required = _required === void 0 ? false : _required, error = props.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        htmlFor: name,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                css: (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(font, [
                    "color",
                    "font_family",
                    "font_weight",
                    "font_style", 
                ])),
                children: [
                    label,
                    required && "*"
                ]
            }),
            error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                css: (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(font, [
                    "font_family",
                    "font_weight"
                ])),
                children: error
            }) : null
        ]
    });
}
var Wrapper = (0,stitches/* styled */.zo)("label", {
    alignItems: "center",
    display: "flex",
    position: "relative",
    width: "100%"
});
var Label = (0,stitches/* styled */.zo)("span", {
    bottom: "1px",
    color: "$shade600",
    cursor: "text",
    fontFamily: "$primary",
    fontSize: "$text300",
    left: "1px",
    margin: 0,
    padding: "$3",
    position: "absolute",
    pointerEvents: "none",
    top: "1px",
    transformOrigin: "0 0",
    transition: "all .2s ease",
    zIndex: "$20"
});
var Field = (0,stitches/* styled */.zo)("input", (0,_define_property/* default */.Z)({
    alignItems: "center",
    appearance: "none",
    backgroundColor: "transparent",
    border: "1px solid $shade300",
    borderRadius: "$md",
    boxSizing: "border-box",
    color: "$shade800",
    cursor: "text",
    flex: 1,
    fontFamily: "$primary",
    fontSize: "$text300",
    height: "$12",
    lineHeight: 1,
    margin: 0,
    minWidth: 0,
    padding: "$5-5 $3 $2",
    position: "relative",
    transition: "all .2s ease",
    zIndex: "$10",
    "&:focus": {
        borderColor: "$accentPrimary",
        outline: "none"
    }
}, "&:focus ~".concat(Label, ", &:not(:placeholder-shown) ~ ").concat(Label), {
    transform: "scale(.75) translate3d(5px, -7px, 0)"
}));
var Error = (0,stitches/* styled */.zo)("span", {
    bottom: "1px",
    color: "$accentError",
    cursor: "text",
    fontFamily: "$primary",
    fontSize: "$text300",
    margin: 0,
    padding: "$3",
    position: "absolute",
    right: "1px",
    top: "1px",
    transform: "scale(.75) translate3d(-5px, -7px, 0)",
    transformOrigin: "100% 0",
    transition: "all .2s ease",
    zIndex: "$20"
});

;// CONCATENATED MODULE: ./src/components/ui/form/input.tsx







function Input(_param) {
    var label = _param.label, name = _param.name, _required = _param.required, required = _required === void 0 ? false : _required, error = _param.error, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "name",
        "required",
        "error"
    ]);
    var baseProps = {
        label: label,
        name: name,
        required: required,
        error: error
    };
    var ref = (0,configs/* useConfigOverride */.$E)("forms"), background_color = ref.background_color, border_color = ref.border_color, border_radius = ref.border_radius, font = ref.font;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Base, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, (0,_object_spread/* default */.Z)({
            id: name,
            placeholder: " ",
            required: required,
            "aria-label": label,
            css: (0,_object_spread/* default */.Z)({
                backgroundColor: background_color !== null && background_color !== void 0 ? background_color : "transparent",
                borderColor: border_color !== null && border_color !== void 0 ? border_color : "$shade300",
                borderRadius: "".concat(Number(border_radius), "px")
            }, (0,utils/* getFontStyles */.l)(font, [
                "color",
                "font_family",
                "font_weight",
                "font_style", 
            ]))
        }, otherProps))
    }));
}

;// CONCATENATED MODULE: ./src/components/ui/form/select.tsx








function Icon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19.5 9L12 16.5L4.5 9",
            fill: "none",
            stroke: "currentColor"
        })
    });
}
function Select(_param) {
    var label = _param.label, name = _param.name, _required = _param.required, required = _required === void 0 ? false : _required, error = _param.error, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "name",
        "required",
        "error",
        "children"
    ]);
    var baseProps = {
        label: label,
        name: name,
        required: required,
        error: error
    };
    var ref = (0,configs/* useConfigOverride */.$E)("forms"), background_color = ref.background_color, border_color = ref.border_color, border_radius = ref.border_radius, font = ref.font;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Base, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                as: "select",
                id: name,
                required: required,
                "aria-label": label,
                css: (0,_object_spread/* default */.Z)({
                    backgroundColor: background_color !== null && background_color !== void 0 ? background_color : "transparent",
                    borderColor: border_color !== null && border_color !== void 0 ? border_color : "$shade300",
                    borderRadius: "".concat(Number(border_radius), "px")
                }, (0,utils/* getFontStyles */.l)(font, [
                    "color",
                    "font_family",
                    "font_weight",
                    "font_style", 
                ]))
            }, otherProps), {
                children: children
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
                css: {
                    display: "flex",
                    position: "absolute",
                    right: "$4",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 10
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/ui/form/textarea.tsx







function Textarea(_param) {
    var label = _param.label, name = _param.name, _required = _param.required, required = _required === void 0 ? false : _required, error = _param.error, _css = _param.css, css = _css === void 0 ? {} : _css, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "name",
        "required",
        "error",
        "css"
    ]);
    var baseProps = {
        label: label,
        name: name,
        required: required,
        error: error
    };
    var ref = (0,configs/* useConfigOverride */.$E)("forms"), background_color = ref.background_color, border_color = ref.border_color, border_radius = ref.border_radius, font = ref.font;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Base, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, (0,_object_spread/* default */.Z)({
            id: name,
            required: required,
            as: "textarea",
            placeholder: " ",
            "aria-label": label,
            css: (0,_object_spread/* default */.Z)({
                height: "$24",
                backgroundColor: background_color !== null && background_color !== void 0 ? background_color : "transparent",
                borderColor: border_color !== null && border_color !== void 0 ? border_color : "$shade300",
                borderRadius: "".concat(Number(border_radius), "px")
            }, (0,utils/* getFontStyles */.l)(font, [
                "color",
                "font_family",
                "font_weight",
                "font_style", 
            ]), css)
        }, otherProps))
    }));
}

;// CONCATENATED MODULE: ./src/components/ui/form/index.tsx



var Form = {
    Input: Input,
    Select: Select,
    Textarea: Textarea
};

;// CONCATENATED MODULE: ./src/components/ui/index.ts





/***/ }),

/***/ 96301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ Stack; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_content_stitches__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65465);





var Stack = function(_param) /*#__PURE__*/ {
    var _align = _param.align, align = _align === void 0 ? "center" : _align, _position = _param.position, position = _position === void 0 ? "leading" : _position, _children = _param.children, children = _children === void 0 ? null : _children, _css = _param.css, css = _css === void 0 ? {} : _css, _direction = _param.direction, direction = _direction === void 0 ? "horizontal" : _direction, _gap = _param.gap, gap = _gap === void 0 ? "$2" : _gap, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "align",
        "position",
        "children",
        "css",
        "direction",
        "gap"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        align: align,
        position: position,
        direction: direction,
        css: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            gap: gap
        }, css)
    }, otherProps), {
        children: children
    }));
};
var Container = (0,_components_content_stitches__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    variants: {
        align: {
            leading: {
                alignItems: "flex-start"
            },
            center: {
                alignItems: "center"
            },
            trailing: {
                alignItems: "flex-end"
            },
            fill: {
                alignItems: "stretch"
            }
        },
        position: {
            leading: {
                justifyContent: "flex-start"
            },
            center: {
                justifyContent: "center"
            },
            trailing: {
                justifyContent: "flex-end"
            },
            fill: {
                justifyContent: "stretch"
            },
            between: {
                justifyContent: "space-between"
            }
        },
        direction: {
            horizontal: {
                flexDirection: "row"
            },
            vertical: {
                flexDirection: "column"
            }
        }
    }
});


/***/ }),

/***/ 68801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Box; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/uielements/box/box.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b50a112e-0"
})(_templateObject(), function(param) {
    var styles = param.styles;
    return styles;
});

;// CONCATENATED MODULE: ./src/components/uielements/box/box.tsx





var Box = function(_param) // @ts-ignore
/*#__PURE__*/ {
    var children = _param.children, _overrides = _param.overrides, overrides = _overrides === void 0 ? {} : _overrides, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "overrides"
    ]);
    return (0,jsx_runtime.jsx)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        styles: overrides
    }, otherProps), {
        children: children
    }));
};


/***/ }),

/***/ 92682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ ReduxFormField; },
  "A": function() { return /* reexport */ SecureField; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/lodash/kebabCase.js
var kebabCase = __webpack_require__(79857);
var kebabCase_default = /*#__PURE__*/__webpack_require__.n(kebabCase);
// EXTERNAL MODULE: ./src/components/uielements/form-fields/styles.ts
var form_fields_styles = __webpack_require__(73081);
// EXTERNAL MODULE: ./src/components/uielements/label/index.tsx
var uielements_label = __webpack_require__(34404);
;// CONCATENATED MODULE: ./src/components/uielements/form-fields/redux-form-field/redux-form-field.tsx






var ref;
var ReduxFormField = function(param) {
    var autoComplete = param.autoComplete, placeholder = param.placeholder, height = param.height, type = param.type, inputMode = param.inputMode, autoFocus = param.autoFocus, disabled = param.disabled, _meta = param.meta, touched = _meta.touched, error = _meta.error, noErrorOnTouch = param.noErrorOnTouch, input = param.input, step = param.step, maxLength = param.maxLength, width = param.width;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(form_fields_styles/* StyledField */.ob, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_label/* default */.Z, {
                visuallyHidden: true,
                htmlFor: (ref = input === null || input === void 0 ? void 0 : input.name) !== null && ref !== void 0 ? ref : "",
                children: placeholder
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledInput */.Fy, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                step: step,
                autoFocus: autoFocus,
                autoComplete: autoComplete,
                maxLength: maxLength,
                disabled: disabled,
                height: height,
                placeholder: placeholder,
                type: type || "text",
                inputMode: inputMode,
                id: input === null || input === void 0 ? void 0 : input.name,
                "aria-describedby": "".concat(kebabCase_default()(placeholder), "-form-input"),
                width: width
            })),
            !noErrorOnTouch && touched && error && /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFieldError */.kf, {
                tabIndex: 0,
                role: "alert",
                id: "".concat(kebabCase_default()(placeholder), "-input-error-message"),
                children: error
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/form-fields/secure-field/secure-field.tsx




var SecureField = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, fieldType = param.fieldType, label = param.label, icon = param.icon, children = param.children, error = param.error, styles = param.styles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_fields_styles/* StyledField */.ob, {
        style: styles,
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledLoading */.Nm, {
                "data-testid": "loading"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_label/* default */.Z, {
                visuallyHidden: true,
                htmlFor: fieldType,
                children: label
            }),
            children ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: fieldType
            }),
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFieldIcon */.Sr, {
                icon: icon,
                type: "placeholder"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFieldError */.kf, {
                tabIndex: 0,
                role: "alert",
                id: "".concat(kebabCase_default()(fieldType), "-secure-field-error-message"),
                hidden: !error,
                children: error
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/form-fields/index.ts





/***/ }),

/***/ 73081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fy": function() { return /* binding */ StyledInput; },
/* harmony export */   "Ll": function() { return /* binding */ StyledFormField; },
/* harmony export */   "Nm": function() { return /* binding */ StyledLoading; },
/* harmony export */   "Sr": function() { return /* binding */ StyledFieldIcon; },
/* harmony export */   "dS": function() { return /* binding */ StyledFormGroup; },
/* harmony export */   "kf": function() { return /* binding */ StyledFieldError; },
/* harmony export */   "ob": function() { return /* binding */ StyledField; },
/* harmony export */   "x": function() { return /* binding */ StyledGenericFieldset; },
/* harmony export */   "yO": function() { return /* binding */ StyledGenericForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _components_checkout_uielements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73393);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-basis: auto;\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: ",
        ";\n  overflow: hidden;\n  padding-left: ",
        "px;\n  position: relative;\n  width: ",
        ";\n\n  &:nth-child(odd) {\n    padding-left: 0;\n  }\n\n  @media (max-width: 767px) {\n    flex-basis: 100%;\n    padding-left: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  position: absolute;\n  top: ",
        "px;\n  font-size: 12px;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: start;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 0;\n  padding: 0;\n  width: 100%;\n\n  & > legend {\n    opacity: 0.01;\n    position: absolute;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: start;\n  border: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: translateX(-100%);\n  }\n\n  to {\n    transform: translateX(100%);\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 8px;\n  padding: ",
        "px;\n  padding-left: 14px;\n  height: ",
        "px;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: ",
        ';\n\n  &:before {\n    background-color: rgba(0, 0, 0, 0.05);\n    border-radius: 2px;\n    content: "";\n    display: block;\n    height: ',
        "px;\n    position: relative;\n    width: 120px;\n    z-index: 2;\n  }\n\n  &:after {\n    animation: ",
        " 0.8s ease infinite;\n    background: linear-gradient(\n      90deg,\n      ",
        " 0%,\n      ",
        " 47.4%,\n      ",
        ' 100%\n    );\n    content: "";\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    transform: translateX(-100%);\n    width: 100%;\n    z-index: 1;\n  }\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var StyledFormField = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-861f017d-0"
})(_templateObject(), function(param) {
    var theme = param.theme, autoHeight = param.autoHeight;
    return autoHeight ? "auto" : "".concat(theme.forms.field_height + _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER, "px");
}, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER, function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "50%";
});
var _background_color, _border_radius, _border_color;
var StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-861f017d-1"
})(function(param) {
    var theme = param.theme, width = param.width;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        backgroundColor: (_background_color = theme.forms.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        borderRadius: "".concat((_border_radius = theme.forms.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        border: "1px solid ".concat((_border_color = theme.forms.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        height: "".concat(theme.forms.field_height, "px"),
        marginBottom: "20px",
        padding: "0 12px",
        width: width !== null && width !== void 0 ? width : "100%"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_6__/* .getFontStyles */ .l)(theme.forms.font, [
        "color",
        "font_family",
        "font_size"
    ])), {
        "@media (max-width: 767px)": {
            fontSize: "16px",
            width: "100%"
        },
        "::-webkit-input-placeholder": {
            /* Chrome/Opera/Safari */ color: theme.forms.placeholder_color
        },
        "::-moz-placeholder": {
            /* Firefox 19+ */ color: theme.forms.placeholder_color
        },
        ":-ms-input-placeholder": {
            /* IE 10+ */ color: theme.forms.placeholder_color
        },
        ":-moz-placeholder": {
            /* Firefox 18- */ color: theme.forms.placeholder_color
        },
        "&:focus": {
            borderColor: theme.global.primary_active_color
        },
        "&:disabled": {
            background: _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.LIGHTGRAY */ .DM.LIGHTGRAY,
            cursor: "not-allowed"
        }
    });
});
var StyledFieldError = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-861f017d-2"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.global.error_color;
}, function(param) {
    var theme = param.theme;
    return theme.forms.field_height;
}, function(param) {
    var hidden = param.hidden;
    return hidden && "\n    display: none;\n  ";
});
var StyledGenericForm = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-861f017d-3"
})(_templateObject2());
var StyledGenericFieldset = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fieldset.withConfig */ .ZP.fieldset.withConfig({
    componentId: "sc-861f017d-4"
})(_templateObject3());
var StyledFormGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-861f017d-5"
})(_templateObject4());
var StyledField = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-861f017d-6"
})(_templateObject5());
var StyledFieldIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_components_checkout_uielements__WEBPACK_IMPORTED_MODULE_1__/* .CardIcon */ ._K).withConfig({
    componentId: "sc-861f017d-7"
})(_templateObject6());
var moveLoadingIndicator = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject7());
var StyledLoading = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-861f017d-8"
})(_templateObject8(), _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.MEDIUMGRAY */ .DM.MEDIUMGRAY, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .SPACING_SCALE.XS */ .jl.XS, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .SPACING_SCALE.XL */ .jl.XL, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .ORDER.LOADING_SKELETON */ .kl.LOADING_SKELETON, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .SPACING_SCALE.MEDIUM */ .jl.MEDIUM, moveLoadingIndicator, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.MEDIUMGRAY */ .DM.MEDIUMGRAY, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.PRIMARY_NAVY_XX_LIGHT */ .DM.PRIMARY_NAVY_XX_LIGHT, _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.MEDIUMGRAY */ .DM.MEDIUMGRAY);


/***/ }),

/***/ 98414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icon; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/components/uielements/icon/back.tsx




var Back = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 19.5L7.5 12L15 4.5",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/back-enclosed.tsx




var BackEnclosed = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.995 21.999C17.4756 21.999 22 17.4756 22 12.004C22 6.52341 17.4667 2 11.9852 2C6.5145 2 2 6.52341 2 12.004C2 17.4746 6.52341 21.999 11.995 21.999V21.999ZM11.995 19.9976C7.55874 19.9976 4.01128 16.4314 4.01128 12.004C4.01128 7.56765 7.55874 4.0004 11.9852 4.0004C16.4224 4.0004 19.9887 7.56765 19.9986 12.004C20.0085 16.4314 16.4323 19.9976 11.995 19.9976V19.9976ZM13.9281 16.76C14.2667 16.4314 14.2568 15.8988 13.9281 15.59L10.1204 12.004L13.9281 8.42779C14.2667 8.11798 14.2568 7.56666 13.9182 7.25784C13.5995 6.95793 13.1066 6.97773 12.7681 7.28754L8.8346 10.9894C8.25458 11.5298 8.25458 12.487 8.8346 13.0284L12.7681 16.7303C13.068 17.0203 13.648 17.0401 13.9281 16.76V16.76Z",
                fill: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/caret.tsx




var Caret = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m9 4.5 7.5 7.5L9 19.5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/cart.tsx




var Cart = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.64286 5.37313C6.64286 2.40563 9.04133 0 12 0C14.9587 0 17.3571 2.40563 17.3571 5.37313H20.5714C21.3604 5.37313 22 6.01464 22 6.80597V22.5672C22 23.3585 21.3604 24 20.5714 24H3.42857C2.63959 24 2 23.3585 2 22.5672V6.80597C2 6.01464 2.63959 5.37313 3.42857 5.37313H6.64286ZM8.85714 5.26829H15.1429C15.1429 3.65185 13.7358 2.34146 12 2.34146C10.2642 2.34146 8.85714 3.65185 8.85714 5.26829Z",
                fill: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/check-mark.tsx




var CheckMark = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7071 7.29289C20.0676 7.65338 20.0953 8.22061 19.7903 8.6129L19.7071 8.70711L11.0404 17.3738C10.8902 17.524 10.7041 17.6164 10.5098 17.6511L10.3924 17.6649H10.2743C10.0777 17.6534 9.88389 17.5841 9.72043 17.457L9.62623 17.3738L5.29289 13.0404C4.90237 12.6499 4.90237 12.0168 5.29289 11.6262C5.65338 11.2657 6.22061 11.238 6.6129 11.543L6.70711 11.6262L10.333 15.252L18.2929 7.29289C18.6834 6.90237 19.3166 6.90237 19.7071 7.29289Z",
                fill: "currentColor",
                fillRule: "evenodd",
                clipRule: "evenodd"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/close.tsx




var Close = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 5L19 19M19 5L5 19",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/crosshair.tsx




var Crosshair = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 34 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 29.5V24.5",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.5 16H24.5",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 16H7.5",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 2.5V7.5",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/ellipsis.tsx




var Ellipsis = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.61523 11.6631C6.61523 10.6875 5.82422 9.90527 4.83105 9.90527C3.86426 9.90527 3.07324 10.6875 3.07324 11.6631C3.07324 12.6387 3.86426 13.4209 4.83105 13.4209C5.82422 13.4209 6.61523 12.6387 6.61523 11.6631ZM13.1191 11.6631C13.1191 10.6875 12.3369 9.90527 11.3613 9.90527C10.3945 9.90527 9.6123 10.6875 9.6123 11.6631C9.6123 12.6387 10.3945 13.4209 11.3613 13.4209C12.3369 13.4209 13.1191 12.6387 13.1191 11.6631ZM19.6494 11.6631C19.6494 10.6875 18.8672 9.90527 17.8916 9.90527C16.8984 9.90527 16.1162 10.6875 16.1162 11.6631C16.1162 12.6387 16.8984 13.4209 17.8916 13.4209C18.8672 13.4209 19.6494 12.6387 19.6494 11.6631Z",
                fill: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/heart.tsx




var Heart = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 20.25S2.625 15 2.625 8.625A4.876 4.876 0 0 1 12 6.747h0a4.876 4.876 0 0 1 9.375 1.878C21.375 15 12 20.25 12 20.25z",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/history.tsx




var History = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.897 14.25 12 12M12 7.5V12M6.734 9.348h-3.75v-3.75",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.166 17.834a8.25 8.25 0 1 0 0-11.668L2.984 9.348",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/uielements/icon/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-486d558d-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/uielements/animation/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate3d(0,0,0) rotate(0);\n  }\n\n  to {\n    transform: translate3d(0,0,0) rotate(360deg);\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation-name: ",
        ";\n  animation-fill-mode: both;\n  animation-direction: forward;\n  animation-duration: 0.8s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var spin = (0,styled_components_browser_esm/* keyframes */.F4)(styles_templateObject());
var SpinAnimation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d2970a0-0"
})(_templateObject1(), spin);

;// CONCATENATED MODULE: ./src/components/uielements/animation/spin.tsx


var Spin = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinAnimation, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/animation/index.tsx

var Animation = {
    Spin: Spin
};
/* harmony default export */ var animation = (Animation);

;// CONCATENATED MODULE: ./src/components/uielements/icon/loading.tsx



var Loading = function(param) {
    var _title = param.title, title = _title === void 0 ? "Loading" : _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(animation.Spin, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SVG, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5V0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12H21.5Z",
                    fill: "currentColor"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/mail.tsx




var Mail = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 5.25h18V18a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 18V5.25z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m21 5.25-9 8.25-9-8.25",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/menu.tsx




var Menu = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 5.778A.778.778 0 0 0 22.222 5H1.778a.778.778 0 1 0 0 1.556h20.444c.43 0 .778-.349.778-.778zM23 12a.778.778 0 0 0-.778-.778H1.778a.778.778 0 1 0 0 1.556h20.444c.43 0 .778-.348.778-.778zm-.778 5.444a.778.778 0 0 1 0 1.556H1.778a.778.778 0 1 1 0-1.556h20.444z",
                fill: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/plus.tsx




var Plus = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 12H16",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 8V16",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/reward.tsx




var Reward = function(_param) /*#__PURE__*/ {
    var title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.5 12v6.75a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V12M20.25 7.5H3.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75zM12 7.5v12M16.243 6.44C15.182 7.5 12 7.5 12 7.5s0-3.182 1.06-4.243a2.25 2.25 0 0 1 3.183 3.182v0zM7.757 6.44C8.818 7.5 12 7.5 12 7.5s0-3.182-1.06-4.243A2.25 2.25 0 0 0 7.756 6.44v0z",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                stroke: "currentColor"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/uielements/icon/styles.ts

function icon_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 24px;\n  width: 24px;\n"
    ]);
    icon_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1f3ba846-0"
})(icon_styles_templateObject());

;// CONCATENATED MODULE: ./src/components/uielements/icon/index.tsx



















var Custom = function(_param) {
    var src = _param.src, fallback = _param.fallback, title = _param.title, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "fallback",
        "title"
    ]);
    return src ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
            src: src,
            alt: title
        }, otherProps))
    }) : fallback;
};
var Icon = {
    Cart: Cart,
    CheckMark: CheckMark,
    Back: Back,
    BackEnclosed: BackEnclosed,
    Caret: Caret,
    Close: Close,
    Crosshair: Crosshair,
    Custom: Custom,
    Ellipsis: Ellipsis,
    Heart: Heart,
    History: History,
    Loading: Loading,
    Mail: Mail,
    Menu: Menu,
    Reward: Reward,
    Plus: Plus
};
/* harmony default export */ var icon = (Icon);


/***/ }),

/***/ 74730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ ItemRecipient; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
;// CONCATENATED MODULE: ./src/components/uielements/itemRecipient/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-left: -3px;\n  }\n\n  span {\n    font-style: normal;\n    margin-left: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledItemRecipient = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-bf11a4c4-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/uielements/itemRecipient/index.tsx




var UserIcon = (0,styled_components_browser_esm/* withTheme */.Zz)(function(props) {
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: (ref = props.theme[props.themeContext]) === null || ref === void 0 ? void 0 : ref.font.color,
            fillRule: "evenodd",
            d: "M8.005 8.203c1.125 0 2.063-.995 2.063-2.286 0-1.25-.943-2.224-2.063-2.224-1.114 0-2.062.984-2.057 2.229 0 1.286.932 2.281 2.057 2.281zm3.354 4.771c.709 0 1-.203 1-.656 0-1.339-1.671-3.183-4.359-3.183-2.688 0-4.36 1.844-4.36 3.183 0 .453.292.656 1 .656h6.72z",
            clipRule: "evenodd"
        })
    });
});
var _ItemRecipient = function(param) {
    var basketLocation = param.basketLocation, locationDetail = param.locationDetail, meOrderDetails = param.meOrderDetails, themeContext = param.themeContext, recipient = param.recipient;
    var ref;
    if ((meOrderDetails === null || meOrderDetails === void 0 ? void 0 : (ref = meOrderDetails.store_location) === null || ref === void 0 ? void 0 : ref.supports_item_recipients) || basketLocation.supports_item_recipients || // @ts-expect-error ensure that `locationDetail` isn't `null`.
    !(basketLocation === null || basketLocation === void 0 ? void 0 : basketLocation.id) && locationDetail.supports_item_recipients) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItemRecipient, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon, {
                    themeContext: themeContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: recipient
                })
            ]
        });
    }
    return null;
};
var mapStateToProps = function(state) {
    return {
        basketLocation: state.app.basket.location,
        locationDetail: state.app.locations.detail,
        meOrderDetails: state.app.me.orderDetails
    };
};
var connector = (0,es.connect)(mapStateToProps);
var ItemRecipient = connector(_ItemRecipient);


/***/ }),

/***/ 34404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ StyledLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  // Visually hidden considerations\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Label = function(param) {
    var children = param.children, visuallyHidden = param.visuallyHidden, htmlFor = param.htmlFor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLabel, {
        htmlFor: htmlFor,
        visuallyHidden: visuallyHidden,
        children: children
    });
};
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-17a62d6f-0"
})(_templateObject(), function(props) {
    return props.visuallyHidden && "\n    position: absolute;\n    left: -10000px;\n    top: auto;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n  ";
});
/* harmony default export */ __webpack_exports__["Z"] = (Label);


/***/ }),

/***/ 84247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-dialog/dist/index.mjs
var dist = __webpack_require__(70241);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/components/uielements/modal/container.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  bottom: 0;\n  display: grid;\n  left: 0;\n  opacity: var(--modal-container__opacity);\n  place-items: center;\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: all 0.2s ease;\n  z-index: 1000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  transform: scale(var(--modal-content-wrapper__scale));\n  transition: all 0.2s ease;\n  max-width: var(--size-128);\n  width: 100%;\n\n  @media (min-width: 768px) {\n    width: var(--size-96);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgba(0 0 0 / 0.5);\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: all 0.2s ease;\n  z-index: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dec35bf2-0"
})(_templateObject(), function(param) {
    var isVisible = param.isVisible;
    return "\n    --modal-container__opacity: ".concat(isVisible ? 1 : 0.01, ";\n  ");
});
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dec35bf2-1"
})(_templateObject1(), function(param) {
    var isVisible = param.isVisible;
    return "\n    --modal-content-wrapper__scale: ".concat(isVisible ? 1 : 0.9, ";\n  ");
});
var Overlay = (0,styled_components_browser_esm/* default */.ZP)(dist/* Overlay */.aV).withConfig({
    componentId: "sc-dec35bf2-2"
})(_templateObject2());
var Content = (0,styled_components_browser_esm/* default */.ZP)(dist/* Content */.VY).withConfig({
    componentId: "sc-dec35bf2-3"
})(function(param) {
    var theme = param.theme;
    var primaryFontProperties = (0,utils/* getFontStyles */.l)(theme.modals.font);
    var secondaryFontProperties = (0,utils/* getFontStyles */.l)(theme.modals.secondary_font);
    var _background_color, _border_color, _border_radius, _active_font_color;
    return {
        " --modal__background": (_background_color = theme.modals.background_color) !== null && _background_color !== void 0 ? _background_color : theme.global.body_color,
        "--modal__border-color": (_border_color = theme.modals.border_color) !== null && _border_color !== void 0 ? _border_color : theme.global.primary_border_color,
        "--modal__border-radius": "".concat((_border_radius = theme.modals.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        "--modal__color": primaryFontProperties.color,
        "--modal-title__color": secondaryFontProperties.color,
        "--modal-title__font-family": secondaryFontProperties.fontFamily,
        "--modal-title__font-size": secondaryFontProperties.fontSize,
        "--modal__button-color": (_active_font_color = theme.modals.active_font_color) !== null && _active_font_color !== void 0 ? _active_font_color : "black",
        backgroundColor: "var(--modal__background)",
        border: "1px solid var(--modal__border-color)",
        borderRadius: "var(--modal__border-radius)",
        color: "var(--modal__color)",
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100vh - 8rem)",
        width: "100%"
    };
});

;// CONCATENATED MODULE: ./src/components/uielements/modal/context/index.ts

var ModalContext = (0,react.createContext)({
    onCancel: function() {
        return null;
    },
    onToggle: function() {
        return null;
    },
    dismissible: true
});
var useModalContext = function() {
    return (0,react.useContext)(ModalContext);
};

// EXTERNAL MODULE: ./src/utils/useAnimatedVisibility.ts
var useAnimatedVisibility = __webpack_require__(80378);
;// CONCATENATED MODULE: ./src/components/uielements/modal/container.tsx









var ModalContainer = function(param) {
    var _requestVisibility = param.requestVisibility, requestVisibility = _requestVisibility === void 0 ? false : _requestVisibility, _dismissible = param.dismissible, dismissible = _dismissible === void 0 ? true : _dismissible, trigger = param.trigger, children = param.children, onCancel = param.onCancel;
    var ref = (0,useAnimatedVisibility/* useAnimatedVisibility */.p)(), isMounted = ref.isMounted, shouldDisplay = ref.shouldDisplay, toggle = ref.toggle, ref1 = ref.ref;
    (0,react.useEffect)(function() {
        requestVisibility && toggle();
    }, [
        requestVisibility
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Root */.fC, {
        open: isMounted,
        children: [
            trigger && trigger(toggle),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Portal */.h_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                    ref: ref1,
                    isVisible: shouldDisplay,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                            "data-testid": "modal-overlay"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProvider, {
                            onCancel: function() {
                                onCancel && onCancel();
                                toggle();
                            },
                            onToggle: toggle,
                            dismissible: dismissible,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContents, {
                                shouldDisplay: shouldDisplay,
                                children: children
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var ModalProvider = function(param) {
    var children = param.children, onCancel = param.onCancel, onToggle = param.onToggle, dismissible = param.dismissible;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContext.Provider, {
        value: {
            onCancel: onCancel,
            onToggle: onToggle,
            dismissible: dismissible
        },
        children: children
    });
};
var ModalContents = function(_param) {
    var shouldDisplay = _param.shouldDisplay, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "shouldDisplay",
        "children"
    ]);
    var ref = useModalContext(), onCancel = ref.onCancel, onToggle = ref.onToggle, dismissible = ref.dismissible;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            isVisible: shouldDisplay
        }, otherProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                onEscapeKeyDown: function() {
                    dismissible && onCancel();
                },
                onPointerDownOutside: function() {
                    dismissible && onCancel();
                },
                children: [
                    /*#__PURE__*/ (0,react.isValidElement)(children) && children,
                    typeof children === "function" && children(onToggle)
                ]
            })
        }))
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/modal/content.styles.ts

function content_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: scroll;\n  padding: var(--size-6);\n\n  @media (min-width: 768px) {\n    max-height: var(--size-96);\n  }\n"
    ]);
    content_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Main = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de141866-0"
})(content_styles_templateObject());

;// CONCATENATED MODULE: ./src/components/uielements/modal/content.tsx





var ModalContent = function(_param) /*#__PURE__*/ {
    var children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
            children: children
        }))
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/modal/footer.styles.ts

function footer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border-top: 1px solid var(--modal__border-color);\n  display: flex;\n  gap: var(--size-2);\n  justify-content: flex-end;\n  min-height: var(--size-16);\n  padding: var(--size-3) var(--size-3) var(--size-3) var(--size-6);\n  transform: translate3d(0, 0, 0);\n"
    ]);
    footer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function footer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  appearance: none;\n  background: transparent;\n  border: none;\n  color: var(--modal__button-color);\n  font-weight: bold;\n  padding: 0 var(--size-5);\n"
    ]);
    footer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Footer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-958d30cf-0"
})(footer_styles_templateObject());
var CancelButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-958d30cf-1"
})(footer_styles_templateObject1());

;// CONCATENATED MODULE: ./src/components/uielements/modal/footer.tsx







var ModalCancel = function(_param) {
    var children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var onCancel = useModalContext().onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
        asChild: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
            onClick: onCancel,
            children: children
        }))
    });
};
var ModalFooter = function(_param) /*#__PURE__*/ {
    var children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
            children: children
        }))
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/modal/title.styles.ts

function title_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border-bottom: 1px solid var(--modal__border-color);\n  display: grid;\n  grid-template-columns: var(--size-6) 1fr var(--size-6);\n  padding: var(--size-6);\n"
    ]);
    title_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function title_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--modal__title-color);\n  font-family: var(--modal-title__font-family);\n  font-size: var(--modal-title__font-size);\n  margin: 0;\n  text-align: center;\n"
    ]);
    title_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function title_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  appearance: none;\n  background: none;\n  border: 0;\n  cursor: pointer;\n  color: var(--modal__color);\n  padding: 0;\n\n  & svg {\n    display: block;\n  }\n"
    ]);
    title_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-1c177757-0"
})(title_styles_templateObject());
var Title = (0,styled_components_browser_esm/* default */.ZP)(dist/* Title */.Dx).withConfig({
    componentId: "sc-1c177757-1"
})(title_styles_templateObject1());
var CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-1c177757-2"
})(title_styles_templateObject2());

// EXTERNAL MODULE: ./src/components/uielements/icon/index.tsx + 20 modules
var icon = __webpack_require__(98414);
;// CONCATENATED MODULE: ./src/components/uielements/modal/title.tsx








var ModalTitle = function(_param) {
    var children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var ref = useModalContext(), onCancel = ref.onCancel, dismissible = ref.dismissible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
        children: [
            dismissible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Close */.x8, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                    onClick: onCancel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Close */.Z.Close, {
                        title: "Dismiss",
                        focusable: false
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
                    children: children
                }))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/modal/index.tsx




var Modal = {
    Container: ModalContainer,
    Title: ModalTitle,
    Footer: ModalFooter,
    Content: ModalContent,
    Cancel: ModalCancel
};


/***/ }),

/***/ 21516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ Navigation; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/uielements/icon/index.tsx + 20 modules
var icon = __webpack_require__(98414);
;// CONCATENATED MODULE: ./src/components/uielements/navigation/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border-top: 1px solid var(--navigation-item__border-color);\n  color: var(--navigation-item__color);\n  display: flex;\n  height: var(--navigation-item__height, var(--size-18));\n  font-family: var(--navigation-item__font-family);\n  font-size: var(--navigation-item__font-size);\n  line-height: normal;\n  font-weight: var(--navigation-item__font-weight, bold);\n  gap: var(--size-2);\n  padding: var(--navigation-item__padding-y, 0)\n    var(--navigation-item__padding-x, var(--size-4));\n\n  &:active {\n    opacity: 0.35;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  margin-left: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-6f08e4a0-0"
})(_templateObject());
var Item = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-6f08e4a0-1"
})(_templateObject1());
var Caret = (0,styled_components_browser_esm/* default */.ZP)(icon/* default.Caret */.Z.Caret).withConfig({
    componentId: "sc-6f08e4a0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/components/uielements/navigation/item.tsx






var item_Item = function(_param) /*#__PURE__*/ {
    var href = _param.href, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "href",
        "children"
    ]);
    return (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Caret, {
                    "aria-hidden": true,
                    title: "Caret"
                })
            ]
        }))
    });
};
/* harmony default export */ var item = (item_Item);

;// CONCATENATED MODULE: ./src/components/uielements/navigation/index.tsx



var List = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: children
    });
};
var Navigation = {
    List: List,
    Item: item
};


/***/ }),

/***/ 45190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ Render; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

function Render(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
}


/***/ }),

/***/ 66143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GB": function() { return /* binding */ StyledSearchInput; },
/* harmony export */   "KK": function() { return /* binding */ StyledRadarAddressSearchInputWrapper; },
/* harmony export */   "Mj": function() { return /* binding */ SearchInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var lodash_kebabCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79857);
/* harmony import */ var lodash_kebabCase__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_kebabCase__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89961);
/* harmony import */ var _label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34404);
/* harmony import */ var _components_fulfillmentManager_deliveryManager_deliveryForm_autocomplete_input_id__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27249);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73393);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-image: url(",
        ");\n  background-position: 10px center;\n  background-repeat: no-repeat;\n  position: absolute;\n  top: 0;\n  left: 2px;\n  height: 40px;\n  width: 30px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var SearchInput = function(param) {
    var placeholder = param.placeholder, icon = param.icon, _meta = param.meta, meta = _meta === void 0 ? {
        submitFailed: false,
        error: null
    } : _meta, _input = param.input, input = _input === void 0 ? {
        name: "search-input"
    } : _input;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledInputContainer, {
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIcon, {
                icon: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_label__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // TODO - eventually this could be configurable
                visuallyHidden: true,
                htmlFor: input === null || input === void 0 ? void 0 : input.name,
                children: placeholder
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSearchInput, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, input), {
                id: input === null || input === void 0 ? void 0 : input.name,
                placeholder: placeholder,
                error: Boolean(meta.submitFailed && meta.error),
                "aria-describedby": "".concat(lodash_kebabCase__WEBPACK_IMPORTED_MODULE_2___default()(placeholder), "-search-input")
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                role: "alert",
                id: "".concat(lodash_kebabCase__WEBPACK_IMPORTED_MODULE_2___default()(placeholder), "-search-input"),
                children: meta.submitFailed && meta.error
            })
        ]
    });
};
var StyledInputContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-86c25fe6-0"
})({
    paddingBottom: "10px",
    position: "relative",
    p: {
        color: _constants_styles__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.ERROR_RED */ .DM.ERROR_RED,
        fontSize: ".75em",
        marginTop: ".25rem"
    }
});
var _background_color, _error_color, _border_color, _border_radius, _border_radius1, _border_radius2;
var StyledSearchInput = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-86c25fe6-1"
})(function(param) {
    var theme = param.theme, error = param.error, padding = param.padding, id = param.id;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        backgroundColor: (_background_color = theme.location_search.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        border: "1px solid ".concat(error ? (_error_color = theme.location_search.error_color) !== null && _error_color !== void 0 ? _error_color : _constants_styles__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.ERROR_RED */ .DM.ERROR_RED : (_border_color = theme.location_search.border_color) !== null && _border_color !== void 0 ? _border_color : _constants_styles__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.LIGHTERGRAY */ .DM.LIGHTERGRAY),
        borderRadius: "".concat((_border_radius = theme.location_search.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        display: "block",
        flexBasis: "66.66%",
        height: "40px",
        width: "100%",
        textOverflow: "ellipsis",
        padding: padding !== null && padding !== void 0 ? padding : "2px 30px 0 30px"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_8__/* .getFontStyles */ .l)(theme.location_search.font, [
        "font_family",
        "font_size"
    ]), (id === null || id === void 0 ? void 0 : id.includes(_components_fulfillmentManager_deliveryManager_deliveryForm_autocomplete_input_id__WEBPACK_IMPORTED_MODULE_9__/* .autocompleteInputId */ .h)) && {
        height: "".concat(theme.forms.field_height, "px"),
        marginBottom: "20px"
    }), {
        "@media (max-width: 767px)": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, !(id === null || id === void 0 ? void 0 : id.includes(_components_fulfillmentManager_deliveryManager_deliveryForm_autocomplete_input_id__WEBPACK_IMPORTED_MODULE_9__/* .autocompleteInputId */ .h)) && {
            borderRight: 0,
            fontSize: "16px",
            borderRadius: "".concat((_border_radius1 = theme.location_search.border_radius) !== null && _border_radius1 !== void 0 ? _border_radius1 : 0, "px 0 0 ").concat((_border_radius2 = theme.location_search.border_radius) !== null && _border_radius2 !== void 0 ? _border_radius2 : 0, "px}")
        })
    });
});
var _background_color1, _error_color1, _border_color1, _border_radius3, _error_color2, _border_color2;
var StyledRadarAddressSearchInputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-86c25fe6-2"
})(function(param) {
    var theme = param.theme, error = param.error, padding = param.padding, id = param.id;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (id === null || id === void 0 ? void 0 : id.includes(_components_fulfillmentManager_deliveryManager_deliveryForm_autocomplete_input_id__WEBPACK_IMPORTED_MODULE_9__/* .autocompleteInputId */ .h)) && {
        marginBottom: "20px"
    }), {
        input: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (id === null || id === void 0 ? void 0 : id.includes(_components_fulfillmentManager_deliveryManager_deliveryForm_autocomplete_input_id__WEBPACK_IMPORTED_MODULE_9__/* .autocompleteInputId */ .h)) && {
            height: "".concat(theme.forms.field_height, "px")
        }), {
            padding: padding !== null && padding !== void 0 ? padding : "2px 30px 0 40px",
            backgroundColor: (_background_color1 = theme.location_search.background_color) !== null && _background_color1 !== void 0 ? _background_color1 : "transparent",
            border: "1px solid ".concat(error ? (_error_color1 = theme.location_search.error_color) !== null && _error_color1 !== void 0 ? _error_color1 : _constants_styles__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.ERROR_RED */ .DM.ERROR_RED : (_border_color1 = theme.location_search.border_color) !== null && _border_color1 !== void 0 ? _border_color1 : _constants_styles__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.LIGHTERGRAY */ .DM.LIGHTERGRAY),
            borderRadius: "".concat((_border_radius3 = theme.location_search.border_radius) !== null && _border_radius3 !== void 0 ? _border_radius3 : 0, "px"),
            display: "block",
            flexBasis: "66.66%",
            height: "40px",
            width: "100%",
            textOverflow: "ellipsis"
        }), (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_8__/* .getFontStyles */ .l)(theme.location_search.font, [
            "font_family",
            "font_size"
        ])), {
            "&:focus": {
                boxShadow: "none",
                border: "1px solid ".concat(error ? (_error_color2 = theme.location_search.error_color) !== null && _error_color2 !== void 0 ? _error_color2 : _constants_styles__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.ERROR_RED */ .DM.ERROR_RED : (_border_color2 = theme.location_search.border_color) !== null && _border_color2 !== void 0 ? _border_color2 : _constants_styles__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.LIGHTERGRAY */ .DM.LIGHTERGRAY)
            }
        }),
        "& .radar-autocomplete-results-list": {
            display: "table"
        }
    });
});
var StyledIcon = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-86c25fe6-3"
})(_templateObject(), function(param) {
    var icon = param.icon;
    return icon;
});


/***/ }),

/***/ 24274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ReduxFormSelect; }
/* harmony export */ });
/* unused harmony export DefaultSelect */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_uielements_form_fields_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73081);
/* harmony import */ var _components_uielements_label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34404);
/* harmony import */ var _components_uielements_selectInput_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6295);




var ReduxFormSelect = function(param) {
    var autoComplete = param.autoComplete, optionsArray = param.optionsArray, handleChange = param.handleChange, width = param.width, defaultValue = param.defaultValue, title = param.title, titleEnabled = param.titleEnabled, name = param.name, meta = param.meta, placeholder = param.placeholder, noErrorOnTouch = param.noErrorOnTouch, value = param.value, loadingMessage = param.loadingMessage, errorMessage = param.errorMessage;
    return optionsArray.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            position: "relative",
            paddingBottom: 20
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_selectInput_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledSelectContainer */ .Q, {
                width: width,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "select-style",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_label__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            visuallyHidden: true,
                            htmlFor: name,
                            children: placeholder || name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                            autoComplete: autoComplete,
                            name: name,
                            id: name,
                            onChange: handleChange,
                            defaultValue: defaultValue,
                            value: value,
                            children: [
                                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                    value: "",
                                    disabled: !titleEnabled,
                                    children: title
                                }),
                                optionsArray.map(function(entry, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: entry.value || entry,
                                        children: entry.label || entry
                                    }, "".concat(entry.value, "-").concat(index) || "".concat(entry, "-").concat(index));
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_form_fields_styles__WEBPACK_IMPORTED_MODULE_1__/* .StyledFieldError */ .kf, {
                children: meta && !noErrorOnTouch && meta.touched && meta.error || errorMessage
            })
        ]
    }) : // Fake dropdown to display loading message
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_selectInput_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledSelectContainer */ .Q, {
        width: width,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "select-style",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                    children: loadingMessage || ""
                })
            })
        })
    });
};
var DefaultSelect = function(param) {
    var optionsArray = param.optionsArray, handleChange = param.handleChange, title = param.title, name = param.name, placeholder = param.placeholder, value = param.value, errorMessage = param.errorMessage, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            position: "relative",
            paddingBottom: 20
        },
        children: [
            /*#__PURE__*/ _jsx(StyledSelectContainer, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "select-style",
                    children: [
                        /*#__PURE__*/ _jsx(Label, {
                            visuallyHidden: true,
                            htmlFor: name,
                            children: placeholder || name
                        }),
                        /*#__PURE__*/ _jsxs("select", {
                            name: name,
                            id: name,
                            onChange: handleChange,
                            value: value,
                            disabled: disabled,
                            children: [
                                title && /*#__PURE__*/ _jsx("option", {
                                    value: "",
                                    disabled: true,
                                    children: title
                                }),
                                optionsArray.map(function(entry, index) {
                                    return /*#__PURE__*/ _jsx("option", {
                                        value: entry.value || entry,
                                        children: entry.label || entry
                                    }, "".concat(entry.value, "-").concat(index) || "".concat(entry, "-").concat(index));
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(StyledFieldError, {
                children: errorMessage
            })
        ]
    });
};


/***/ }),

/***/ 6295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ StyledSelectContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89961);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73393);



var _background_color, _border_color, _border_radius;
var StyledSelectContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f5834ecf-0"
})(function(param) {
    var theme = param.theme, width = param.width;
    return {
        position: "relative",
        ".select-style": {
            background: 'url("/static/img/dropdown-expand-temp.png") no-repeat right 50%',
            backgroundColor: (_background_color = theme.forms.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
            border: "1px solid ".concat((_border_color = theme.forms.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
            borderRadius: "".concat((_border_radius = theme.forms.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
            overflow: "hidden",
            padding: 0,
            minWidth: width !== null && width !== void 0 ? width : "100%",
            select: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                appearance: "none",
                backgroundColor: "transparent",
                backgroundImage: "none",
                border: "none",
                height: "".concat(theme.forms.field_height, "px"),
                padding: "0px 30px 0 12px",
                width: "100%"
            }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFontStyles */ .l)(theme.forms.font, [
                "color",
                "font_family",
                "font_size", 
            ]))
        }
    };
});


/***/ }),

/***/ 45866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ Stack; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/uielements/stack/stack.helpers.ts
var getPlacement = function(value) {
    switch(value){
        case "leading":
            return "flex-start";
        case "center":
            return "center";
        case "trailing":
            return "flex-end";
        default:
            throw new Error("undefined alignment");
    }
};
var getDirection = function(value) {
    switch(value){
        case "horizontal":
            return "row";
        case "vertical":
            return "column";
        default:
            throw new Error("undefined direction");
    }
};

;// CONCATENATED MODULE: ./src/components/uielements/stack/stack.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  ",
        "\n\n  align-items: var(--stack-container__align-items);\n  display: flex;\n  flex-direction: var(--stack-container__flex-direction);\n  justify-content: var(--stack-container__justify-content);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5b1716e-0"
})(_templateObject(), function(param) {
    var align = param.align, position = param.position, direction = param.direction;
    return "\n    --stack-container__flex-direction: ".concat(getDirection(direction), ";\n    --stack-container__align-items: ").concat(getPlacement(align), ";\n    --stack-container__justify-content: ").concat(getPlacement(position), ";\n  ");
}, function(param) {
    var styles = param.styles;
    return styles;
});

;// CONCATENATED MODULE: ./src/components/uielements/stack/stack.tsx




var Stack = function(param) {
    var _align = param.align, align = _align === void 0 ? "center" : _align, _position = param.position, position = _position === void 0 ? "leading" : _position, children = param.children, _overrides = param.overrides, overrides = _overrides === void 0 ? {} : _overrides, _direction = param.direction, direction = _direction === void 0 ? "horizontal" : _direction, _gap = param.gap, gap = _gap === void 0 ? "var(--size-2)" : _gap;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        align: align,
        position: position,
        direction: direction,
        styles: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overrides), {
            gap: gap
        }),
        children: children
    });
};


/***/ }),

/***/ 5733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ CSS_CLASSES; }
/* harmony export */ });
var CSS_CLASSES = {
    GLOBAL_HEADER: {
        CONTAINER: "koala__ui-global_header-nav",
        ORDER_NOW: "koala__ui-global_header-order_now-button",
        AUTH_NOTIFICATION_COUNTER: "koala__ui-global_header-auth-notification-counter-div",
        AUTH_SIGN_IN: "koala__ui-global_header-auth-sign-in-div",
        AUTH_USERNAME: "koala__ui-global_header-auth-signed-in-span"
    },
    GLOBAL: {
        STYLED_CONTENT_CONTAINER: "koala__ui-global_styled-content-container"
    },
    CHECKOUT: {
        HEADER: "koala__ui-checkout_header-div",
        CONTAINER: "koala__ui-checkout_container-div",
        STEP_HEADER_CONTAINER: "koala__ui-checkout-step_header_container-div",
        COMPONENT_TAXES_AND_FEES_TOOLTIP: "koala__ui-checkout-component_taxes_and_fees-tooltip"
    },
    CHECKOUT_HANDOFF_TOGGLE: {
        RADIO_ROW_DINEIN: "koala__ui-checkout_handoff-toggle-radio-row-dinein-div"
    },
    CHECKOUT_PAYMENT_DETAILS: {
        PAY_IN_STORE: "koala__ui-checkout_payment_details-pay_in_store-div",
        NEW_CREDIT_CARD: "koala__ui-checkout_payment_details-new_credit_card-div"
    },
    LOCATION_LIST: {
        CONTAINER: "koala__ui-location_list-div",
        HANDOFF_TOGGLE: "koala__ui-location_list-handoff_toggle-div"
    },
    LOCATION_CARD: {
        CONTAINER: "koala__ui-location-card",
        PICKUP_BUTTON: "koala__ui-location_card-pickup-button"
    },
    SIDECART: {
        CONTAINER: "koala__ui-side_cart-div",
        ITEMS_HEADER: "koala__ui-side_cart-items-header-h3"
    },
    STORE_MENU: {
        DESKTOP_NAV: "koala__ui-store_menu-desktop_nav_items-div",
        MOBILE_NAV: "koala__ui-store_menu-mobile_nav_items-div",
        ACTIVE_NAV_BUTTON: "koala__ui-store_menu-active_nav_items-a",
        PRODUCT_CARD: "koala__ui-store_menu-product_card-div",
        PRODUCT_CARD_META_INFO: "koala__ui-store_menu-product_card_meta_info-div",
        PRODUCT_OPTION_GROUP_HEADER: "koala__ui-store_menu-product_option_group_header",
        MENU_SEARCH: "koala__ui-store_menu-menu_search-div",
        MENU_SEARCH_MOBILE: "koala__ui-store_menu-menu_search_mobile-div"
    },
    STORE_DETAIL: {
        INFO_CARD: "koala__ui-store_detail-info_card-div",
        SEE_LOCATION_INFO_CTA: "koala__ui-store_detail-see-location-info-cta-button",
        CONVEYANCE_TOGGLE: "koala__ui-store_detail-conveyance_toggle-div",
        LOCATION_NAME: "koala__ui-store_detail-location_name-button"
    },
    PRODUCT_DETAIL: {
        CONTAINER: "koala__ui-product_detail-div",
        PRODUCT_INFO: "koala__ui-product_detail-product_info-div",
        SPECIAL_INSTRUCTION_HEADER: "koala__ui-product_detail-special_instruction-header",
        RECIPIENT_INSTRUCTIONS_HEADER: "koala__ui-product_detail-recipient_instruction-header"
    },
    FOOTER: {
        CONTAINER: "koala__ui-footer_container-div"
    },
    STORE_LOCATOR: {
        VIEW_ALL_LOCATION_LINK: "koala__ui-store_locator-view_all_location-link",
        SEARCH_HEADING: "koala__ui-store_locator-search-heading-h4"
    },
    AUTH: {
        CHECKOUT_AS_GUEST_LINK: "koala__ui-auth-checkout_as_guest-link-button"
    },
    MENU_HANDOFF_ADDRESS: {
        DELIVERY: "koala__ui-menu_handoff-address_delivery-button",
        PICKUP: "koala__ui-menu_handoff-address_pickup-button"
    },
    LOYALTY_REWARDS_FOOTER: {
        POINTS_HISTORY: "koala__ui-loyalty_rewards_footer-points-history",
        RECEIPT_BARCODE: "koala__ui-loyalty_rewards_footer-receipt-barcode"
    },
    LOYALTY: {
        NAV_BUTTON: "koala__ui-loyalty-nav-button",
        DROPDOWN_BUTTON: "koala__ui-loyalty-dropdown-button",
        PAGE_HEADER: "koala__ui-loyalty-page-header-h2",
        LOCATIONS_REWARDS_SUMMARY: "koala__ui-loyalty_locations_rewards_summary-div",
        LOCATIONS_REWARDS_SUMMARY_LINK: "koala__ui-loyalty_locations_rewards_summary-link-a"
    }
};


/***/ }),

/***/ 49956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ canadianProvinceAbbrMappings; },
/* harmony export */   "S": function() { return /* binding */ stateAbbrMappings; }
/* harmony export */ });
var stateAbbrMappings = {
    AL: "Alabama",
    AK: "Alaska",
    AS: "American Samoa",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District Of Columbia",
    FM: "Federated States Of Micronesia",
    FL: "Florida",
    GA: "Georgia",
    GU: "Guam",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MH: "Marshall Islands",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    MP: "Northern Mariana Islands",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PW: "Palau",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VI: "Virgin Islands",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming"
};
var canadianProvinceAbbrMappings = {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland and Labrador",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon"
};


/***/ }),

/***/ 40634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ MARKETING_TAG_POSITION; },
/* harmony export */   "Z": function() { return /* binding */ FILTER_TAG_LOCATION; }
/* harmony export */ });
var MARKETING_TAG_POSITION = {
    PDP: "PDP",
    MENU_CARD: "MENU_CARD"
};
var FILTER_TAG_LOCATION = {
    TAKEOVER: "TAKEOVER",
    NAV: "NAV"
};


/***/ }),

/***/ 5682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NF": function() { return /* reexport */ HandoffTimePicker; },
  "c2": function() { return /* reexport */ useSetHandoffTime; }
});

// UNUSED EXPORTS: useHandoffTimes

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/features/handoff/time-picker/styles.ts
var styles = __webpack_require__(56613);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../packages/sdk/dist/v4/index.mjs + 8 modules
var v4 = __webpack_require__(40024);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(47661);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isToday/index.js
var isToday = __webpack_require__(82236);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(31807);
// EXTERNAL MODULE: ./src/features/handoff/time-picker/utils.ts
var utils = __webpack_require__(65242);
// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/analytics/events/constants.ts
var constants = __webpack_require__(45048);
// EXTERNAL MODULE: ./src/constants/events.ts
var constants_events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/constants/global.ts
var global = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/redux/basket/actions.ts
var actions = __webpack_require__(29682);
// EXTERNAL MODULE: ./src/redux/basket/messages.ts
var messages = __webpack_require__(31387);
// EXTERNAL MODULE: ./src/redux/conveyanceMode/actions.ts
var conveyanceMode_actions = __webpack_require__(38534);
// EXTERNAL MODULE: ./src/redux/orderStatus/actions.ts
var orderStatus_actions = __webpack_require__(76750);
// EXTERNAL MODULE: ./src/services/client.ts
var services_client = __webpack_require__(49741);
// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(32210);
// EXTERNAL MODULE: ./src/utils/global.ts
var utils_global = __webpack_require__(36304);
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(87809);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
;// CONCATENATED MODULE: ./src/features/handoff/time-picker/use-handoff-times.ts





















/** Retrieves a list of available handoff times for a basket or location. */ function getHandoffTimes(input) {
    return _getHandoffTimes.apply(this, arguments);
}
function _getHandoffTimes() {
    _getHandoffTimes = (0,_async_to_generator/* default */.Z)(function(input) {
        var hoursType, res, origin, client;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hoursType = input.handoffType === v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY ? "delivery_hours" : "operating_hours";
                    origin = (0,src_utils/* getOrigin */.P$)(window.location.host);
                    client = (0,services_client/* createHttpClient */.d9)({
                        origin: origin
                    });
                    if (!input.basketId) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,v4/* getPickupTimeByBasket */.gk)({
                            basketId: input.basketId,
                            locationId: input.locationId,
                            hoursType: hoursType,
                            dayWanted: input.dayWanted
                        }, {
                            client: client
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        (0,v4/* getPickupTime */.Wq)({
                            locationId: input.locationId,
                            wantedAtType: hoursType,
                            dayWanted: input.dayWanted
                        }, {
                            client: client
                        })
                    ];
                case 3:
                    // Otherwise, look up pickup times for the location.
                    res = _state.sent();
                    _state.label = 4;
                case 4:
                    /**
   * If the user wants to pick up today and the location supports
   * ASAP, prepend it to the list of available handoff times.
   *
   * NOTE: Other places in the codebase we use isStoreCurrentlyOpen(operatingHours?: LocationOperatingHours[]) function to determine if store is open
   */ if (input.supportsAsap && (0,isToday/* default */.Z)((0,parseISO/* default */.Z)(input.dayWanted))) {
                        return [
                            2,
                            [
                                global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP
                            ].concat((0,_to_consumable_array/* default */.Z)(res))
                        ];
                    }
                    // If there are no times available, the store is likely closed on a given day.
                    if (res.length === 0) {
                        return [
                            2,
                            res
                        ];
                    }
                    // Otherwise, return the list of times as-is.
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return _getHandoffTimes.apply(this, arguments);
}
function useHandoffTimes(input) {
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            "handoffTimes",
            input
        ],
        queryFn: function() {
            return getHandoffTimes(input);
        },
        refetchOnWindowFocus: false,
        staleTime: 3600000
    });
}
function setHandoffTime(input) {
    return _setHandoffTime.apply(this, arguments);
}
function _setHandoffTime() {
    _setHandoffTime = (0,_async_to_generator/* default */.Z)(function(input) {
        var origin, client, res, res1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    origin = (0,src_utils/* getOrigin */.P$)(window.location.host);
                    client = (0,services_client/* createHttpClient */.d9)({
                        origin: origin
                    });
                    if (!(input.handoffTime === global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP || !input.handoffTime)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,v4/* removePickupTime */.Di)({
                            basketId: input.basketId,
                            locationId: input.locationId
                        }, {
                            client: client
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 2:
                    return [
                        4,
                        (0,v4/* setPickupTime */.cq)({
                            basketId: input.basketId,
                            locationId: input.locationId,
                            wanted_at: input.handoffTime
                        }, {
                            client: client
                        })
                    ];
                case 3:
                    res1 = _state.sent();
                    return [
                        2,
                        res1
                    ];
            }
        });
    });
    return _setHandoffTime.apply(this, arguments);
}
function useSetHandoffTime() {
    var checkoutBasket = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket;
    }).checkoutBasket;
    var dispatch = (0,redux/* useDispatch */.I0)();
    return (0,useMutation/* useMutation */.D)(setHandoffTime, {
        // Trigger analytics events when the mutation is fired.
        onMutate: function(input) {
            if (input.handoffTime === global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP) {
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.asapTimeSelected */.cE.asapTimeSelected);
            } else {
                var ref;
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.pickupTimeSelected */.cE.pickupTimeSelected);
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.WANTED_AT_SELECTED */.x.WANTED_AT_SELECTED, {
                    name: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : (ref = checkoutBasket.conveyance_type) === null || ref === void 0 ? void 0 : ref.type.toLowerCase(),
                    details: input.handoffTime
                });
            }
        },
        // Surface any errors that occurred when setting the handoff time.
        onError: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                var err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,utils_global/* prepareErrorMessage */.Xr)(messages/* BASKET_ERROR.setPickupTimeSaga */.Y.setPickupTimeSaga, e)
                            ];
                        case 1:
                            err = _state.sent();
                            dispatch(orderStatus_actions/* default.orderStatusMessageErrorSet */.Z.orderStatusMessageErrorSet(err.message));
                            (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.SET_PICKUP_TIME_ERROR */.RZ.SET_PICKUP_TIME_ERROR, e, err);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(),
        // Dispatch actions to sync up Redux with the updated basket.
        onSuccess: function(basket) {
            dispatch(orderStatus_actions/* default.orderPending */.Z.orderPending());
            dispatch(actions/* default.success */.Z.success(basket));
            dispatch(conveyanceMode_actions/* default.setWantedTime */.Z.setWantedTime(basket.wanted_at !== null ? basket.wanted_at : undefined, Number(basket.location.id), (0,utils/* getMappedConveyanceType */.et)(basket.conveyance_type.type)));
            (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.BASKET_WANTED_AT_UPDATE */.AH.BASKET_WANTED_AT_UPDATE);
        }
    });
}

// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/genericErrorBoundary/index.tsx
var genericErrorBoundary = __webpack_require__(11995);
// EXTERNAL MODULE: ./src/components/uielements/form-fields/styles.ts
var form_fields_styles = __webpack_require__(73081);
// EXTERNAL MODULE: ./src/components/uielements/label/index.tsx
var label = __webpack_require__(34404);
// EXTERNAL MODULE: ./src/components/uielements/selectInput/styles.ts
var selectInput_styles = __webpack_require__(6295);
;// CONCATENATED MODULE: ./src/components/uielements/forms/select.tsx




var Select = function(param) {
    var options = param.options, onChange = param.onChange, title = param.title, name = param.name, placeholder = param.placeholder, value = param.value, errorMessage = param.errorMessage, disabled = param.disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(selectInput_styles/* StyledSelectContainer */.Q, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "select-style",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                            visuallyHidden: true,
                            htmlFor: name,
                            children: placeholder || name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                            name: name,
                            id: name,
                            onChange: function(e) {
                                return onChange(e.target.value);
                            },
                            value: value,
                            disabled: disabled,
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "",
                                    disabled: true,
                                    children: title
                                }),
                                options.map(function(param) {
                                    var label = param.label, value = param.value;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: value,
                                        children: label
                                    }, value);
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFieldError */.kf, {
                children: errorMessage
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constants/dates.ts
var dates = __webpack_require__(81584);
// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var utils_dates = __webpack_require__(63654);
;// CONCATENATED MODULE: ./src/features/handoff/time-picker/time-picker.tsx














function HandoffTimePicker(param) {
    var isSubmitting = param.isSubmitting, onChange = param.onChange, value = param.value, checkoutBasket = param.checkoutBasket, location = param.location, handoffType = param.handoffType, supportsAsap = param.supportsAsap, _stack = param.stack, stack = _stack === void 0 ? true : _stack;
    var ref;
    var strings = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.strings;
    });
    /**
   * Find the initial value for the handoff day based on the basket's current
   * handoff time. This will populate the day selector on first render.
   *
   * - If a value is present (which means a user selected a time previously):
   *  - ensure the value isn't "asap" (a non time specific wanted at time)
   *  - format the day in local time as YYYY-MM-DD. This is important as all wanted at times (both selected and returned from the API)
   *    are in UTC, but are displayed in local time (the day value must be calculated in the same timezone as the user)
   * - Otherwise, grab todays date as YYYY-MM-DD in local time.
   */ var initialDay = value && value !== global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP ? (0,utils_dates/* formatDate */.p6)(value, dates/* DATE_FORMAT.YEAR_MONTH_DAY_DASHED */.z.YEAR_MONTH_DAY_DASHED) : (0,utils_dates/* formatDate */.p6)(new Date(), dates/* DATE_FORMAT.YEAR_MONTH_DAY_DASHED */.z.YEAR_MONTH_DAY_DASHED);
    var ref1 = (0,react.useState)(initialDay), selectedDay = ref1[0], setSelectedDay = ref1[1];
    // Retrieve available handoff times for the current order.
    var ref2 = useHandoffTimes({
        basketId: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.id,
        dayWanted: selectedDay,
        handoffType: handoffType,
        locationId: location.id,
        supportsAsap: supportsAsap
    }), data = ref2.data, isLoading = ref2.isLoading, isError = ref2.isError;
    function handleDaySelect(day) {
        return _handleDaySelect.apply(this, arguments);
    }
    function _handleDaySelect() {
        _handleDaySelect = /**
   * Fires when the user selects a different handoff day.
   * It's somewhat complex because we must:
   * a) find available times for the selected day
   * b) set the basket's handoff time to the first available slot on that day
   */ (0,_async_to_generator/* default */.Z)(function(day) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Optimistically update the dropdown menu.
                        setSelectedDay(day);
                        return [
                            4,
                            getHandoffTimes({
                                basketId: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.id,
                                dayWanted: day,
                                handoffType: handoffType,
                                locationId: location.id,
                                supportsAsap: supportsAsap
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        // If times are available, set the basket's handoff to the first slot.
                        if (res.length > 0) {
                            onChange(res[0]);
                        } else {
                            // If no times are available, reset the basket's handoff time.
                            onChange("");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleDaySelect.apply(this, arguments);
    }
    // Get a list of days that the order can be scheduled for.
    var days = (0,utils/* getAvailableDays */.JS)({
        canOrderAhead: location.order_ahead,
        advanceDays: location.order_ahead_days
    });
    var ref3;
    // Format the list of handoff times for a given day.
    var timeslots = (ref3 = data === null || data === void 0 ? void 0 : data.map((0,utils/* getTimeslot */.bv)(strings, checkoutBasket))) !== null && ref3 !== void 0 ? ref3 : [];
    // Set value to the first available timeslot if there is no initial value set in store where values is coming from in parent component.
    (0,react.useEffect)(function() {
        if (!value && timeslots.length > 0) {
            var ref;
            onChange((ref = timeslots[0]) === null || ref === void 0 ? void 0 : ref.value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        timeslots.length,
        value
    ]);
    (0,react.useEffect)(function() {
        if (value && value !== global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP) {
            // formats the time in a specific timezone
            setSelectedDay((0,utils_dates/* formatDate */.p6)(value, dates/* DATE_FORMAT.YEAR_MONTH_DAY_DASHED */.z.YEAR_MONTH_DAY_DASHED));
        } else {
            setSelectedDay((0,utils_dates/* formatDate */.p6)(new Date(), dates/* DATE_FORMAT.YEAR_MONTH_DAY_DASHED */.z.YEAR_MONTH_DAY_DASHED));
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericErrorBoundary/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledDayTimeSelectContainer */.Hy, {
            stack: stack,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
                    name: "day_wanted",
                    placeholder: "Date Wanted",
                    onChange: handleDaySelect,
                    value: selectedDay,
                    options: days,
                    title: "Date Wanted"
                }),
                (!data || data.length !== 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledTimeSelect */.s9, {
                    showLoading: isLoading || isSubmitting,
                    showError: isError,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
                            name: "time_wanted",
                            placeholder: "Time Wanted Mode",
                            onChange: onChange,
                            // value could be empty string so we set it to first available timeslot
                            // it works along with useEffect above
                            value: value || ((ref = timeslots[0]) === null || ref === void 0 ? void 0 : ref.value),
                            options: timeslots,
                            title: "Time Wanted",
                            errorMessage: isError ? "Please select a different time." : undefined
                        }),
                        (isLoading || isSubmitting) && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledLoader */.Hl, {})
                    ]
                }),
                data && data.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    tag: styles/* StyledNoAvailability */.hm,
                    accessor: "handoff_time.no_available_times",
                    html: true
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/features/handoff/time-picker/index.ts




/***/ }),

/***/ 56613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hl": function() { return /* binding */ StyledLoader; },
/* harmony export */   "Hy": function() { return /* binding */ StyledDayTimeSelectContainer; },
/* harmony export */   "hm": function() { return /* binding */ StyledNoAvailability; },
/* harmony export */   "s9": function() { return /* binding */ StyledTimeSelect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  font-style: italic;\n  line-height: normal;\n  margin: 0 0 ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  transition: opacity 0.2s linear;\n  ",
        "\n  .select-style {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 22px;\n  position: absolute;\n  right: ",
        "px;\n  top: ",
        "px;\n  width: 22px;\n  /* Spinner Circle Rotation */\n  border: 3px rgba(0, 0, 0, 0.25) solid;\n  border-top: 3px rgba(0, 0, 0, 1) solid;\n  border-radius: 50%;\n  -webkit-animation: spCircRot 0.6s infinite linear;\n  animation: spCircRot 0.6s infinite linear;\n  @-webkit-keyframes spCircRot {\n    from {\n      -webkit-transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(359deg);\n    }\n  }\n  @keyframes spCircRot {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(359deg);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  width: 100%;\n  @media (max-width: 767px) {\n    display: ",
        ";\n  }\n  > div {\n    flex: 1;\n    &:first-child {\n      margin-right: ",
        "px;\n      @media (max-width: 767px) {\n        margin-right: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledNoAvailability = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-98d37057-0"
})(_templateObject(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledTimeSelect = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98d37057-1"
})(_templateObject1(), function(param) {
    var showLoading = param.showLoading;
    return showLoading && "\nopacity: 0.5;\n";
}, function(param) {
    var showError = param.showError;
    return showError && "\n  border-color: red\n";
});
var StyledLoader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98d37057-2"
})(_templateObject2(), function(param) {
    var right = param.right;
    return right || 35;
}, function(param) {
    var top = param.top;
    return top || 14;
});
var StyledDayTimeSelectContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98d37057-3"
})(_templateObject3(), function(param) {
    var _stack = param.stack, stack = _stack === void 0 ? true : _stack;
    return stack ? "block" : "flex";
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER, function(param) {
    var _stack = param.stack, stack = _stack === void 0 ? true : _stack;
    return stack ? 0 : "".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER, "px");
});


/***/ }),

/***/ 50019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useMenu; }
/* harmony export */ });
/* harmony import */ var _koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40024);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47661);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66686);
/* harmony import */ var _services_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49741);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32210);
/* harmony import */ var _utils_events__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41762);







function useMenu(param) {
    var id = param.id, ifModifiedSince = param.ifModifiedSince, wantedAt = param.wantedAt;
    var origin;
    if (true) {
        origin = (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .getOrigin */ .P$)(window.location.host);
    } else {}
    var client = (0,_services_client__WEBPACK_IMPORTED_MODULE_3__/* .createHttpClient */ .d9)({
        origin: origin
    });
    var ref = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a)({
        queryKey: [
            "menu",
            {
                id: id,
                ifModifiedSince: ifModifiedSince,
                wantedAt: wantedAt !== null && wantedAt !== void 0 ? wantedAt : _constants_global__WEBPACK_IMPORTED_MODULE_2__/* .DELIVERY_TIME_WANTED_MODES.ASAP */ .hC.ASAP
            }, 
        ],
        queryFn: function() {
            return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__/* .getMenu */ .r7)({
                id: id !== null && id !== void 0 ? id : 0,
                ifModifiedSince: ifModifiedSince,
                wantedAt: wantedAt === _constants_global__WEBPACK_IMPORTED_MODULE_2__/* .DELIVERY_TIME_WANTED_MODES.ASAP */ .hC.ASAP ? undefined : wantedAt,
                compressed: true
            }, {
                client: client
            });
        },
        enabled: id !== undefined,
        refetchOnWindowFocus: false,
        staleTime: wantedAt === _constants_global__WEBPACK_IMPORTED_MODULE_2__/* .DELIVERY_TIME_WANTED_MODES.ASAP */ .hC.ASAP ? 120000 : 300000,
        keepPreviousData: true
    }), data = ref.data, status = ref.status, fetchStatus = ref.fetchStatus;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data[0]) {
            (0,_utils_events__WEBPACK_IMPORTED_MODULE_5__/* .objectifyOptions */ .d5)(data[0]);
        }
    }, [
        data
    ]);
    return {
        categories: (data === null || data === void 0 ? void 0 : data[0]) ? data[0] : [],
        status: status,
        isLoading: fetchStatus === "fetching"
    };
}


/***/ }),

/***/ 26738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$E": function() { return /* binding */ useConfigOverride; },
/* harmony export */   "EL": function() { return /* binding */ useStrings; },
/* harmony export */   "Fx": function() { return /* binding */ useStringsOverride; },
/* harmony export */   "JR": function() { return /* binding */ useWebConfig; }
/* harmony export */ });
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86879);

function useWebConfig() {
    return (0,_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.webConfig;
    });
}
function useConfigOverride(slice) {
    var config = useWebConfig();
    return config[slice];
}
function useStrings() {
    return (0,_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.strings;
    });
}
function useStringsOverride(slice) {
    var strings = useStrings();
    return strings[slice];
}


/***/ }),

/***/ 77203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useFooterQuery; },
/* harmony export */   "s": function() { return /* binding */ getFooterTemplate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var _koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40024);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47661);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49741);





function getFooterTemplate(origin) {
    return _getFooterTemplate.apply(this, arguments);
}
function _getFooterTemplate() {
    _getFooterTemplate = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(origin) {
        var client;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .createHttpClient */ .d9)({
                        origin: origin
                    });
                    return [
                        4,
                        (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__/* .getFooter */ .$2)({
                            client: client
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _getFooterTemplate.apply(this, arguments);
}
function useFooterQuery(origin) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)({
        queryKey: [
            "site-footer"
        ],
        queryFn: function() {
            return getFooterTemplate(origin);
        },
        refetchOnWindowFocus: false
    });
}


/***/ }),

/***/ 91021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HO": function() { return /* binding */ PageQueryDocument; },
/* harmony export */   "VI": function() { return /* binding */ StagedPageQueryDocument; },
/* harmony export */   "d8": function() { return /* binding */ LinkListQueryDocument; },
/* harmony export */   "vt": function() { return /* binding */ HomePageQueryDocument; }
/* harmony export */ });
/* unused harmony exports KeystoneAdminUiFieldMetaCreateViewFieldMode, KeystoneAdminUiFieldMetaItemViewFieldMode, KeystoneAdminUiFieldMetaListViewFieldMode, KeystoneAdminUiSortDirection, OrderDirection, QueryMode, HasHomePageQueryDocument, SiteIndexedPageQueryDocument */
var KeystoneAdminUiFieldMetaCreateViewFieldMode;
(function(KeystoneAdminUiFieldMetaCreateViewFieldMode) {
    KeystoneAdminUiFieldMetaCreateViewFieldMode["Edit"] = "edit";
    KeystoneAdminUiFieldMetaCreateViewFieldMode["Hidden"] = "hidden";
})(KeystoneAdminUiFieldMetaCreateViewFieldMode || (KeystoneAdminUiFieldMetaCreateViewFieldMode = {}));
var KeystoneAdminUiFieldMetaItemViewFieldMode;
(function(KeystoneAdminUiFieldMetaItemViewFieldMode) {
    KeystoneAdminUiFieldMetaItemViewFieldMode["Edit"] = "edit";
    KeystoneAdminUiFieldMetaItemViewFieldMode["Hidden"] = "hidden";
    KeystoneAdminUiFieldMetaItemViewFieldMode["Read"] = "read";
})(KeystoneAdminUiFieldMetaItemViewFieldMode || (KeystoneAdminUiFieldMetaItemViewFieldMode = {}));
var KeystoneAdminUiFieldMetaListViewFieldMode;
(function(KeystoneAdminUiFieldMetaListViewFieldMode) {
    KeystoneAdminUiFieldMetaListViewFieldMode["Hidden"] = "hidden";
    KeystoneAdminUiFieldMetaListViewFieldMode["Read"] = "read";
})(KeystoneAdminUiFieldMetaListViewFieldMode || (KeystoneAdminUiFieldMetaListViewFieldMode = {}));
var KeystoneAdminUiSortDirection;
(function(KeystoneAdminUiSortDirection) {
    KeystoneAdminUiSortDirection["Asc"] = "ASC";
    KeystoneAdminUiSortDirection["Desc"] = "DESC";
})(KeystoneAdminUiSortDirection || (KeystoneAdminUiSortDirection = {}));
var OrderDirection;
(function(OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (OrderDirection = {}));
var QueryMode;
(function(QueryMode) {
    QueryMode["Default"] = "default";
    QueryMode["Insensitive"] = "insensitive";
})(QueryMode || (QueryMode = {}));
var PageQueryDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "pageQuery"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "slug"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pages"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "slug"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "equals"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "slug"
                                                            }
                                                        }
                                                    }, 
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "status"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "equals"
                                                        },
                                                        value: {
                                                            kind: "StringValue",
                                                            value: "publish",
                                                            block: false
                                                        }
                                                    }, 
                                                ]
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "title"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "slug"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "excludeFromSitemap"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "homepage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "seoTitle"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "seoDescription"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "seoImage"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var HomePageQueryDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "homePageQuery"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pages"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "homepage"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "equals"
                                                        },
                                                        value: {
                                                            kind: "BooleanValue",
                                                            value: true
                                                        }
                                                    }, 
                                                ]
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "title"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "slug"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "excludeFromSitemap"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "homepage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "seoTitle"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "seoDescription"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "seoImage"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var HasHomePageQueryDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "hasHomePageQuery"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pages"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "homepage"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "equals"
                                                        },
                                                        value: {
                                                            kind: "BooleanValue",
                                                            value: true
                                                        }
                                                    }, 
                                                ]
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SiteIndexedPageQueryDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "siteIndexedPageQuery"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pages"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "excludeFromSitemap"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "equals"
                                                        },
                                                        value: {
                                                            kind: "BooleanValue",
                                                            value: false
                                                        }
                                                    }, 
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "status"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "equals"
                                                        },
                                                        value: {
                                                            kind: "StringValue",
                                                            value: "publish",
                                                            block: false
                                                        }
                                                    }, 
                                                ]
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "slug"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var StagedPageQueryDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "stagedPageQuery"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "stagedPage"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "title"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var LinkListQueryDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "linkListQuery"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "linkLists"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "title"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "slug"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "links"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 44373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jd": function() { return /* binding */ useAddScript; },
/* harmony export */   "mA": function() { return /* binding */ useAccount; },
/* harmony export */   "rV": function() { return /* binding */ useRewardsState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86879);
/* harmony import */ var _redux_auth_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45479);
/* harmony import */ var _utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36304);
/* harmony import */ var _utils_loyalty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53174);
/* harmony import */ var _utils_stringHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60738);






var useRewardsState = function() {
    var ref = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.me;
    }), loyaltyState = ref.loyaltyState, myOffers = ref.myOffers, messages = ref.messages, redeemables = ref.redeemables;
    var ref1;
    var currentPoints = (ref1 = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points) !== null && ref1 !== void 0 ? ref1 : 0;
    return {
        currentPoints: (loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points) ? loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points.toString() : "0",
        rewardsCount: (0,_utils_loyalty__WEBPACK_IMPORTED_MODULE_4__/* .getActiveRewardsAndOffersLength */ .gx)(redeemables, myOffers, currentPoints) || 0,
        inboxNotificationsCount: (0,_utils_loyalty__WEBPACK_IMPORTED_MODULE_4__/* .getUnreadPersonalMessagesLength */ .Xy)(messages)
    };
};
var useAccount = function() {
    var dispatch = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var strings = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.strings;
    });
    var user = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.me;
    });
    var loyalty = user.loyaltyState;
    var details = user === null || user === void 0 ? void 0 : user.data;
    var ref;
    var points = (ref = loyalty === null || loyalty === void 0 ? void 0 : loyalty.points) !== null && ref !== void 0 ? ref : 0;
    return {
        loggedIn: details ? true : false,
        userDetails: details,
        loyalty: loyalty,
        points: {
            message: (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_5__/* .pluralizeString */ .fB)((0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_5__/* .safelyGetString */ .bc)(strings, "rewards.rewards_counter"), points !== 1),
            value: points
        },
        availableRewards: (0,_utils_loyalty__WEBPACK_IMPORTED_MODULE_4__/* .getActiveRewardsAndOffersLength */ .gx)(user.redeemables, user.myOffers, points) || 0,
        unreadMessages: (0,_utils_loyalty__WEBPACK_IMPORTED_MODULE_4__/* .getUnreadPersonalMessagesLength */ .Xy)(user.messages),
        logout: function(cancelRedirect) {
            return dispatch(_redux_auth_actions__WEBPACK_IMPORTED_MODULE_2__/* ["default"].logout */ .Z.logout(cancelRedirect));
        }
    };
};
var useAddScript = function(scriptSource) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var addScript = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if ((0,_utils_global__WEBPACK_IMPORTED_MODULE_3__/* .isScriptInDOM */ .Jz)(scriptSource)) {
            setIsLoaded(true);
        } else {
            (0,_utils_global__WEBPACK_IMPORTED_MODULE_3__/* .addScriptToDOM */ .UT)(scriptSource, function() {
                setIsLoaded(true);
            });
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        addScript();
        return function() {
            (0,_utils_global__WEBPACK_IMPORTED_MODULE_3__/* .removeScriptFromDOM */ .PB)(scriptSource);
        };
    }, [
        addScript
    ]);
    return isLoaded;
};


/***/ }),

/***/ 84986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ RADAR_MAPS_CONFIG; }
/* harmony export */ });
var RADAR_MAPS_CONFIG = {
    sharableKey: "prj_live_pk_c32be99ba9cd8b075d23100be76f64a09d8c7a6b"
};


/***/ }),

/***/ 80378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useAnimatedVisibility; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useAnimatedVisibility = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    /*
   * in order to correctly handle animations and
   * visibility of the navigation drawer, we need to
   * use both open and visible state variables.
   *
   * `isOpen` controls the mounting of the drawer while
   * `isVisible` controls the visiblity of the drawer
   * to the user
   */ var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMounted = ref1[0], setMounted = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), shouldDisplay = ref2[0], setShouldDisplay = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref1;
        ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("transitionend", onTransitionEnd);
        return function() {
            var ref1;
            return ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("transitionend", onTransitionEnd);
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timeout;
        if (isMounted) {
            timeout = setTimeout(function() {
                return setShouldDisplay(true);
            }, 10);
        }
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        isMounted
    ]);
    var onTransitionEnd = function() {
        return !shouldDisplay && setMounted(false);
    };
    var toggle = function() {
        if (isMounted) {
            setShouldDisplay(false);
        } else {
            setMounted(true);
        }
    };
    return {
        isMounted: isMounted,
        shouldDisplay: shouldDisplay,
        toggle: toggle,
        ref: ref
    };
};


/***/ })

}]);